export default {
  "12313": "",
  "123123": "",
  "77777777": "",
  "plant.running.status.alarm": "แจ้งเตือน",
  "nl.second.code": "พลังงาน PV ต่ำ",
  "end.web": "เว็บ",
  "test.label_G_P_C_L2": "พลังงาน Gen L2",
  "device.offline": "อุปกรณ์ออฟไลน์",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "ywt.60419.AllowCounterCurrentPower": "อนุญาตให้มีกำลังย้อนกลับ",
  "ywt.60419.internalharderror0": "ไม่มีข้อผิดปกติ",
  "ywt.60419.loadDropMode": "โหมดลดโหลด",
  "ywt.60419.loadDropMode11": "การป้องกันการไหลย้อนของเครื่องเดี่ยว",
  "ywt.60419.meterCommQuality": "คุณภาพการสื่อสารของมิเตอร์ไฟฟ้า",
  "ywt.60419.meterRPower": "กำลังไฟเฟส R ของมิเตอร์ไฟฟ้า",
  "ywt.60419.meterSelect": "การเลือกมิเตอร์ไฟฟ้า",
  "ywt.60419.meterSPower": "กำลังไฟเฟส S ของมิเตอร์ไฟฟ้า",
  "ywt.60419.meterTPower": "กำลังไฟฟ้าของมิเตอร์เฟส T",
  "ywt.60419.multiReverseFlowEnable": "เปิดใช้งานการป้องกันกระแสย้อนกลับสำหรับหลายเครื่อง",
  "ywt.60419.restrictCounterCurrent": "จำกัดวิธีการย้อนกลับ",
  "ywt.60419.singleReverseFlowEnable": "เปิดใช้งานการป้องกันกระแสย้อนกลับสำหรับเครื่องเดียว",
  "bw_param_ctrl_group_ParallelSetting": "การตั้งค่าแบบขนาน",
  "bw_param_ctrl_group_SpecialSetting": "การตั้งค่าพิเศษ",
  "bw_param_ctrl_name_PhaseOrderResume": "คืนค่าลำดับเฟส",
  "bw_param_ctrl_note_ParallelModeSetting": "สำหรับตั้งค่าหากอินเวอร์เตอร์เป็นหน่วยมาสเตอร์หรือสเลฟในการทำงานแบบขนาน",
  "bw_param_ctrl_option_host": "มาสเตอร์ในโหมดขนาน",
  "bw_param_ctrl_option_PhaseOrderResume": "รีเซ็ต",
  "bw_param_ctrl_option_single": "โหมดไม่ขนาน (โหมดเดี่ยว)",
  "bw_param_ctrl_option_Slave": "สเลฟในโหมดขนาน",
  "0X3809-F-0607": "ข้อผิดพลาดป้องกันอุณหภูมิเกินที่ขั้วต่อ PV",
  "0X3809-F-1103": "รีเลย์ทดสอบตัวเองผิดปกติ",
  "0X3809-F-3112": "ข้อผิดพลาดล็อกเฟสแรงดันไฟ",
  "0X3809-F-3113": "ลำดับเฟสไฟผิดปกติ",
  "0X3809-S-0101": "1. ตรวจสอบว่าการเชื่อมต่อโมดูลโซลาร์เซลล์เป็นปกติหรือไม่ และว่าโมดูลมีความเสียหาย มีฝุ่นบนพื้นผิว หรือมีสิ่งบดบังหรือไม่\n2. ตรวจสอบว่าโมดูลโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และว่าข้อกำหนดแรงดันไฟฟ้าของโมดูลสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. ตรวจสอบว่าโมดูลโซลาร์เซลล์มีไฟฟ้าลัดวงจรหรือไม่",
  "0X3809-S-0102": "1. ตรวจสอบว่าการเชื่อมต่อโมดูลโซลาร์เซลล์เป็นปกติหรือไม่ และว่าโมดูลมีความเสียหาย มีฝุ่นบนพื้นผิว หรือมีสิ่งบดบังหรือไม่\n2. ตรวจสอบว่าโมดูลโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และว่าข้อกำหนดแรงดันไฟฟ้าของโมดูลสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. ตรวจสอบว่าโมดูลโซลาร์เซลล์มีไฟฟ้าลัดวงจรหรือไม่",
  "0X3809-S-0103": "1. ตรวจสอบว่าการเชื่อมต่อโมดูลโซลาร์เซลล์เป็นปกติหรือไม่ และว่าโมดูลมีความเสียหาย มีฝุ่นบนพื้นผิว หรือมีสิ่งบดบังหรือไม่\n2. ตรวจสอบว่าโมดูลโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และว่าข้อกำหนดแรงดันไฟฟ้าของโมดูลสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. ตรวจสอบว่าโมดูลโซลาร์เซลล์มีไฟฟ้าลัดวงจรหรือไม่",
  "0X3809-S-0301": "1. มักเกิดขึ้นในช่วงเช้าตรู่ กรุณาตรวจสอบความสะอาดของพื้นผิวแผงโซลาร์เซลล์\n2. ตรวจสอบว่าแผงโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และข้อกำหนดแรงดันไฟฟ้าของแผงสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0302": "1. มักเกิดขึ้นในช่วงเช้าตรู่ กรุณาตรวจสอบความสะอาดของพื้นผิวแผงโซลาร์เซลล์\n2. ตรวจสอบว่าแผงโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และข้อกำหนดแรงดันไฟฟ้าของแผงสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0303": "1. มักเกิดขึ้นในช่วงเช้าตรู่ กรุณาตรวจสอบความสะอาดของพื้นผิวแผงโซลาร์เซลล์\n2. ตรวจสอบว่าแผงโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และข้อกำหนดแรงดันไฟฟ้าของแผงสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0304": "1. มักเกิดขึ้นในช่วงเช้าตรู่ กรุณาตรวจสอบความสะอาดของพื้นผิวแผงโซลาร์เซลล์\n2. ตรวจสอบว่าแผงโซลาร์เซลล์เชื่อมต่อปกติหรือไม่ และข้อกำหนดแรงดันไฟฟ้าของแผงสูงกว่าช่วงแรงดันไฟฟ้าทำงานของอินเวอร์เตอร์หรือไม่\n3. กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0501": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0502": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0503": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0504": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0505": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0506": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0507": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0508": "กรุณารีสตาร์ทอินเวอร์เตอร์ หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0601": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0602": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0603": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0604": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0605": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0606": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0607": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าท่อลมของฮีทซิงก์ถูกอุดตันหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์หลังเย็นตัวลง หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0701": "1. ตรวจสอบว่าโมดูลมีไฟฟ้าลัดวงจรลงกราวด์หรือไม่\n2. ตรวจสอบว่ามีการเชื่อมต่อหลวมในวงจรไฟฟ้ากระแสตรงหรือไม่\n3. หากไม่มีปัญหาในวงจรไฟฟ้ากระแสตรง ให้ปิดเครื่องเป็นเวลา 5 นาทีแล้วเปิดใหม่ หากยังไม่สามารถแก้ไขได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0801": "1. ข้อผิดพลาดวงจรขับ\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0901": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0902": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0903": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0904": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0905": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0906": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-0907": "1. ข้อผิดพลาดแผงควบคุม\n2. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1001": "1. หากเกิดขึ้นเป็นครั้งคราว อาจเกิดจากความผิดปกติของสายภายนอกเป็นครั้งคราว การรีสตาร์ทอินเวอร์เตอร์จะทำให้การทำงานกลับสู่ปกติ\n2. หากเกิดขึ้นบ่อยครั้งหรือไม่สามารถกู้คืนได้เป็นเวลานาน โปรดตรวจสอบว่าการต่อสายดินของสายโซลาร์เซลล์มีความน่าเชื่อถือหรือไม่",
  "0X3809-S-1002": "1. หากเกิดขึ้นเป็นครั้งคราว อาจเกิดจากความผิดปกติของสายภายนอกเป็นครั้งคราว การรีสตาร์ทอินเวอร์เตอร์จะทำให้การทำงานกลับสู่ปกติ\n2. หากเกิดขึ้นบ่อยครั้งหรือไม่สามารถกู้คืนได้เป็นเวลานาน โปรดตรวจสอบว่าการต่อสายดินของสายโซลาร์เซลล์มีความน่าเชื่อถือหรือไม่",
  "0X3809-S-1003": "1. หากเกิดขึ้นเป็นครั้งคราว อาจเกิดจากความผิดปกติของสายภายนอกเป็นครั้งคราว การรีสตาร์ทอินเวอร์เตอร์จะทำให้การทำงานกลับสู่ปกติ\n2. หากเกิดขึ้นบ่อยครั้งหรือไม่สามารถกู้คืนได้เป็นเวลานาน โปรดตรวจสอบว่าการต่อสายดินของสายโซลาร์เซลล์มีความน่าเชื่อถือหรือไม่",
  "0X3809-S-1004": "1. หากเกิดขึ้นเป็นครั้งคราว อาจเกิดจากความผิดปกติของสายภายนอกเป็นครั้งคราว การรีสตาร์ทอินเวอร์เตอร์จะทำให้การทำงานกลับสู่ปกติ\n2. หากเกิดขึ้นบ่อยครั้งหรือไม่สามารถกู้คืนได้เป็นเวลานาน โปรดตรวจสอบว่าการต่อสายดินของสายโซลาร์เซลล์มีความน่าเชื่อถือหรือไม่",
  "0X3809-S-1101": "1. ตรวจสอบว่าเส้นลวดกราวด์ด้านเอซีมีไฟฟ้าหรือไม่\n2. ข้อผิดพลาดรีเลย์ภายใน\n3. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1102": "1. ตรวจสอบว่าเส้นลวดกราวด์ด้านเอซีมีไฟฟ้าหรือไม่\n2. ข้อผิดพลาดรีเลย์ภายใน\n3. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1103": "1. ตรวจสอบว่าเส้นลวดกราวด์ด้านเอซีมีไฟฟ้าหรือไม่\n2. ข้อผิดพลาดรีเลย์ภายใน\n3. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1201": "1. พัดลมภายในเสียหาย\n2. ข้อผิดพลาดวงจรตรวจจับพัดลม\n3. ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ กรุณาติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1901": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1902": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1903": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1904": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1905": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1906": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-1907": "ปิดเครื่องและรีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3101": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3102": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3103": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3104": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3105": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3106": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3107": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3108": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3109": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3110": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3111": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3112": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3113": "1. ตรวจสอบว่ามีเซอร์กิตเบรกเกอร์ในตู้กระจายไฟฟ้าทริปหรือไม่\n2. วัดว่าแรงดันไฟฟ้าจริงเกินช่วงของอินเวอร์เตอร์หรือไม่\n3. หากแรงดันไฟฟ้าอยู่นอกช่วง สามารถปรับค่าการป้องกันแรงดันเกินและแรงดันต่ำของอินเวอร์เตอร์ได้",
  "0X3809-S-3301": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3302": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3303": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3304": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3305": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3306": "1. ตรวจสอบว่ามีการเชื่อมต่อหลวมในระบบไฟฟ้าหรือไม่\n2. ปรับช่วงความถี่ให้เหมาะสม",
  "0X3809-S-3701": "ตรวจสอบว่าอินเวอร์เตอร์ถูกตั้งค่าให้ปิดเครื่องด้วยตนเองหรือไม่",
  "0X3809-S-3801": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3802": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3803": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3804": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3805": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3806": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3807": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3808": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3809": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3810": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3811": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3812": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3813": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3814": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3815": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3816": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3817": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3818": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3819": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3820": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3901": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3902": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3903": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3904": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3905": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3906": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3907": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3908": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3909": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3910": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3911": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3912": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3913": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3914": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3915": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3916": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3917": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3918": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3919": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-3920": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-4101": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-4201": "ตรวจสอบว่าแรงดัน N-PE ผิดปกติหรือไม่",
  "0X3809-S-4301": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3809-S-4401": "กรุณาปิดอินเวอร์เตอร์และตัดสวิตช์อินพุต/เอาต์พุต เริ่มการทำงานอินเวอร์เตอร์ใหม่หลังจาก 5 นาที หากยังไม่สามารถแก้ไขข้อผิดพลาดได้ โปรดติดต่อตัวแทนจำหน่าย",
  "0X3807-F-02": "การเตือนไฟฟ้าลัดวงจร PV2",
  "0X3807-F-03": "การเตือนแรงดันไฟฟ้า PV ต่ำ",
  "0X3807-S-0101": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0102": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0103": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0104": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0105": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0106": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0107": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0108": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0109": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0110": "1. ตรวจสอบว่าพัดลมติดขัดจากสิ่งแปลกปลอมหรือไม่\n2. ตรวจสอบว่าพัดลมหมุนปกติหรือไม่\n3. รีสตาร์ทอินเวอร์เตอร์ หากไม่สามารถกู้คืนได้ โปรดเปลี่ยนพัดลม",
  "0X3807-S-0401": "ตรวจสอบว่าการเดินสายมิเตอร์ผิดพลาดหรือไม่",
  "0X3807-S-0402": "ตรวจสอบว่าการเดินสายมิเตอร์ผิดพลาดหรือไม่",
  "0X3807-S-0404": "ตรวจสอบว่าการเดินสายมิเตอร์ผิดพลาดหรือไม่",
  "0X3807-S-0408": "ตรวจสอบว่าการเดินสายมิเตอร์ผิดพลาดหรือไม่",
  "0X3807-S-0416": "ตรวจสอบว่าการเดินสายมิเตอร์ผิดพลาดหรือไม่",
  "0X3807-S-0500": "1. หากเกิดขึ้นเป็นครั้งคราว อาจเกิดจากความผิดปกติชั่วคราวของโครงข่ายไฟฟ้า อินเวอร์เตอร์จะกลับมาทำงานปกติหลังจากโครงข่ายไฟฟ้ากลับสู่ภาวะปกติ\n2. หากข้อผิดพลาดนี้รายงานบ่อยครั้ง โปรดตรวจสอบว่าโครงข่ายไฟฟ้าผิดปกติหรือไม่",
  "0X3807-S-0601": "หลังจากปิดเครื่อง ให้ตรวจสอบว่าแรงดันของโมดูลเป็นปกติหรือไม่ หากการรีสตาร์ทไม่สามารถแก้ไขปัญหาได้ แสดงว่ามีข้อผิดพลาดภายในอินเวอร์เตอร์",
  "0X3807-S-02": "หลังจากปิดเครื่อง ให้ตรวจสอบว่าแรงดันของโมดูลเป็นปกติหรือไม่ หากการรีสตาร์ทไม่สามารถแก้ไขปัญหาได้ แสดงว่ามีข้อผิดพลาดภายในอินเวอร์เตอร์",
  "0X3807-S-03": "หลังจากปิดเครื่อง ให้ตรวจสอบว่าแรงดันของโมดูลเป็นปกติหรือไม่ หากการรีสตาร์ทไม่สามารถแก้ไขปัญหาได้ แสดงว่ามีข้อผิดพลาดภายในอินเวอร์เตอร์",
  "In Alarm": "กำลังแจ้งเตือน",
  "Inverter": "พลังงาน PV ต่ำ",
  "Controller": "พลังงาน PV ต่ำ",
  "Collector": "พลังงาน PV ต่ำ",
  "BMS": "พลังงาน PV ต่ำ",
  "Inverter (hex)": "พลังงาน PV ต่ำ",
  "AFCI": "พลังงาน PV ต่ำ",
  "BMS（.S19）": "พลังงาน PV ต่ำ",
  "Grid-tie & Off-grid Control Box": "พลังงาน PV ต่ำ",
  "逆变器ARM（禾迈）": "พลังงาน PV ต่ำ",
  "数据棒（禾迈）": "พลังงาน PV ต่ำ",
  "Gateway (Weimai)": "พลังงาน PV ต่ำ",
  "Display Screen (Weimai)": "พลังงาน PV ต่ำ",
  "HMID (Weimai)": "พลังงาน PV ต่ำ",
  "DCDC (Weimai)": "พลังงาน PV ต่ำ",
  "Battery BMS (Weimai)": "พลังงาน PV ต่ำ",
  "Inverter Auxiliary DSP (Weimai)": "พลังงาน PV ต่ำ",
  "Inverter Main DSP (Weimai)": "พลังงาน PV ต่ำ",
  "Charging Pile (Weimai)": "พลังงาน PV ต่ำ",
  "device.category.energyStorageCabinet": "ตู้จัดเก็บพลังงาน",
  "device.category.commercialRobot": "หุ่นยนต์สำหรับอุตสาหกรรมและธุรกิจ",
  "device.category.pvinverter": "อินเวอร์เตอร์พลังงานแสงอาทิตย์",
  "collector.upgrade.progress": "ความคืบหน้าการอัปเกรดนักสะสม",
  "device.upgrade.progress": "ความคืบหน้าการอัปเกรดอุปกรณ์",
  "failed.to.obtain.firmware": "ไม่สามารถรับเฟิร์มแวร์ได้",
  "file.CRC.check.failed": "การตรวจสอบ CRC ไฟล์ล้มเหลว",
  "burning.timed.out": "การเขียนไฟล์ใช้เวลานานเกินไป",
  "burning.failed": "การเขียนไฟล์ล้มเหลว",
  "shujvabng": "สติ๊กข้อมูล (Bumai)",
  "paramSet.select.dataError.tip": "ตัวเลือกไม่ใช่ตัวเลือกที่ดีที่สุด โปรดรีเซ็ต",
  "ywt.60419.pbusVol": "PBUS Voltage  ",
  "bw_param_qqq": "โหมดการตั้งค่าขนาน",
  "paramSet.dateTime.title.month": "เดือน",
  "ywt.60419.invRTemp": "อิเล็กตรอน",
  "ywt.60419.sGridVol": "แรงดันเฟส S ของกริด",
  "paramSet.dateTime.title.year": "ปี",
  "ywt.60419.btDspDebugInfo8": "ข้อมูลการดีบักของ BT DSP 8",
  "ywt.60419.btDspDebugInfo7": "ข้อมูลการดีบักของ BT DSP 7",
  "ywt.60419.btDspDebugInfo6": "ข้อมูลการดีบักของ BT DSP 6",
  "ywt.60419.sPhaseDci": "เฟส S DCI",
  "ywt.60419.armDebugInfo7": "ข้อมูลดีบั๊ก ARM 7  ",
  "ywt.60419.armDebugInfo5": "ข้อมูลดีบั๊ก ARM 5  ",
  "ywt.60419.armDebugInfo6": "ข้อมูลดีบั๊ก ARM 6  ",
  "ywt.60419.armDebugInfo3": "ข้อมูลดีบั๊ก ARM 3  ",
  "ywt.60419.armDebugInfo4": "ข้อมูลดีบั๊ก ARM 4  ",
  "ywt.60419.armDebugInfo1": "ข้อมูลดีบั๊ก ARM 1  ",
  "ywt.60419.armDebugInfo2": "ข้อมูลดีบั๊ก ARM 2  ",
  "ywt.60419.deratedPower": "กำลังลดลง",
  "ywt.60419.todayPvEnergy": "ปริมาณการผลิตไฟฟ้าในวันนี้",
  "ywt.60419.btDspDebugInfo1": "ข้อมูลการดีบักของ BT DSP 1",
  "ywt.60419.invSTemp": "อุณหภูมิของโมดูล INV S (°C)",
  "ywt.60419.btDspDebugInfo5": "ข้อมูลการดีบักของ BT DSP 5",
  "ywt.60419.btDspDebugInfo4": "ข้อมูลการดีบักของ BT DSP 4",
  "ywt.60419.btDspDebugInfo3": "ข้อมูลการดีบักของ BT DSP 3",
  "ywt.60419.btDspDebugInfo2": "ข้อมูลการดีบักของ BT DSP 2",
  "ywt.60419.dcInsulationImpedance": "อิมพีแดนซ์ความฉนวน DC",
  "test.label_G_P_C_L1": "พลังงาน Gen L1",
  "ywt.60419.internalHardwareError": "ข้อผิดพลาดฮาร์ดแวร์ภายในเครื่อง",
  "ywt.60419.versionStr": "หมายเลขเวอร์ชัน",
  "test.label_G_P_C_L5": "แรงดันไฟฟ้า Gen L2",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "แรงดันไฟฟ้า Gen L2",
  "test.label_G_P_C_L4": "แรงดันไฟฟ้า Gen L1",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "แรงดันไฟฟ้า Gen L3",
  "test.label_G_P_C_L3": "พลังงาน Gen L3",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "แรงดันไฟฟ้า Gen L1",
  "test.label_G_P_C_L6": "แรงดันไฟฟ้า Gen L3",
  "ywt.60419.envTemp": "อุณหภูมิแวดล้อม(℃)  ",
  "bw_param_ctrl_name_ParallelSetting": "สถานะแบบขนาน",
  "ywt.60419.rGridVol": "แรงดันเฟสของสายไฟฟ้า R",
  "ywt.60419.scanStatus": "สถานะการสแกน I/V  ",
  "ywt.60419.groupStrCurrent1": "กระแสของสตริง 1",
  "ywt.60419.invTTemp": "อุณหภูมิของโมดูล INV (℃)",
  "ywt.60419.groupStrCurrent2": "กระแสของสตริง 2",
  "ywt.60419.groupStrCurrent5": "กระแสของสตริง 5",
  "ywt.60419.groupStrCurrent6": "กระแสของสตริง 6",
  "ywt.60419.groupStrCurrent3": "กระแสของสตริง 3",
  "ywt.60419.groupStrCurrent4": "กระแสของสตริง 4",
  "ywt.60419.groupStrCurrent9": "กระแสของสตริง 9",
  "ywt.60419.groupStrCurrent7": "กระแสของสตริง 7",
  "ywt.60419.groupStrCurrent8": "กระแสของสตริง 8",
  "ywt.60419.pvInputVol2": "แรงดันอินพุต PV2",
  "ywt.60419.pvInputVol1": "แรงดันอินพุต PV1",
  "ywt.60419.pvPower2": "กำลังงาน PV 2",
  "ywt.60419.pvPower1": "กำลังงาน PV 1",
  "ywt.60419.pvPower8": "กำลังงาน PV 8",
  "ywt.60419.pvPower7": "กำลังงาน PV 7",
  "ywt.60419.pvPower9": "กำลังงาน PV 9",
  "ywt.60419.pvPower4": "กำลังงาน PV 4",
  "ywt.60419.pvPower3": "กำลังงาน PV 3",
  "ywt.60419.pvPower6": "กำลังงาน PV 6",
  "ywt.60419.pvPower5": "กำลังงาน PV 5",
  "ywt.60419.pvInputVol9": "แรงดันอินพุต PV9",
  "ywt.60419.pvInputVol8": "แรงดันอินพุต PV8",
  "ywt.60419.pvInputVol7": "แรงดันอินพุต PV7",
  "ywt.60419.pvInputVol6": "แรงดันอินพุต PV6",
  "ywt.60419.pvInputVol5": "แรงดันอินพุต PV5",
  "ywt.60419.pvInputVol4": "แรงดันอินพุต PV4",
  "ywt.60419.pvInputVol3": "แรงดันอินพุต PV3",
  "ywt.60419.pvChargeTime": "เวลาการผลิตไฟฟ้า  ",
  "ywt.60419.invDspDebugInfo1": "ข้อมูลดีบัก INV DSP 1  ",
  "ywt.60419.invDspDebugInfo2": "ข้อมูลดีบัก INV DSP 2  ",
  "ywt.60419.invDspDebugInfo3": "ข้อมูลดีบัก INV DSP 3  ",
  "ywt.60419.invDspDebugInfo4": "ข้อมูลดีบัก INV DSP 4  ",
  "ywt.60419.invDspDebugInfo5": "ข้อมูลดีบัก INV DSP 5  ",
  "ywt.60419.invDspDebugInfo6": "ข้อมูลดีบัก INV DSP 6  ",
  "ywt.60419.invDspDebugInfo7": "ข้อมูลดีบัก INV DSP 7  ",
  "ywt.60419.invDspDebugInfo8": "ข้อมูลดีบัก INV DSP 8  ",
  "ywt.60419.workStatus0": "การเริ่มต้น",
  "ywt.60419.workStatus1": "รอ",
  "ywt.60419.workStatus2": "การเชื่อมต่อเครือข่าย",
  "ywt.60419.workStatus3": "ความล้มเหลว",
  "ywt.60419.workStatus4": "การเขียนโปรแกรม",
  "ywt.60419.workStatus5": "นอกเครือข่าย",
  "ywt.60419.rPhaseDci": "DCI ของ Pha R",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "พลังงาน Gen L2",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "พลังงาน Gen L1",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "พลังงาน Gen L3",
  "paramSet.dateTime.title.hour": "ชั่วโมง",
  "ywt.60419.tOnGridCurrent": "กระแสไฟฟ้าเชื่อมต่อกริดเฟส T  ",
  "ywt.60419.trGridVol": "แรงดันสายกริด TR  ",
  "paramSet.dateTime.title.minute": "นาที",
  "ywt.60419.loadPower": "กำลังไฟโหลด",
  "ywt.60419.tPhaseDci": "T phase DCI  ",
  "ywt.60419.pvPower11": "กำลังไฟฟ้าของ PV11",
  "ywt.60419.pvPower10": "กำลังไฟฟ้าของ PV10",
  "ywt.60419.reactivePower": "กำลังไฟฟ้าไม่ประกอบ",
  "ywt.60419.rsGirdVol": "แรงดันไฟฟ้าเส้นกริด RS  ",
  "ywt.60419.rOnGridCurrent": "กระแสเชื่อมต่อกริดเฟส R",
  "ywt.60419.pvInputVol11": "PV11 Input Voltage  ",
  "ywt.60419.pvInputVol10": "PV10 Input Voltage  ",
  "ywt.60419.pvInputVol12": "PV12 Input Voltage  ",
  "ywt.60419.totalPvEnergy": "ผลผลิตทั้งหมด",
  "paramSet.dateTime.title.second": "วินาที",
  "ywt.60419.groupStrCurrent23": "กระแสของสตริง 23",
  "ywt.60419.groupStrCurrent22": "กระแสของสตริง 22",
  "ywt.60419.groupStrCurrent21": "กระแสของสตริง 21",
  "ywt.60419.groupStrCurrent20": "กระแสของสตริง 20",
  "ywt.60419.pvInputCurrent9": "PV9 กระแสอินพุต  ",
  "ywt.60419.stGirdVol": "แรงดันสายกริด ST",
  "ywt.60419.groupStrCurrent19": "กระแสของสตริง 19",
  "ywt.60419.groupStrCurrent18": "กระแสของสตริง 18",
  "ywt.60419.groupStrCurrent17": "กระแสของสตริง 17",
  "ywt.60419.groupStrCurrent16": "กระแสของสตริง 16",
  "ywt.60419.groupStrCurrent15": "กระแสของสตริง 15",
  "ywt.60419.groupStrCurrent14": "กระแสของสตริง 14",
  "ywt.60419.groupStrCurrent13": "กระแสของสตริง 13",
  "ywt.60419.groupStrCurrent12": "กระแสของสตริง 12",
  "ywt.60419.groupStrCurrent11": "กระแสของสตริง 11",
  "ywt.60419.groupStrCurrent10": "กระแสของสตริง 10",
  "ywt.60419.pvInputCurrent7": "PV7 กระแสอินพุต  ",
  "ywt.60419.leakCurrent": "กระแสรั่ว",
  "ywt.60419.pvInputCurrent8": "PV8 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent5": "PV5 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent6": "PV6 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent3": "PV3 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent4": "PV4 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent1": "PV1 กระแสอินพุต  ",
  "ywt.60419.pvInputCurrent2": "PV2 กระแสอินพุต  ",
  "ywt.60419.scanPercentage": "เปอร์เซ็นต์การสแกน I/V  ",
  "ywt.60419.powerFactor": "ตัวประกอบกำลัง",
  "ywt.60419.onGridCountdown": "นับถอยหลังเชื่อมต่อกริด  ",
  "ywt.60419.radiatorTemp": "อุณหภูมิหม้อน้ำ (℃)",
  "ywt.60419.rsGridFrequency": "ความถี่ของกริด RS",
  "ywt.60419.activePower": "กำลังงาน Active  ",
  "paramSet.dateTime.title.day": "วัน",
  "ywt.60419.meterPower": "กำลังไฟรวมของมิเตอร์ไฟฟ้า",
  "paramSet.input.dataError.tip": "ค่ามិនอยู่ในช่วงที่สมเหตุสมผล โ",
  "ywt.60419.workStatus": "การเฝ้าสังเกตการทำงาน",
  "ywt.60419.tGridVol": "แรงดันไฟฟ้าเฟสของระบบไฟฟ้า T",
  "ywt.60419.sOnGridCurrent": "กระแสเชื่อมต่อกับสายไฟฟ้า Pha S",
  "ywt.60419.nbusVol": "NBUS Voltage  ",
  "ywt.60419.pvInputCurrent10": "กระแสอินพุต PV10",
  "ywt.60419.pvInputCurrent11": "กระแสอินพุต PV11",
  "ywt.60419.pvInputCurrent12": "กระแสอินพุต PV12",
  "current.collector.upgrade.progress": "ความก้าวหน้าในการอัปเกรดตัวรวบรวมข้อมูลปัจจุบันคือ",
  "CSP Plant": "สถานีพลังงานแสงอาทิตย์ความร้อน",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "เปิดใช้งานการย้อนกลับ Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "เปิดใช้งานการย้อนกลับ PV CT",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "การตั้งค่าอัตราส่วนขดลวดมิเตอร์ Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "การตั้งค่าอัตราส่วนขดลวดมิเตอร์ PV CT",
  "50901.ctrl_Config-Grid Profile.country": "ประเทศ / มาตรฐานการเชื่อมต่อเครือข่าย",
  "50901.ctrl_Device.meterConfiguration": "การตั้งค่ามิเตอร์",
  "50901.ctrl_WorkMode.workMode": "โหมดการทำงาน EMS",
  "50901.ctrl_ESS_Advanced_Config-System": "การตั้งค่าขั้นสูง - ระบบ",
  "50901.ctrl_Config-Grid Profile": "การตั้งค่า - พารามิเตอร์เครือข่าย",
  "50901.ctrl_Device": "ควบคุม_อุปกรณ์",
  "50901.ctrl_WorkMode": "โหมดการทำงาน",
  "connect.type.wifi": "เครือข่ายไร้สาย",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "การตั้งค่าโหมดการทำงาน",
  "50901.ctrl_WorkMode-Backup": "โหมดการทำงาน - รезอร์ฟ",
  "50901.ctrl_WorkMode-economic": "โหมดการทำงาน - เศรษฐกิจ",
  "50901.ctrl_WorkMode-forceCharge": "โหมดการทำงาน - การชาร์จแบบบังคับ",
  "50901.ctrl_WorkMode-forceDischarge": "โหมดการทำงาน - การปล่อยแรงแบบบังคับ",
  "50901.ctrl_WorkMode-peakMeter": "โหมดการทำงาน - มิเตอร์ยอดสูงสุด",
  "50901.ctrl_WorkMode-Selfuse": "โหมดการทำงาน - ใช้เอง",
  "50901.ctrl_WorkMode-TOU": "โหมดการทำงาน - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "โหมด TOU - SOC ที่สำรองไว้",
  "50901.ctrl_Device.meterConfiguration.desc": "คำอธิบายเกี่ยวกับการตั้งค่ามิเตอร์",
  "50901.ctrl_Config-Grid Profile.country.desc": "คำอธิบายเกี่ยวกับประเทศ / ประเทศที่มีมาตรฐานการเชื่อมต่อเครือข่าย",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "เปิดใช้งาน",
  "50901.ctrl_Device.meterConfiguration.0": "ไม่มีประเภทมิเตอร์",
  "50901.ctrl_Device.meterConfiguration.1": "การตั้งค่ามิเตอร์ด้านเครือข่าย",
  "50901.ctrl_Device.meterConfiguration.2": "การตั้งค่ามิเตอร์ PV",
  "50901.ctrl_Device.meterConfiguration.3": "การตั้งค่ามิเตอร์ด้านเครือข่าย + PV",
  "Do_not_connect": "ไม่เชื่อมต่อ",
  "connect.type.Do.not.connect": "ไม่เชื่อมต่อ",
  "platformType.web": "Web",
  "50901.Selfuse": "การใช้เอง",
  "50901.TOU": "อัตราค่าไฟฟ้าตามช่วงเวลา",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "คำอธิบายการกำหนดค่ามิเตอร์",
  "50901.ctrl_Config.Grid Profile.country.desc": "คำอธิบายประเทศ / ประเทศตามมาตรฐานการเชื่อมต่อโครงข่าย",
  "50901.ctrl_Config.Device.meterConfiguration.0": "ไม่มีประเภทมิเตอร์",
  "50901.ctrl_Config.Device.meterConfiguration.1": "กำหนดค่ามิเตอร์ฝั่งโครงข่ายแล้ว",
  "50901.ctrl_Config.Device.meterConfiguration.2": "กำหนดค่ามิเตอร์พีวีแล้ว",
  "50901.ctrl_Config.Device.meterConfiguration.3": "กำหนดค่ามิเตอร์ฝั่งโครงข่ายและพีวีแล้ว",
  "50901.ctrl_WorkMode.Switch.workMode.0": "การใช้เอง",
  "50901.ctrl_WorkMode.Switch.workMode.1": "โหมดประหยัด",
  "50901.ctrl_WorkMode.Switch.workMode.2": "โหมดสำรอง",
  "50901.ctrl_WorkMode.Switch.workMode.3": "โหมดนอกระบบ",
  "50901.ctrl_WorkMode.Switch.workMode.4": "โหมดการประจุแบบบังคับ",
  "50901.ctrl_WorkMode.Switch.workMode.5": "โหมดการคายประจุแบบบังคับ",
  "50901.ctrl_WorkMode.Switch.workMode.6": "โหมดลดช่วงพีค",
  "50901.ctrl_WorkMode.Switch.workMode.7": "Modalità TOU",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "เปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "เปิดใช้งาน",
  "50901.ctrl_Config.Device.meterConfiguration": "การกำหนดค่ามิเตอร์",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "เปิดใช้งานการกลับทิศทางกริดซีที",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "การตั้งค่าอัตราส่วนรอบมิเตอร์กริดซีที",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "เปิดใช้งานการกลับทิศทางพีวีซีที",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "การตั้งค่าอัตราส่วนรอบมิเตอร์พีวีซีที",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "ชั่วโมงเริ่มประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "ชั่วโมงเริ่มคายประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "ชั่วโมงเริ่มประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "ชั่วโมงเริ่มคายประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "ชั่วโมงเริ่มประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "ชั่วโมงเริ่มคายประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "ชั่วโมงเริ่มประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "ชั่วโมงเริ่มคายประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_Config.Grid Profile.country.0": "ЄС EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549 (ค่าเริ่มต้น)",
  "50901.ctrl_Config.Grid Profile.country.10": "Австралія AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "Філіппіни PH",
  "50901.ctrl_Config.Grid Profile.country.12": "Бразилія BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "Пакистан PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "Таїланд THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "Італія IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "Колумбія CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "Велика Британія UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "Австралія AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "Велика Британія UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "Еквадор EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "Словенія SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "Франція FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "Іспанія ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "Іспанія ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "Литва LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208 (สหรัฐอเมริกา)",
  "50901.ctrl_Config.Grid Profile.country.28": "Таїланд THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "Австрія AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220 (สหรัฐอเมริกา)",
  "50901.ctrl_Config.Grid Profile.country.31": "Велика Британія UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "Велика Британія UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "Велика Британія UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "Велика Британія UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "В'єтнам VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "Панама PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "Бразилія BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "Пуерто-Рико LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "Пуерто-Рико LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "Польща PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "Індія IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "Румунія RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "Китай CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "Ірак IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V (สหรัฐอเมริกา)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V (สหรัฐอเมริกา)",
  "50901.ctrl_Config.Grid Profile.country.46": "Саудівська Аравія SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "Шрі-Ланка LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "Чеська Республіка CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "Бельгія BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "Естонія EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "Нідерланди NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "Україна UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "Канада CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "Канада CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "Малайзія MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "Індонезія ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "Південна Африка ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "Швеція SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "Греція GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "Люксембург LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "Угорщина HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "Ірландія IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "Замбія ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "Генератор GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "Генератор GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "Саудівська Аравія SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "Сербія SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "Швейцарія CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "Ліван LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "Чилі CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "Сирія SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "Австралія AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "Австралія AU_AS4777_C",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547 (สหรัฐอเมริกา)",
  "50901.ctrl_Config.Grid Profile.country.18": "Сполучені Штати USHECO_Rule14 (Гаваї)",
  "50901.ctrl_Config.Grid Profile.country.29": "Тест США LX_US_50Hz",
  "alarm.trigger.condition": "ถูกกระตุ้นโดยอุปกรณ์",
  "alarm.iot": "IoT เสียงเตือน",
  "module.alarmInfo": "ข้อมูลการแจ้งเตือน",
  "edit.failed": "แก้ไขไม่สำเร็จ",
  "tag_test_3": "tag_test_3",
  "Transit_Warehouse": "คลังสินค้าขนส่งผ่าน",
  "bw_Param_strl_option_GridUseMeter": "ระบบโครงข่ายไฟฟ้าใช้มิเตอร์ไฟฟ้า",
  "bw_Param_strl_option_GridUseCT": "ระบบโครงข่ายไฟฟ้าใช้ CT",
  "50901.fault.dSPSAFcomparatorFault": "ข้อบกพร่องของตัวเปรียบเทียบ",
  "50901.fault.dSPPWRfanFault": "ข้อบกพร่องของพัดลม",
  "50901.fault.dSPPWRgridRelayProtection": "การป้องกันรีเลย์กริดทำงาน",
  "50901.fault.dSPPWRmachineTypeMismatch": "ประเภทเครื่องไม่ตรงกัน",
  "50901.fault.dSPSAFbatteryFault": "ข้อบกพร่องของแบตเตอรี่",
  "50901.fault.dSPSAFfanFault": "ข้อบกพร่องของพัดลม",
  "50901.fault.dSPSAFgridRelayProtection": "การกระตุ้นการป้องกันรีเลย์โครงข่าย",
  "50901.fault.dSPPWRbatteryFault": "ข้อบกพร่องด้านแบตเตอรี่",
  "50901.fault.dSPPWRcomparatorFault": "คอมพาราเตอร์ขัดข้อง",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "ความผิดปกติของไฟเลี้ยงเสริม",
  "50901.fault.dSPSAFmachineTypeMismatch": "ประเภทเครื่องไม่ตรงกัน",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "ความผิดปกติของอคติการสุ่มตัวอย่าง",
  "50901.fault.canCommunicationTimeout": "การหมดเวลาการสื่อสาร Can",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "ไฟเลี้ยงเสริมผิดปกติ",
  "50901.fault.dSPSAFarmCommunicationFault": "ข้อบกพร่องการสื่อสาร Arm",
  "50901.fault.dSPSAFspiCommunicationFault": "ข้อบกพร่องการสื่อสาร Spi",
  "50901.fault.dSPSAFversionMismatch": "เวอร์ชันไม่ตรงกัน",
  "50901.fault.dSPPWRarmCommunicationFault": "ข้อบกพร่องการสื่อสาร Arm",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "ความผิดปกติของอคติการสุ่มตัวอย่าง",
  "50901.fault.dSPPWRspiCommunicationFault": "ข้อบกพร่องการสื่อสาร Spi",
  "50901.fault.dSPPWRversionMismatch": "เวอร์ชันไม่ตรงกัน (ความไม่สอดคล้องของเวอร์ชันซอฟต์แวร์/ฮาร์ดแวร์)",
  "50901.fault.hardwareProtection": "การกระตุ้นการป้องกันฮาร์ดแวร์",
  "50901.fault.lowBatteryEnergy": "พลังงานแบตเตอรี่ต่ำเกินไป",
  "50901.fault.dSPPWRgridRelayProtection.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRgridRelayProtection.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRbatteryFault.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRcomparatorFault.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRcomparatorFault.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRfanFault.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRfanFault.1": "เปิดใช้งาน",
  "50901.fault.canCommunicationTimeout.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRarmCommunicationFault.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRarmCommunicationFault.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRbatteryFault.0": "ปิดใช้งาน",
  "50901.fault.canCommunicationTimeout.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "เปิดใช้งาน",
  "50901.fault.hardwareProtection.1": "เปิดใช้งาน",
  "50901.fault.lowBatteryEnergy.0": "ปิดใช้งาน",
  "50901.fault.lowBatteryEnergy.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFspiCommunicationFault.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFspiCommunicationFault.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFversionMismatch.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFversionMismatch.1": "เปิดใช้งาน",
  "50901.fault.hardwareProtection.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFarmCommunicationFault.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFgridRelayProtection.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFbatteryFault.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFbatteryFault.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFcomparatorFault.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFcomparatorFault.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFfanFault.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFfanFault.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRversionMismatch.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRversionMismatch.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFarmCommunicationFault.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dSPPWRspiCommunicationFault.0": "ปิดใช้งาน",
  "50901.fault.dSPPWRspiCommunicationFault.1": "เปิดใช้งาน",
  "50901.fault.dSPSAFgridRelayProtection.0": "ปิดใช้งาน",
  "50901..数据分析_电网功率.tag": "พลังงานตาราง",
  "50901.real_time.数据分析_AC光伏功率.tag": "กำลังไฟฟ้าพีวีเอซี",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "กำลังไฟฟ้าจริงพีวีเอซี",
  "50901.real_time.数据分析_EPS电压.tag": "แรงดันไฟฟ้า eps",
  "50901.real_time.数据分析_混逆光伏电流.tag": "กระแสไฟฟ้าพีวีของอินเวอร์เตอร์ไฮบริด",
  "50901..数据分析_单体SOC.tag": "Soc ของเซลล์เดี่ยว",
  "50901..数据分析_发电机功率.tag": "พลังงานเครื่องกำเนิดไฟฟ้า",
  "50901..数据分析_混逆光伏功率.tag": "กำลังไฟฟ้า Pv ของอินเวอร์เตอร์ไฮบริด",
  "50901..数据分析_电池包.tag": "แบตเตอรี่",
  "50901..数据分析_电网电压.tag": "แรงดันไฟฟ้าจากโครงข่าย",
  "50901..数据分析_电网电流.tag": "กระแสตาราง",
  "50901.Backup": "สำรอง",
  "50901.Battery": "แบตเตอรี่",
  "50901.ClockSetting": "การตั้งค่านาฬิกา",
  "50901.Connection": "การเชื่อมต่อการสื่อสาร",
  "50901.ctrl_Config": "การควบคุมการเชื่อมต่อการสื่อสาร",
  "50901.ctrl_Config.Device.networkingType.1": "ไวไฟ",
  "50901.ctrl_Config.Device.networkingType.2": "อีเธอร์เน็ต",
  "50901.ctrl_Dry_Contact": "การตั้งค่ารายชื่อแห้ง",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "คำอธิบายชั่วโมงเริ่มการประจุของการควบคุมเครื่องปั่นไฟ - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "คำอธิบายนาทีเริ่มการประจุของการควบคุมเครื่องปั่นไฟ - นาที",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "คำอธิบายความจุแบตเตอรี่ปิดเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "คำอธิบายความจุแบตเตอรี่สตาร์ทเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "คำอธิบายความถี่โหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "คำอธิบายเวลาทำงานของโหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "คำอธิบายเวลาเริ่มต้นของโหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "คำอธิบายการเปิดใช้งานเวลาสแตนด์บาย",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "โหมดเปิดใช้ SOC สำหรับแบตเตอรี่ปั๊มความร้อน 0: ปิดใช้งาน 1: เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "กำลังป้อนกลับเข้าสูงสุดของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "เมื่อระยะเวลาการทำงานครั้งเดียวถึงค่านี้ โหมดควบคุมปั๊มความร้อนจะถูกปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "เมื่อค่า SOC ของแบตเตอรี่ถึงค่านี้ โหมดควบคุมปั๊มความร้อนจะถูกเปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "อ่าน เขียน และรายงาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "สามารถตั้งค่าได้สูงสุด 4 ช่วงเวลาการทำงาน",
  "50901.ctrl_ESS_Advanced_Config": "การกำหนดค่าขั้นสูง",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "คำอธิบายกำลังคายประจุสูงสุดของแบตเตอรี่ในช่วงพีค",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "คำอธิบายกำลังป้อนเข้าสู่โครงข่ายในช่วงพีค",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "คำอธิบายกำลังชาร์จสูงสุดของแบตเตอรี่",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "คำอธิบายกำลังคายประจุสูงสุดของแบตเตอรี่",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "คำอธิบายเวลาบำรุงรักษาแบตเตอรี่ตะกั่ว-กรด",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "คำอธิบาย soc สูงสุด",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "คำอธิบาย soc ต่ำสุด",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "คำอธิบายการชดเชยกำลังไฟฟ้า",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "คำอธิบายกำลังสำรอง rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "คำอธิบายการปิดใช้งานบายพาส",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "คำอธิบายโหมด eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "คำอธิบายการเปิดใช้งานโหมดพีวี",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "คำอธิบายโหมดพอร์ตเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "คำอธิบายตำแหน่งเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "คำอธิบายเวลาหน่วงการปิดเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "คำอธิบายเวลาซิงโครไนซ์เครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "คำอธิบายประเภทเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "คำอธิบายเวลาทำงานสูงสุด",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "คำอธิบายเวลาทำงานต่ำสุด",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "คำอธิบายช่วงเวลาป้องกันการทำงาน",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "คำอธิบายการเปิดใช้งานการสแกนทั่วโลก",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "คำอธิบายการเปิดใช้งานการกลับทิศทางกริดซีที",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "คำอธิบายการตั้งค่าอัตราส่วนรอบมิเตอร์กริดซีที",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "คำอธิบายการจำกัดกำลังไฟฟ้าจากโครงข่าย",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "คำอธิบายรุ่นมิเตอร์",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "คำอธิบายการเปิดใช้งาน mid / เกตเวย์",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "คำอธิบายการเปิดใช้งานการกลับทิศทางพีวีซีที",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "คำอธิบายการตั้งค่าอัตราส่วนรอบมิเตอร์พีวีซีที",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "คำอธิบายการเปิดใช้งานความไม่สมดุลสามเฟส",
  "50901.ctrl_Safety": "กฎระเบียบด้านความปลอดภัย",
  "50901.DCI": "การแยกดีซี",
  "50901.Device": "อุปกรณ์",
  "50901.economic": "โหมดประหยัด",
  "50901.EPS": "แหล่งจ่ายไฟฉุกเฉิน",
  "50901.Fault": "ข้อบกพร่อง",
  "50901.Fault.arcFault.0": "ปิดใช้งาน",
  "50901.Fault.arcFault.1": "เปิดใช้งาน",
  "50901.Fault.arcSelfTestFault.0": "ปิดใช้งาน",
  "50901.Fault.arcSelfTestFault.1": "เปิดใช้งาน",
  "50901.Fault.batteryCapacityAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.batteryCapacityAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.batteryForceChargeRequest.0": "ปิดใช้งาน",
  "50901.Fault.batteryForceChargeRequest.1": "เปิดใช้งาน",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.busbarAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.busbarAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.cmpssBiasCalculationError.0": "ปิดใช้งาน",
  "50901.Fault.cmpssBiasCalculationError.1": "เปิดใช้งาน",
  "50901.Fault.driveAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.driveAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dspSafCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dspSafCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtsCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtsCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.e2rpomFault.0": "ปิดใช้งาน",
  "50901.Fault.e2rpomFault.1": "เปิดใช้งาน",
  "50901.Fault.epsOverload.0": "ปิดใช้งาน",
  "50901.Fault.epsOverload.1": "เปิดใช้งาน",
  "50901.Fault.epsRelayProtection.0": "ปิดใช้งาน",
  "50901.Fault.epsRelayProtection.1": "เปิดใช้งาน",
  "50901.Fault.epsVoltageAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.epsVoltageAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.evCharger1Fault.0": "ปิดใช้งาน",
  "50901.Fault.evCharger1Fault.1": "เปิดใช้งาน",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.evCharger2Fault.0": "ปิดใช้งาน",
  "50901.Fault.evCharger2Fault.1": "เปิดใช้งาน",
  "50901.Fault.fanSpeedAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.fanSpeedAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.flashCommunicationFault.0": "ปิดใช้งาน",
  "50901.Fault.flashCommunicationFault.1": "เปิดใช้งาน",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "ปิดใช้งาน",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "เปิดใช้งาน",
  "50901.Fault.genAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.genAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.genOverload.0": "ปิดใช้งาน",
  "50901.Fault.genOverload.1": "เปิดใช้งาน",
  "50901.fault.genRelayAFault.0": "ปิดใช้งาน",
  "50901.fault.genRelayAFault.1": "เปิดใช้งาน",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "ปิดใช้งาน",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "เปิดใช้งาน",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.gridMeterTypeError.0": "ปิดใช้งาน",
  "50901.Fault.gridMeterTypeError.1": "เปิดใช้งาน",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "ปิดใช้งาน",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "เปิดใช้งาน",
  "50901.Fault.gridOverfrequency.0": "ปิดใช้งาน",
  "50901.Fault.gridOverfrequency.1": "เปิดใช้งาน",
  "50901.Fault.gridOvervoltage.0": "ปิดใช้งาน",
  "50901.Fault.gridOvervoltage.1": "เปิดใช้งาน",
  "50901.fault.gridPortOvercurrent.0": "ปิดใช้งาน",
  "50901.fault.gridPortOvercurrent.1": "เปิดใช้งาน",
  "50901.Fault.gridPowerOutage.0": "ปิดใช้งาน",
  "50901.Fault.gridPowerOutage.1": "เปิดใช้งาน",
  "50901.Fault.gridUnderfrequency.0": "ปิดใช้งาน",
  "50901.Fault.gridUnderfrequency.1": "เปิดใช้งาน",
  "50901.Fault.gridUndervoltage.0": "ปิดใช้งาน",
  "50901.Fault.gridUndervoltage.1": "เปิดใช้งาน",
  "50901.Fault.gridVoltageAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.gridVoltageAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.hmidCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.hmidCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.hmidMachineFault.0": "ปิดใช้งาน",
  "50901.Fault.hmidMachineFault.1": "เปิดใช้งาน",
  "50901.Fault.insulationFault.0": "ปิดใช้งาน",
  "50901.Fault.insulationFault.1": "เปิดใช้งาน",
  "50901.Fault.interruptOverflow.0": "ปิดใช้งาน",
  "50901.Fault.interruptOverflow.1": "เปิดใช้งาน",
  "50901.fault.inverterCanCommunicationFailed.0": "ปิดใช้งาน",
  "50901.fault.inverterCanCommunicationFailed.1": "เปิดใช้งาน",
  "50901.Fault.lineToEarthFault.0": "ปิดใช้งาน",
  "50901.Fault.lineToEarthFault.1": "เปิดใช้งาน",
  "50901.fault.loadRelayAFault.0": "ปิดใช้งาน",
  "50901.fault.loadRelayAFault.1": "เปิดใช้งาน",
  "50901.fault.loadRelayBFault.0": "ปิดใช้งาน",
  "50901.fault.loadRelayBFault.1": "เปิดใช้งาน",
  "50901.Fault.lowAmbientTemperature.0": "ปิดใช้งาน",
  "50901.Fault.lowAmbientTemperature.1": "เปิดใช้งาน",
  "50901.Fault.lowDtuVersion.0": "ปิดใช้งาน",
  "50901.Fault.lowDtuVersion.1": "เปิดใช้งาน",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.meterWiringAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.meterWiringAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.microelectronicFault.0": "ปิดใช้งาน",
  "50901.Fault.microelectronicFault.1": "เปิดใช้งาน",
  "50901.Fault.neutralWireNotConnected.0": "ปิดใช้งาน",
  "50901.Fault.neutralWireNotConnected.1": "เปิดใช้งาน",
  "50901.Fault.neutralWireToEarthFault.0": "ปิดใช้งาน",
  "50901.Fault.neutralWireToEarthFault.1": "เปิดใช้งาน",
  "50901.Fault.overTemperature.0": "ปิดใช้งาน",
  "50901.Fault.overTemperature.1": "เปิดใช้งาน",
  "50901.fault.overtemperatureAlarm.0": "ปิดใช้งาน",
  "50901.fault.overtemperatureAlarm.1": "เปิดใช้งาน",
  "50901.Fault.pllLockFailed.0": "ปิดใช้งาน",
  "50901.Fault.pllLockFailed.1": "เปิดใช้งาน",
  "50901.Fault.preSynchronizationFailed.0": "ปิดใช้งาน",
  "50901.Fault.preSynchronizationFailed.1": "เปิดใช้งาน",
  "50901.Fault.pvFault.0": "ปิดใช้งาน",
  "50901.Fault.pvFault.1": "เปิดใช้งาน",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.pvMeterTypeError.0": "ปิดใช้งาน",
  "50901.Fault.pvMeterTypeError.1": "เปิดใช้งาน",
  "50901.fault.pvRelayAbFault.0": "ปิดใช้งาน",
  "50901.fault.pvRelayAbFault.1": "เปิดใช้งาน",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "ปิดใช้งาน",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "เปิดใช้งาน",
  "50901.Fault.rcdFault.0": "ปิดใช้งาน",
  "50901.Fault.rcdFault.1": "เปิดใช้งาน",
  "50901.Fault.rcdSelfTestFault.0": "ปิดใช้งาน",
  "50901.Fault.rcdSelfTestFault.1": "เปิดใช้งาน",
  "50901.Fault.reconnectionFailed.0": "ปิดใช้งาน",
  "50901.Fault.reconnectionFailed.1": "เปิดใช้งาน",
  "50901.Fault.shutDown.0": "ปิดใช้งาน",
  "50901.Fault.shutDown.1": "เปิดใช้งาน",
  "50901.Fault.slaveWrongBatteryConnection.0": "ปิดใช้งาน",
  "50901.Fault.slaveWrongBatteryConnection.1": "เปิดใช้งาน",
  "50901.fault.smartloadPortOvercurrent.0": "ปิดใช้งาน",
  "50901.fault.smartloadPortOvercurrent.1": "เปิดใช้งาน",
  "50901.Fault.sustainedNegativeLoad.0": "ปิดใช้งาน",
  "50901.Fault.sustainedNegativeLoad.1": "เปิดใช้งาน",
  "50901.Fault.temperatureAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.temperatureAbnormality.1": "เปิดใช้งาน",
  "50901.Fault.tenMinuteOvervoltage.0": "ปิดใช้งาน",
  "50901.Fault.tenMinuteOvervoltage.1": "เปิดใช้งาน",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "ปิดใช้งาน",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "เปิดใช้งาน",
  "50901.Fault.wiringAbnormality.0": "ปิดใช้งาน",
  "50901.Fault.wiringAbnormality.1": "เปิดใช้งาน",
  "50901.forceCharge": "การประจุแบบบังคับ",
  "50901.forceDischarge": "การคายประจุแบบบังคับ",
  "50901.FRT": "การทนแรงดันตกชั่วขณะทางความถี่",
  "50901.FW": "การเลื่อนความถี่",
  "50901.Gateway": "เกตเวย์",
  "50901.Generator": "เครื่องปั่นไฟ",
  "50901.Grid Profile": "พารามิเตอร์โครงข่ายไฟฟ้า",
  "50901.HeatPump": "การควบคุมปั๊มความร้อน",
  "50901.peakMeter": "การวัดค่าพีค",
  "50901.PV": "ชินท์ เฟสเดียว",
  "50901.RCD": "การป้องกันกระแสรั่วไหล",
  "50901.real_time": "ความหมายของค่า Enum 0",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "คำอธิบายเวอร์ชัน dsp (เวอร์ชัน u หลัก)",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "กำลังไฟฟ้ารีแอกทีฟพีวีเอซี",
  "50901.real_time.数据分析_AC光伏电压.tag": "แรงดันไฟฟ้าพีวีเอซี",
  "50901.real_time.数据分析_AC光伏电流.tag": "กระแสไฟฟ้าพีวีเอซี",
  "50901.real_time.数据分析_EPS功率.tag": "กำลังไฟฟ้า eps",
  "50901.real_time.数据分析_EPS电流.tag": "กระแสไฟฟ้า eps",
  "50901.real_time.数据分析_发电机电压.tag": "แรงดันไฟฟ้าของเครื่องปั่นไฟ",
  "50901.real_time.数据分析_发电机电流.tag": "กระแสไฟฟ้าของเครื่องปั่นไฟ",
  "50901.real_time.数据分析_混逆光伏功率.tag": "กำลังไฟฟ้าพีวีของอินเวอร์เตอร์ไฮบริด",
  "50901.real_time.数据分析_混逆光伏电压.tag": "แรงดันไฟฟ้าพีวีของอินเวอร์เตอร์ไฮบริด",
  "50901.RPC": "ไม่",
  "50901.RR": "อัตราการเปลี่ยนแปลง",
  "50901.RT": "ความหมายของค่า Enum 0",
  "50901.Settings": "โหมดการทำงาน",
  "50901.Settings-Load_Control": "การควบคุมโหลด",
  "50901.Settings-Manual_Control": "ความหมายของค่า Enum 0",
  "50901.Switch": "การสลับโหมด",
  "50901.System": "ความหมายของค่า Enum 0",
  "50901.VRT": "ความหมายของค่า Enum 0",
  "50901.VW": "การเลื่อนแรงดัน",
  "50901.warning": "การควบคุมปั๊มความร้อน",
  "50901.warning.batteryHighVoltageAlarm.0": "ปิดใช้งาน",
  "50901.warning.batteryHighVoltageAlarm.1": "เปิดใช้งาน",
  "50901.warning.batteryLowVoltageAlarm.0": "ปิดใช้งาน",
  "50901.warning.batteryLowVoltageAlarm.1": "เปิดใช้งาน",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "ปิดใช้งาน",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "เปิดใช้งาน",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "ปิดใช้งาน",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "เปิดใช้งาน",
  "50901.warning.chargeHighTemperatureAlarm.0": "ปิดใช้งาน",
  "50901.warning.chargeHighTemperatureAlarm.1": "เปิดใช้งาน",
  "50901.warning.chargeLowTemperatureAlarm.0": "ปิดใช้งาน",
  "50901.warning.chargeLowTemperatureAlarm.1": "เปิดใช้งาน",
  "50901.warning.dischargeHighTemperatureAlarm.0": "ปิดใช้งาน",
  "50901.warning.dischargeHighTemperatureAlarm.1": "เปิดใช้งาน",
  "50901.warning.dischargeLowTemperatureAlarm.0": "ปิดใช้งาน",
  "50901.warning.dischargeLowTemperatureAlarm.1": "เปิดใช้งาน",
  "50901.warning.inputOvervoltageAlarm.0": "ปิดใช้งาน",
  "50901.warning.inputOvervoltageAlarm.1": "เปิดใช้งาน",
  "50901..cfgMultPcsBmsFlag.0": "ไม่",
  "50901..cfgMultPcsBmsFlag.1": "ใช่",
  "50901..connectionRouterStatus.0": "ไม่ได้เชื่อมต่อ",
  "50901..connectionRouterStatus.1": "เชื่อมต่อแล้ว",
  "50901..connectionRouterStatus.3": "ไม่ได้เชื่อมต่อ",
  "50901..connectionServerStatus.0": "ไม่ได้เชื่อมต่อ",
  "50901..connectionServerStatus.1": "เชื่อมต่อแล้ว",
  "50901..connectionServerStatus.2": "เชื่อมต่อแล้ว",
  "50901..connectionServerStatus.3": "ไม่ได้เชื่อมต่อ",
  "50901..hpTime2WeekRange1.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange1.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange2.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange2.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange3.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange3.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange4.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange4.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange5.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange5.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange6.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange6.1": "เปิดใช้งาน",
  "50901..hpTime2WeekRange7.0": "ปิดใช้งาน",
  "50901..hpTime2WeekRange7.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange1.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange1.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange2.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange2.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange3.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange3.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange4.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange4.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange5.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange5.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange6.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange6.1": "เปิดใช้งาน",
  "50901..hpTime3WeekRange7.0": "ปิดใช้งาน",
  "50901..hpTime3WeekRange7.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange1.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange1.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange2.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange2.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange3.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange3.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange4.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange4.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange5.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange5.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange6.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange6.1": "เปิดใช้งาน",
  "50901..hpTime4WeekRange7.0": "ปิดใช้งาน",
  "50901..hpTime4WeekRange7.1": "เปิดใช้งาน",
  "50901..materType.0": "ไม่มีมิเตอร์ฝั่งโครงข่าย",
  "50901..materType.1": "Zhengtai เฟสเดียว",
  "50901..materType.2": "ชินท์ เฟสเดียว",
  "50901..materType.3": "Zhengtai แยกเฟส",
  "50901..materType.5": "โมดูลการวัดค่า",
  "50901..materType.6": "ถนนเดียว Ankerui",
  "50901..materType.7": "ถนน Ankerui คู่",
  "50901..section1WeekRange1.0": "วันจันทร์",
  "50901..section1WeekRange1.1": "วันอังคาร",
  "50901..section1WeekRange1.2": "วันพุธ",
  "50901..section1WeekRange1.3": "วันพฤหัสบดี",
  "50901..section1WeekRange1.4": "วันศุกร์",
  "50901..section1WeekRange1.5": "วันเสาร์",
  "50901..section1WeekRange1.6": "วันอาทิตย์",
  "50901..section1WeekRange2.0": "ความหมายของค่า Enum 0",
  "50901..section1WeekRange2.1": "ความหมายของค่า Enum 1",
  "50901..section2WeekRange1.0": "ความหมายของค่า Enum 0",
  "50901..section2WeekRange1.1": "ความหมายของค่า Enum 2",
  "50901..section3WeekRange1.0": "ความหมายของค่า Enum 0",
  "50901..section3WeekRange1.1": "ความหมายของค่า Enum 2",
  "50901..section4WeekRange1.0": "ความหมายของค่า Enum 0",
  "50901..section4WeekRange1.1": "ความหมายของค่านับ 2",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "ไม่",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "ใช่",
  "50901.ctrl_Config.Device.masterSlave.0": "หน่วยเดียว",
  "50901.ctrl_Config.Device.masterSlave.1": "มาสเตอร์",
  "50901.ctrl_Config.Device.masterSlave.2": "สเลฟ",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "ปิด",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "แมนนวล",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "อัตโนมัติ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "ไม่มี",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "รายสัปดาห์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "ทุก 2 สัปดาห์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "ทุก 3 สัปดาห์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "ทุก 4 สัปดาห์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "ไม่",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "ใช่",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "ไม่",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "ใช่",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "ไม่",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "ใช่",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "แมนนวล",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "โหมดเวลา",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "โหลดอัจฉริยะ",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "โหลดอัจฉริยะนอกระบบ",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "เครื่องชาร์จ ev",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "การควบคุมปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "ไม่",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "ใช่",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "ไม่มี",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "ข้อบกพร่องสายดิน",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "การควบคุมโหลด",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "เครื่องปั่นไฟ",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "ความหมายของค่านับ 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "ความหมายของค่า Enum 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "ปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "ความหมายของค่านับ 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "ความหมายของค่า Enum 1",
  "50901.fault.emergencyStopSwitchStatus.0": "ปิดใช้งาน",
  "50901.fault.emergencyStopSwitchStatus.1": "เปิดใช้งาน",
  "50901.fault.fiveVoltPowerSupplyFault.0": "ปิดใช้งาน",
  "50901.fault.fiveVoltPowerSupplyFault.1": "เปิดใช้งาน",
  "50901.fault.genPortOvercurrent.0": "ปิดใช้งาน",
  "50901.fault.genPortOvercurrent.1": "เปิดใช้งาน",
  "50901.fault.genRelayBFault.0": "ปิดใช้งาน",
  "50901.fault.genRelayBFault.1": "เปิดใช้งาน",
  "50901.fault.gridMeter.0": "ปิดใช้งาน",
  "50901.fault.gridMeter.1": "เปิดใช้งาน",
  "50901.fault.inverterCommunicationFailed.0": "ปิดใช้งาน",
  "50901.fault.inverterCommunicationFailed.1": "เปิดใช้งาน",
  "50901.fault.kmRelayFault.0": "ปิดใช้งาน",
  "50901.fault.kmRelayFault.1": "เปิดใช้งาน",
  "50901.fault.pvPortOvercurrent.0": "ปิดใช้งาน",
  "50901.fault.pvPortOvercurrent.1": "เปิดใช้งาน",
  "50901.fault.twelveVoltPowerSupplyFault.0": "ปิดใช้งาน",
  "50901.fault.twelveVoltPowerSupplyFault.1": "เปิดใช้งาน",
  "50901.real_time.batteryConnectionStatus.0": "ไม่",
  "50901.real_time.batteryConnectionStatus.1": "ใช่",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.0": "ไม่มีแบตเตอรี่",
  "50901.real_time.batteryType_04.1": "แบตเตอรี่ลิเธียม",
  "50901.real_time.batteryType_04.2": "แบตเตอรี่ตะกั่วกรด",
  "50901.real_time.batteryWorkingStatus.00": "สแตนด์บาย",
  "50901.real_time.batteryWorkingStatus.01": "กำลังชาร์จ",
  "50901.real_time.batteryWorkingStatus.02": "กำลังคายประจุ",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "ปลดล็อคขีดจำกัดกำลัง, โหมดเริ่มต้น",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "กำลังไฟฟ้าอินเวอร์เตอร์เป็น 0, นอกระบบ",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "กำลังชาร์จ Pc=0, ไม่ใช่นอกระบบ",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "กำลังชาร์จ Pc<50%Pn กำลังไฟฟ้าที่กำหนด",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "กำลังชาร์จ Pc<75%Pn กำลังไฟฟ้าที่กำหนด && กำลังไฟฟ้ารีแอกทีฟ Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "กำลังชาร์จ Pc, ไม่จำกัด",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "กำลังคายประจุ P=0, ไม่ใช่นอกระบบ",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "กำลังคายประจุ P<50%Pn กำลังไฟฟ้าที่กำหนด",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "กำลังคายประจุ P<75%Pn กำลังไฟฟ้าที่กำหนด && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "กำลังคายประจุ P, ไม่จำกัด",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "กำลังชาร์จ Pc<50%Pn กำลังไฟฟ้าที่กำหนด --> กำลังชาร์จลดลงเหลือ 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "กำลังชาร์จ Pc<50%Pn กำลังไฟฟ้าที่กำหนด && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "กำลังคายประจุ P<50%Pn กำลังไฟฟ้าที่กำหนด --> กำลังคายประจุลดลงเหลือ 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "กำลังชาร์จ Pc<50%Pn กำลังไฟฟ้าที่กำหนด && Q=-Qmax",
  "50901.real_time.meterFlag.0": "ออฟไลน์",
  "50901.real_time.meterFlag.1": "ออนไลน์",
  "50901.real_time.meterFlag.3": "การสื่อสารเกตเวย์ปกติ",
  "50901.real_time.meterFlag.4": "การสื่อสารเกตเวย์ตัดการเชื่อมต่อ",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "เจ็ด",
  "50901.real_time.packNum.15": "สี่",
  "50901.real_time.packNum.16383": "สิบสี่",
  "50901.real_time.packNum.2047": "สิบหนึ่ง",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "สอง",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "สิบห้า",
  "50901.real_time.packNum.4095": "สิบสอง",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "หก",
  "50901.real_time.packNum.65535": "สิบหก",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "สิบสาม",
  "50901.real_time.relayStatus.00": "ฟีด km1",
  "50901.real_time.relayStatus.01": "ฟีด km1",
  "50901.real_time.relayStatus.02": "ฟีดเครื่องปั่นไฟ a",
  "50901.real_time.relayStatus.03": "ฟีดเครื่องปั่นไฟ a",
  "50901.real_time.relayStatus.04": "ฟีดเครื่องปั่นไฟ b",
  "50901.real_time.relayStatus.05": "ฟีดเครื่องปั่นไฟ b",
  "50901.real_time.relayStatus.06": "ฟีดเครื่องปั่นไฟ ab",
  "50901.real_time.relayStatus.07": "ฟีดเครื่องปั่นไฟ ab",
  "50901.real_time.relayStatus.08": "ฟีดโหลดสำคัญ a",
  "50901.real_time.relayStatus.09": "ฟีดโหลดสำคัญ a",
  "50901.real_time.relayStatus.10": "ฟีดโหลดสำคัญ b",
  "50901.real_time.relayStatus.11": "ฟีดโหลดสำคัญ b",
  "50901.real_time.relayStatus.12": "สงวนไว้",
  "50901.real_time.relayStatus.13": "สงวนไว้",
  "50901.real_time.relayStatus.14": "สงวนไว้",
  "50901.real_time.relayStatus.15": "สงวนไว้",
  "50901.real_time.workStatus.00": "การเริ่มต้นระบบไฟฟ้า",
  "50901.real_time.workStatus.01": "โหมดสแตนด์บาย",
  "50901.real_time.workStatus.02": "ทดสอบการเชื่อมต่อโครงข่าย",
  "50901.real_time.workStatus.03": "โหมดเชื่อมต่อโครงข่าย",
  "50901.real_time.workStatus.04": "โหมดข้อบกพร่อง",
  "50901.real_time.workStatus.05": "โหมดนอกระบบ",
  "50901.real_time.workStatus.06": "โหมดบายพาส",
  "50901..antiIslandingEnable.0": "ปิดใช้งาน",
  "50901..antiIslandingEnable.1": "เปิดใช้งาน",
  "50901..apcEn.0": "ปิดใช้งาน",
  "50901..apcEn.1": "เปิดใช้งาน",
  "50901..drmEnable.0": "ปิดใช้งาน",
  "50901..drmEnable.1": "เปิดใช้งาน",
  "50901..parallelNetworking.0": "ไม่ถูกต้อง",
  "50901..parallelNetworking.1": "กำลังสร้างเครือข่าย",
  "50901..parallelNetworking.2": "ยกเลิกเครือข่าย",
  "50901..permitEnable.0": "ปิดใช้งาน",
  "50901..permitEnable.1": "เปิดใช้งาน",
  "50901..phaseOrderInverseDisable.0": "ปิดใช้งาน",
  "50901..phaseOrderInverseDisable.1": "เปิดใช้งาน",
  "50901..relayU16NlineRlyTestDis.0": "ปิดใช้งาน",
  "50901..relayU16NlineRlyTestDis.1": "เปิดใช้งาน",
  "50901.ctrl_Config.ClockSetting.clockSet": "ระยะเวลาการตั้งนาฬิกา",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "ปิดใช้งาน",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "เปิดใช้งาน",
  "50901.ctrl_Config.Device.arcfaultClear.0": "ไม่",
  "50901.ctrl_Config.Device.arcfaultClear.1": "ใช่",
  "50901.ctrl_Config.Device.batActivate.0": "ไม่",
  "50901.ctrl_Config.Device.batActivate.1": "ใช่",
  "50901.ctrl_Config.Device.batteryBalancing.0": "ไม่",
  "50901.ctrl_Config.Device.batteryBalancing.1": "ใช่",
  "50901.ctrl_Config.Device.checkTime": "เวลาอุปกรณ์",
  "50901.ctrl_Config.Device.clearfault.0": "ไม่",
  "50901.ctrl_Config.Device.clearfault.1": "ใช่",
  "50901.ctrl_Config.Device.networkingType": "ประเภทการเชื่อมต่อโครงข่าย",
  "50901.ctrl_Config.Device.restartSystem.0": "ไม่",
  "50901.ctrl_Config.Device.restartSystem.1": "ใช่",
  "50901.ctrl_Config.Device.restoreDefault.0": "ไม่",
  "50901.ctrl_Config.Device.restoreDefault.1": "ใช่",
  "50901.ctrl_Config.Device.selfTest.0": "ไม่",
  "50901.ctrl_Config.Device.selfTest.1": "ใช่",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "หยุดระบบ",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "เริ่มระบบ",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "การชาร์จเครื่องกำเนิดไฟฟ้าห้อง",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "เครื่องกำเนิดไฟฟ้าห้องสแตนด์บาย 1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "สแตนด์บายเครื่องกำเนิดไฟฟ้า Dry Contact 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "โหมดปฏิบัติเครื่องกำเนิดไฟฟ้า เวลาเริ่มต้น",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "ระยะเวลาปั๊มความร้อน 1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "ช่วงเวลาปั๊มความร้อน 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "ระยะเวลาปั๊มความร้อน 3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "ระยะเวลาปั๊มความร้อน 4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "ตัวจับเวลา Dry Contact 1 ช่วงที่ 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "ระยะเวลา Node แห้ง 1 ระยะเวลา 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "เวลา Node แห้ง 2 ระยะเวลา 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "ตัวจับเวลา Dry Contact 2 ช่วงที่ 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "ระยะเวลา Node แห้ง 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "ระยะเวลา Node แห้ง 2",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "ไม่",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "ใช่",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "แหล่งจ่ายไฟฉุกเฉิน",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "เครื่องสำรองไฟ",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "ไม่",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "ใช่",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "ห้าม",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "พีวีภายนอก",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "เครื่องปั่นไฟภายนอก",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "เริ่มต้นแบบบังคับ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "การควบคุมในพื้นที่",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "ไม่มี",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "ฝั่งเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "ฝั่งโครงข่าย",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "แมนนวล",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "เปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "ไม่ได้ใช้มิเตอร์",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "มิเตอร์เฟสเดียว",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "มิเตอร์สองเฟส",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "มิเตอร์สามเฟส",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "มิเตอร์อัจฉริยะ (hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "หม้อแปลงกระแสไฟฟ้า (ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "มิเตอร์เฟสเดียว acrel",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "มิเตอร์สองเฟส acrel",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "เปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "ปิดใช้งาน",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.DCI.dciEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.DCI.dciEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.FW.fwEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.FW.fwEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.RPC.gcfEn.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.RPC.gcfEn.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.RPC.rpcMode.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.RPC.rpcMode.1": "ปัจจัยพลังงานคงที่, โหมด PF",
  "50901.ctrl_Safety.RPC.rpcMode.2": "พลังงานปฏิกิริยาคงที่, โหมด Q",
  "50901.ctrl_Safety.RPC.rpcMode.3": "เส้นโค้ง Pf(P), โหมด Pf(P)",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.VRT.vrtEn.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "เปิดใช้งาน",
  "50901.ctrl_Safety.VW.vwEnable.0": "ปิดใช้งาน",
  "50901.ctrl_Safety.VW.vwEnable.1": "เปิดใช้งาน",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "โหมดโหนดช่วงที่ 1 หุบเขา 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "โหมด Node ระยะเวลา 1 หุบเขาต่ำ 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "โหมด ระยะเวลา Node 1 สูงสุด 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "โหมดโหนดช่วงที่ 1 จุดสูงสุด 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "โหมด Node Period 2 หุบเขาต่ำ 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "โหมด Node Period 2 หุบเขาต่ำ 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "โหมดโหนดช่วงที่ 2 จุดสูงสุด 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "โหมด Node ระยะเวลา 2 สูงสุด 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "โหมดโหนดช่วงที่ 3 หุบเขา 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "โหมด Node ระยะเวลา 3 หุบเขาต่ำ 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "โหมด Node ระยะเวลา 3 สูงสุด 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "โหมดโหนดช่วงที่ 3 จุดสูงสุด 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "โหมด ระยะเวลา Node 4 หุบเขาต่ำ 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "โหมดโหนดช่วงที่ 4 หุบเขา 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "โหมด ระยะเวลา Node 4 สูงสุด 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "โหมด Node ระยะเวลา 4 สูงสุด 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "โหมดโหนดช่วงที่ 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "โหมด Node ระยะเวลา 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "โหมดโหนดช่วงที่ 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "โหมด Node ระยะเวลา 4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "ระยะเวลาการแบ่งปันเวลา 1 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 1 คายประจุ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "ระยะเวลาการแบ่งโหนด 2 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "ระยะเวลาการแบ่งโหนด 2 การปล่อย",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 3 ชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "ระยะเวลาการแบ่งโหนด 3 การปล่อย",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "ระยะเวลาการแบ่งปันโหนด 4 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 4 คายประจุ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "ระยะเวลาการแบ่งปันโหนด 5 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 5 คายประจุ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "ระยะเวลาการแบ่งปันโหนด 6 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "ระยะเวลาการแบ่งโหนด 6 การปล่อย",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 7 ชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "ระยะเวลาการแบ่งโหนด 7 การปล่อย",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "ระยะเวลาการแบ่งโหนด 8 การชาร์จ",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "โหนดช่วงเวลาการใช้งาน ช่วงที่ 8 คายประจุ",
  "50901.Fault.arcFault": "ข้อบกพร่องอาร์ค",
  "50901.Fault.arcSelfTestFault": "ความล้มเหลวในการตรวจสอบตนเองของอาร์ค",
  "50901.Fault.batteryCapacityAbnormality": "ความผิดปกติของความจุแบตเตอรี่",
  "50901.Fault.batteryForceChargeRequest": "คำขอการประจุแบตเตอรี่แบบบังคับ",
  "50901.Fault.bmsCanCommunicationAbnormality": "ความผิดปกติของการสื่อสาร can bms",
  "50901.Fault.busbarAbnormality": "ความผิดปกติของบัสดีซี",
  "50901.Fault.cmpssBiasCalculationError": "ข้อผิดพลาดในการคำนวณออฟเซต Cmpss",
  "50901.Fault.driveAbnormality": "ความผิดปกติของไดรฟ์",
  "50901.Fault.dspPwrCommunicationAbnormality": "ความผิดปกติของการสื่อสารพลังงาน dsp",
  "50901.Fault.dspSafCommunicationAbnormality": "ความผิดปกติของการสื่อสารที่ปลอดภัย dsp",
  "50901.Fault.dtsCommunicationAbnormality": "ความผิดปกติของการสื่อสาร dts",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu1 rs485",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu2 rs485",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu3 rs485",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu4 rs485",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu5 rs485",
  "50901.Fault.e2rpomFault": "ข้อบกพร่อง Eeprom",
  "50901.Fault.epsOverload": "การโอเวอร์โหลดของ Eps",
  "50901.Fault.epsRelayProtection": "การป้องกันรีเลย์ Eps",
  "50901.Fault.epsVoltageAbnormality": "แรงดันไฟฟ้า Eps ผิดปกติ",
  "50901.Fault.evCharger1CommunicationAbnormality": "ความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 1",
  "50901.Fault.evCharger1Fault": "ข้อบกพร่องของเครื่องชาร์จ 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "ความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 2",
  "50901.Fault.evCharger2Fault": "ข้อบกพร่องของเครื่องชาร์จ 2",
  "50901.Fault.fanSpeedAbnormality": "ความผิดปกติของความเร็วพัดลม",
  "50901.Fault.flashCommunicationFault": "ข้อบกพร่องการสื่อสารหน่วยความจำแฟลช",
  "50901.Fault.frequencyVariationRateOutOfRange": "อัตราการเปลี่ยนแปลงความถี่เกินขีดจำกัด",
  "50901.Fault.genAbnormality": "เครื่องปั่นไฟผิดปกติ",
  "50901.Fault.genOverload": "การโอเวอร์โหลดของเครื่องปั่นไฟ",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "ออฟเซตกระแสไฟตรงของกระแสไฟฟ้าโครงข่ายเกินขีดจำกัด",
  "50901.Fault.gridMeterCommunicationAbnormality": "ความผิดปกติของการสื่อสารของมิเตอร์โครงข่าย",
  "50901.Fault.gridMeterTypeError": "ข้อผิดพลาดประเภทมิเตอร์โครงข่าย",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "ออฟเซตแรงดันไฟตรงของแรงดันไฟฟ้านอกระบบเกินขีดจำกัด",
  "50901.Fault.gridOverfrequency": "ความถี่โครงข่ายเกิน",
  "50901.Fault.gridOvervoltage": "แรงดันไฟฟ้าโครงข่ายเกิน",
  "50901.Fault.gridPowerOutage": "ไฟดับจากโครงข่าย",
  "50901.Fault.gridUnderfrequency": "ความถี่โครงข่ายต่ำเกิน",
  "50901.Fault.gridUndervoltage": "แรงดันไฟฟ้าโครงข่ายต่ำเกิน",
  "50901.Fault.gridVoltageAbnormality": "แรงดันไฟฟ้าโครงข่ายผิดปกติ",
  "50901.Fault.hmidCommunicationAbnormality": "ความผิดปกติของการสื่อสาร hmi",
  "50901.Fault.hmidMachineFault": "ข้อบกพร่องของอุปกรณ์ hmi",
  "50901.Fault.insulationFault": "ข้อบกพร่องของฉนวน",
  "50901.Fault.interruptOverflow": "การล้นของอินเทอร์รัพท์",
  "50901.Fault.lineToEarthFault": "ข้อบกพร่องสายดิน (สายเฟสลงดิน)",
  "50901.Fault.lowAmbientTemperature": "อุณหภูมิแวดล้อมต่ำเกินไป",
  "50901.Fault.lowDtuVersion": "เวอร์ชัน dtu ต่ำเกินไป",
  "50901.Fault.masterSlaveCommunicationAbnormality": "ความผิดปกติของการสื่อสารมาสเตอร์-สเลฟ",
  "50901.Fault.meterWiringAbnormality": "การเดินสายมิเตอร์ผิดปกติ",
  "50901.Fault.microelectronicFault": "ข้อบกพร่องของไมโครอิเล็กทรอนิกส์",
  "50901.Fault.neutralWireNotConnected": "สายนิวทรัลไม่ได้เชื่อมต่อ",
  "50901.Fault.neutralWireToEarthFault": "ข้อบกพร่องสายนิวทรัลลงดิน",
  "50901.Fault.overTemperature": "อุณหภูมิเกิน",
  "50901.Fault.pllLockFailed": "ความล้มเหลวในการล็อก Pll",
  "50901.Fault.preSynchronizationFailed": "ความล้มเหลวในการซิงโครไนซ์ล่วงหน้า",
  "50901.Fault.pvFault": "ข้อบกพร่องของ Pv",
  "50901.Fault.pvMeterCommunicationAbnormality": "ความผิดปกติของการสื่อสารมิเตอร์พีวี",
  "50901.Fault.pvMeterTypeError": "ข้อผิดพลาดประเภทมิเตอร์พีวี",
  "50901.Fault.pvVoltageExceedingBusVoltage": "แรงดันไฟฟ้า Pv เกินแรงดันบัส",
  "50901.Fault.rcdFault": "ข้อบกพร่องของ Rcd",
  "50901.Fault.rcdSelfTestFault": "ความล้มเหลวในการตรวจสอบตนเองของ Rcd",
  "50901.Fault.reconnectionFailed": "การเชื่อมต่อใหม่ล้มเหลว",
  "50901.Fault.shutDown": "การปิดระบบ",
  "50901.Fault.slaveWrongBatteryConnection": "ข้อผิดพลาดการเชื่อมต่อแบตเตอรี่สเลฟ",
  "50901.Fault.sustainedNegativeLoad": "โหลดเชิงลบอย่างต่อเนื่อง",
  "50901.Fault.temperatureAbnormality": "อุณหภูมิผิดปกติ",
  "50901.Fault.tenMinuteOvervoltage": "แรงดันเกิน 10 นาที",
  "50901.Fault.wiringAbnormality": "การเดินสายผิดปกติ",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.communicationStickHardwareVersion": "เวอร์ชันฮาร์ดแวร์ของดองเกิลการสื่อสาร",
  "50901.real_time.communicationStickSn": "sn ของดองเกิลการสื่อสาร",
  "50901.real_time.copy_communicationStickSoftwareVersion": "รุ่นซอฟต์แวร์ติดสื่อสาร",
  "50901.real_time.dTSReset": "การรีเซ็ตแฟลชไดรฟ์ข้อมูล",
  "50901.real_time.inverterHardwareVersion": "เวอร์ชันฮาร์ดแวร์ของอินเวอร์เตอร์",
  "50901.real_time.inverterModelNumber": "หมายเลขรุ่นของอินเวอร์เตอร์",
  "50901.real_time.macAddr": "ที่อยู่ mac",
  "50901.real_time.rssi": "ความแรงของสัญญาณ",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryLowVoltageAlarm": "แรงดันแบตเตอรี่ตก",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "การแจ้งเตือนแรงดันเกินขณะประจุของชุดแบตเตอรี่",
  "50901.warning.chargeHighTemperatureAlarm": "การแจ้งเตือนอุณหภูมิสูงขณะประจุ",
  "50901.warning.chargeLowTemperatureAlarm": "การแจ้งเตือนอุณหภูมิต่ำขณะประจุ",
  "50901.warning.dischargeHighTemperatureAlarm": "การแจ้งเตือนอุณหภูมิสูงขณะคายประจุ",
  "50901.warning.dischargeLowTemperatureAlarm": "การแจ้งเตือนอุณหภูมิต่ำขณะคายประจุ",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "การตั้งค่านาฬิกา",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "การตั้งค่านาฬิกา - วัน",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "การตั้งค่านาฬิกา - ชั่วโมง",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "การตั้งค่านาฬิกา - นาที",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "การตั้งค่านาฬิกา - เดือน",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "การตั้งค่านาฬิกา - วินาที",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "การตั้งค่านาฬิกา - วันในสัปดาห์",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "การตั้งค่านาฬิกา - ปี",
  "50901.ctrl_Config.Device.masterSlave": "มาสเตอร์/สเลฟ",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "เกณฑ์อุณหภูมิแวดล้อม",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "เกณฑ์อุณหภูมิแวดล้อมของแผงวงจร",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "ที่อยู่การสื่อสารเกตเวย์",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "โหมดตรวจจับ BattSoc สำหรับปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "ปิดปั๊มความร้อน Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "ขีดจำกัดเวลาการตรวจจับความล่าช้าของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "พลังงานการตอบสนองสูงสุดของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "เวลาทำงานสูงสุดทุกวันของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "การตรวจจับเวลาเปิดใช้งานสูงสุดของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "จำกัดเวลาใช้งานขั้นต่ำสําหรับปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "กำลังสตาร์ทของปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "ปั๊มความร้อนเริ่มต้น Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "แหล่งจ่ายไฟปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "เวลาปั๊มความร้อน 1 สิ้นสุด - วัน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "เวลาปั๊มความร้อน 1 สิ้นสุด-",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "เวลาปั๊มความร้อน 1 เริ่มต้น - วัน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "เวลาเริ่มต้นปั๊มความร้อน 1 เดือน",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "เวลาปั๊มความร้อน 1 สัปดาห์ 1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "เวลาปั๊มความร้อน 1 สัปดาห์ที่ 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "เวลาปั๊มความร้อน 1 สัปดาห์ 3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "เวลาปั๊มความร้อน 1 สัปดาห์ 4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "เวลาปั๊มความร้อน 1 สัปดาห์ที่ 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "เวลาปั๊มความร้อน 1 สัปดาห์ 6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "เวลาปั๊มความร้อน 1 สัปดาห์ 7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "โหมดการทำงานปั๊มความร้อน",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "เวลาทำงานของปั๊มความร้อน",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4StartDay": "วันเริ่มต้นของส่วนที่ 4",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "เดือนเริ่มต้นของส่วนที่ 4",
  "50901.ctrl_WorkMode.economic.section4StopDay": "วันสิ้นสุดของส่วนที่ 4",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "เดือนสิ้นสุดของส่วนที่ 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 4 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 4 - นาที",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "ช่วงที่ 4 กลุ่มที่ 1 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "ช่วงเวลา 4 กลุ่ม 1 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "ช่วงที่ 4 กลุ่มที่ 1 วันพุธ",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "ช่วงเวลา 4 กลุ่ม 1 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "ช่องเวลา 4, กลุ่ม 1, วันศุกร์",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "ช่วงที่ 4 กลุ่มที่ 1 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "ช่องเวลา 4, กลุ่ม 1, วันจันทร์",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "ช่วงสัปดาห์ที่ 2 ของส่วนที่ 4",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "กำลังไฟฟ้าของมิเตอร์วัดค่าพีค",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "soc ของมิเตอร์วัดค่าพีค",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "ช่วงเวลาโหมด tou",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "กำลังไฟตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "ชั่วโมงเริ่มการประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "ชั่วโมงเริ่มการคายประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "ชั่วโมงเริ่มการประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "ชั่วโมงเริ่มการคายประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "ชั่วโมงเริ่มการประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "ชั่วโมงเริ่มการคายประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "ชั่วโมงสิ้นสุดการประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "นาทีสิ้นสุดการประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "กำลังไฟชาร์จ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "ชั่วโมงเริ่มการประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "นาทีเริ่มการประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "ความจุตัดการประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "ชั่วโมงสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "นาทีสิ้นสุดการคายประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "กำลังไฟคายประจุ",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "ชั่วโมงเริ่มการคายประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "นาทีเริ่มการคายประจุช่วงเวลาการใช้งาน 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "ความจุตัดการคายประจุ",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "โหมด tou - soc สำรอง",
  "50901.fault.emergencyStopSwitchStatus": "การหยุดฉุกเฉิน",
  "50901.fault.fiveVoltPowerSupplyFault": "ข้อบกพร่องของแหล่งจ่ายไฟ 5V",
  "50901.fault.genPortOvercurrent": "กระแสเกินพอร์ตเครื่องปั่นไฟ",
  "50901.fault.genRelayAFault": "ข้อบกพร่องของรีเลย์ a ของเครื่องปั่นไฟ",
  "50901.fault.genRelayBFault": "ข้อบกพร่องของรีเลย์ b ของเครื่องปั่นไฟ",
  "50901.fault.gridMeter": "ความล้มเหลวในการสื่อสารของมิเตอร์โครงข่าย",
  "50901.fault.gridPortOvercurrent": "กระแสเกินพอร์ตโครงข่าย",
  "50901.fault.inverterCanCommunicationFailed": "ความล้มเหลวในการสื่อสาร can ของอินเวอร์เตอร์",
  "50901.fault.inverterCommunicationFailed": "ความล้มเหลวในการสื่อสารของอินเวอร์เตอร์",
  "50901.fault.kmRelayFault": "ข้อบกพร่องของรีเลย์ km",
  "50901.fault.loadRelayAFault": "ข้อบกพร่องของรีเลย์โหลด a",
  "50901.fault.loadRelayBFault": "ข้อบกพร่องของรีเลย์โหลด b",
  "50901.fault.overtemperatureAlarm": "การแจ้งเตือนความร้อนเกิน",
  "50901.fault.pvPortOvercurrent": "กระแสเกินพอร์ตพีวี",
  "50901.fault.pvRelayAbFault": "ข้อบกพร่องของรีเลย์ ab พีวี",
  "50901.fault.smartloadPortOvercurrent": "กระแสเกินพอร์ตโหลดอัจฉริยะ",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "ข้อบกพร่องของแหล่งจ่ายไฟ 3.3V",
  "50901.fault.twelveVoltPowerSupplyFault": "ข้อบกพร่องของแหล่งจ่ายไฟ 12V",
  "50901.real_time.12vAuxiliaryVoltageSampling": "การสุ่มตัวอย่างแรงดันไฟฟ้าช่วย 12V",
  "50901.real_time.12vOutputVoltageSampling": "การสุ่มตัวอย่างแรงดันไฟฟ้าขาออก 12V",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "การสุ่มตัวอย่างแรงดันไฟฟ้าช่วย 3.3V",
  "50901.real_time.5vAuxiliaryVoltageSampling": "การสุ่มตัวอย่างแรงดันไฟฟ้าช่วย 5V",
  "50901.real_time.afciVersion": "เวอร์ชัน afci",
  "50901.real_time.ambientTemperatureSampling": "การสุ่มตัวอย่างอุณหภูมิแวดล้อม",
  "50901.real_time.appSoftwareVersion": "เวอร์ชันซอฟต์แวร์แอป",
  "50901.real_time.batteryChargePower": "ความจุการประจุสะสมของแบตเตอรี่",
  "50901.real_time.batteryConnectionStatus": "สถานะการเชื่อมต่อแบตเตอรี่",
  "50901.real_time.batteryCurrent": "กระแสไฟฟ้าของแบตเตอรี่",
  "50901.real_time.batteryDailyChargeEnergy": "ความจุการประจุรายวันของแบตเตอรี่",
  "50901.real_time.batteryDailyDischargeEnergy": "ความจุการคายประจุรายวันของแบตเตอรี่",
  "50901.real_time.batteryDischargePower": "ความจุการคายประจุสะสมของแบตเตอรี่",
  "50901.real_time.batteryPower": "กำลังไฟฟ้าของแบตเตอรี่ (การประจุ/การคายประจุ)",
  "50901.real_time.batterySoc": "soc ของแบตเตอรี่",
  "50901.real_time.batteryType_04": "ประเภทแบตเตอรี่",
  "50901.real_time.batteryVoltage": "แรงดันไฟฟ้าของแบตเตอรี่",
  "50901.real_time.batteryWorkingStatus": "สถานะแบตเตอรี่",
  "50901.real_time.bootSoftwareVersion": "เวอร์ชันซอฟต์แวร์บูตโหลดเดอร์",
  "50901.real_time.commAddress10Slave9": "ที่อยู่สื่อสาร 10 (สเลฟ 9)",
  "50901.real_time.commAddress1Master": "ที่อยู่สื่อสาร 1 (มาสเตอร์)",
  "50901.real_time.commAddress2Slave1": "ที่อยู่สื่อสาร 2 (สเลฟ 1)",
  "50901.real_time.commAddress3Slave2": "ที่อยู่สื่อสาร 3 (สเลฟ 2)",
  "50901.real_time.commAddress3Slave3": "ที่อยู่สื่อสาร 4 (สเลฟ 3)",
  "50901.real_time.commAddress4Slave4": "ที่อยู่สื่อสาร 5 (สเลฟ 4)",
  "50901.real_time.commAddress6Slave6": "ที่อยู่สื่อสาร 6 (สเลฟ 5)",
  "50901.real_time.commAddress7Slave6": "ที่อยู่สื่อสาร 7 (สเลฟ 6)",
  "50901.real_time.commAddress8Slave7": "ที่อยู่สื่อสาร 8 (สเลฟ 7)",
  "50901.real_time.commAddress9Slave8": "ที่อยู่สื่อสาร 9 (สเลฟ 8)",
  "50901.real_time.copy_bmsSoftwareVersion": "เวอร์ชั่น BMS - ซอฟต์แวร์",
  "50901.real_time.copy_controllerarmFirmwareVersion": "เวอร์ชัน Arm ของอินเวอร์เตอร์",
  "50901.real_time.copy_dspVersionMainUVersion": "เวอร์ชัน dsp (เวอร์ชัน u หลัก)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "สถานะ drm (สำหรับออสเตรเลีย/เยอรมนี/ออสเตรีย)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "เวอร์ชัน dsp (เวอร์ชัน u เสริม)",
  "50901.real_time.epsCurrentA": "กระแสไฟฟ้าเฟส a ฝั่ง eps",
  "50901.real_time.epsCurrentB": "กระแสไฟฟ้าเฟส b ฝั่ง eps",
  "50901.real_time.epsCurrentC": "กระแสไฟฟ้าเฟส c ฝั่ง eps",
  "50901.real_time.epsPower": "กำลังไฟฟ้าฝั่ง eps",
  "50901.real_time.epsPowerA": "กำลังไฟฟ้าเฟส a ฝั่ง eps",
  "50901.real_time.epsPowerB": "กำลังไฟฟ้าเฟส b ฝั่ง eps",
  "50901.real_time.epsPowerC": "กำลังไฟฟ้าเฟส c ฝั่ง eps",
  "50901.real_time.epsVoltageA": "แรงดันไฟฟ้าเฟส a ฝั่ง eps",
  "50901.real_time.epsVoltageB": "แรงดันไฟฟ้าเฟส b ฝั่ง eps",
  "50901.real_time.epsVoltageC": "แรงดันไฟฟ้าเฟส c ฝั่ง eps",
  "50901.real_time.essAccessPoint": "จุดเชื่อมต่อ ess",
  "50901.real_time.externalFanSpeed1": "ความเร็วพัดลมภายนอก 1",
  "50901.real_time.externalFanSpeed2": "ความเร็วพัดลมภายนอก 2",
  "50901.real_time.externalFanSpeed3": "ความเร็วพัดลมภายนอก 3",
  "50901.real_time.externalFanSpeed4": "ความเร็วพัดลมภายนอก 4",
  "50901.real_time.firmwareBuildTimeDateHour": "เวลาในการสร้างเฟิร์มแวร์ (วัน/ชั่วโมง)",
  "50901.real_time.firmwareBuildTimeYearMonth": "เวลาในการสร้างเฟิร์มแวร์ (ปีและเดือน)",
  "50901.real_time.firmwareCrc": "crc ของเฟิร์มแวร์",
  "50901.real_time.firmwareEndAddressHigh": "ที่อยู่สิ้นสุดของเฟิร์มแวร์ (สูง)",
  "50901.real_time.firmwareEndAddressLow": "ที่อยู่สิ้นสุดของเฟิร์มแวร์ (ต่ำ)",
  "50901.real_time.firmwareInformationCrc": "crc ของข้อมูลเฟิร์มแวร์",
  "50901.real_time.firmwareStartAddressHigh": "ที่อยู่เริ่มต้นของเฟิร์มแวร์ (สูง)",
  "50901.real_time.firmwareStartAddressLow": "ที่อยู่เริ่มต้นของเฟิร์มแวร์ (ต่ำ)",
  "50901.real_time.generatorConnectionStatus": "สถานะการเชื่อมต่อของเครื่องปั่นไฟ",
  "50901.real_time.generatorCurrentA": "กระแสไฟฟ้าเฟส a ของเครื่องปั่นไฟ",
  "50901.real_time.generatorCurrentB": "กระแสไฟฟ้าเฟส b ของเครื่องปั่นไฟ",
  "50901.real_time.generatorCurrentC": "กระแสไฟฟ้าเฟส c ของเครื่องปั่นไฟ",
  "50901.real_time.generatorPower": "กำลังไฟฟ้าของเครื่องปั่นไฟ",
  "50901.real_time.generatorVoltageA": "แรงดันไฟฟ้าเฟส a ของเครื่องปั่นไฟ",
  "50901.real_time.generatorVoltageB": "แรงดันไฟฟ้าเฟส b ของเครื่องปั่นไฟ",
  "50901.real_time.generatorVoltageC": "แรงดันไฟฟ้าเฟส c ของเครื่องปั่นไฟ",
  "50901.real_time.gridCurrentA": "กระแสไฟฟ้าเฟส a ฝั่งโครงข่าย",
  "50901.real_time.gridCurrentB": "กระแสไฟฟ้าเฟส b ฝั่งโครงข่าย",
  "50901.real_time.gridCurrentC": "กระแสไฟฟ้าเฟส c ฝั่งโครงข่าย",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "อุณหภูมิฮีทซิงค์ฝั่งโครงข่าย",
  "50901.real_time.gridMeterSerialNumber": "หมายเลขซีเรียลของมิเตอร์ฝั่งโครงข่าย",
  "50901.real_time.gridPower": "กำลังไฟฟ้าฝั่งโครงข่าย",
  "50901.real_time.gridPowerA": "กำลังไฟฟ้าเฟส a ฝั่งโครงข่าย",
  "50901.real_time.gridPowerB": "กำลังไฟฟ้าเฟส b ฝั่งโครงข่าย",
  "50901.real_time.gridPowerC": "กำลังไฟฟ้าเฟส c ฝั่งโครงข่าย",
  "50901.real_time.gridPowerFactor": "ตัวประกอบกำลังไฟฟ้าฝั่งโครงข่าย",
  "50901.real_time.gridPowerFactorA": "ตัวประกอบกำลังไฟฟ้าเฟส a ฝั่งโครงข่าย",
  "50901.real_time.gridPowerFactorB": "ตัวประกอบกำลังไฟฟ้าเฟส b ฝั่งโครงข่าย",
  "50901.real_time.gridPowerFactorC": "ตัวประกอบกำลังไฟฟ้าเฟส c ฝั่งโครงข่าย",
  "50901.real_time.gridReactivePower": "กำลังไฟฟ้ารีแอกทีฟฝั่งโครงข่าย",
  "50901.real_time.gridReactivePowerA": "กำลังไฟฟ้ารีแอกทีฟเฟส a ฝั่งโครงข่าย",
  "50901.real_time.gridReactivePowerB": "กำลังไฟฟ้ารีแอกทีฟเฟส b ฝั่งโครงข่าย",
  "50901.real_time.gridReactivePowerC": "กำลังไฟฟ้ารีแอกทีฟเฟส c ฝั่งโครงข่าย",
  "50901.real_time.gridTotalFrequency": "ความถี่ฝั่งโครงข่าย",
  "50901.real_time.gridVoltageA": "แรงดันไฟฟ้าเฟส a ฝั่งโครงข่าย",
  "50901.real_time.gridVoltageB": "แรงดันไฟฟ้าเฟส b ฝั่งโครงข่าย",
  "50901.real_time.gridVoltageC": "แรงดันไฟฟ้าเฟส c ฝั่งโครงข่าย",
  "50901.real_time.hoymilesSerialNumber": "หมายเลขซีเรียล hoymiles",
  "50901.real_time.internalFanSpeed1": "ความเร็วพัดลมภายใน 1",
  "50901.real_time.internalFanSpeed2": "ความเร็วพัดลมภายใน 2",
  "50901.real_time.internalFanSpeed3": "ความเร็วพัดลมภายใน 3",
  "50901.real_time.inverterSideRadiatorTemperature": "อุณหภูมิฮีทซิงค์ฝั่งอินเวอร์เตอร์",
  "50901.real_time.inverterTemp": "อุณหภูมิการทำงานภายในของอินเวอร์เตอร์",
  "50901.real_time.invRatedPower": "กำลังไฟฟ้าที่กำหนด",
  "50901.real_time.invRunningtime": "เวลาทำงานของ inv (hoymiles: เวลาทำงานปกติ)",
  "50901.real_time.machineSnMaster": "sn ของหน่วยมาสเตอร์",
  "50901.real_time.machineSnSlave1": "sn ของสเลฟ 1",
  "50901.real_time.machineSnSlave2": "sn ของสเลฟ 2",
  "50901.real_time.machineSnSlave3": "sn ของสเลฟ 3",
  "50901.real_time.machineSnSlave4": "sn ของสเลฟ 4",
  "50901.real_time.machineSnSlave5": "sn ของสเลฟ 5",
  "50901.real_time.machineSnSlave6": "sn ของสเลฟ 6",
  "50901.real_time.machineSnSlave7": "sn ของสเลฟ 7",
  "50901.real_time.machineSnSlave8": "sn ของสเลฟ 8",
  "50901.real_time.machineSnSlave9": "sn ของสเลฟ 9",
  "50901.real_time.maxCellTemperature": "อุณหภูมิสูงสุดของเซลล์",
  "50901.real_time.maxCellVoltage": "แรงดันไฟฟ้าสูงสุดของเซลล์",
  "50901.real_time.MaxChargeCurrent": "กระแสไฟชาร์จสูงสุด",
  "50901.real_time.MaxDisChargeCurrent": "กระแสไฟคายประจุสูงสุด",
  "50901.real_time.meterFlag": "แฟล็กมิเตอร์",
  "50901.real_time.minCellTemperature": "อุณหภูมิต่ำสุดของเซลล์",
  "50901.real_time.minCellVoltage": "แรงดันไฟฟ้าต่ำสุดของเซลล์",
  "50901.real_time.mpptTemp": "อุณหภูมิฮีทซิงค์ฝั่งพีวี",
  "50901.real_time.numberOfUnits": "จำนวนหน่วย",
  "50901.real_time.oemModelName": "ชื่อรุ่น oem",
  "50901.real_time.oemSerialNumber": "หมายเลขซีเรียล oem",
  "50901.real_time.packNum": "จำนวนแบบขนาน (จำนวนชุดแบตเตอรี่)",
  "50901.real_time.previous_gridPower": "กำลังไฟฟ้าฝั่งโครงข่าย",
  "50901.real_time.pv1Current": "กระแสไฟฟ้าของ pv1",
  "50901.real_time.pv1Power": "กำลังไฟฟ้าของ pv1",
  "50901.real_time.pv1Voltage": "แรงดันไฟฟ้าของ pv1",
  "50901.real_time.pv2Current": "กระแสไฟฟ้าของ pv2",
  "50901.real_time.pv2Power": "กำลังไฟฟ้าของ pv2",
  "50901.real_time.pv2Voltage": "แรงดันไฟฟ้าของ pv2",
  "50901.real_time.pv3Current": "กระแสไฟฟ้าของ pv3",
  "50901.real_time.pv3Power": "กำลังไฟฟ้าของ pv3",
  "50901.real_time.pv3Voltage": "แรงดันไฟฟ้าของ pv3",
  "50901.real_time.pv4Current": "กระแสไฟฟ้าของ pv4",
  "50901.real_time.pv4Power": "กำลังไฟฟ้าของ pv4",
  "50901.real_time.pv4Voltage": "แรงดันไฟฟ้าของ pv4",
  "50901.real_time.pvConnectionStatus": "สถานะการเชื่อมต่อพีวี",
  "50901.real_time.pvDailyYield": "การผลิตรายวันของพีวี",
  "50901.real_time.pvMeterConnectionStatus": "สถานะการเชื่อมต่อมิเตอร์พีวี",
  "50901.real_time.pvMeterCurrentA": "กระแสไฟฟ้าเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterCurrentB": "กระแสไฟฟ้าเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterCurrentC": "กระแสไฟฟ้าเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvMeterFrequency": "ความถี่ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseAActivePower": "กำลังไฟฟ้าจริงเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseAPowerFactor": "ตัวประกอบกำลังไฟฟ้าเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseAReactivePower": "กำลังไฟฟ้ารีแอกทีฟเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseBActivePower": "กำลังไฟฟ้าจริงเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseBPowerFactor": "ตัวประกอบกำลังไฟฟ้าเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseBReactivePower": "กำลังไฟฟ้ารีแอกทีฟเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseCActivePower": "กำลังไฟฟ้าจริงเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseCPowerFactor": "ตัวประกอบกำลังไฟฟ้าเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPhaseCReactivePower": "กำลังไฟฟ้ารีแอกทีฟเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPower": "กำลังไฟฟ้าของมิเตอร์พีวี",
  "50901.real_time.pvMeterPowerA": "กำลังไฟฟ้าเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPowerB": "กำลังไฟฟ้าเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterPowerC": "กำลังไฟฟ้าเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvMeterSerialNumber": "หมายเลขซีเรียลของมิเตอร์พีวี",
  "50901.real_time.pvMeterVoltageA": "แรงดันไฟฟ้าเฟส a ของมิเตอร์พีวี",
  "50901.real_time.pvMeterVoltageB": "แรงดันไฟฟ้าเฟส b ของมิเตอร์พีวี",
  "50901.real_time.pvMeterVoltageC": "แรงดันไฟฟ้าเฟส c ของมิเตอร์พีวี",
  "50901.real_time.pvPower": "กำลังไฟฟ้าพีวี",
  "50901.real_time.relayStatus": "สถานะรีเลย์",
  "50901.real_time.relaySupplyVoltageSampling": "การสุ่มตัวอย่างแรงดันไฟฟ้าของแหล่งจ่ายไฟรีเลย์",
  "50901.real_time.serviceEntranceBreakerCurrent": "กระแสไฟฟ้าของเบรกเกอร์ทางเข้าบริการ",
  "50901.real_time.soh": "soh",
  "50901.real_time.workStatus": "สถานะการทำงาน",
  "50901.warning.batteryHighVoltageAlarm": "การแจ้งเตือนแรงดันแบตเตอรี่เกิน",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "การแจ้งเตือนแรงดันตกขณะคายประจุของชุดแบตเตอรี่",
  "50901.warning.inputOvervoltageAlarm": "การแจ้งเตือนแรงดันอินพุตเกิน",
  "50901.ctrl_Config.Battery.absorptionVoltage": "แรงดันไฟฟ้าดูดซับ",
  "50901.ctrl_Config.Battery.endChargeVoltage": "แรงดันไฟฟ้าสิ้นสุดการประจุ",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "กระแสไฟฟ้าสิ้นสุดการประจุ",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "การหมดเวลาการประจุสมดุล",
  "50901.ctrl_Config.Battery.equalizationEnable": "การเปิดใช้งานการปรับสมดุล",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "จำนวนวันช่วงการปรับสมดุล",
  "50901.ctrl_Config.Battery.equalizationTime": "เวลาการปรับสมดุล",
  "50901.ctrl_Config.Battery.equalizationVoltage": "แรงดันไฟฟ้าปรับสมดุล",
  "50901.ctrl_Config.Battery.floatVoltage": "แรงดันไฟฟ้าลอยตัว",
  "50901.ctrl_Config.Battery.initialResistance": "ความต้านทานเริ่มต้น",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "ขีดจำกัดการชาร์จสูงสุด",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "ขีดจำกัดการคายประจุสูงสุด",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "ค่าสัมประสิทธิ์การแก้ไขอุณหภูมิ",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "การเปิดใช้งานการสื่อสาร dtu",
  "50901.ctrl_Config.Device.arcfaultClear": "การกำจัดข้อบกพร่องของอาร์ก",
  "50901.ctrl_Config.Device.batActivate": "การเปิดใช้งานแบตเตอรี่",
  "50901.ctrl_Config.Device.batteryBalancing": "การปรับสมดุลแบตเตอรี่",
  "50901.ctrl_Config.Device.clearfault": "ล้างข้อบกพร่อง",
  "50901.ctrl_Config.Device.restartSystem": "การรีสตาร์ทระบบ",
  "50901.ctrl_Config.Device.restoreDefault": "การคืนค่าเริ่มต้น",
  "50901.ctrl_Config.Device.selfTest": "การทดสอบตัวเอง",
  "50901.ctrl_Config.Device.systemPowerOnOff": "การเปิด/ปิดระบบ",
  "50901.ctrl_Config.Grid Profile.country": "ประเทศ/มาตรฐานการเชื่อมต่อโครงข่าย",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "ชั่วโมงสิ้นสุดการประจุของการควบคุมเครื่องปั่นไฟ - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "นาทีสิ้นสุดการประจุของการควบคุมเครื่องปั่นไฟ - นาที",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "ชั่วโมงเริ่มการประจุของการควบคุมเครื่องปั่นไฟ - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "นาทีเริ่มการประจุของการควบคุมเครื่องปั่นไฟ - นาที",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "ความจุแบตเตอรี่ปิดเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "โหมดเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "ความจุแบตเตอรี่สตาร์ทเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "ความถี่โหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "โหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "เวลาทำงานของโหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "ชั่วโมงเริ่มต้นของโหมดฝึกซ้อมของเครื่องปั่นไฟ - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "นาทีเริ่มต้นของโหมดฝึกซ้อมของเครื่องปั่นไฟ - นาที",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "เวลาเริ่มต้นของโหมดฝึกซ้อมของเครื่องปั่นไฟ",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "ชั่วโมงสิ้นสุดเวลาสแตนด์บาย 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "นาทีสิ้นสุดเวลาสแตนด์บาย 1 - นาที",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "ชั่วโมงเริ่มเวลาสแตนด์บาย 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "นาทีเริ่มเวลาสแตนด์บาย 1 - นาที",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "ชั่วโมงสิ้นสุดเวลาสแตนด์บาย 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "นาทีสิ้นสุดเวลาสแตนด์บาย 2 - นาที",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "ชั่วโมงเริ่มเวลาสแตนด์บาย 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "นาทีเริ่มเวลาสแตนด์บาย 2 - นาที",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "การเปิดใช้งานเวลาสแตนด์บาย",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "โหมดการควบคุมโหลด",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "กระแสไฟฟ้าที่กำหนดของเครื่องชาร์จ ev",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "การควบคุมโหลดวันจันทร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "การควบคุมโหลดวันอังคาร",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "การควบคุมโหลดวันพุธ",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "การควบคุมโหลดวันพฤหัสบดี",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "การควบคุมโหลดวันศุกร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "การควบคุมโหลดวันเสาร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "การควบคุมโหลดวันอาทิตย์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "กระแสไฟฟ้าที่กำหนดของเบรกเกอร์หลัก",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "สวิตช์โหมดแมนนวล",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "เกณฑ์กำลังโหลดในโหมดโหลด",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "เวลาเปิดสั้นที่สุดของการควบคุมโหลด",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "soc การป้องกันนอกระบบ",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "ช่วงเวลา 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "วันอังคาร",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "วันพุธ",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "วันพฤหัสบดี",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "วันศุกร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "วันเสาร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "วันอาทิตย์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "วันอาทิตย์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "ชั่วโมงสิ้นสุดตัวจับเวลา 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "ชั่วโมงสิ้นสุดตัวจับเวลา 1_2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "ชั่วโมงสิ้นสุดช่วงเวลา 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "นาทีสิ้นสุดตัวจับเวลา 1 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "นาทีสิ้นสุดตัวจับเวลา 1_2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "นาทีสิ้นสุดช่วงเวลา 1 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "นาทีเริ่มตัวจับเวลา 1 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "นาทีเริ่มตัวจับเวลา 1_2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "นาทีเริ่มช่วงเวลา 1 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "ชั่วโมงสิ้นสุดตัวจับเวลา 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "ชั่วโมงสิ้นสุดตัวจับเวลา 2_2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "ชั่วโมงสิ้นสุดช่วงเวลา 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "นาทีสิ้นสุดตัวจับเวลา 2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "นาทีสิ้นสุดตัวจับเวลา 2_2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "นาทีสิ้นสุดช่วงเวลา 2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "นาทีเริ่มตัวจับเวลา 2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "นาทีเริ่มตัวจับเวลา 2_2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "นาทีเริ่มช่วงเวลา 2 - นาที",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "ชั่วโมงเริ่มตัวจับเวลา 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "ชั่วโมงเริ่มตัวจับเวลา 1_2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "ชั่วโมงเริ่มช่วงเวลา 1 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "ชั่วโมงเริ่มตัวจับเวลา 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "ชั่วโมงเริ่มตัวจับเวลา 2_2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "ชั่วโมงเริ่มช่วงเวลา 2 - ชั่วโมง",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "โหมดกำหนดเวลา - เปิดใช้งาน soc แบตเตอรี่",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "โหมดกำหนดเวลา - soc เริ่มแบตเตอรี่",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "โหมดกำหนดเวลา - soc หยุดแบตเตอรี่",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "วันจันทร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "วันอังคาร",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "วันพุธ",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "วันพฤหัสบดี",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "วันศุกร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "วันเสาร์",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "วันอาทิตย์",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "โหมดการทำงานของรายชื่อแห้ง",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "กำลังคายประจุสูงสุดของแบตเตอรี่ในช่วงพีค",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "กำลังป้อนเข้าสู่โครงข่ายในช่วงพีค",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "กำลังชาร์จสูงสุดของแบตเตอรี่",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "กำลังคายประจุสูงสุดของแบตเตอรี่",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "เวลาบำรุงรักษาแบตเตอรี่ตะกั่ว-กรด",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "soc สูงสุด",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "soc ต่ำสุด",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "การชดเชยกำลังไฟฟ้า",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "กำลังสำรอง rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "การปิดใช้งานบายพาส",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "โหมด eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "การเปิดใช้งานโหมดพีวี",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "ขีดจำกัดบนความถี่ของเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "ขีดจำกัดบนแรงดันไฟฟ้าของเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "ขีดจำกัดล่างความถี่ของเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "ขีดจำกัดล่างแรงดันไฟฟ้าของเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "กำลังชาร์จแบตเตอรี่จากเครื่องปั่นไฟในแบบขนานหลายหน่วย",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "เวลาหน่วงการปิดเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "การเปิดใช้งานการสแกนทั่วโลก",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "การจำกัดกำลังไฟฟ้าจากโครงข่าย",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "การเปิดใช้งาน mid / เกตเวย์",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "การเปิดใช้งานความไม่สมดุลสามเฟส",
  "50901.ctrl_Safety.DCI.dciEnable": "การเปิดใช้งาน dci",
  "50901.ctrl_Safety.DCI.lowerLimit": "กระแสขีดจำกัดล่างของ dci",
  "50901.ctrl_Safety.DCI.lowerTime": "เวลาขีดจำกัดล่างของ dci",
  "50901.ctrl_Safety.DCI.upperLimit": "กระแสขีดจำกัดบนของ dci",
  "50901.ctrl_Safety.DCI.upperTime": "เวลาขีดจำกัดบนของ dci",
  "50901.ctrl_Safety.FRT.frtFuncCode": "รหัสฟังก์ชัน frt",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "ขีดจำกัดบนความถี่ 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "ระยะเวลาขีดจำกัดบนความถี่ 1",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "ขีดจำกัดบนความถี่ 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "ระยะเวลาขีดจำกัดบนความถี่ 2",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "ขีดจำกัดบนความถี่ 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "ระยะเวลาขีดจำกัดบนความถี่ 3",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "ขีดจำกัดล่างความถี่ 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "ระยะเวลาขีดจำกัดล่างความถี่ 1",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "ขีดจำกัดล่างความถี่ 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "ระยะเวลาขีดจำกัดล่างความถี่ 2",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "ขีดจำกัดล่างความถี่ 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "ระยะเวลาขีดจำกัดล่างความถี่ 3",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "การเปิดใช้งานความแตกต่างโหมดแบตเตอรี่ fw",
  "50901.ctrl_Safety.FW.fwEnable": "การเปิดใช้งาน fw",
  "50901.ctrl_Safety.FW.fwFuncCode": "รหัสฟังก์ชัน fw",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "ความถี่สิ้นสุดความถี่เกิน fw",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "ความถี่เริ่มต้นความถี่เกิน fw",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "ความถี่เปลี่ยนผ่านความถี่เกิน fw",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "ขีดจำกัดล่างความถี่การกู้คืน fw",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "เวลาเสถียรภาพการกู้คืน fw",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "ขีดจำกัดบนความถี่การกู้คืน fw",
  "50901.ctrl_Safety.FW.fwTr": "เวลา fw_tr",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "ความถี่สิ้นสุดความถี่ต่ำ fw",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "ความถี่เริ่มต้นความถี่ต่ำ fw",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "ความถี่หยุดความถี่ต่ำ fw",
  "50901.ctrl_Safety.RCD.continueLimitTime": "เวลาขีดจำกัดต่อเนื่องของ rcd",
  "50901.ctrl_Safety.RCD.continueLimitValue": "กระแสขีดจำกัดต่อเนื่องของ rcd",
  "50901.ctrl_Safety.RCD.rcdEnable": "การเปิดใช้งาน rcd",
  "50901.ctrl_Safety.RCD.step1LimitTime": "เวลาขีดจำกัดขั้นตอนที่ 1 ของ rcd",
  "50901.ctrl_Safety.RCD.step1LimitValue": "กระแสขีดจำกัดขั้นตอนที่ 1 ของ rcd",
  "50901.ctrl_Safety.RCD.step2LimitTime": "เวลาขีดจำกัดขั้นตอนที่ 2 ของ rcd",
  "50901.ctrl_Safety.RCD.step2LimitValue": "กระแสขีดจำกัดขั้นตอนที่ 2 ของ rcd",
  "50901.ctrl_Safety.RCD.step3LimitTime": "เวลาขีดจำกัดขั้นตอนที่ 3 ของ rcd",
  "50901.ctrl_Safety.RCD.step3LimitValue": "กระแสขีดจำกัดขั้นตอนที่ 3 ของ rcd",
  "50901.ctrl_Safety.RPC.gcfEn": "การเปิดใช้งาน gcf",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "อัตราส่วนขีดจำกัดแข็งการส่งออก Gcf",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "อัตราส่วนขีดจำกัดอ่อนการส่งออก Gcf",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "รหัสฟังก์ชัน gcf",
  "50901.ctrl_Safety.RPC.rpcMode": "โหมด rp",
  "50901.ctrl_Safety.RPC.rpcPf": "ตัวประกอบกำลัง pf ของ rpc",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "อัตราส่วนกำลังไฟฟ้ารีแอกทีฟของ rpc",
  "50901.ctrl_Safety.RPC.rpcTr": "เวลา rpc_tr",
  "50901.ctrl_Safety.RPC.vvFuncCode": "รหัสฟังก์ชัน volt-var",
  "50901.ctrl_Safety.RPC.vvLockIn": "ค่า lock-in ของ vv",
  "50901.ctrl_Safety.RPC.vvLockOut": "ค่า lock-out ของ vv",
  "50901.ctrl_Safety.RPC.vvQ1": "จุดเซ็ตพอยต์รีแอกทีฟ_q1",
  "50901.ctrl_Safety.RPC.vvQ2": "จุดเซ็ตพอยต์รีแอกทีฟ_q2",
  "50901.ctrl_Safety.RPC.vvQ3": "จุดเซ็ตพอยต์รีแอกทีฟ_q3",
  "50901.ctrl_Safety.RPC.vvQ4": "จุดเซ็ตพอยต์รีแอกทีฟ_q4",
  "50901.ctrl_Safety.RPC.vvV1": "จุดเซ็ตพอยต์แรงดัน_v1",
  "50901.ctrl_Safety.RPC.vvV2": "จุดเซ็ตพอยต์แรงดัน_v2",
  "50901.ctrl_Safety.RPC.vvV3": "จุดเซ็ตพอยต์แรงดัน_v3",
  "50901.ctrl_Safety.RPC.vvV4": "จุดเซ็ตพอยต์แรงดัน_v4",
  "50901.ctrl_Safety.RPC.vvVref": "ค่าอ้างอิง volt-var (vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "เวลา tr ของค่าอ้างอิง volt-var",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "รหัสฟังก์ชัน wpf",
  "50901.ctrl_Safety.RPC.wpfLockIn": "ค่า lock-in ของ wpf",
  "50901.ctrl_Safety.RPC.wpfLockOut": "ค่า lock-out ของ wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "pf ขั้นต่ำของกำลังเกิน wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "pf ขั้นต่ำของกำลังต่ำ wpf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "อัตราส่วนสิ้นสุดกำลังของ wpf",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "อัตราส่วนเริ่มต้นกำลังของ wpf",
  "50901.ctrl_Safety.RR.rrFuncCode": "รหัสฟังก์ชัน rr",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "ขีดจำกัดบนการกู้คืนความถี่ rt",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "ขีดจำกัดล่างการกู้คืนความถี่ rt",
  "50901.ctrl_Safety.RT.rtFuncCode": "รหัสฟังก์ชัน rt",
  "50901.ctrl_Safety.RT.rtNMTime": "เวลา rt_nm",
  "50901.ctrl_Safety.RT.rtSRTTime": "เวลา rt_srt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "ขีดจำกัดบนการกู้คืนแรงดัน rt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "ขีดจำกัดล่างการกู้คืนแรงดัน rt",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "แรงดันเฉลี่ย 10 นาที",
  "50901.ctrl_Safety.VRT.vrtEn": "การเปิดใช้งาน vrt",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "รหัสฟังก์ชัน vrt",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "เกณฑ์แรงดันสูง vrt",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "เกณฑ์แรงดันต่ำ vrt",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "เวลาเสถียรภาพการกู้คืน vrt",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "ระยะเวลาแรงดันเกินชั่วขณะ",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "เกณฑ์แรงดันเกินชั่วขณะ",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "ขีดจำกัดบนแรงดัน 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "ระยะเวลาขีดจำกัดบนแรงดัน 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "ขีดจำกัดบนแรงดัน 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "ระยะเวลาขีดจำกัดบนแรงดัน 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "ขีดจำกัดบนแรงดัน 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "ระยะเวลาขีดจำกัดบนแรงดัน 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "ขีดจำกัดล่างแรงดัน 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "ระยะเวลาขีดจำกัดล่างแรงดัน 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "ขีดจำกัดล่างแรงดัน 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "ระยะเวลาขีดจำกัดล่างแรงดัน 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "ขีดจำกัดล่างแรงดัน 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "ระยะเวลาขีดจำกัดล่างแรงดัน 3",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "การเปิดใช้งานความแตกต่างโหมดแบตเตอรี่ vw",
  "50901.ctrl_Safety.VW.vwEnable": "การเปิดใช้งาน vw",
  "50901.ctrl_Safety.VW.vwFuncCode": "รหัสฟังก์ชัน vw",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "แรงดันสิ้นสุดแรงดันเกิน vw",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "แรงดัน kp / แรงดันสัมประสิทธิ์แรงดันเกิน vw",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "แรงดันเริ่มต้นแรงดันเกิน vw",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "ขีดจำกัดล่างแรงดันการกู้คืน vw",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "เวลาเสถียรภาพการกู้คืน vw",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "ขีดจำกัดบนแรงดันการกู้คืน vw",
  "50901.ctrl_Safety.VW.vwTr": "เวลา vw_tr",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "แรงดันสิ้นสุดแรงดันตก vw",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "แรงดัน kp / แรงดันสัมประสิทธิ์แรงดันตก vw",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "แรงดันเริ่มต้นแรงดันตก vw",
  "50901.ctrl_WorkMode.Backup.backupSoc": "soc สำรอง",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "soc โหมดประหยัด",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "ดัชนีวันที่ของโหมดประหยัด",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1StartDay": "วันเริ่มต้นของส่วนที่ 1",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "เดือนเริ่มต้นของส่วนที่ 1",
  "50901.ctrl_WorkMode.economic.section1StopDay": "วันสิ้นสุดของส่วนที่ 1",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "เดือนสิ้นสุดของส่วนที่ 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 1 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 1 - นาที",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "ช่วงที่ 1 กลุ่มที่ 1 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "ช่วงที่ 1 กลุ่มที่ 1 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "ช่วงที่ 1 กลุ่มที่ 1 วันพุธ",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "ช่วงที่ 1 กลุ่มที่ 1 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "ช่วงที่ 1 กลุ่มที่ 1 วันศุกร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "ช่วงที่ 1 กลุ่มที่ 1 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "ช่วงที่ 1 กลุ่มที่ 1 วันอาทิตย์",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "ช่วงที่ 1 กลุ่มที่ 2 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "ช่วงที่ 1 กลุ่มที่ 2 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "ช่วงที่ 1 กลุ่มที่ 2 วันพุธ",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "ช่วงที่ 1 กลุ่มที่ 2 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "ช่วงที่ 1 กลุ่มที่ 2 วันศุกร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "ช่วงที่ 1 กลุ่มที่ 2 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "ช่วงที่ 1 กลุ่มที่ 2 วันอาทิตย์",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2StartDay": "วันเริ่มต้นของส่วนที่ 2",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "เดือนเริ่มต้นของส่วนที่ 2",
  "50901.ctrl_WorkMode.economic.section2StopDay": "วันสิ้นสุดของส่วนที่ 2",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "เดือนสิ้นสุดของส่วนที่ 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 2 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 2 - นาที",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "ช่วงที่ 2 กลุ่มที่ 1 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "ช่วงที่ 2 กลุ่มที่ 1 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "ช่วงที่ 2 กลุ่มที่ 1 วันพุธ",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "ช่วงที่ 2 กลุ่มที่ 1 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "ช่วงที่ 2 กลุ่มที่ 1 วันศุกร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "ช่วงที่ 2 กลุ่มที่ 1 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "ช่วงที่ 2 กลุ่มที่ 1 วันอาทิตย์",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "ช่วงที่ 2 กลุ่มที่ 2 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "ช่วงที่ 2 กลุ่มที่ 2 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "ช่วงที่ 2 กลุ่มที่ 2 วันพุธ",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "ช่วงที่ 2 กลุ่มที่ 2 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "ช่วงที่ 2 กลุ่มที่ 2 วันศุกร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "ช่วงที่ 2 กลุ่มที่ 2 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "ช่วงที่ 2 กลุ่มที่ 2 วันอาทิตย์",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "ชั่วโมงเริ่มต้นช่วงพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "นาทีเริ่มต้นช่วงพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "ชั่วโมงสิ้นสุดช่วงพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "นาทีสิ้นสุดช่วงพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3StartDay": "วันเริ่มต้นของส่วนที่ 3",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "เดือนเริ่มต้นของส่วนที่ 3",
  "50901.ctrl_WorkMode.economic.section3StopDay": "วันสิ้นสุดของส่วนที่ 3",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "เดือนสิ้นสุดของส่วนที่ 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "ชั่วโมงเริ่มต้นช่วงนอกพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "นาทีเริ่มต้นช่วงนอกพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "ชั่วโมงสิ้นสุดช่วงนอกพีคของส่วนที่ 3 - ชั่วโมง",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "นาทีสิ้นสุดช่วงนอกพีคของส่วนที่ 3 - นาที",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "ช่วงที่ 3 กลุ่มที่ 1 วันจันทร์",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "ช่วงที่ 3 กลุ่มที่ 1 วันอังคาร",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "ช่วงที่ 3 กลุ่มที่ 1 วันพุธ",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "ช่วงที่ 3 กลุ่มที่ 1 วันพฤหัสบดี",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "ช่วงที่ 3 กลุ่มที่ 1 วันศุกร์",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "ช่วงที่ 3 กลุ่มที่ 1 วันเสาร์",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "ช่วงที่ 3 กลุ่มที่ 1 วันอาทิตย์",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "ช่วงสัปดาห์ที่ 2 ของส่วนที่ 3",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "soc การประจุแบบบังคับ",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "กำลังไฟชาร์จสูงสุด",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "soc การคายประจุแบบบังคับ",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "กำลังไฟคายประจุสูงสุด",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "soc การใช้เอง",
  "50901.ctrl_WorkMode.Switch.workMode": "โหมดการทำงานของ ems",
  "50901.real_time.batteryCapacity": "ความจุที่ติดตั้งของแบตเตอรี่",
  "50901.real_time.BatteryModel": "รุ่นแบตเตอรี่",
  "50901.real_time.inverterSn": "sn ของอินเวอร์เตอร์",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "โหมดพอร์ตเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "ตำแหน่งเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "เวลาซิงโครไนซ์เครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "ประเภทเครื่องปั่นไฟ",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "เวลาทำงานสูงสุด",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "เวลาทำงานต่ำสุด",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "ช่วงเวลาป้องกันการทำงาน",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "รุ่นมิเตอร์",
  "50901.real_time.batteryWorkingStatus.desc": "คำอธิบายสถานะแบตเตอรี่",
  "50901.real_time.batteryWorkingStatus.1": "สแตนด์บาย",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "ดำเนินการคำสั่งชาร์จสำเร็จ",
  "ai.message.charge.title.fail": "ดำเนินการคำสั่งชาร์จล้มเหลว",
  "ai.message.charge.content.success": "ดำเนินการคำสั่งชาร์จสำเร็จ กลยุทธ์ AI ทำงานปกติ",
  "ai.message.charge.content.fail": "คำสั่งชาร์จล้มเหลว (ลองอัตโนมัติ 3 ครั้ง) AI จะลองใหม่ในภายหลัง จัดการด้วยตนเองได้หลังจากปิดโหมด AI",
  "ai.message.discharge.title.success": "ดำเนินการคำสั่งคายประจุสำเร็จ",
  "ai.message.discharge.title.fail": "ดำเนินการคำสั่งคายประจุล้มเหลว",
  "ai.message.discharge.content.success": "ดำเนินการคำสั่งคายประจุสำเร็จ กลยุทธ์ AI ทำงานปกติ",
  "ai.message.discharge.content.fail": "คำสั่งคายประจุล้มเหลว (ลองอัตโนมัติ 3 ครั้ง) AI จะลองใหม่ในภายหลัง จัดการด้วยตนเองได้หลังจากปิดโหมด AI",
  "50901.fault.evCharger1CommunicationAbnormality": "ความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 1",
  "50901.fault.bmsCanCommunicationAbnormality": "ความผิดปกติของการสื่อสาร can bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu3 rs485",
  "50901.fault.gridMeterTypeError": "ข้อผิดพลาดประเภทมิเตอร์โครงข่าย",
  "50901.fault.lowDtuVersion": "เวอร์ชัน dtu ต่ำเกินไป",
  "50901.fault.gridMeterCommunicationAbnormality": "ความผิดปกติของการสื่อสารของมิเตอร์โครงข่าย",
  "50901.fault.pvMeterTypeError": "ข้อผิดพลาดประเภทมิเตอร์พีวี",
  "50901.fault.dspPwrCommunicationAbnormality": "ความผิดปกติของการสื่อสารพลังงาน dsp",
  "50901.fault.evCharger2CommunicationAbnormality": "ความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu5 rs485",
  "50901.fault.dtsCommunicationAbnormality": "ความผิดปกติของการสื่อสาร dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu4 rs485",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu1 rs485",
  "50901.fault.pvMeterCommunicationAbnormality": "ความผิดปกติของการสื่อสารมิเตอร์พีวี",
  "50901.fault.slaveWrongBatteryConnection": "ข้อผิดพลาดการเชื่อมต่อแบตเตอรี่สเลฟ",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "ความผิดปกติของการสื่อสาร dtu2 rs485",
  "50901.fault.dspSafCommunicationAbnormality": "ความผิดปกติของการสื่อสารที่ปลอดภัย dsp",
  "50901.fault.sustainedNegativeLoad": "โหลดเชิงลบอย่างต่อเนื่อง",
  "50901.fault.hmidMachineFault": "ข้อบกพร่องของอุปกรณ์ hmi",
  "50901.fault.evCharger1Fault": "ข้อบกพร่องของเครื่องชาร์จ 1",
  "50901.fault.evCharger2Fault": "ข้อบกพร่องของเครื่องชาร์จ 2",
  "50901.fault.fanSpeedAbnormality": "ความผิดปกติของความเร็วพัดลม",
  "50901.fault.masterSlaveCommunicationAbnormality": "ความผิดปกติของการสื่อสารมาสเตอร์-สเลฟ",
  "50901.fault.batteryCapacityAbnormality": "ความผิดปกติของความจุแบตเตอรี่",
  "50901.fault.batteryForceChargeRequest": "คำขอการประจุแบตเตอรี่แบบบังคับ",
  "50901.fault.hmidCommunicationAbnormality": "ความผิดปกติของการสื่อสาร hmi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "เครื่องปั่นไฟเริ่มทำงานเป็นระยะในเวลานี้",
  "50901.fault.loadRelayAfault.0": "ปิดใช้งาน",
  "50901.fault.fiveVoltPowerSupplyfault.0": "ปิดใช้งาน",
  "50901.fault.fiveVoltPowerSupplyfault.1": "เปิดใช้งาน",
  "50901.fault.genRelayAfault.0": "ปิดใช้งาน",
  "50901.fault.genRelayAfault.1": "เปิดใช้งาน",
  "50901.fault.genRelayBfault.0": "ปิดใช้งาน",
  "50901.fault.genRelayBfault.1": "เปิดใช้งาน",
  "50901.fault.kmRelayfault.0": "ปิดใช้งาน",
  "50901.fault.kmRelayfault.1": "เปิดใช้งาน",
  "50901.fault.twelveVoltPowerSupplyfault.1": "เปิดใช้งาน",
  "50901.fault.loadRelayAfault.1": "เปิดใช้งาน",
  "50901.fault.loadRelayBfault.0": "ปิดใช้งาน",
  "50901.fault.loadRelayBfault.1": "เปิดใช้งาน",
  "50901.fault.pvRelayAbfault.0": "ปิดใช้งาน",
  "50901.fault.pvRelayAbfault.1": "เปิดใช้งาน",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "ปิดใช้งาน",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "เปิดใช้งาน",
  "50901.fault.twelveVoltPowerSupplyfault.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "เปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "ปิดใช้งาน",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "เปิดใช้งาน",
  "50901.fault.loadRelayAfault": "รีเลย์โหลด A ขัดข้อง",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "ไฟเลี้ยง 3.3V ขัดข้อง",
  "50901.fault.pvRelayAbfault": "รีเลย์ PV AB ขัดข้อง",
  "50901.fault.twelveVoltPowerSupplyfault": "ไฟเลี้ยง 12V ขัดข้อง",
  "50901.fault.loadRelayBfault": "รีเลย์โหลด B ขัดข้อง",
  "50901.fault.kmRelayfault": "รีเลย์ KM ขัดข้อง",
  "50901.fault.genRelayBfault": "รีเลย์เครื่องปั่นไฟ B ขัดข้อง",
  "50901.fault.genRelayAfault": "รีเลย์เครื่องปั่นไฟ A ขัดข้อง",
  "50901.fault.fiveVoltPowerSupplyfault": "ไฟเลี้ยง 5V ขัดข้อง",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันพฤหัสบดี",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันพุธ",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันศุกร์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันเสาร์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันอังคาร",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันอาทิตย์",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "เวลาเริ่มต้นโหมดฝึกเครื่องปั่นไฟ วันจันทร์",
  "50901.fault.evCharger1CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.evCharger1CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.bmsCanCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.bmsCanCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.gridMeterTypeError.0": "ปิดใช้งาน",
  "50901.fault.gridMeterTypeError.1": "เปิดใช้งาน",
  "50901.fault.lowDtuVersion.0": "ปิดใช้งาน",
  "50901.fault.lowDtuVersion.1": "เปิดใช้งาน",
  "50901.fault.gridMeterCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.gridMeterCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.pvMeterTypeError.0": "ปิดใช้งาน",
  "50901.fault.pvMeterTypeError.1": "เปิดใช้งาน",
  "50901.fault.dspPwrCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dspPwrCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.evCharger2CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.evCharger2CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dtsCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtsCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.pvMeterCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.pvMeterCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.slaveWrongBatteryConnection.0": "ปิดใช้งาน",
  "50901.fault.slaveWrongBatteryConnection.1": "เปิดใช้งาน",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.dspSafCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.dspSafCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.sustainedNegativeLoad.0": "ปิดใช้งาน",
  "50901.fault.sustainedNegativeLoad.1": "เปิดใช้งาน",
  "50901.fault.hmidMachineFault.0": "ปิดใช้งาน",
  "50901.fault.hmidMachineFault.1": "เปิดใช้งาน",
  "50901.fault.evCharger1Fault.0": "ปิดใช้งาน",
  "50901.fault.evCharger1Fault.1": "เปิดใช้งาน",
  "50901.fault.evCharger2Fault.0": "ปิดใช้งาน",
  "50901.fault.evCharger2Fault.1": "เปิดใช้งาน",
  "50901.fault.fanSpeedAbnormality.0": "ปิดใช้งาน",
  "50901.fault.fanSpeedAbnormality.1": "เปิดใช้งาน",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.batteryCapacityAbnormality.0": "ปิดใช้งาน",
  "50901.fault.batteryCapacityAbnormality.1": "เปิดใช้งาน",
  "50901.fault.batteryForceChargeRequest.0": "ปิดใช้งาน",
  "50901.fault.batteryForceChargeRequest.1": "เปิดใช้งาน",
  "50901.fault.hmidCommunicationAbnormality.0": "ปิดใช้งาน",
  "50901.fault.hmidCommunicationAbnormality.1": "เปิดใช้งาน",
  "50901.fault.batteryFault": "ข้อบกพร่องของแบตเตอรี่",
  "50901.fault.fanFault.0": "ปิดใช้งาน",
  "50901.fault.armCommunicationFault.1": "เปิดใช้งาน",
  "50901.fault.batteryFault.0": "ปิดใช้งาน",
  "50901.fault.batteryFault.1": "เปิดใช้งาน",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 1",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร can bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dtu3 rs485",
  "50901.fault.gridMeterTypeError.desc": "คำอธิบายข้อผิดพลาดประเภทมิเตอร์โครงข่าย",
  "50901.fault.lowDtuVersion.desc": "คำอธิบายเวอร์ชัน dtu ต่ำเกินไป",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารของมิเตอร์โครงข่าย",
  "50901.fault.pvMeterTypeError.desc": "คำอธิบายข้อผิดพลาดประเภทมิเตอร์พีวี",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารพลังงาน dsp",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารของเครื่องชาร์จ ev 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dtu5 rs485",
  "50901.fault.dtsCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dtu4 rs485",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dtu1 rs485",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารมิเตอร์พีวี",
  "50901.fault.slaveWrongBatteryConnection.desc": "คำอธิบายข้อผิดพลาดการเชื่อมต่อแบตเตอรี่สเลฟ",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร dtu2 rs485",
  "50901.fault.dspSafCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารที่ปลอดภัย dsp",
  "50901.fault.sustainedNegativeLoad.desc": "คำอธิบายโหลดเชิงลบอย่างต่อเนื่อง",
  "50901.fault.hmidMachineFault.desc": "คำอธิบายข้อบกพร่องของอุปกรณ์ hmi",
  "50901.fault.evCharger1Fault.desc": "คำอธิบายข้อบกพร่องของเครื่องชาร์จ 1",
  "50901.fault.evCharger2Fault.desc": "คำอธิบายข้อบกพร่องของเครื่องชาร์จ 2",
  "50901.fault.fanSpeedAbnormality.desc": "คำอธิบายความผิดปกติของความเร็วพัดลม",
  "50901.fault.batteryFault.desc": "คำอธิบายข้อบกพร่องของแบตเตอรี่",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสารมาสเตอร์-สเลฟ",
  "50901.fault.batteryCapacityAbnormality.desc": "คำอธิบายความผิดปกติของความจุแบตเตอรี่",
  "50901.fault.batteryForceChargeRequest.desc": "คำอธิบายคำขอการประจุแบตเตอรี่แบบบังคับ",
  "50901.fault.hmidCommunicationAbnormality.desc": "คำอธิบายความผิดปกติของการสื่อสาร hmi",
  "50901.fault.evCharger1CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.evCharger1CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.bmsCanCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.bmsCanCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.gridMeterTypeError.00": "ปิดใช้งาน",
  "50901.fault.gridMeterTypeError.01": "เปิดใช้งาน",
  "50901.fault.lowDtuVersion.00": "ปิดใช้งาน",
  "50901.fault.lowDtuVersion.01": "เปิดใช้งาน",
  "50901.fault.gridMeterCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.gridMeterCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.pvMeterTypeError.00": "ปิดใช้งาน",
  "50901.fault.pvMeterTypeError.01": "เปิดใช้งาน",
  "50901.fault.dspPwrCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dspPwrCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.evCharger2CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.evCharger2CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dtsCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtsCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.pvMeterCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.pvMeterCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.slaveWrongBatteryConnection.00": "ปิดใช้งาน",
  "50901.fault.slaveWrongBatteryConnection.01": "เปิดใช้งาน",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.dspSafCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.dspSafCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.sustainedNegativeLoad.00": "ปิดใช้งาน",
  "50901.fault.sustainedNegativeLoad.01": "เปิดใช้งาน",
  "50901.fault.hmidMachineFault.00": "ปิดใช้งาน",
  "50901.fault.hmidMachineFault.01": "เปิดใช้งาน",
  "50901.fault.evCharger1Fault.00": "ปิดใช้งาน",
  "50901.fault.evCharger1Fault.01": "เปิดใช้งาน",
  "50901.fault.evCharger2Fault.00": "ปิดใช้งาน",
  "50901.fault.evCharger2Fault.01": "เปิดใช้งาน",
  "50901.fault.fanSpeedAbnormality.00": "ปิดใช้งาน",
  "50901.fault.fanSpeedAbnormality.01": "เปิดใช้งาน",
  "50901.fault.batteryFault.00": "ปิดใช้งาน",
  "50901.fault.batteryFault.01": "เปิดใช้งาน",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "เปิดใช้งาน",
  "50901.fault.batteryCapacityAbnormality.00": "ปิดใช้งาน",
  "50901.fault.batteryCapacityAbnormality.01": "เปิดใช้งาน",
  "50901.fault.batteryForceChargeRequest.00": "ปิดใช้งาน",
  "50901.fault.batteryForceChargeRequest.01": "เปิดใช้งาน",
  "50901.fault.hmidCommunicationAbnormality.00": "ปิดใช้งาน",
  "50901.fault.hmidCommunicationAbnormality.01": "เปิดใช้งาน",
  "alarm.excDesc.2047494139783155712": "การสื่อสาร ARM ขัดข้อง",
  "alarm.name.2047494139783155712": "การสื่อสาร ARM ขัดข้อง",
  "plant.create.type.0": "ผู้ติดตั้ง",
  "plant.create.type.1": "ผู้ใช้ปลายทาง",
  "not.configured": "ยังไม่ได้ตั้งค่า",
  "10001.quickset.note1": "1. โหมดการใช้เอง: การตั้งค่าที่แนะนำคือโหมดการใช้เอง โหมดนี้สามารถใช้ประโยชน์สูงสุดจากไฟฟ้าที่ผลิตได้จาก PV สำหรับใช้ในครัวเรือน หรือเก็บไว้ในแบตเตอรี่และนำมาใช้ในครัวเรือน 2. โหมดลำดับการขายเข้าสู่กริด: โหมดนี้สามารถส่งพลังงานไปยังกริดเป็นลำดับแรกเมื่อโหลดได้รับการตอบสนอง ใช้ในพื้นที่ที่มีเงินอุดหนุนสำหรับการขายไฟฟ้าเข้าสู่กริด 3. โหมดลดการใช้ไฟฟ้าในช่วงพีค: หลังจากตั้งค่าโหมดการใช้เองหรือโหมดลำดับการขายเข้าสู่กริดแล้ว สามารถเลือกการลดการใช้ไฟฟ้าช่วงพีคของกริดได้เมื่อบริษัทไฟฟ้าท้องถิ่นเรียกเก็บค่าไฟฟ้าตามกำลังไฟฟ้าสูงสุดของระบบ ลูกค้าสามารถเปิดใช้งานการลดพีคนี้เพื่อหลีกเลี่ยงกำลังไฟฟ้าช่วงพีคที่จุดเชื่อมต่อกริด 4. โหมดนอกกริด: โหมดนี้ใช้สำหรับระบบนอกกริดเท่านั้น และไม่แนะนำสำหรับระบบกักเก็บพลังงานมาตรฐาน โปรดทราบว่าหากเปิดใช้งานโหมดนี้ในสถานะเชื่อมต่อกริด ตรรกะการทำงานของเครื่องจะสับสน และจะแสดงข้อความ \"นอกกริด\" 5. การใช้ตามช่วงเวลา: หากคุณต้องการควบคุมการชาร์จและคายประจุแบตเตอรี่ตามเวลาด้วยตนเองภายใต้โหมดการใช้เอง โหมดลำดับการขายเข้าสู่กริด หรือโหมดลดการใช้ไฟฟ้าช่วงพีค ให้ใช้สวิตช์การใช้ตามช่วงเวลาและจุดตั้งค่าต่อไปนี้ และค่า \"อนุญาตให้ชาร์จจากกริด\" ในทั้งสามโหมดนี้แนะนำให้เปิดไว้ (หากปิด อินเวอร์เตอร์จะไม่บังคับชาร์จแบตเตอรี่ และแบตเตอรี่อาจเข้าสู่โหมดพัก)",
  "10001.quickset.note2": "1. โหมดใช้งานเอง (Self-Use Mode): การตั้งค่าที่แนะนำคือโหมดใช้งานเอง โหมดนี้จะช่วยให้การใช้พลังงานจากการผลิตไฟฟ้าจากโซลาร์เซลล์สำหรับใช้ในบ้านเกิดประโยชน์สูงสุด หรือสามารถเก็บไว้ในแบตเตอรี่และนำมาใช้ในบ้านได้\n2. โหมดจ่ายไฟเข้าระบบก่อน (Feed in Priority Mode): โหมดนี้จะส่งไฟฟ้าเข้าระบบกริดก่อนเมื่อโหลดในบ้านเพียงพอแล้ว เหมาะสำหรับพื้นที่ที่มีการสนับสนุนค่าไฟฟ้าจากการส่งไฟฟ้าคืนกริด\n3. โหมดลดปริมาณการใช้ไฟช่วงพีก (Peak-shaving Mode): หลังจากตั้งค่าโหมดใช้งานเองหรือโหมดจ่ายไฟเข้าระบบก่อนแล้ว ยังสามารถเลือกลดปริมาณการใช้ไฟช่วงพีกได้ หากการไฟฟ้าท้องถิ่นคิดค่าไฟฟ้าตามปริมาณการใช้ไฟฟ้าสูงสุดของระบบ ผู้ใช้สามารถเลือกลดปริมาณการใช้ไฟช่วงพีกเพื่อหลีกเลี่ยงการใช้ไฟฟ้าสูงสุด ณ จุดเชื่อมต่อกริด\n4. โหมดนอกกริด (Off-Grid Mode): โหมดนี้ใช้สำหรับระบบนอกกริดเท่านั้น และไม่แนะนำให้ใช้กับระบบกักเก็บพลังงานมาตรฐาน หากเปิดโหมดนี้ในขณะที่เชื่อมต่อกับกริด การทำงานของเครื่องจะสับสนและจะแสดงข้อความ \"นอกกริด\"\n5. โหมดใช้ตามช่วงเวลา (Time Of Use): หากต้องการควบคุมการชาร์จและการจ่ายไฟของแบตเตอรี่ตามช่วงเวลาด้วยตนเอง ในโหมดใช้งานเอง โหมดจ่ายไฟเข้าระบบก่อน หรือโหมดลดปริมาณการใช้ไฟช่วงพีก ให้ใช้สวิตช์โหมดตามช่วงเวลาและค่าตั้งต่อไปนี้ และไม่แนะนำให้เปิดฟังก์ชัน \"อนุญาตให้ชาร์จจากการไฟฟ้า\" (Allow Grid Charging) ใน 3 โหมดนี้ (หากปิดฟังก์ชันนี้ อินเวอร์เตอร์จะไม่บังคับชาร์จแบตเตอรี่ และแบตเตอรี่อาจเข้าสู่โหมดหลับ)",
  "10001.quickset.note3": "1. โหมดใช้งานเอง (Self-Use Mode): การตั้งค่าที่แนะนำคือโหมดใช้งานเอง โหมดนี้จะช่วยให้การใช้พลังงานจากการผลิตไฟฟ้าจากโซลาร์เซลล์สำหรับใช้ในบ้านเกิดประโยชน์สูงสุด หรือสามารถเก็บไว้ในแบตเตอรี่และนำมาใช้ในบ้านได้\n2. โหมดจ่ายไฟเข้าระบบก่อน (Feed in Priority Mode): โหมดนี้จะส่งไฟฟ้าเข้าระบบกริดก่อนเมื่อโหลดในบ้านเพียงพอแล้ว เหมาะสำหรับพื้นที่ที่มีการสนับสนุนค่าไฟฟ้าจากการส่งไฟฟ้าคืนกริด\n3. โหมดนอกกริด (Off-Grid Mode): โหมดนี้ใช้สำหรับระบบนอกกริดเท่านั้น และไม่แนะนำให้ใช้กับระบบกักเก็บพลังงานมาตรฐาน หากเปิดโหมดนี้ในขณะที่เชื่อมต่อกับกริด การทำงานของเครื่องจะสับสนและจะแสดงข้อความ \"นอกกริด\"\n4. โหมดใช้ตามช่วงเวลา (Time Of Use): หากต้องการควบคุมการชาร์จและการจ่ายไฟของแบตเตอรี่ตามช่วงเวลาด้วยตนเอง ในโหมดใช้งานเอง โหมดจ่ายไฟเข้าระบบก่อน หรือโหมดลดปริมาณการใช้ไฟช่วงพีก ให้ใช้สวิตช์โหมดตามช่วงเวลาและค่าตั้งต่อไปนี้ และไม่แนะนำให้เปิดฟังก์ชัน \"อนุญาตให้ชาร์จจากการไฟฟ้า\" (Allow Grid Charging) ใน 3 โหมดนี้ (หากปิดฟังก์ชันนี้ อินเวอร์เตอร์จะไม่บังคับชาร์จแบตเตอรี่ และแบตเตอรี่อาจเข้าสู่โหมดหลับ)",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "จีน",
  "json.50901.workmode.timeSection": "ช่วงเวลา",
  "json.device.dryWorking": "การทำงานแบบแห้ง",
  "device.dryWorking": "การทำงานแบบแห้ง",
  "51002.ctrl_antireverse": "การควบคุมป้องกันการไหลย้อนกลับ",
  "51002.ctrl_inverter": "การควบคุม",
  "51002.null.数据分析_实时监控_PV.tag": "การตรวจสอบแบบเรียลไทม์_PV",
  "51002.real_time": "การตรวจสอบแบบเรียลไทม์",
  "51002.real_time.Energy_PV1.desc": "พลังงานสะสม PV1",
  "51002.real_time.Energy_PV2.desc": "พลังงานสะสม PV2",
  "51002.real_time.Energy_PV3.desc": "พลังงานสะสม PV3",
  "51002.real_time.Energy_PV4.desc": "พลังงานสะสม PV4",
  "51002.real_time.gridTotalFrequency.desc": "ความถี่รวมของโครงข่าย",
  "51002.real_time.inverterTemp.desc": "อุณหภูมิอินเวอร์เตอร์",
  "51002.real_time.pvPower.desc": "กำลังไฟฟ้าขาออก PV",
  "51002.real_time.stRelayoN.desc": "สถานะการเชื่อมต่อรีเลย์",
  "51002.real_time.workStatus.desc": "สถานะการทำงาน",
  "51002.real_time.数据分析_实时监控_GRID.tag": "ข้อมูลโครงข่าย",
  "51002.real_time.数据分析_实时监控_P.tag": "กำลังไฟฟ้าขาออก PV",
  "51002.real_time.数据分析_实时监控_PV.tag": "พีวี",
  "51002.real_time.数据分析_实时监控_TP.tag": "อุณหภูมิอินเวอร์เตอร์",
  "51002.warning": "การแจ้งเตือน",
  "51002.warning.stAbnorm_Ris.desc": "ความผิดปกติของอิมพีแดนซ์ฉนวน",
  "51002.warning.stErrAccess_EEPROM.desc": "ความผิดปกติของการเข้าถึง EEPROM",
  "51002.warning.stErrOP_Relay.desc": "ความผิดปกติของรีเลย์ฝั่งโครงข่าย",
  "51002.warning.stHW_Fault.desc": "การป้องกันฮาร์ดแวร์อินเวอร์เตอร์",
  "51002.warning.stOV_Fgrid.desc": "การป้องกันความถี่เกินฝั่งโครงข่าย",
  "51002.warning.stOV_Temp.desc": "การป้องกันอุณหภูมิเกินอินเวอร์เตอร์",
  "51002.warning.stOV_Vgrid.desc": "การป้องกันแรงดันเกินฝั่งโครงข่าย",
  "51002.warning.stPV1_OV.desc": "แรงดันเกินอินพุต PV 1",
  "51002.warning.stPV1_UV.desc": "แรงดันตกอินพุต PV 1",
  "51002.warning.stPV2_OV.desc": "แรงดันเกินอินพุต PV 2",
  "51002.warning.stPV2_UV.desc": "แรงดันตกอินพุต PV 2",
  "51002.warning.stPV3_OV.desc": "แรงดันเกินอินพุต PV 3",
  "51002.warning.stPV3_UV.desc": "แรงดันตกอินพุต PV 3",
  "51002.warning.stPV4_OV.desc": "แรงดันเกินอินพุต PV 4",
  "51002.warning.stPV4_UV.desc": "แรงดันตกอินพุต PV 4",
  "51002.warning.stUV_Fgrid.desc": "การป้องกันความถี่ต่ำกว่าฝั่งโครงข่าย",
  "51002.warning.stUV_Vgrid.desc": "การป้องกันแรงดันตกฝั่งโครงข่าย",
  "51002..gridtype.desc": "มาตรฐานโครงข่าย",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "ปิดใช้งาน",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaRestoretodefault.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaRestoretodefault.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "เปิดใช้งาน",
  "51002.real_time.stRelayoN.0": "ตัดการเชื่อมต่อ",
  "51002.real_time.stRelayoN.1": "ปิด",
  "51002.real_time.workStatus.0": "ปิดเครื่อง",
  "51002.real_time.workStatus.1": "เปิดเครื่อง",
  "51002.warning.stAbnorm_Ris.0": "การทำงานปกติ",
  "51002.warning.stAbnorm_Ris.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stErrAccess_EEPROM.0": "การทำงานปกติ",
  "51002.warning.stErrAccess_EEPROM.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stErrOP_Relay.0": "การทำงานปกติ",
  "51002.warning.stErrOP_Relay.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stHW_Fault.0": "การทำงานปกติ",
  "51002.warning.stHW_Fault.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stOV_Fgrid.0": "การทำงานปกติ",
  "51002.warning.stOV_Fgrid.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stOV_Temp.0": "การทำงานปกติ",
  "51002.warning.stOV_Temp.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stOV_Vgrid.0": "การทำงานปกติ",
  "51002.warning.stOV_Vgrid.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV1_OV.0": "การทำงานปกติ",
  "51002.warning.stPV1_OV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV1_UV.0": "การทำงานปกติ",
  "51002.warning.stPV1_UV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV2_OV.0": "การทำงานปกติ",
  "51002.warning.stPV2_OV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV2_UV.0": "การทำงานปกติ",
  "51002.warning.stPV2_UV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV3_OV.0": "การทำงานปกติ",
  "51002.warning.stPV3_OV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV3_UV.0": "การทำงานปกติ",
  "51002.warning.stPV3_UV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV4_OV.0": "การทำงานปกติ",
  "51002.warning.stPV4_OV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stPV4_UV.0": "การทำงานปกติ",
  "51002.warning.stPV4_UV.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stUV_Fgrid.0": "การทำงานปกติ",
  "51002.warning.stUV_Fgrid.1": "กระตุ้นการแจ้งเตือน",
  "51002.warning.stUV_Vgrid.0": "การทำงานปกติ",
  "51002.warning.stUV_Vgrid.1": "กระตุ้นการแจ้งเตือน",
  "51002.ctrl_inverter.ena10mVs1Prot": "เปิดใช้งานการป้องกันแรงดันเกินเฉลี่ยระดับ 1 ฝั่งโครงข่าย 10 นาที",
  "51002.ctrl_inverter.enaINVTR.0": "ปิดเครื่อง",
  "51002.ctrl_inverter.enaINVTR.1": "เปิดเครื่อง",
  "51002.ctrl_inverter.enaOVTPWDN.0": "ปิดใช้งาน",
  "51002.ctrl_inverter.enaOVTPWDN.1": "เปิดใช้งาน",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "สวิตช์ฟังก์ชันทดสอบตัวเองของอินเทอร์เฟซการป้องกันระบบ",
  "51002.real_time.Energy_PV1": "การผลิตพลังงานสะสม PV1",
  "51002.real_time.Energy_PV2": "การผลิตพลังงานสะสม PV2",
  "51002.real_time.Energy_PV3": "การผลิตพลังงานสะสม PV3",
  "51002.real_time.Energy_PV4": "การผลิตพลังงานสะสม PV4",
  "51002.real_time.Firmware_ver": "หมายเลขเวอร์ชันเฟิร์มแวร์",
  "51002.real_time.Fn": "ความถี่พิกัดของโครงข่ายที่เชื่อมต่อ",
  "51002.real_time.gridTotalFrequency": "ความถี่รวม",
  "51002.real_time.Iacrms": "ค่า RMS ของกระแสฝั่งโครงข่าย",
  "51002.real_time.inverterTemp": "อุณหภูมิอินเวอร์เตอร์",
  "51002.real_time.Ipv1": "กระแสอินพุต PV1",
  "51002.real_time.Ipv2": "กระแสอินพุต PV2",
  "51002.real_time.Ipv3": "กระแสอินพุต PV3",
  "51002.real_time.Ipv4": "กระแสอินพุต PV4",
  "51002.real_time.Ipvmax": "กระแสอินพุต PV สูงสุด",
  "51002.real_time.Irmsmax": "ค่า RMS สูงสุดของกระแสเชื่อมต่อโครงข่าย",
  "51002.real_time.Pn": "กำลังงานจริงสูงสุดที่เชื่อมต่อโครงข่าย",
  "51002.real_time.powerGeneration": "การผลิตพลังงานรวม",
  "51002.real_time.Powpvmax": "กำลังไฟฟ้าอินพุต PV สูงสุด",
  "51002.real_time.pvPower": "กำลังไฟฟ้าขาออก PV",
  "51002.real_time.stRelayoN": "สถานะการเชื่อมต่อรีเลย์",
  "51002.real_time.Tempmax": "อุณหภูมิทำงานสูงสุด",
  "51002.real_time.Un": "ค่า RMS ของแรงดันไฟฟ้าพิกัดที่เชื่อมต่อโครงข่าย",
  "51002.real_time.Vacrms": "ค่า RMS ของแรงดันฝั่งโครงข่าย",
  "51002.real_time.Vmpptmax": "แรงดัน MPPT สูงสุด",
  "51002.real_time.Vmpptmin": "แรงดัน MPPT ต่ำสุด",
  "51002.real_time.Vpv1": "แรงดันอินพุต PV1",
  "51002.real_time.Vpv2": "แรงดันอินพุต PV2",
  "51002.real_time.Vpv3": "แรงดันอินพุต PV3",
  "51002.real_time.Vpv4": "แรงดันอินพุต PV4",
  "51002.real_time.workStatus": "สถานะการทำงาน",
  "51002.warning.stAbnorm_Ris": "ความผิดปกติของอิมพีแดนซ์ฉนวน",
  "51002.warning.stErrAccess_EEPROM": "ความผิดปกติของการเข้าถึง EEPROM",
  "51002.warning.stErrOP_Relay": "การป้องกันความผิดปกติของรีเลย์ฝั่งโครงข่าย",
  "51002.warning.stHW_Fault": "การป้องกันฮาร์ดแวร์อินเวอร์เตอร์",
  "51002.warning.stOV_Fgrid": "การป้องกันความถี่เกินฝั่งโครงข่าย",
  "51002.warning.stOV_Temp": "การป้องกันอุณหภูมิเกินอินเวอร์เตอร์",
  "51002.warning.stOV_Vgrid": "การป้องกันแรงดันเกินฝั่งโครงข่าย",
  "51002.warning.stPV1_OV": "แรงดันเกินอินพุต PV 1",
  "51002.warning.stPV1_UV": "แรงดันตกอินพุต PV 1",
  "51002.warning.stPV2_OV": "แรงดันเกินอินพุต PV 2",
  "51002.warning.stPV2_UV": "แรงดันตกอินพุต PV 2",
  "51002.warning.stPV3_OV": "แรงดันเกินอินพุต PV 3",
  "51002.warning.stPV3_UV": "แรงดันตกอินพุต PV 3",
  "51002.warning.stPV4_OV": "แรงดันเกินอินพุต PV 4",
  "51002.warning.stPV4_UV": "แรงดันตกอินพุต PV 4",
  "51002.warning.stUV_Fgrid": "การป้องกันความถี่ต่ำกว่าฝั่งโครงข่าย",
  "51002.warning.stUV_Vgrid": "การป้องกันแรงดันตกฝั่งโครงข่าย",
  "51002.ctrl_antireverse.dynamicPowerLimit": "ค่าเปอร์เซ็นต์ขีดจำกัดกำลังป้องกันการย้อนกลับ",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "เปิดใช้งานป้องกันการไหลย้อนกลับ",
  "51002.ctrl_inverter.enaAPP_PWSET": "เปิดใช้งานการตั้งค่ากำลังไฟฟ้าของผู้ใช้",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "เปิดใช้งานการควบคุมกำลังไฟฟ้าด้วยออฟเซ็ตความถี่",
  "51002.ctrl_inverter.enaINVTR": "เปิด/ปิดอินเวอร์เตอร์ระยะไกล",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "เปิดใช้งานการป้องกันความผิดปกติของอิมพีแดนซ์ฉนวน",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "เปิดใช้งานการลดพิกัดแรงดันเกินระดับ 1",
  "51002.ctrl_inverter.enaOVTPWDN": "เปิดใช้งานการลดพิกัดอุณหภูมิเกิน",
  "51002.ctrl_inverter.enaRestoretodefault": "คืนค่าเริ่มต้นของค่าการป้องกันและสวิตช์ฟังก์ชัน",
  "51002.ctrl_inverter.powersetUserApp": "เปอร์เซ็นต์ขีดจำกัดกำลังไฟฟ้าของผู้ใช้",
  "bw_param_ctrl_option_BackupMode": "โหมดพลังงานสำรอง",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "ลำดับความสำคัญป้อนไฟเข้าเน็ตเวิร์ก",
  "50657.fault.comStatus": "สถานะการสื่อสาร",
  "50657.fault.comStatus.00": "ตัดการเชื่อมต่อ",
  "50657.fault.comStatus.01": "เชื่อมต่อ",
  "50657.realtime.FADE": "พลังงานไฟฟ้าจริงช่วงหุบเขาลึกทิศหน้า",
  "50657.realtime.FAFE": "พลังงานไฟฟ้าจริงช่วงปกติทิศหน้า",
  "50657.realtime.FAFE_PSD": "พลังงานไฟฟ้าจริงช่วงปกติทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.FAPE": "พลังงานไฟฟ้าจริงช่วงพีคทิศหน้า",
  "50657.realtime.FAPE_PSD": "พลังงานไฟฟ้าจริงช่วงพีคทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.FAPVE": "พลังงานไฟฟ้าจริงช่วงพีค-หุบเขาทิศหน้า",
  "50657.realtime.FAPVE_PSD": "พลังงานไฟฟ้าจริงช่วงพีค-หุบเขาทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.FASE": "พลังงานไฟฟ้าจริงช่วงพีคสูงสุดทิศหน้า",
  "50657.realtime.FASE_PSD": "พลังงานไฟฟ้าจริงช่วงพีคสูงสุดทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.FAVE": "พลังงานไฟฟ้าจริงช่วงหุบเขาทิศหน้า",
  "50657.realtime.FAVE_PSD": "พลังงานไฟฟ้าจริงช่วงหุบเขาทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.FTAE": "พลังงานไฟฟ้าจริงรวมทิศหน้า",
  "50657.realtime.FTAE_PSD": "พลังงานไฟฟ้าจริงรวมทิศหน้า (วันชำระเงินก่อนหน้า)",
  "50657.realtime.Fr": "ความถี่",
  "50657.realtime.Ia": "กระแสเฟส A",
  "50657.realtime.Ib": "กระแสเฟส B",
  "50657.realtime.Ic": " กระแสเฟส C",
  "50657.realtime.P": "กำลังไฟฟ้าจริงรวม",
  "50657.realtime.Pa": "กำลังไฟฟ้าจริงรวมเฟส A",
  "50657.realtime.Pb": "กำลังไฟฟ้าจริงรวมเฟส B",
  "50657.realtime.Pc": "กำลังไฟฟ้าจริงรวมเฟส C",
  "50657.realtime.Pf": "ตัวประกอบกำลังไฟฟ้ารวม",
  "50657.realtime.Pfa": "ตัวประกอบกำลังไฟฟ้าเฟส A",
  "50657.realtime.Pfb": "ตัวประกอบกำลังไฟฟ้าเฟส B",
  "50657.realtime.Pfc": "ตัวประกอบกำลังไฟฟ้าเฟส C",
  "50657.realtime.Q": "กำลังไฟฟ้าเฉื่อยรวม",
  "50657.realtime.Qa": "กำลังไฟฟ้าเฉื่อยรวมเฟส A",
  "50657.realtime.Qb": "กำลังไฟฟ้าเฉื่อยรวมเฟส B",
  "50657.realtime.Qc": "กำลังไฟฟ้าเฉื่อยรวมเฟส C",
  "50657.realtime.RADE": "พลังงานไฟฟ้าจริงช่วงหุบเขาลึกทิศย้อน",
  "50657.realtime.RAFE": "พลังงานไฟฟ้าจริงช่วงปกติทิศย้อน",
  "50657.realtime.RAPE": "พลังงานไฟฟ้าจริงช่วงพีคทิศย้อน",
  "50657.realtime.RASE": "พลังงานไฟฟ้าจริงช่วงพีคสูงสุดทิศย้อน",
  "50657.realtime.RAVE": "พลังงานไฟฟ้าจริงช่วงหุบเขาทิศย้อน",
  "50657.realtime.RTAE": "พลังงานไฟฟ้าจริงรวมทิศย้อน",
  "50657.realtime.S": "กำลังไฟฟ้าปรากฏรวม",
  "50657.realtime.Sa": "กำลังไฟฟ้าปรากฏเฟส A",
  "50657.realtime.Sb": "กำลังไฟฟ้าปรากฏเฟส B",
  "50657.realtime.Sc": "กำลังไฟฟ้าปรากฏเฟส C",
  "50657.realtime.T": "อุณหภูมิ",
  "50657.realtime.Ua": "แรงดันเฟส A",
  "50657.realtime.Uab": "แรงดันไลน์ AB",
  "50657.realtime.Ub": " แรงดันเฟส B",
  "50657.realtime.Ubc": "แรงดันไลน์ BC",
  "50657.realtime.Uc": "แรงดันเฟส C",
  "50657.realtime.Uca": "แรงดันไลน์ CA",
  "50657.realtime.Z0": "ความต้านทานลำดับศูนย์",
  "50657.realtime.Zf": "ความต้านทานทิศหน้า",
  "bw_param_ctrl_note_DispatchActivepower": "การตั้งค่าข้อมูลนี้เป็นจำนวนบวกบ่งชี้ถึงความจำเป็นในการคายประจุ ในขณะที่การตั้งค่าเป็นจำนวนลบบ่งชี้ถึงความจำเป็นในการชาร์จ",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "บังคับชาร์จ/คายประจุ",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "โครงข่ายใช้ CT、PV ใช้มิเตอร์",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "ใช้มิเตอร์สำหรับระบบไฟฟ้า ใช้ CT สำหรับพลังงานแสงอาทิตย์",
  "bw_param_ctrl_option_DisableTimePeriodControl": "ปิดใช้งานการควบคุมช่วงเวลา",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "เปิดใช้งานการควบคุมช่วงเวลาการชาร์จเท่านั้น",
  "bw_RTparam_name_TotalApparentPower_Grid": "กำลังไฟฟ้าปรากฏมิเตอร์ (รวม)",
  "bw_param_ctrl_name_FactoryReset ": "รีเซ็ตโรงงาน",
  "bw_param_ctrl_option_FactoryReset ": "รีบูต",
  "bw_param_ctrl_note_DSPReset": "เมื่อข้อมูลข้อผิดพลาดไม่สอดคล้องกับสถานการณ์จริง สามารถกู้คืนได้โดยการรีสตาร์ท DSP ตัวอย่างเช่น หากแอปพบข้อผิดพลาดการสูญเสียสายกราวด์ แต่สายกราวด์ที่เชื่อมต่อกับอินเวอร์เตอร์ไม่ได้ขาด สามารถกู้คืนได้โดยการรีสตาร์ท DSP",
  "bw_param_ctrl_note_EMSReset": "เมื่อเกิดการรวบรวมข้อมูลผิดปกติ โปรดรีเซ็ต EMS เพื่อกู้คืนระบบ",
  "bw_param_ctrl_note_FactoryReset": "หากต้องการตั้งค่าพารามิเตอร์ทั้งหมดของอินเวอร์เตอร์เป็นค่าเริ่มต้น สามารถใช้ฟังก์ชันนี้ได้",
  "bw_param_ctrl_option_Grid&PVuseCT": "กริดและ PV ใช้ CT",
  "bw_param_outage_soc_setting": "การตั้งค่า SOC เมื่อหยุดการ cấpไฟ",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "การตั้งค่ามาตรฐานความปลอดภัย",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "ลำดับความสำคัญรายได้สถานี",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "subtitle.warn": "แจ้งตำรวจ",
  "subtitle.fault": "ข้อผิดพลาด",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "bw_RTparam_name_TotalPowerFactor_PV": "ตัวประกอบกำลังของมิเตอร์ไฟฟ้า (รวม)",
  "bw_RTparam_name_TotalPowerFactor_PV1": "ตัวประกอบกําลังมิเตอร์ (รวม)1",
  "plant.runningState": "สถานะการทำงาน",
  "solis.10001.gridVoltageA": "แรงดันไฟฟ้าของกริด L1",
  "solis.10001.iPv30": "กระแส PV-30",
  "systemAuthority.enable": "เปิดใช้งาน",
  "solis.10001.iPv31": "กระแส PV-31",
  "solis.10001.gridVoltageC": "แรงดันไฟฟ้าของกริด L3",
  "solis.10001.iPv32": "กระแส PV-32",
  "solis.10001.gridVoltageB": "แรงดันไฟฟ้าของกริด L2",
  "jl_param_ctrl_group_AdvancedSetting-OtherSetting": "การตั้งค่าขั้นสูง - การตั้งค่าอื่น ๆ",
  "agent.search": "ค้นหา",
  "datalog.methods_rereset": "รีสตาร์ท?",
  "bw_param_ctrl_option_ON": "เปิด",
  "shipment.shippingManagement": "การจัดการการจัดส่ง",
  "common.50402.PV21_V": "แรงดัน PV21",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFdstart": "01-ความถี่ต่ำเพิ่มโหลด Fdstart",
  "org.passwordResetFail": "การรีเซ็ตรหัสผ่านล้มเหลว",
  "product.time": "เวลาบริการ",
  "mini.65290.stPV4_UV": "PV  อินพุต 4 แรงดันต่ำ",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "สวิตช์ช่วงเวลาการคายประจุ 5",
  "ship.add.data.error": "พบข้อมูลผิดปกติในการเพิ่มข้อมูลการจัดการการจัดส่ง โปรดติดต่อผู้ดูแลระบบ",
  "mini.65290.Vacrms": "ค่าแรงดันไฟฟ้าที่มีประสิทธิผลของกริด",
  "solis.10001.iPv20": "กระแส PV-20",
  "solis.10001.iPv21": "กระแส PV-21",
  "solis.10001.iPv22": "กระแส PV-22",
  "unc.65323.pvTotalEnergy": "กำลังการผลิตไฟฟ้าทั้งหมดจาก PV",
  "solis.10001.iPv23": "กระแส PV-23",
  "solis.10001.iPv24": "กระแส PV-24",
  "solis.10001.iPv25": "กระแส PV-25",
  "solis.10001.iPv26": "กระแส PV-26",
  "subtitle.happening": "กำลังดำเนินการ",
  "solis.10001.iPv27": "กระแส PV-27",
  "solis.10001.pacPec": "เปอร์เซ็นต์กำลัง",
  "solis.10001.iPv28": "กระแส PV-28",
  "solis.10001.iPv29": "กระแส PV-29",
  "org.leaderPhone": "ข้อมูลติดต่อผู้รับผิดชอบ",
  "jl_param_ctrl_name_FeedinCurrentLimitSwtich": "สวิตช์จำกัดกระแสไฟฟ้าเข้าสู่กริด",
  "ES-L-N": "Spain_ES-L-N",
  "setting.type10.chargePriority": "ลำดับความสำคัญของการชาร์จ",
  "setting.type12.LEDBrightness": "ความสว่างของ LED",
  "product.PleaseEnterTheParameterSettingType": "โปรดป้อนประเภทการตั้งค่าพารามิเตอร์",
  "socket.startaddress": "ที่อยู่รีจิสเตอร์เริ่มต้น",
  "product.LastWeek": "สัปดาห์ล่าสุด",
  "solis.10001.iPv10": "กระแส PV-10",
  "bw_param_ctrl_name_Systemmode": "โหมดระบบ",
  "solis.10001.iPv11": "กระแส PV-11",
  "bw_RTparam_name_PFOC_Grid": "ตัวประกอบกำลังของมิเตอร์ไฟฟ้า C",
  "solis.10001.iPv12": "กระแส PV-12",
  "solis.10001.iPv13": "กระแส PV-13",
  "solis.10001.iPv14": "กระแส PV-14",
  "setting.type11.dischargeTimeMaxSOC3": "SOC ต่ำสุดของช่วงเวลาการคายประจุ 3 (%)",
  "solis.10001.iPv15": "กระแส PV-15",
  "setting.type11.dischargeTimeMaxSOC2": "SOC ต่ำสุดของช่วงเวลาการคายประจุ 2 (%)",
  "solis.10001.iPv16": "กระแส PV-16",
  "solis.10001.iPv17": "กระแส PV-17",
  "setting.type11.dischargeTimeMaxSOC4": "SOC ต่ำสุดของช่วงเวลาการคายประจุ 4 (%)",
  "solis.10001.iPv18": "กระแส PV-18",
  "tip.log.connectWiFiSuccess": "การเชื่อมต่อเร้าเตอร์สำเร็จ",
  "solis.10001.iPv19": "กระแส PV-19",
  "setting.type11.dischargeTimeMaxSOC1": "SOC ต่ำสุดของช่วงเวลาการคายประจุ 1 (%)",
  "product.agent": "ตัวแทน",
  "bw_RTparam_name_Minimumcellvoltage": "แรงดันเซลล์ต่ำสุด",
  "subtitle.solution": "วิธีการแก้ปัญหา",
  "title.datalogger": "ตัวเก็บข้อมูล",
  "ywt.65323.ctBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของเฟส B ของมิเตอร์ไฟฟ้า",
  "bw_param_ctrl_option_ACMode": "โหมด AC",
  "storage.s3.65292.pv1Power": "กำลังไฟฟ้าที่ผลิตจากแผง PV เส้นที่ 1",
  "tip.energy.tip3.deforestation": "ปกป้องต้นไม้:",
  "solis.10001.gridSellYearEnergy": "ปริมาณไฟฟ้าที่ขายให้กริดต่อปี",
  "datalog.span_name": "ชื่ออื่น:",
  "title.editPlant": "แก้ไขสถานีไฟฟ้า",
  "GN-DZL": "China_GN-DZL",
  "subtitle.VisitSupportCenter": "เยี่ยมชมเว็บไซต์อย่างเป็นทางการเพื่อความช่วยเหลือเพิ่มเติม",
  "setting.type12.maxAcChargingCur": "กระแสชาร์จ AC สูงสุด",
  "bw_param_ctrl_option_Reverse": "กลับด้าน",
  "setting.type7.setVal.recover": "กู้คืน",
  "jl_param_ctrl_option_PAND": "PAND",
  "subtitle.manualInstuction": "คู่มือแนะนำ",
  "setting.general.valScope": "ช่วงของพารามิเตอร์ที่ป้อนคือ",
  "datalog.delete": "ลบ",
  "solis.10001.fAc": "ความถี่ของกริด",
  "storage.s3.65292.aChargeActivePower": "กำลังไฟฟ้าที่ใช้งานของเฟส A",
  "jl_param_ctrl_name_PhysicalAddressID": "ID ที่อยู่ทางกายภาพ",
  "jl_param_ctrl_note_AFCIlevel": "ระดับการป้องกัน AFCI โปรดอย่าปรับเปลี่ยนโดยไม่ได้รับคำแนะนำจากวิศวกรผู้เชี่ยวชาญ",
  "setting.type10.timeSharingGridConnectedDischarge": "การคายประจุแบบเชื่อมต่อกับกริดตามเวลา",
  "city.not.exist": "ไม่มีเมืองดังกล่าว",
  "sidebar.firmware_up": "อัปโหลดเฟิร์มแวร์",
  "setting.type19.offgridSettings": "การตั้งค่าเชื่อมต่อและแยกจากกริด",
  "validate.email.sendVerificationCodeEmailAddress": "ส่งรหัสยืนยัน",
  "jl_param_ctrl_name_ACCoulplingMax.fre": "ความถี่การลดโหลดสูงสุด",
  "App.System_Config": "การตั้งค่าระบบ",
  "bw_RTparam_name_noCharging": "ห้ามชาร์จ/ห้ามคายประจุ",
  "jl_param_ctrl_name_GradientLimitforPowerChange": "การจำกัดความชันของการเปลี่ยนแปลงกำลังไฟฟ้า",
  "shipment.packUp": "ย่อ",
  "subtitle.month": "เดือน",
  "tip.validate.firstChoiceCountry": "โปรดเลือกประเทศก่อน",
  "setting.type22.highVoltage": "แรงดันสูงเริ่มต้น AC",
  "jl_param_ctrl_name_UN-G-V-T01": "UN-G-V-T 01",
  "jl_param_ctrl_name_UN-G-V-T02": "UN-G-V-T 02",
  "jl_param_ctrl_option_J-Pack-LV": "J-Pack-LV",
  "solis.10001.iB": "กระแสของมิเตอร์ไฟฟ้า B",
  "solis.10001.iA": "กระแสของมิเตอร์ไฟฟ้า A",
  "jl_param_ctrl_note_MeterTypeandInstallationLocation": "ตั้งค่าประเภทของมิเตอร์ไฟฟ้าอัจฉริยะที่ใช้ในระบบ",
  "solis.10001.iC": "กระแสของมิเตอร์ไฟฟ้า C",
  "setting.type19.gridConnectedControlMode": "การควบคุมการเชื่อมต่อกับกริด",
  "jl_param_ctrl_name_PowerFactorSettingPowerDownStorage": "การตั้งค่าตัวประกอบกำลังที่บันทึกเมื่อไฟฟ้าดับ",
  "subtitle.agent": "ตัวแทน",
  "login.password": "รหัสผ่าน",
  "subtitle.masterControlConfiguration": "การตั้งค่าเครือข่ายหลัก",
  "tip.opsLog.control": "ตัวควบคุม",
  "jl_param_ctrl_note_FeedinCurrentLimitSwtich": "สวิตช์นี้ใช้เพื่อเปิด/ปิดฟังก์ชันการควบคุมกระแสไฟฟ้าเข้าสู่กริดของระบบ",
  "R14-208A": "USA_R14-208A",
  "Meter_in_Grid_Acrel_1P_Meter": "แรงดันไฟฟ้าของกริดแบบเฟสเดียว Acrel",
  "setting.type22.acUnderVolTime1": "เวลาระดับแรกของแรงดันต่ำ AC (s)",
  "validate.email.getVerificationCode": "รับรหัสยืนยัน",
  "jl_param_ctrl_note_MPPTMulti-peakScanningSwitch": "ใช้ในสภาพแวดล้อมที่มีเงา เปิดใช้งานการสแกนจุดกำลังสูงสุดทั่วโลก เนื่องจากการดำเนินการสแกน IV อาจส่งผลต่อการผลิตไฟฟ้า",
  "setting.type22.acUnderVolTime2": "เวลาระดับสองของแรงดันต่ำ AC (s)",
  "setting.type12.parallelMode": "โหมดการทำงานร่วมกัน",
  "title.selectCity": "เลือกเมือง",
  "plant.batterySOC": "SOC ของแบตเตอรี่กักเก็บพลังงาน",
  "unc.65323.busVoltage": "แรงดันบัส",
  "systemAuthority.Disabled": "ปิดใช้งาน",
  "subtitle.totalConsumption": "ปริมาณการใช้ไฟฟ้ารวม",
  "plant.totalPlantNum": "จำนวนทั้งหมด",
  "bw_RTparam_name_forced": "การชาร์จ/คายประจุแบบบังคับ",
  "plant.input_IncomeUnit": "เลือกหน่วยรายได้",
  "solis.10001.eYear": "ปริมาณการผลิตไฟฟ้าต่อปี",
  "ywt.65323.loadReactivePower": "กำลังไฟฟ้าที่ไม่ใช้งานของโหลด",
  "button.unsubscribe": "ยกเลิกบัญชี",
  "ywt.65323.batteryCurrent": "กระแสของแบตเตอรี่",
  "upload.image": "รูปภาพ",
  "button.redistributionNetwork": "การตั้งค่าเครือข่ายใหม่",
  "subtitle.Anti-backflowSwitch": "สวิตช์ป้องกันการไหลย้อนกลับ",
  "common.save": "บันทึก",
  "placeholder.enter": "โปรดป้อน {scope}",
  "plant.input_InstalltionDate": "โปรดเลือกวันที่ติดตั้ง",
  "button.refresh": "รีเฟรช",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "ไม่ได้เปิดใช้งานฟังก์ชันการชาร์จ/คายประจุ",
  "product.PleaseEnterABlockCode": "โปรดป้อนรหัสกลุ่ม",
  "login.correctEmail": "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
  "unc.65323.load2GeneratorTotalGenerateEnergy": "ปริมาณการผลิตไฟฟ้ารวมของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "bw_RTparam_name_electricity": "การใช้มิเตอร์ไฟฟ้าสำหรับกริด และ CT สำหรับ PV",
  "plant.max_20": "จำนวนตัวอักษรต้องไม่เกิน 20 ตัว",
  "setting.type22.ACStartVoltage": "การตั้งค่าแรงดัน/ความถี่เริ่มต้น",
  "jl_param_ctrl_option_FixPF_": "PF คงที่",
  "End_user.input_StationName": "โปรดป้อนชื่อสถานการณ์",
  "tip.home.month": "ปริมาณการผลิตไฟฟ้าต่อเดือน",
  "tip.validate.plantName": "ชื่อสถานีไฟฟ้าไม่สามารถเว้นว่างได้ โปรดป้อนชื่อสถานีไฟฟ้า",
  "setting.type6.OV_resopnseTime": "เวลาตอบสนองต่อแรงดันเกินระดับ {num}",
  "jl_param_ctrl_option_Lead-aci_Battery": "แบตเตอรี่ตะกั่วกรด",
  "tip.home.year": "ปริมาณการผลิตไฟฟ้าต่อปี",
  "subtitle.alarmStartTime": "เวลาเริ่มต้นการแจ้งเตือน",
  "storage.s3.65292.bat4CellVol": "แรงดันเซลล์ 4",
  "common.50100.pv1Power": "กำลังไฟฟ้าตามเวลาจริงของ PV1",
  "placeholder.enterEmail": "โปรดป้อนอีเมล",
  "End_user.input_TimeZone": "โปรดเลือกเขตเวลา",
  "device.plant": "สถานีไฟฟ้า",
  "jl_param_ctrl_option_Q_Mode-Volt-var": "โหมดแรงดันและกำลังไฟฟ้าไม่ใช้งาน Q",
  "ywt.65323.batAlarmFlag": "สัญญาณเตือนของแบตเตอรี่",
  "button.delete": "ลบ",
  "setting.type22.ACStartFrequency": "การตั้งค่าแรงดันเกิน/ต่ำและความถี่",
  "subtitle.restored": "กู้คืนแล้ว",
  "can.not.empty": "ไม่สามารถเว้นว่างได้",
  "plant.buyPowers": "กำลังไฟฟ้าที่ซื้อ",
  "common.50300.capacity": "กำลังไฟฟ้าที่ปรากฏ (Kw)",
  "jl_paran_ctrl_name_InverterConnectedPhaseSetting": "การตั้งค่าเฟสการเชื่อมต่อของอินเวอร์เตอร์",
  "storage.v2.65284.pvInputVoltage": "แรงดันไฟฟ้าอินพุตของ PV",
  "bw_RTparam_name_BatteryDischargeCurrentLimit": "การจำกัดกระแสการคายประจุของแบตเตอรี่",
  "unc.65323.load2GeneratorTodayGenerateEnergy": "ปริมาณการผลิตไฟฟ้าวันนี้ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "ywt.65323.runStatus": "สถานะการทำงาน",
  "jl_param_ctrl_group_BatterySetting": "การตั้งค่าแบตเตอรี่",
  "ywt.65323.returnFlowPortApparentPower": "กำลังไฟฟ้าที่ปรากฏของพอร์ตการไหลกลับ",
  "tip.validate.passwordNotMatch": "รหัสผ่านที่ป้อนทั้งสองครั้งไม่ตรงกัน โปรดตรวจสอบและยืนยันก่อนส่ง",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_3P_Meter_Only_applicable_for_Eastron_Meter": "แรงดันไฟฟ้าของกริดและด้านเอาต์พุตของอินเวอร์เตอร์แบบขนาน (มิเตอร์ไฟฟ้าคู่) Acrel แบบสามเฟส มีผลเฉพาะกับมิเตอร์ไฟฟ้า Donghong",
  "setting.type12.ratedOutputFreq": "ความถี่เอาต์พุตที่กำหนด",
  "End_user.please_select": "โปรดเลือก",
  "setting.type10.auxSourceSet": "สวิตช์แหล่งจ่ายไฟเสริม",
  "bw_RTparam_name_ReactivePOAP_Grid": "กำลังไฟฟ้าที่ไม่ใช้งานของมิเตอร์ไฟฟ้า A",
  "setting.type3.timeDischarge": "การคายประจุตามเวลา",
  "setting.type12.val.purple": "สีม่วง",
  "subtitle.TheDataGatewayRestarts": "รีสตาร์ทเกตเวย์ข้อมูล",
  "title.selectCountry": "เลือกประเทศ",
  "jl_param_ctrl_option_Factory_Reset": "คืนค่าการตั้งค่าโรงงาน",
  "device.drmStatus": "สถานะ DRM",
  "datalog.span_upgrade": "อัปเกรดตัวเก็บข้อมูล",
  "datalog.btn_upgrade": "อัปเกรด",
  "tip.request.loading": "กำลังโหลด",
  "jl_param_ctrl_note_Min.DroopVoltage": "แรงดันไฟฟ้าต่ำสุดที่อนุญาตในฟังก์ชันการลดแรงดันเมื่อโหลดเกิน",
  "setting.type6.enaSysProtIF_selfCheck": "การตรวจสอบตัวเองของอินเทอร์เฟซการป้องกันระบบ",
  "jl_param_ctrl_option_0C-Denmark": "0C-เดนมาร์ก",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "พลังงานเข้าสู่กริด",
  "common.50402.Derating": "การลดโหลด",
  "tip.validate.SN1": "หมายเลขซีเรียลไม่สามารถเว้นว่างได้",
  "login.agreement.and": "และ",
  "setting.type7.setVal.clearHistory": "ลบประวัติ",
  "tip.validate.SN2": "หมายเลขซีเรียลต้องมี 10 หลัก",
  "jl_param_ctrl_name_GridCodeWorkMode": "โหมดการทำงานตามมาตรฐานแห่งชาติ\nID 378",
  "storage.v2.65284.ratedCapacity": "ความจุที่กำหนดของแบตเตอรี่",
  "setting.type6.enaRestoretodefault": "คืนค่าการตั้งค่าเริ่มต้น",
  "upload.fielExceed": "ไฟล์เกินจำนวนที่กำหนด",
  "KS3-LVRT": "KS3-LVRT",
  "solis.10001.homeLoadTotalEnergy": "ปริมาณการใช้พลังงานรวมของโหลด",
  "jl_param_ctrl_note_Self-UseModeSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดโหมดการใช้ไฟฟ้าเอง\nโหมดการใช้ไฟฟ้าเอง โหมดให้ความสำคัญกับกริด โหมด Peak-shaving และโหมดแยกจากกริดไม่สามารถปิดพร้อมกันได้ เมื่อเปิดโหมดอื่น โหมดการใช้ไฟฟ้าเองจะปิดโดยอัตโนมัติ",
  "VDE0126": "Germany_VDE0126",
  "common.update": "อัปเดต",
  "jl_param_ctrl_option_11H-France": "11H-ฝรั่งเศส",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "SOC ต่ำสุดของการคายประจุแบบแยกจากกริด (%)",
  "storage.v2.65284.cycleNumber": "จำนวนรอบการชาร์จ/คายประจุ",
  "subtitle.deviceManagement": "การจัดการอุปกรณ์",
  "GNSD-A": "China_GNSD-A",
  "GNSD-B": "China_GNSD-B",
  "tip.energy.tip3.title": "มาตรฐานการคำนวณการมีส่วนร่วมทางสังคม",
  "bw_param_ctrl_name_UPSReserveSoc": "SOC ที่สงวนไว้ของ UPS",
  "plant.lable_City": "เมือง",
  "service.internal.error": "ข้อผิดพลาดภายในเซิร์ฟเวอร์",
  "setting.type12.val.orange": "สีส้ม",
  "shipment.spread": "ขยาย",
  "mini.65290.stPV4_OV": "PV  อินพุต 4 แรงดันเกิน",
  "tip.log.searchFail": "ไม่พบอุปกรณ์ในบริเวณใกล้เคียง โปรดตรวจสอบให้แน่ใจว่า Bluetooth ของอุปกรณ์เปิดอยู่ แล้วคลิกรีเฟรช",
  "bw_param_ctrl_option_OFF": "ปิด",
  "common.50402.PV21_I": "กระแส PV21",
  "plant.stationInfo": "ข้อมูลสถานีไฟฟ้า",
  "upload.seeOrigin": "คลิกเพื่อดูไฟล์ต้นฉบับ",
  "jl_param_ctrl_option_0B-Germany_BDEW": "0B-เยอรมนี BDEW",
  "org.role": "บทบาท",
  "jl_param_ctrl_name_59.S1": "59.S1",
  "org.ChangeSupplier": "เปลี่ยนผู้ติดตั้ง",
  "jl_param_ctrl_name_81>S1-Time": "81>S1-Time",
  "jl_param_ctrl_option_Parallel": "การทำงานร่วมกัน",
  "jl_param_ctrl_name_59.S2": "59.S2",
  "plant.lable_IncomeUnit": "หน่วยรายได้",
  "plant.input_StationName": "โปรดป้อนชื่อสถานการณ์",
  "setting.type12.restoreFactorySet": "คืนค่าการตั้งค่าโรงงาน",
  "agent.email": "อีเมล",
  "tip.home.homePower": "โหลดรวมของบ้าน",
  "product.PleaseEnterAParameterName": "โปรดป้อนชื่อพารามิเตอร์",
  "jl_param_ctrl_name_81>S1": "81>S1",
  "storage.s3.65292.girdDisplayPower": "กำลังไฟฟ้าที่แสดงของกริด",
  "jl_param_ctrl_group_AdvancedSetting-PassiveMode": "การตั้งค่าขั้นสูง - โหมดพาสซีฟ",
  "plant.max_5": "จำนวนตัวอักษรต้องไม่เกิน 5 ตัว",
  "setting.type10.batFullSocSet": "ค่าการตัดสินความอิ่มตัวของการชาร์จแบตเตอรี่ (%)",
  "common.50402.PV29_V": "แรงดัน PV29",
  "End_user.input_InstalltionDate": "โปรดเลือกวันที่ติดตั้ง",
  "ywt.65323.inverterTemperature": "อุณหภูมิของอินเวอร์เตอร์ (°C)",
  "bw_RTparam_name_forbidden": "ห้ามชาร์จ/อนุญาตให้คายประจุ",
  "tip.validate.can`tEmpty": "{param} ไม่สามารถเว้นว่างได้",
  "plant.max_8": "จำนวนตัวอักษรต้องไม่เกิน 8 ตัว",
  "bw_param_ctrl_group_Charge&DischargeSettings": "การตั้งค่าการชาร์จ/คายประจุ",
  "Firmware.craete_folder": "สร้างโฟลเดอร์ใหม่",
  "jl_param_ctrl_note_DailyPV-ISODetection": "อินเวอร์เตอร์แบบไฮบริดทำการตรวจสอบฉนวนของ PV ทุกเช้า",
  "common.50402.PV29_I": "กระแส PV29",
  "tip.log.connectWiFi": "เชื่อมต่อ WiFi",
  "switchover.switchover.Installers": "ฉันคือผู้ติดตั้ง",
  "mini.65290.Fn": "ความถี่ที่กำหนดของกริดที่เชื่อมต่อ",
  "unc.65323.spiAutoTestEndFlag": "เครื่องหมายการสิ้นสุดการทดสอบ SPI อัตโนมัติ",
  "Brazil-H": "Brazil_Brazil-H",
  "device.softVersion": "เวอร์ชันซอฟต์แวร์",
  "User_defined50": "User defined50",
  "Firmware.close": "กลับ",
  "Czech_2023_A1/A": "Czech_2023 A1/A",
  "jl_param_ctrl_option_HaierHV": "Haier HV",
  "bw_RTparam_name_PV3Voltage": "แรงดันไฟฟ้าตามเวลาจริงของ PV3",
  "subtitle.TheAmountOfElectricityGeneratedToday": "ปริมาณการผลิตไฟฟ้าวันนี้",
  "product.OwningPowerStation": "สถานีไฟฟ้าที่เกี่ยวข้อง",
  "jl_param_ctrl_name_Position": "ตำแหน่งการเชื่อมต่อ",
  "jl_param_ctrl_note_AllowGridCharging": "ตั้งค่าว่าจะอนุญาตให้ระบบชาร์จแบตเตอรี่จากไฟฟ้าสาธารณะหรือไม่",
  "bw_RTparam_name_MeterInstallationLocation": "ตำแหน่งการติดตั้งมิเตอร์ไฟฟ้า",
  "jl_param_ctrl_name_AllowGridCharging": "อนุญาตให้ชาร์จจากไฟฟ้าสาธารณะ",
  "placeholder.choiceTimezone": "โปรดเลือกเขตเวลา",
  "solis.10001.stateExceptionFlag": "สถานะออฟไลน์ของอินเวอร์เตอร์",
  "subtitle.coal": "ถ่านหิน",
  "unc.65323.batterySOC": "SOC ของแบตเตอรี่",
  "subtitle.selectCurrency": "เลือกสกุลเงิน",
  "unc.65323.batterySOH": "SOH ของแบตเตอรี่",
  "storage.s3.65292.socketWorkStatus": "จำนวนเต้าเสียบ",
  "Meter_in_Load_Acrel_1P_Meter": "แรงดันไฟฟ้าของโหลดแบบเฟสเดียว Eastron",
  "solis.10001.socChargingSet": "SOC การชาร์จที่แข็งแกร่ง",
  "setting.type10.inverter2": "อินเวอร์เตอร์จ่ายไฟฟ้าให้โหลดในพื้นที่โดยใช้ CT",
  "setting.type10.inverter3": "อินเวอร์เตอร์จ่ายไฟฟ้าให้โหลดในพื้นที่หรือเต้าเสียบอัจฉริยะและมิเตอร์ไฟฟ้าอัจฉริยะ",
  "setting.type10.inverter0": "อินเวอร์เตอร์เสริมพลังงานให้โหลดในพื้นที่",
  "setting.type10.inverter1": "อินเวอร์เตอร์จ่ายไฟฟ้าเข้าสู่กริด",
  "solis.10001.uB": "แรงดันของมิเตอร์ไฟฟ้า B",
  "solis.10001.uA": "แรงดันของมิเตอร์ไฟฟ้า A",
  "supplier.type.nt": "นาทง",
  "solis.10001.uC": "แรงดันของมิเตอร์ไฟฟ้า C",
  "setting.type10.startTime": "เวลาเริ่มต้น",
  "jl_param_ctrl_name_ECOFunction": "โหมดประหยัดพลังงานตอนกลางคืน",
  "common.50100.pv2Current": "กระแสไฟฟ้าตามเวลาจริงของ PV2",
  "sidebar.agent": "การจัดการตัวแทน",
  "unc.65323.dcComponentC": "ส่วนประกอบ DC C",
  "tip.validate.confirmAgreement": "โปรดอ่านและยอมรับข้อตกลงความเป็นส่วนตัวก่อน",
  "Reset_the_grid_code_related_10min_overvoltage_protection": "การกู้คืนการป้องกันแบบสไลด์วินโดว์เป็นค่าเริ่มต้น",
  "unc.65323.dcComponentB": "ส่วนประกอบ DC B",
  "unc.65323.dcComponentA": "ส่วนประกอบ DC A",
  "tip.log.subscriptionEigenvalueSuccess": "เปิดใช้งานฟังก์ชันแจ้งเตือนเมื่อค่าคุณลักษณะของอุปกรณ์ Bluetooth แบบประหยัดพลังงานเปลี่ยนแปลง สมัครสมาชิกค่าคุณลักษณะ",
  "common.50402.PV16_V": "แรงดัน PV16",
  "btn.Setting_parameters": "ตั้งค่าพารามิเตอร์",
  "jl_param_ctrl_option_SUNWODALV": "SUNWODA LV",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM3mode": "การตั้งค่าเปอร์เซ็นต์กำลังไฟฟ้าที่ไม่ใช้งานในโหมด DRM3",
  "en-US": "ภาษาอังกฤษ",
  "bw_RTparam_name_TotalGridLoadConsumption": "ปริมาณการใช้ไฟฟ้ารวมของโหลดกริด",
  "common.50402.PV16_I": "กระแส PV16",
  "plant.InstallationPlan": "แผนการติดตั้ง",
  "setting.type10.enable": "เปิดใช้งาน",
  "unc.65323.gridVoltageCA": "แรงดันไฟฟ้าของกริด CA",
  "product.parameterType": "ประเภทพารามิเตอร์",
  "ywt.65323.load2GeneratorVoltageC": "แรงดันไฟฟ้า C ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "ywt.65323.load2GeneratorVoltageB": "แรงดันไฟฟ้า B ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "ywt.65323.load2GeneratorVoltageA": "แรงดันไฟฟ้า A ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "datalog.yes": "ใช่",
  "jl_param_ctrl_option_Lock": "ล็อค",
  "placeholder.enterDatalogger": "โปรดป้อนหมายเลขซีเรียลของตัวเก็บข้อมูล",
  "unc.65323.mpptTemperature": "อุณหภูมิของ MPPT (°C)",
  "unc.65323.gridVoltageBC": "แรงดันไฟฟ้าของกริด BC",
  "ywt.65323.faultStatus1": "สถานะความผิดปกติ 1",
  "ywt.65323.faultStatus2": "สถานะความผิดปกติ 2",
  "product.management": "การจัดการผลิตภัณฑ์",
  "jl_param_ctrl_name_81<S2F-Time": "81<S2F-Time",
  "setting.type10.disable": "ไม่เปิดใช้งาน",
  "bw_RTparam_name_PV3Current": "กระแสไฟฟ้าตามเวลาจริงของ PV3",
  "jl_param_ctrl_name_0D-FrequencyDeratingSlope(Fdroop)": "0D-ความชันการลดโหลด",
  "battery.select": "โปรดเลือก",
  "jl_param_ctrl_option_03-VDE&EN50438": "03-VDE&EN50438",
  "jl_param_ctrl_name_13H-FrequencyDeratingFstart": "13H-จุดเริ่มต้นความถี่การลดโหลด",
  "tip.log.monitoringFail": "การฟังเหตุการณ์การเปลี่ยนแปลงค่าคุณลักษณะของอุปกรณ์ Bluetooth แบบประหยัดพลังงานล้มเหลว",
  "setting.type12.LED2Color": "สี LED2",
  "bar.energy": "วิเคราะห์",
  "unc.65323.gridVoltageAB": "แรงดันไฟฟ้าของกริด AB",
  "device.dateRangeError": "ช่วงวันที่ควรอยู่ภายใน 3 วัน",
  "product.ParameterOperationType": "ประเภทการดำเนินการพารามิเตอร์",
  "common.50100.pv1CumulativePowerGeneration": "ปริมาณการผลิตไฟฟ้ารวมของ PV1",
  "common.50100.totalPowerGeneration": "ปริมาณการผลิตไฟฟ้ารวมของอุปกรณ์",
  "setting.type22.reactiveControlMode": "วิธีการควบคุมกำลังไฟฟ้าที่ไม่ใช้งาน",
  "jl_param_ctrl_note_DischargeTimeSlot6": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "jl_param_ctrl_note_DischargeTimeSlot5": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "supplier.type.jl": "Jinlang",
  "home.echarts4.subhead_plant": "เพิ่มสถานีไฟฟ้า/จำนวนสถานีไฟฟ้าทั้งหมด",
  "jl_param_ctrl_note_DischargeTimeSlot4": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "jl_param_ctrl_note_DischargeTimeSlot3": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "jl_param_ctrl_note_DischargeTimeSlot2": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "jl_param_ctrl_note_FeedinPowerLimitSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดฟังก์ชันการควบคุมการเข้าสู่กริดของระบบ",
  "jl_param_ctrl_note_DischargeTimeSlot1": "ไม่ควรทับซ้อนกับช่วงเวลาการชาร์จ/คายประจุแบบบังคับอื่น ๆ",
  "tip.energy.tip1.load": "พลังงานที่โหลดใช้ไป",
  "device.totalElectricityConsumption": "ปริมาณการใช้ไฟฟ้ารวม",
  "mini.65290.stPV1_OV": "PV  อินพุต 1 แรงดันเกิน",
  "setting.type10.antiRefluxSet": "เปิดใช้งานการป้องกันการไหลย้อนกลับ",
  "tip.device.signal": "ความแรงของสัญญาณ",
  "sidebar.inverter": "รายการอินเวอร์เตอร์",
  "product.PlantDetails": "รายละเอียดสถานีไฟฟ้า",
  "unc.65323.pv2Power": "กำลังไฟฟ้าของ PV2",
  "solis.10001.batteryCurrent": "กระแสของแบตเตอรี่",
  "ship.hrSn.not.empty": "หมายเลขซีเรียลของ Haier ไม่สามารถเว้นว่างได้",
  "ywt.65323.load2GeneratorActivePower": "กำลังไฟฟ้าที่ใช้งานของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "Meter_in_Load_Eastron_Standard_1P_Meter": "แรงดันไฟฟ้าของโหลดแบบเฟสเดียว Eastron",
  "Tips.firmware_delete": "ยืนยันการลบ?",
  "plant.input_PVCapacity": "โปรดป้อนความจุของแบตเตอรี่",
  "subtitle.dataloggerSN": "หมายเลขซีเรียลของตัวเก็บข้อมูล",
  "supplier.type.yx": "หินแกน",
  "supplier.type.yw": "Yingwei",
  "tip.connectWifi.devicePower": "กำลังไฟฟ้าของอุปกรณ์",
  "ywt.65323.bmsTemperature": "อุณหภูมิของ BMS (°C)",
  "tip.device.updateTime": "เวลาที่อัปเดต",
  "title.login": "เข้าสู่ระบบ",
  "login.passType": "รหัสผ่านต้องประกอบด้วยตัวเลข ตัวอักษรพิมพ์ใหญ่ ตัวอักษรพิมพ์เล็ก และสัญลักษณ์ภาษาอังกฤษอย่างน้อยสามประเภท",
  "tip.home.latestVersion": "เป็นเวอร์ชันล่าสุดแล้ว",
  "unc.65323.pv6Voltage": "แรงดันไฟฟ้าของ PV6",
  "common.50100.outputGridPower": "กำลังไฟฟ้าที่ส่งออกสู่กริด",
  "validator.password": "ความยาวรหัสผ่าน 8-20 ตัวอักษร ต้องประกอบด้วยประเภทตัวอักษรต่อไปนี้อย่างน้อยสามประเภท (ตัวเลข ตัวอักษรพิมพ์ใหญ่ ตัวอักษรพิมพ์เล็ก สัญลักษณ์ภาษาอังกฤษ)",
  "storage.s3.65292.bChargeActivePower": "กำลังไฟฟ้าที่ใช้งานของเฟส B",
  "ywt.65323.batteryPower": "กำลังไฟฟ้าของแบตเตอรี่",
  "home.echarts4.title": "เพิ่มสถานการณ์  ",
  "bw_param_ctrl_name_DispatchMode": "โหมดการจัดตาราง  ",
  "storage.s3.65292.mainsChargeTimerSet": "เปิดใช้งานการชาร์จไฟฟ้าตามเวลาที่กำหนด  ",
  "jl_param_ctrl_name_GridCode": "มาตรฐานไฟฟ้า  ",
  "jl_param_ctrl_option_Highstar": "Highstar  ",
  "tip.configurationState.connectFail": "การเชื่อมต่อล้มเหลว  ",
  "tip.log.locationNotTurnOn": "ไม่สามารถค้นหาบลูทูธได้เนื่องจากไม่ได้เปิดใช้งานการระบุตำแหน่ง  ",
  "jl_param_ctrl_name_AFCIlevel": "การตั้งค่าความไวของ AFCI protection  ",
  "plant.lable_PVCapacity": "ความจุของเซลล์แสงอาทิตย์  ",
  "setting.type10.batteryFull": "จุดปิดเครื่องเมื่อแบตเตอรี่เต็ม  ",
  "storage.s3.65292.pvVoltageLevel": "ระดับแรงดันไฟฟ้าโซลาร์เซลล์  ",
  "setting.type6.activePowerPermillage": "อัตราส่วนกำลังไฟฟ้าที่ใช้งานเป็นส่วนพัน  ",
  "jl_param_ctrl_group_GridCodeSetting-InitialSetting": "การตั้งค่ามาตรฐานไฟฟ้า - คืนค่าเริ่มต้น  ",
  "storage.v2.65284.invPower": "กำลังไฟไมโครอินเวอร์เตอร์  ",
  "bw_RTparam_name_forcedCharging": "ห้ามปล่อยไฟเมื่อชาร์จเต็ม  ",
  "storage.s3.65292.allActivePower": "กำลังไฟฟ้าที่ใช้งานทั้งหมดของเครื่อง  ",
  "common.50402.creationDate": "เวลาล่าสุดของข้อมูล  ",
  "battery.email": "กรุณากรอกอีเมล  ",
  "setting.type7.passwordValue": "รหัสผ่านผู้ใช้  ",
  "common.50300.iac2": "กระแสไฟฟ้า AC 2  ",
  "common.50300.iac3": "กระแสไฟฟ้า AC 3  ",
  "common.50300.iac1": "กระแสไฟฟ้า AC 1  ",
  "storage.s3.65292.aPhaseCurrent": "กระแสไฟขาออกเฟส A  ",
  "bw_RTparam_name_sell": "ขายไฟฟ้า  ",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส B U>>  ",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส B U>10 นาที  ",
  "device.category.inverter": "อินเวอร์เตอร์  ",
  "bw_RTparam_name_BatteryVoltage": "แรงดันแบตเตอรี่  ",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส B U<  ",
  "ywt.65323.pv5Current": "กระแสไฟฟ้าโซลาร์เซลล์ 5  ",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส B U<<  ",
  "plant.search": "ค้นหา  ",
  "Special.starttime": "เวลาเริ่มต้น  ",
  "setting.type22.manufacturer": "ผู้ผลิต  ",
  "tip.plant.unfollow": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการติดตามสถานีนี้?  ",
  "jl_param_ctrl_name_FCASDroopSwitch": "FCAS Droop Switch  ",
  "AUS-Q-0.9": "Australia_AUS-Q-0.9  ",
  "AUS-Q-0.8": "Australia_AUS-Q-0.8  ",
  "subtitle.DischargeTimePeriod": "ช่วงเวลาปล่อยไฟ  ",
  "subtitle.addTime": "เพิ่มเวลา  ",
  "tip.connectWifi.tip1": "ตั้งค่าอุปกรณ์เพื่อเข้าร่วมเครือข่าย  ",
  "unc.65323.loadActivePower": "กำลังไฟฟ้าที่ใช้งานของโหลด  ",
  "btn.submit": "ส่ง  ",
  "storage.s3.65292.acTodayEnergy": "ปริมาณการผลิตไฟฟ้า AC วันนี้  ",
  "placeholder.startTime": "เวลาเริ่มต้น  ",
  "End_user.submit": "ส่ง  ",
  "device.category.energy.storage": "เครื่องควบคุมการเก็บพลังงานแบบบูรณาการ  ",
  "subttile.week": "สัปดาห์  ",
  "bw_RTparam_name_dontBuy": "ไม่ซื้อไม่ขาย  ",
  "shipment.supplierSN": "หมายเลขซีเรียลของผู้จัดหา  ",
  "setting.type10.energyNet": "การตั้งค่าการส่งออกไฟฟ้าแบบเชื่อมต่อกริด  ",
  "setting.type3.loadMode": "โหมดโหลด  ",
  "unc.65323.dcTemperature": "อุณหภูมิ DC (°C)  ",
  "jl_param_ctrl_name_DRMSwitch": "สวิตช์ DRM  ",
  "unc.65323.bmsMaxVoltage": "แรงดันไฟฟ้าสูงสุดของ BMS  ",
  "unc.65323.totalConsumeEnergy": "ปริมาณการใช้ไฟฟ้ารวม  ",
  "product.PleaseEnterTheOrder": "กรุณากรอกการจัดเรียง  ",
  "jl_param_ctrl_option_HaierLV": "Haier LV  ",
  "btn.login": "เข้าสู่ระบบ  ",
  "tip.base.maxSize": "สูงสุด  ",
  "bw_RTparam_name_ApparentPOCP_Grid": "กำลังไฟฟ้าปรากฏของมิเตอร์ C  ",
  "unc.65323.pv6Current": "กระแสไฟฟ้าโซลาร์เซลล์ 6  ",
  "bw_param_ctrl_name_DispatchActivepower": "กำลังไฟฟ้าที่ใช้งานที่จัดตาราง  ",
  "supplier.type.tb": "Tebian  ",
  "setting.socket.sunday": "วันอาทิตย์  ",
  "supplier.type.sk": "Sanke  ",
  "supplier.type.sh": "Shouhang  ",
  "unc.65323.pv5Power": "กำลังไฟฟ้าโซลาร์เซลล์ 5  ",
  "user.mail.password.not.correct": "อีเมลหรือรหัสผ่านผู้ใช้ไม่ถูกต้อง  ",
  "agent.btn_upload": "อัปโหลด  ",
  "unc.65323.loadBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของโหลดเฟส B  ",
  "global.socket_data": "ตั้งค่าพารามิเตอร์ซ็อกเก็ต  ",
  "subtitle.FeederMode": "โหมดการส่งกลับไฟฟ้า  ",
  "common.50402.PV7_V": "แรงดันไฟฟ้า PV7  ",
  "login.read": "อ่านและยอมรับ  ",
  "storage.s3.65292.cPhaseOnGridCurrent": "กระแสไฟฟ้าด้านกริดเฟส C  ",
  "ywt.65323.loadFrequency": "ความถี่โหลด  ",
  "tip.plant.visitorTip": "สามารถแบ่งปันให้กับผู้ใช้ที่ลงทะเบียนเท่านั้น  ",
  "product.search": "ค้นหา  ",
  "jl_param_ctrl_name_ChargeTimeSlot5": "ช่วงเวลาชาร์จ 5  ",
  "ywt.65323.pv5Voltage": "แรงดันไฟฟ้าโซลาร์เซลล์ 5  ",
  "jl_param_ctrl_name_ChargeTimeSlot4": "ช่วงเวลาชาร์จ 4  ",
  "subtitle.socketSwitch": "สวิตช์ซ็อกเก็ต  ",
  "jl_param_ctrl_name_ChargeTimeSlot6": "ช่วงเวลาชาร์จ 6  ",
  "bw_RTparam_name_BatteryCurrent": "กระแสแบตเตอรี่  ",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "เวลาการทดสอบอัตโนมัติ SPI เฟส A U>10 นาที  ",
  "common.50402.PV7_I": "กระแสไฟฟ้า PV7  ",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "เวลาการทดสอบอัตโนมัติ SPI เฟส A U<  ",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "เวลาการทดสอบอัตโนมัติ SPI เฟส A U>>  ",
  "jl_param_ctrl_name_ChargeTimeSlot1": "ช่วงเวลาชาร์จ 1  ",
  "jl_param_ctrl_name_ChargeTimeSlot3": "ช่วงเวลาชาร์จ 3  ",
  "jl_param_ctrl_name_ChargeTimeSlot2": "ช่วงเวลาชาร์จ 2  ",
  "solis.10001.pA": "กำลังไฟฟ้ามิเตอร์ A  ",
  "product.havePublished": "เผยแพร่แล้ว  ",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "เวลาการทดสอบอัตโนมัติ SPI เฟส A U<<  ",
  "solis.10001.pC": "กำลังไฟฟ้ามิเตอร์ C  ",
  "solis.10001.pB": "กำลังไฟฟ้ามิเตอร์ B  ",
  "setting.type22.setManufacturer.val1": "Invt  ",
  "common.50300.offline": "ออฟไลน์  ",
  "G98-NI": "UK_G98-NI  ",
  "setting.type22.setManufacturer.val2": "Skyworth  ",
  "title.addDatalogger": "เพิ่มอุปกรณ์  ",
  "unc.65323.runStatus": "สถานะการทำงาน  ",
  "common.50402.PV20_I": "กระแสไฟฟ้า PV20  ",
  "plant.energyBalance": "สมดุลพลังงาน (kWh)  ",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส C U>>  ",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส C U<  ",
  "ywt.65323.gridBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของกริดเฟส B  ",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส C U>10 นาที  ",
  "unc.65323.bmsRequestFlag": "BMS request flag  ",
  "sidebar.organizationalManagement": "การจัดการองค์กร  ",
  "tip.request.connectServerFail": "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์  ",
  "ywt.65323.load2GeneratorCPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของโหลด 2/เครื่องกำเนิดไฟฟ้าเฟส C  ",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "เกณฑ์การทดสอบอัตโนมัติ SPI เฟส C U<<  ",
  "bw_RTparam_name_BatteryModel": "รุ่นแบตเตอรี่  ",
  "uk-UA": "ภาษายูเครน  ",
  "common.50300.online": "ออนไลน์  ",
  "jl_param_ctrl_option_GeneratorControl": "การควบคุมเครื่องกำเนิดไฟฟ้า  ",
  "common.50100.pv4Voltage": "แรงดันไฟฟ้าตามเวลาจริง PV4  ",
  "ywt.65323.pvMonthlyEnergy": "ปริมาณการผลิตไฟฟ้าโซลาร์เซลล์ประจำเดือน  ",
  "subtitle.defaultConfiguration": "การตั้งค่าเครือข่ายเริ่มต้น  ",
  "unc.65323.load2GeneratorTotalConsumeEnergy": "ปริมาณการใช้ไฟฟ้ารวมของโหลด 2/เครื่องกำเนิดไฟฟ้า  ",
  "mini.65290.Fgrid": "ความถี่ด้านกริด  ",
  "bar.home": "หน้าแรก  ",
  "login.agreement.readAndAgree": "อ่านและยอมรับ  ",
  "setting.type12.val.pink": "สีชมพู  ",
  "jl_param_ctrl_note_GradientLimitforPowerChange": "การจำกัดความชันเมื่อเปลี่ยนกำลังไฟสูงสุด  ",
  "plant.saveStandardCoal": "มาตรฐานการประหยัดถ่านหิน  ",
  "subtitle.log": "บันทึก  ",
  "jl_param_ctrl_option_DynessLV": "Dyness LV  ",
  "mini.65290.Un": "ค่าแรงดันไฟฟ้าที่กำหนดของกริดเชื่อมต่อ  ",
  "CQC-B": "China_CQC-B  ",
  "storage.s3.65292.ctWorkStatus": "สถานะสวิตช์ CT แบบไร้สาย  ",
  "setting.type10.gridConnectionStandard": "มาตรฐานการเชื่อมต่อกริด  ",
  "role.action": "การดำเนินการ  ",
  "common.50402.PV20_V": "แรงดันไฟฟ้า PV20  ",
  "jl_param_ctrl_note_GridChargingPowerLimit": "การจำกัดกำลังไฟสูงสุดของกริดสามารถใช้เพื่อรักษาระดับ SOC ของแบตเตอรี่ มีผลเฉพาะเมื่อเปิดใช้งานสวิตช์การรักษาแบตเตอรี่  ",
  "jl_param_ctrl_name_ACCoupling_OFF_SOC": "AC Coupling ปิด SOC  ",
  "N4105-BEL": "Belgium_N4105-BEL  ",
  "jl_param_ctrl_note_Max.usableGridPower": "สำหรับโหมด Peakshaving ให้ตั้งค่าขีดจำกัดกำลังไฟสูงสุดที่อนุญาตที่จุดเชื่อมต่อกริด  ",
  "jl_param_ctrl_option_0A-UK_G98&G99": "0A-UK G98&G99  ",
  "plant.purchasePrice": "ราคาซื้อไฟฟ้า  ",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_1P_Meter_Only_applicable_for_Eastron_Meter": "ด้านกริด+ด้านส่งออกของอินเวอร์เตอร์แบบขนาน (มิเตอร์คู่) Acrel เฟสเดียว มีผลกับมิเตอร์ Donghong เท่านั้น  ",
  "placeholder.enterPlantName": "กรุณากรอกชื่อสถานี  ",
  "jl_param_ctrl_note_PhysicalAddressID": "ตั้งค่าที่อยู่ทางกายภาพในการดำเนินการเชื่อมต่อแบบขนาน  ",
  "Firmware.add": "เพิ่ม  ",
  "jl_param_ctrl_group_GridCodeSetting-\r\nInitialSetting": "การตั้งค่ามาตรฐานไฟฟ้า - คืนค่าเริ่มต้น  ",
  "unc.65323.pvAnnualEnergy": "ปริมาณการผลิตไฟฟ้าโซลาร์เซลล์ประจำปี  ",
  "placeholder.searchDeviceName": "ค้นหาชื่ออุปกรณ์  ",
  "setting.ops15.invSwitch": "สวิตช์อินเวอร์เตอร์  ",
  "sidebar.system_app": "เวอร์ชันแอป  ",
  "plant.plantNum": "จำนวนสถานี  ",
  "common.50402.INV_EG_DAY": "ปริมาณการผลิตไฟฟ้ารายวัน  ",
  "subtitle.on": "เปิด  ",
  "org.editDept": "แก้ไขแผนก  ",
  "subtitle.versionUpgrade": "อัปเดตเวอร์ชัน  ",
  "jl_param_ctrl_name_01-FrequencyDeratingFtransition": "01-Overfrequency load shedding Ftransition  ",
  "jl_param_ctrl_option_10H-South_Africa_levelise": "10H-South Africa levelise  ",
  "btn.Reading": "อ่าน  ",
  "device.deviceSn": "กรุณากรอกหมายเลขซีเรียลอุปกรณ์  ",
  "Special.deviceSn": "กรุณากรอกหมายเลขซีเรียลอุปกรณ์  ",
  "plant.co2emissionReduction": "ปริมาณการลด CO2  ",
  "tip.device.powerOnTime": "เวลาที่เปิดเครื่อง  ",
  "setting.type11.functionSwitch": "สวิตช์ฟังก์ชัน  ",
  "solis.10001.inverterTemperature": "อุณหภูมิอินเวอร์เตอร์ (°C)  ",
  "bw_param_ctrl_note_GridBreake": "กรุณาเลือกตามขนาดจริงของเซอร์กิตเบรกเกอร์ด้านกริดของอินเวอร์เตอร์ หากกรอกข้อมูลไม่ถูกต้องอาจทำให้เซอร์กิตเบรกเกอร์ทำงาน  ",
  "plant.life": "อายุการใช้งาน  ",
  "jl_param_ctrl_name_InverterMaxOutputPowerSettingPowerDownStorage": "การตั้งค่ากำลังไฟสูงสุดของอินเวอร์เตอร์ที่บันทึกเมื่อไฟดับ  ",
  "ywt.65323.spiAutoTestResult": "ผลการทดสอบอัตโนมัติ SPI  ",
  "tip.opsLog.upgrade": "อัปเกรด  ",
  "storage.s3.65292.aPhaseOnGridCurrent": "กระแสไฟฟ้าด้านกริดเฟส A  ",
  "bw_RTparam_name_GridFrequency": "ความถี่กริด  ",
  "menu.button.name": "ปุ่ม  ",
  "End_user.yes": "ใช่  ",
  "setting.type11.chargeTimeMaxSOC4": "ช่วงเวลาชาร์จ 4 SOC สูงสุด (%)  ",
  "setting.type11.chargeTimeMaxSOC1": "ช่วงเวลาชาร์จ 1 SOC สูงสุด (%)  ",
  "setting.type11.chargeTimeMaxSOC3": "ช่วงเวลาชาร์จ 3 SOC สูงสุด (%)  ",
  "setting.type11.chargeTimeMaxSOC2": "ช่วงเวลาชาร์จ 2 SOC สูงสุด (%)  ",
  "SI-2": "SI-2  ",
  "SI-1": "SI-1  ",
  "menu.not.external": "ไม่  ",
  "bw_RTparam_name_BatteryNum": "จำนวนแบตเตอรี่ระบบ  ",
  "setting.type12.outPutSourcePriority": "ลำดับความสำคัญของแหล่งจ่ายไฟ  ",
  "solis.10001.batteryType": "รุ่นแบตเตอรี่  ",
  "tip.delDevice": "คุณแน่ใจหรือไม่ว่าต้องการลบ {device} นี้?  ",
  "jl_param_ctrl_name_LSB": "พารามิเตอร์ LSB  ",
  "jl_param_ctrl_note_BatteryWakeupSwitch": "ฟังก์ชันปลุกด้วยตนเอง อินเวอร์เตอร์จะชาร์จแบตเตอรี่ที่ระดับแรงดันปลุก แล้วจะป้องกันแบตเตอรี่เป็นเวลาหนึ่งเพื่อปลุกแบตเตอรี่จากโหมดสลีป  ",
  "jl_param_ctrl_option_DynessHV": "Dyness HV  ",
  "UL240-13": "USA_UL240-13  ",
  "common.50100.temperature": "อุณหภูมิอินเวอร์เตอร์ (°C)  ",
  "solis.10001.batteryDischargeLimiting": "การจำกัดกระแสไฟปล่อยแบตเตอรี่  ",
  "plant.familyName": "ชื่อครอบครัว  ",
  "button.deselectAll": "ยกเลิกการเลือกทั้งหมด  ",
  "ywt.65323.pv4Power": "กำลังไฟฟ้าโซลาร์เซลล์ 4  ",
  "jl_param_ctrl_option_WECO": "WECO  ",
  "jl_param_ctrl_name_08-FrequencyDeratingFstart": "08-Load shedding start frequency point  ",
  "AS4777-NW": "Australia_AS4777-NW  ",
  "jl_param_ctrl_option_JiaWei": "JiaWei  ",
  "plant.lable_StationName": "ชื่อสถานการณ์  ",
  "mini.65290.UpdateProgress": "ความคืบหน้าการอัปเกรด  ",
  "EIFS-SW": "Sweden_EIFS-SW  ",
  "mini.65290.Pn": "กำลังไฟสูงสุดที่เชื่อมต่อกริด  ",
  "subtitle.account": "บัญชี  ",
  "setting.type12.overLoadToBypass": "Overload bypass  ",
  "bw_RTparam_name_DataUploadCycle": "ช่วงเวลาอัปโหลดข้อมูล  ",
  "subtitle.day": "วัน  ",
  "button.add": "เพิ่ม  ",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "ปริมาณการผลิตไฟฟ้ารวมของโหลด 2/เครื่องกำเนิดไฟฟ้า  ",
  "tip.plant.permission": "สิทธิ์  ",
  "setting.type12.ratedOutputVol": "แรงดันไฟขาออกที่กำหนด  ",
  "tip.currentNoDevice": "ไม่มีอุปกรณ์ในขณะนี้  ",
  "storage.s3.65292.aPhaseApparentPower": "กำลังไฟฟ้าปรากฏขาออกเฟส A  ",
  "common.50402.status": "สถานะ  ",
  "product.editName": "แก้ไขผลิตภัณฑ์  ",
  "solis.10001.batteryCapacitySoc": "SOC แบตเตอรี่  ",
  "supplier.type.hr": "Haier  ",
  "unc.65323.spiAutoTestTimeF3": "เวลาการทดสอบอัตโนมัติ SPI F3  ",
  "solis.10001.totalLoadPower": "กำลังไฟฟ้ารวมที่ใช้  ",
  "unc.65323.spiAutoTestTimeF4": "เวลาการทดสอบอัตโนมัติ SPI F4  ",
  "jl_param_ctrl_note_DRMSwitch": "เปิด/ปิด DRM/อินเตอร์เฟสลอจิก  ",
  "unc.65323.returnFlowPortReactivePower": "กำลังไฟฟ้ารีแอคทีฟของพอร์ตรีเทิร์น  ",
  "End_user.input_Country": "กรุณาเลือกประเทศ  ",
  "menu.assign.error": "เมนูถูกกำหนดแล้ว ไม่สามารถลบได้  ",
  "Reset_the_grid_code_related_frequency_response": "คืนค่าเริ่มต้นของความถี่ลดโหลด  ",
  "solis.10001.powerFactor": "ตัวประกอบกำลัง  ",
  "unc.65323.spiAutoTestTimeF1": "เวลาการทดสอบอัตโนมัติ SPI F1  ",
  "solis.10001.gridSellMonthEnergy": "ปริมาณการขายไฟฟ้าประจำเดือนของกริด  ",
  "unc.65323.spiAutoTestTimeF2": "เวลาการทดสอบอัตโนมัติ SPI F2  ",
  "storage.s3.65292.socketPower14": "กำลังไฟฟ้าซ็อกเก็ต 14  ",
  "storage.s3.65292.socketPower15": "กำลังไฟฟ้าซ็อกเก็ต 15  ",
  "storage.s3.65292.socketPower12": "กำลังไฟฟ้าซ็อกเก็ต 12  ",
  "solis.10001.nationalStandards": "มาตรฐานกริดแห่งชาติ  ",
  "storage.s3.65292.socketPower13": "กำลังไฟฟ้าซ็อกเก็ต 13  ",
  "jl_param_ctrl_option_Ucanpower": "UcanPower  ",
  "device.c.phase": "เฟส C  ",
  "storage.s3.65292.socketPower16": "กำลังไฟฟ้าซ็อกเก็ต 16  ",
  "product.datalog": "ตัวรวบรวมข้อมูล  ",
  "Upgrade.Control": "ตัวควบคุม  ",
  "tip.opsLog.serverTime": "เวลาของเซิร์ฟเวอร์  ",
  "jl_param_ctrl_name_59.S2Time": "59.S2 Time  ",
  "Logs.deviceSn": "กรุณากรอกหมายเลขซีเรียลอุปกรณ์  ",
  "device.btn_address": "ตั้งค่าที่อยู่  ",
  "subtitle.totalEnergy": "ปริมาณไฟฟ้ารวม  ",
  "bw_RTparam_name_PV1Power": "กำลังไฟฟ้าตามเวลาจริง PV1  ",
  "common.50402.ipv11": "กระแสไฟฟ้า DC 11  ",
  "common.50402.ipv10": "กระแสไฟฟ้า DC 10  ",
  "supplier.type.gd": "GoodWe  ",
  "common.50402.ipv12": "กระแสไฟฟ้า DC 12  ",
  "setting.type10.current": "กระแสไฟฟ้าเฟส  ",
  "menu.hide.status": "ซ่อน  ",
  "bw_param_ctrl_option_withoutBattery": "ไม่ได้เชื่อมต่อแบตเตอรี่  ",
  "jl_param_ctrl_group_SmartPort-ACCouplingSetting": "การตั้งค่าพอร์ตอัจฉริยะ-AC Coupling  ",
  "tip.log.setMTUsFail": "การตั้งค่าหน่วยส่งข้อมูลสูงสุดล้มเหลว  ",
  "bw_param_ctrl_note_PVCapacityStorage": "ความจุการติดตั้ง PV ทั้งหมดที่เชื่อมต่อกับอินเวอร์เตอร์โซลาร์เซลล์  ",
  "device.todayPowerGeneration": "ปริมาณการผลิตไฟฟ้าวันนี้  ",
  "tip.validate.dealerSope": "ช่วงหมายเลขตัวแทนจำหน่ายคือ 6-8 หลัก  ",
  "jl_param_ctrl_option_FreedomWon": "FreedomWon  ",
  "jl_param_ctrl_option_AlpSolarrHV": "AlpSolarr HV  ",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeSetting-SpecialSetting": "การตั้งค่ามาตรฐานไฟฟ้า-DRM setting  ",
  "device.setting_inverte": "ตั้งค่าพารามิเตอร์อินเวอร์เตอร์  ",
  "tip.log.locationAuthorization": "ไม่ได้เปิดการอนุญาตตำแหน่งแอป  ",
  "Indon": "Indonesia_Indon  ",
  "datalog.span_setup": "การตั้งค่าขั้นสูง  ",
  "subtitle.home": "โหลด  ",
  "product.delete": "ลบ  ",
  "ywt.65323.returnFlowPortCurrentC": "กระแสไฟฟ้าพอร์ตรีเทิร์น C  ",
  "tip.energy.tip1.battery": "ปริมาณพลังงานที่ชาร์จแบตเตอรี่รวม  ",
  "PH-L": "Philippines_PH-L  ",
  "ywt.65323.returnFlowPortCurrentA": "กระแสไฟฟ้าพอร์ตรีเทิร์น A  ",
  "ywt.65323.returnFlowPortCurrentB": "กระแสไฟฟ้าพอร์ตรีเทิร์น B  ",
  "jl_param_ctrl_option_SOLUNA_HV": "SOLUNA_HV  ",
  "jl_param_ctrl_note_ECOFunction": "สวิตช์นี้ใช้สำหรับเปิด/ปิดฟังก์ชันประหยัดพลังงาน เมื่อแบตเตอรี่ถึง SOC ต่ำสุดในเวลากลางคืน อินเวอร์เตอร์จะปิดวงจรแบตเตอรี่เพื่อหลีกเลี่ยงการใช้พลังงานแบตเตอรี่  ",
  "socket.setting_value": "ตั้งค่าพารามิเตอร์  ",
  "ywt.65323.loadBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของโหลดเฟส B  ",
  "tip.request.requestTimeout": "คำขอย้อนเวลา  ",
  "jl_param_ctrl_name_TimeofUseSwitch": "สวิตช์เพิ่มประสิทธิภาพรายได้  ",
  "subtitle.TheNameOfTheDevice": "ชื่ออุปกรณ์  ",
  "solis.10001.productModel": "รุ่นผลิตภัณฑ์  ",
  "datalogs_logs.search": "ค้นหา  ",
  "plant.edit": "แก้ไข  ",
  "Israel": "Israel_Israel  ",
  "tip.base.maxDistance": "ไกลที่สุด  ",
  "setting.type3.workingDay": "วันทำงาน  ",
  "solis.10001.familyLoadPower": "กำลังไฟฟ้าโหลดครัวเรือน  ",
  "jl_param_ctrl_option_ON": "เปิด  ",
  "ship.import.empty": "ข้อมูลที่นำเข้าไม่สามารถว่างได้  ",
  "datalogs_logs.deviceSn": "กรุณากรอกหมายเลขซีเรียลอุปกรณ์  ",
  "plant.receiveMode": "วิธีการรับ  ",
  "App.update_content": "รายละเอียดการอัปเดต: (ใช้ \"/n\" เพื่อแบ่ง)  ",
  "plant.windSpeed": "ความเร็วลม  ",
  "setting.type7.clearAlarm": "ล้างการแจ้งเตือนปัจจุบัน  ",
  "common.50300.ipv10": "กระแสไฟฟ้า DC 10  ",
  "jl_param_ctrl_name_ParallelSync": "การล็อกซิงโครไนซ์แบบขนาน  ",
  "subtitle.DataGateways": "เกตเวย์ข้อมูล  ",
  "jl_param_ctrl_option_NO": "ไม่  ",
  "storage.s3.65292.socketPower10": "กำลังไฟฟ้าซ็อกเก็ต 10  ",
  "App.Android_Version": "เวอร์ชัน Android:  ",
  "storage.s3.65292.socketPower11": "กำลังไฟฟ้าซ็อกเก็ต 11  ",
  "setting.type12.acChargeEndTime": "เวลาหยุดทำงานของเครื่องชาร์จ AC  ",
  "bw_RTparam_group_PVMeter": "มิเตอร์ด้านโซลาร์เซลล์  ",
  "setting.type12.val.solarPowerInput": "กำลังไฟฟ้าขาเข้าโซลาร์เซลล์  ",
  "storage.s3.65292.mainsChargeCurrent": "กระแสไฟฟ้าชาร์จจากกริด  ",
  "subtitle.AllOptimizerWorkingStatus": "สถานะการทำงานของออปติไมเซอร์ทั้งหมด  ",
  "device.return.port": "พอร์ตรีเทิร์น  ",
  "title.aboutUs": "เกี่ยวกับ  ",
  "storage.s3.65292.cellTemp2": "อุณหภูมิเซลล์ 2 (°C)  ",
  "storage.s3.65292.cellTemp1": "อุณหภูมิเซลล์ 1 (°C)  ",
  "role.not.empty": "ข้อมูลบทบาทไม่สามารถว่างได้  ",
  "storage.s3.65292.cellTemp4": "อุณหภูมิเซลล์ 4 (°C)  ",
  "storage.s3.65292.cellTemp3": "อุณหภูมิเซลล์ 3 (°C)  ",
  "End_user.btn_add": "เพิ่ม  ",
  "AS4777-WA": "Australia_AS4777-WA  ",
  "storage.s3.65292.bat5CellVol": "แรงดันเซลล์ 5  ",
  "product.decimalPoint": "จุดทศนิยม  ",
  "subtitle.checkVersion": "ตรวจสอบการอัปเดต  ",
  "tip.device.type": "ประเภท  ",
  "plant.month": "ประจำเดือน  ",
  "common.50300.ipv12": "กระแสไฟฟ้า DC 12  ",
  "common.50300.ipv11": "กระแสไฟฟ้า DC 11  ",
  "jl_param_ctrl_note_BatteryHealingSwitch": "สวิตช์นี้ใช้สำหรับเปิด/ปิดฟังก์ชันบำบัดแบตเตอรี่ ในช่วงที่กำลังผลิตไฟฟ้าโซลาร์เซลล์ไม่เพียงพอ แบตเตอรี่อาจอยู่ในระดับ SOC ต่ำเป็นเวลานาน ฟังก์ชันบำบัดแบตเตอรี่จะชาร์จแบตเตอรี่ไปยัง SOC เป้าหมาย  ",
  "subtitle.AttachTheDevice": "อุปกรณ์ที่เชื่อมต่อ  ",
  "jl_param_ctrl_group_AdvancedSetting-EPSMode(OnlyForItaly)": "การตั้งค่าขั้นสูง-โหมด EPS (เฉพาะอิตาลี)  ",
  "datalog.span_datalog": "หมายเลขซีเรียลตัวรวบรวมข้อมูล:  ",
  "jl_param_ctrl_name_OnlyPVPowerLoad": "โหลดเฉพาะ PV  ",
  "bw_RTparam_name_InverterInternalOperatingAmbientTemperature": "อุณหภูมิภายในวงจรการทำงานของอินเวอร์เตอร์  ",
  "common.50300.fac1": "ความถี่ AC 1  ",
  "sotrage.email": "กรุณากรอกอีเมล  ",
  "common.50300.fac2": "ความถี่ AC 2  ",
  "tip.addDatalogger.connectBluetoothFail": "การเชื่อมต่อบลูทูธล้มเหลว กรุณาสแกน QR code หรือป้อนหมายเลขซีเรียลตัวรวบรวมข้อมูลด้วยตนเองใต้ QR code แล้วลองเชื่อมต่ออีกครั้ง  ",
  "common.50300.fac3": "ความถี่ AC 3  ",
  "jl_param_ctrl_name_0E-FrequencyDeratingResponseDelay(Tintendelay)": "0E-Load shedding response delay  ",
  "productEquipment.historicalData": "ข้อมูลประวัติ  ",
  "bw_RTparam_name_MeterTypeandInstallationLocation": "ประเภทและตำแหน่งการติดตั้งมิเตอร์  ",
  "subtitle.countdown": "นับถอยหลัง  ",
  "solis.10001.pac": "กำลังไฟฟ้าตามเวลาจริง  ",
  "storage.s3.65292.time": "เวลาของอุปกรณ์  ",
  "datalog.search": "ค้นหา  ",
  "tip.validate.email": "รูปแบบอีเมลไม่ถูกต้อง กรุณากรอกอีเมลที่ถูกต้อง  ",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "เปอร์เซ็นต์การส่งกลับไฟฟ้าสูงสุด  ",
  "jl_param_ctrl_name_IgFollow": "เปิดใช้งานการติดตามกระแสไฟฟ้ากริด  ",
  "Upgrade.search": "ค้นหา  ",
  "common.50100.pv4Power": "กำลังไฟฟ้าตามเวลาจริง PV4  ",
  "device.input_setting_value": "กรุณากรอกค่าที่ตั้ง  ",
  "role.add.select.menu": "กรุณาเลือกทรัพยากรเมนู  ",
  "subtitle.officalWebsite": "เว็บไซต์ทางการ  ",
  "plant.photovoltaicPowerGeneration": "กำลังไฟฟ้าผลิตไฟฟ้าโซลาร์เซลล์  ",
  "bw_RTparam_name_TotalEnergytoGrid": "ปริมาณการขายไฟฟ้ารวม  ",
  "GN-L": "China_GN-L  ",
  "solis.10001.gridPurchasedYearEnergy": "ปริมาณการซื้อไฟฟ้าประจำปีของกริด  ",
  "jl_param_ctrl_option_04-US_Rule21": "04-US Rule21  ",
  "datalog.title_datalog": "การตั้งค่าตัวรวบรวมข้อมูล  ",
  "common.50402.INV_I_AC": "กระแสไฟฟ้าอินเวอร์เตอร์  ",
  "common.50402.PV28_V": "แรงดันไฟฟ้า PV28  ",
  "jl_param_ctrl_option_AoBo": "AoBo  ",
  "common.50402.PV28_I": "กระแสไฟฟ้า PV28  ",
  "plant.building": "กำลังก่อสร้าง  ",
  "jl_param_ctrl_name_G100ManualFaultClearing": "การล้างข้อผิดพลาดมาตรฐาน G100  ",
  "device.electric.current": "กระแสไฟฟ้า  ",
  "solis.10001.power": "ความจุการติดตั้ง  ",
  "placeholder.search": "ค้นหา  ",
  "bw_RTparam_name_BatteryDischargeCut-offVoltage": "แรงดันไฟตัดการปล่อยของระบบ  ",
  "subtitle.BatteryOvervoltageMethod(V)": "ค่าแรงดันไฟเกินของแบตเตอรี่ (V)  ",
  "IEC61727": "India,Pakistan_IEC61727  ",
  "jl_param_ctrl_name_81>S2S-Time": "81>S2S-Time  ",
  "setting.type11.offGridOutputVol": "แรงดันไฟขาออกแบบออฟกริด (V)  ",
  "subtitle.solar": "โซลาร์เซลล์  ",
  "plant.dateOfReceipt": "วันที่รับ  ",
  "jl_param_ctrl_option_NAHUILV": "NAHUI LV  ",
  "jl_param_ctrl_name_08-FrequencyDeratingSlope(Wgra)": "08-Load shedding slope  ",
  "jl_param_ctrl_name_0E-FrequencyDeratingF1": "0E-Load shedding start frequency point  ",
  "placeholder.choiceCountry": "กรุณาเลือกประเทศ  ",
  "setting.type12.acChargeStartTime": "เวลาที่เริ่มทำงานของเครื่องชาร์จ AC  ",
  "jl_param_ctrl_name_EPSDOD": "SOC ตัดการปล่อย EPS  ",
  "device.btn_value": "ตั้งค่าพารามิเตอร์  ",
  "datalog.btn_read": "อ่าน  ",
  "common.50100.wnSn": "หมายเลขซีเรียลสติ๊กการสื่อสาร  ",
  "menu.category.name": "สารบัญ  ",
  "jl_param_ctrl_option_13H-Hawaii": "13H-Hawaii  ",
  "mini.65290.Energy_PV3": "ปริมาณการผลิตไฟฟ้ารวม PV3  ",
  "mini.65290.Energy_PV2": "ปริมาณการผลิตไฟฟ้ารวม PV2  ",
  "mini.65290.Energy_PV1": "ปริมาณการผลิตไฟฟ้ารวม PV1  ",
  "storage.s3.65292.invSubBoardVersion": "รุ่นย่อยของอินเวอร์เตอร์  ",
  "plant.priceSet": "การตั้งค่าราคาไฟฟ้า  ",
  "mini.65290.Energy_PV6": "ปริมาณการผลิตไฟฟ้ารวม PV6  ",
  "mini.65290.Energy_PV5": "ปริมาณการผลิตไฟฟ้ารวม PV5  ",
  "jl_param_ctrl_option_0D-China_2018_New_Standard": "0D-China 2018 มาตรฐานใหม่  ",
  "mini.65290.Energy_PV4": "ปริมาณการผลิตไฟฟ้ารวม PV4  ",
  "jl_param_ctrl_note_OverdischargeSOC": "เมื่อแบตเตอรี่ถึง SOC ต่ำสุด อินเวอร์เตอร์จะหยุดการปล่อยไฟจากแบตเตอรี่  ",
  "unc.65323.returnFlowPortBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของพอร์ตรีเทิร์นเฟส B  ",
  "unc.65323.batTodayChargeEnergy": "ปริมาณการชาร์จวันนี้  ",
  "common.50402.PV15_V": "แรงดันไฟฟ้า PV15  ",
  "common.50402.PV15_I": "กระแสไฟฟ้า PV15  ",
  "plant.primaryUser": "ผู้ใช้หลัก  ",
  "storage.s3.65292.allApparentPower": "กำลังไฟฟ้าปรากฏทั้งหมดของเครื่อง  ",
  "subtitle.ammeter": "มิเตอร์  ",
  "common.50402.vac3": "แรงดันไฟฟ้า AC 3  ",
  "common.50402.vac2": "แรงดันไฟฟ้า AC 2  ",
  "common.50402.vac1": "แรงดันไฟฟ้า AC 1  ",
  "device.sellPowers": "ขายไฟฟ้า  ",
  "email.code.valid": "รหัสยืนยันไม่ถูกต้อง  ",
  "unc.65323.gridBPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานของกริดเฟส B  ",
  "subtitle.ReflowPowerLimit(W)": "ขีดจำกัดกำลังไฟฟ้ารีเทิร์น (W)  ",
  "common.50402.istr9": "กระแสไฟฟ้าสตริง 9  ",
  "common.50402.istr8": "กระแสไฟฟ้าสตริง 8  ",
  "ywt.65323.returnFlowPortPowerFactor": "ตัวประกอบกำลังของพอร์ตรีเทิร์น  ",
  "common.50402.istr5": "กระแสไฟฟ้าสตริง 5",
  "common.50402.istr4": "กลุ่มกระแสไฟฟ้า 4",
  "common.50402.istr7": "กลุ่มกระแสไฟฟ้า 7",
  "common.50402.istr6": "กลุ่มกระแสไฟ 6",
  "form.editShip": "แก้ไขอุปกรณ์จัดส่ง",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "ฉนวนกันความร้อนขั้วบวก 4",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "ฉนวนกันความร้อนขั้วบวก 3",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "ฉนวนกันความร้อนขั้วบวก 2",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "ฉนวนกันความร้อนขั้วบวก 1",
  "device.mutipleSave": "ส่งออกเป็นชุด",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "ฉนวนกันความร้อนแรงสูงสุด 6",
  "common.50100.pv1Current": "กระแสไฟฟ้าสด P 1",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "ฉนวนกันความร้อนขั้วบวก 5",
  "jl_param_ctrl_name_81<S2S": "81 < S 2 S",
  "unc.65323.bmsMinVoltage": "แรงดันไฟฟ้าขั้นต่ำ",
  "org.logo": "ดิวิชั่น, โลโก",
  "solis.10001.psumPec": "เปอร์เซ็นต์ของพลังงานไฟฟ้าทั้งหมด",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "เวลาการชาร์จขัดแย้งกัน",
  "storage.s3.65292.bat9CellVol": "แรงดันไฟฟ้าแกน 9",
  "login.welcome": "ยินดีต้อนรับสู่ห้องพลังงานไฟฟ้าฮาเวียร์",
  "common.50402.istr1": "กลุ่มของกระแสไฟฟ้า 1",
  "storage.s3.65292.mainsApCurrent": "กระแสไฟฟ้าเมือง A",
  "storage.s3.65292.mainsApPower": "ไฟฟ้าเฟส",
  "common.50402.istr3": "กลุ่มของกระแสไฟฟ้า 3",
  "common.50402.istr2": "ชุดรายการปัจจุบัน View - >",
  "solis.10001.bypassLoadPower": "ระบบเสียงโหลด",
  "CQC3310": "CQC 3310",
  "G59/3-A": "K _ G 59 / 3- A",
  "device.chargeAndDisChargeSetting": "ตั้งค่าการปล่อยประจุ",
  "End_user.Bingding_Agent": "ตัวแทนการจับคู่",
  "jl_param_ctrl_name_81<S2F": "81 < S 2 F",
  "tip.log.getFeatureValuesFail": "การรับค่าคุณสมบัติทั้งหมดในบริการ ที่ระบุโดยอุปกรณ์บลูทูธล้มเหลว",
  "setting.type12.val.chargeSourcePriority3": "สุริยะสุริยะ",
  "product.PleaseEnterAGroupName": "โปรดป้อนชื่อกลุ่ม",
  "subtitle.loginIn": "กำลังล็อกอิน...",
  "common.50100.wnWifiVersion": "ไวไฟติดต่อสื่อสาร",
  "jl_param_ctrl_note_FrequencyDeratingDefault": "ตั้งค่ารหัสกริดใหม่การตอบสนองความถี่ ที่เกี่ยวข้อง",
  "bw_RTparam_name_Positionofthehighestvoltagecellinthesystem": "แรงดันสูงสุดของระบบตำแหน่งแกนไฟฟ้า",
  "org.email": "กล่องจดหมาย",
  "setting.type12.val.chargeSourcePriority1": "พลังแสงอาทิตย์สำคัญกว่า",
  "setting.type12.val.chargeSourcePriority2": "สุริยะโฟโต้ และไฟฟ้า",
  "ywt.65323.bmsMaxVoltage": "แรงดันไฟฟ้าสูงสุด",
  "placeholder.enterPlantAddress": "กรุณาป้อน ที่อยู่ของสถานี",
  "subtitle.fixed": "การเลือก",
  "product.maximumValue": "สูงสุด",
  "mini.65290.stErrOP_Relay": "ป้องกันความผิดปกติของรีเลย์ตาข่าย",
  "device.getParamsSuccess": "พารามิเตอร์สำเร็จแล้ว",
  "jl_param_ctrl_option_droop mode": "โหมดวาง",
  "Hungary": "ฮานารี",
  "tip.energy.tip3.coal": "การใช้ถ่านหินส่วนเบี่ยงเบนมาตรฐาน:",
  "jl_param_ctrl_name_LDB": "พารามิเตอร์ของ b",
  "datalog.span_param": "อาร์กิวเมนต์",
  "setting.ops15.batType2": "แบตเตอรี่ลิเธียมทั่วไป",
  "setting.ops15.batType1": "ไม่มีแบตเตอรี่",
  "setting.ops15.batType4": "แบตเตอรี่ลิเธียม",
  "tip.log.openLocationSystem": "เปิดการตั้งค่าตำแหน่ง",
  "setting.ops15.batType3": "แบตเตอรี่ตะกั่ว",
  "setting.type7.increaseChargeReturnVoltage": "เพิ่มแรงดันไฟฟ้าในการชาร์จ",
  "ywt.65323.pv6Voltage": "พลังงานแสงอาทิตย์",
  "title.socketSetting": "ตั้งค่าซ็อกเก็ต",
  "systemAuthority.authorityManagement": "การจัดการสิทธิ์",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "เวลาทดสอบอัตโนมัติ BU < <",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "เวลาทดสอบอัตโนมัติ BU <",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "เวลาทดสอบอัตโนมัติ BU > 10 นาที",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "เวลาทดสอบอัตโนมัติ BU >",
  "plant.format": "โปรดป้อนรูปแบบ ที่ถูกต้อง",
  "org.action": "การกระทำ",
  "subtitle.abnormal": "ผิดปกติ",
  "battery.deviceSn": "กรุณาใส่หมายเลขของอุปกรณ์",
  "plant.familyMembers": "จำนวนสมาชิกในครอบครัว",
  "setting.type12.overloadTemperature": "เมื่ออุณหภูมิเริ่มต้นใหม่",
  "jl_param_ctrl_note_SOC5": "ช่วง: เล่นซอจนถึง 100 %",
  "common.50402.out_pac": "กำลังไฟฟ้า ( KW )",
  "jl_param_ctrl_note_SOC6": "ช่วง: เล่นซอจนถึง 100 %",
  "product.LastMonth": "เดือน ที่ผ่านมา",
  "jl_param_ctrl_name_FCASFMMode": "โหมดเอฟซีเอ",
  "jl_param_ctrl_note_SOC3": "ช่วง: เล่นซอจนถึง 100 %",
  "jl_param_ctrl_note_SOC4": "ช่วง: เล่นซอจนถึง 100 %",
  "jl_param_ctrl_note_SOC1": "ช่วง: เล่นซอจนถึง 100 %",
  "storage.s3.65292.cPhaseApparentPower": "การแสดงผลเฟสของภาพในระดับพลังงาน",
  "jl_param_ctrl_note_SOC2": "ช่วง: เล่นซอจนถึง 100 %",
  "storage.s3.65292.gridMarker": "สัญญาณการไหลของพลังงานไฟฟ้า",
  "setting.type3.DCOutputNormallyClosed": "โหมดการปิด DC",
  "validator.phone": "กรุณาใส่หมายเลขโทรศัพท์ ที่ถูกต้อง หรือหมายเลขโทรศัพท์ปลายทาง",
  "plant.temperature": "อุณหภูมิ (องศาเซลเซียส)",
  "jl_param_ctrl_name_EN50549PowerChangeGradientafterFaultTripRestart": "ความชันของพลังงานหลังจากการรีบูต",
  "jl_param_ctrl_name_OverVoltAutoPLmt": "ความกดอากาศมีข้อ จำกัด อัตโนมัติ",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_3P_Meter_Only_applicable_for_Eastron_Meter": "Section : : : : มาตรฐาน.มาตรฐาน Eastron มีผลเฉพาะกับตารางสัญญาณดงฮง",
  "device.countryStandard": "มาตรฐานระดับชาติ",
  "ship.starttime": "เวลาเริ่ม",
  "bw_param_ctrl_name_GRID_Meter_negate": "เครื่องหมายการกลับกันของกริดไฟฟ้า",
  "IEEE1547-13": "เออร์อีง 1547-13",
  "setting.type12.LED1Color": "เครื่องมือเลือกสี",
  "Philippin": "ฟิลิปปินส์",
  "unc.65323.bmsBatteryCurrent": "ระบบแบตเตอรี่แบบ BMS",
  "subtitle.domainName": "ชื่อโดเมน",
  "language.name": "ภาษาจีน",
  "subtitle.time": "เวลา",
  "user.email.exist": "ตู้จดหมายถูกลงทะเบียน!",
  "ywt.65323.relayStatus": "สถานะส่งถ่ายข้อมูล",
  "sidebar.system": "การจัดการปูมบันทึก",
  "subtitle.manualInstuction4G": "คู่มือการใช้งาน 4 G",
  "jl_param_ctrl_name_BatteryPcmaxPercentageSetting(onlyforCEI0-21)": "ตั้งค่าเปอร์เซ็นต์ของแบตเตอรี่ Pcmax (เฉพาะอิตาลีเท่านั้น )",
  "device.mpptTemp": "อุณหภูมิของ mppt (องศาเซลเซียส)",
  "role.addRole": "เพิ่มตัวอักษร",
  "setting.type22.highFrequency": "คลื่นความถี่สูง",
  "tip.opsLog.bindAgent": "ตัวแทนจำหน่าย",
  "login.accountNumber": "เลขบัญชี",
  "global.battery": "ตั้งค่าแบตเตอรี่",
  "common.50402.PV8_V": "แรงดันไฟฟ้า PV 8",
  "solis.10001.homeGridTotalEnergy": "เก็บค่าการใช้งานด้านข้างของเครือข่าย",
  "ywt.65323.ctVoltageA": "แรงดันไฟฟ้า",
  "device.alarmInfo": "จำนวนของสัญญาณเตือน",
  "common.50402.PV8_I": "ปัจจุบัน PV 8",
  "login.greenLife": "นวัตกรรมพลังงานสะอาดชีวิตสีเขียว",
  "jl_param_ctrl_option_PowerON": "ปิดระบบ",
  "datalogs_logs.endtime": "เวลาสิ้นสุด",
  "ywt.65323.ctVoltageC": "แรงดันไฟฟ้าซี",
  "ywt.65323.ctVoltageB": "แรงดันไฟฟ้าบี",
  "menu.menu.name": "เมนู",
  "bw_param_ctrl_name_DischargeTimeSlot2": "เล่นต่อไป",
  "subtitle.normal": "ปกติ",
  "bw_param_ctrl_name_DischargeTimeSlot1": "เวลาเล่น 1",
  "subtitle.manualInstuctionMasterControl": "คู่มือการควบคุม",
  "G59/3": "UK_G59/3",
  "setting.type11.chargeStartTime1": "เวลาการชาร์จเริ่มต้น 1",
  "setting.type11.chargeStartTime2": "เวลาการชาร์จเริ่มต้น 2",
  "setting.type11.chargeStartTime3": "เวลาการชาร์จเริ่มต้น 3",
  "setting.type11.chargeStartTime4": "เวลาการชาร์จเริ่มต้น 4",
  "subtitle.NumberOfOptimizers": "จำนวนของตัวเพิ่มประสิทธิภาพ",
  "mini.65290.stHW_Fault": "การป้องกันฮาร์ดแวร์อินเวอร์เตอร์",
  "tip.log.connect": "เชื่อมต่อบลูทูธ",
  "agent.edit": "แก้ไข",
  "ESB-Mini": "เรนแลนด์ - มินิ",
  "unc.65323.bmsBatteryVoltage": "แรงดันไฟฟ้าของแบตเตอรี่",
  "datalogs_logs.starttime": "เวลาเริ่ม",
  "Firmware.title": "อัปโหลดเฟิร์มแวร์",
  "setting.type12.equInfoSet": "ตั้งค่าข้อมูลสมดุล",
  "subtitle.configurationGuidance": "ปรับ แต่งคำแนะนำ",
  "org.editorginfo": "แก้ไขข้อมูล",
  "plant.title_delete": "ลบ?",
  "form.warrantyPeriod": "เวลาการรับประกัน",
  "common.50300.vpv9": "แรงดันไฟฟ้ากระแสตรง 9",
  "solis.10001.gridPurchasedMonthEnergy": "ดวงจันทร์สำหรับระบบไฟฟ้า",
  "common.50300.vpv5": "แรงดันไฟฟ้า DC 5",
  "placeholder.selectRepeatTime": "เลือกเวลา ที่ซ้ำกันค่ะ",
  "common.50300.vpv6": "แรงดันไฟฟ้ากระแสตรง 6",
  "common.50300.vpv7": "แรงดันไฟฟ้า DC 7",
  "common.50300.vpv8": "แรงดันไฟฟ้า DC 8",
  "common.50300.vpv1": "แรงดันไฟฟ้ากระแสตรง 1",
  "common.50300.vpv2": "แรงดันไฟฟ้า DC 2",
  "product.addEquipment": "สร้างอุปกรณ์ใหม่",
  "common.50300.vpv3": "แรงดันไฟฟ้ากระแสตรง 3",
  "common.50300.vpv4": "แรงดันไฟฟ้า DC 4",
  "bw_param_ctrl_option_Grid&PV useCT": "ระบบสายส่งไฟฟ้าและการใช้ CT ในระบบโซลาร์เซลล์",
  "unc.65323.load2GeneratorActivePower": "โหลด 2 /เครื่องกำเนิดไฟฟ้าใช้งานได้",
  "bw_RTparam_name_PackIDofMinCellVoltage": "ระบบขั้นต่ำของโมดูลแบตเตอรี่หมายเลขแรงดันไฟฟ้า",
  "datalog.methodes_inputDns": "โปรดป้อนชื่อโดเมน",
  "shipment.category": "หมวดหมู่",
  "jl_param_ctrl_group_TimeSetting": "ตั้งค่าเวลา",
  "common.50300.vac1": "แรงดันไฟฟ้าสลับ 1",
  "common.50300.vac2": "แรงดันไฟฟ้าสลับ 2",
  "common.50300.vac3": "แรงดันไฟฟ้าสลับ 3",
  "org.addDept": "ตำแหน่งใหม่",
  "validator.email": "โปรดป้อนกล่องจดหมาย ที่ถูกต้อง",
  "title.language": "ภาษา",
  "role.updateTime": "เวลา ที่ปรับปรุง",
  "storage.s3.65292.aPhaseVoltage": "แรงดันไฟออกเฟส",
  "jl_param_ctrl_name_08-FrequencyDeratingHysteresisEnableSwitch(HystEna)": "808- ถอยกลับเพื่อให้สามารถสลับได้",
  "ship.devType.not.empty": "วิจัย และพัฒนาไม่สามารถปล่อยให้ว่า ง",
  "subtitle.Reboot": "เริ่มการทำงาน",
  "unc.65323.batteryStatus": "สถานะแบตเตอรี่",
  "setting.type12.acSupplyStartTime": "เวลาเริ่มการทำงานของแหล่งจ่ายไฟ AC",
  "retrieve.lable.newPassword": "รหัสผ่านใหม่",
  "setting.type12.chargeSourcePriority": "แหล่งจ่ายไฟมีความสำคัญ",
  "subtitle.OperationalStatus": "ทำงานอยู่",
  "socket.return": "กลับมา",
  "subtitle.information": "ข้อมูล",
  "storage.v2.65284.BMSWorkingStatus": "กำลังทำงานอยู่",
  "storage.s3.65292.bat13CellVol": "แรงดันไฟฟ้าแกน 13",
  "ywt.65323.batterySOH": "แบตเตอรี่",
  "ywt.65323.batterySOC": "แบตเตอรี่ SOC",
  "ywt.65323.pv6Current": "ไฟฟ้าสุริยะโฟโต้ 6",
  "org.passwordResetTo": "รหัสผ่านจะถูกรีเซ็ตเป็น",
  "role.base": "ข้อมูลพื้นฐาน",
  "home.echarts1.subhead": "วันนี้ รวมผู้ใช้ใหม่ทั้งหมด",
  "tip.opsLog.addUser": "เพิ่มผู้ใช้เทอร์มินัล",
  "G83/1": "UK_G83/1",
  "product.subTypeNumber": "หมายเลขซีเรียล",
  "G83/3": "UK_G83/3",
  "Sri_Lanka": "ศรีพลากา",
  "jl_param_ctrl_option_BMZ_HV": "BMZ_HV",
  "plant.onGridEnergy": "พลังงานอินเทอร์เน็ต",
  "jl_param_ctrl_option_J-PACK-HV": "แจ็ค",
  "product.PleaseEnterTheStepSize": "กรุณาใส่ขั้นตอนยาว ๆ",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_1P_Meter_Only_applicable_for_Eastron_Meter": "Section : : : : มาตรฐาน Eastron เท่านั้น ที่มีผลบังคับใช้กับตารางสัญญาณดงฮง",
  "setting.type22.inputModeChoice.val3": "โหมดของแหล่งข้อมูล",
  "setting.type22.inputModeChoice.val2": "โหมดนำเข้า",
  "common.tip": "เตือนความจำ",
  "setting.type22.inputModeChoice.val1": "ป้อนโหมดอิสระ",
  "plant.lable_Energyprice": "หน่วยพลังงาน",
  "ywt.65323.returnFlowPortTotalActivePower": "ไหลกลับจากพอร์ตพลังงานทั้งหมด",
  "Tips.app_submit": "ยืนยันการแก้ไขข้อมูล?",
  "tip.addDatalogger.noSearchDevice": "ไม่สามารถค้นหาอุปกรณ์ได้โปรดตรวจสอบให้แน่ใจว่า อุปกรณ์บลูทูธเปิดอยู่",
  "subtitle.SoftwareVersionNumber": "หมายเลขรุ่นของซอฟต์แวร์",
  "plant.close": "ปิด",
  "jl_param_ctrl_note_BatteryReserveSwitch": "การตั้งค่าระบบจะต้องมีการเก็บแบตเตอรี่ SOC บางส่วนไว้ในการทำงานปกติ และไฟฟ้า ที่สำรองไว้จะถูกใช้เมื่ออยู่ห่างจากตาข่ายเพื่อรองรับการโหลดเป็นระยะเวลานาน",
  "EN50438L": "ยาไครัสจบแล้ว",
  "jl_param_ctrl_option_PYLON_HV": "PYLON_HV",
  "End_user.max_20": "ตัวละครมากสุดไม่เกิน 20 ตัว",
  "tip.log.wifiPasword": "ไวไฟไม่สามารถว่า งได้โปรดป้อนรหัสผ่าน",
  "MEX-N": "MEX-N_MEX-N",
  "UL-A": "USA_UL-A",
  "subtitle.online": "ออนไลน์",
  "socket.setting_address": "ตั้ง ที่อยู่",
  "jl_param_ctrl_name_BatteryWakeupVoltageSetting": "แรงดันไฟฟ้าของแบตเตอรี่แบบแมนนวล",
  "tip.validate.verification": "กรุณาส่งรหัสยืนยันก่อน",
  "MEX-A": "Mexico_MEX-A",
  "jl_param_ctrl_option_None": "ไม่มีการเชื่อมต่อ",
  "device.dcdcTemp": "อุณหภูมิแบตเตอรี่ (องศาเซลเซียส)",
  "tip.home.others": "อื่น ๆ",
  "datalog.span_time": "เวลา ที่ปรับปรุง:",
  "unc.65323.positiveElectrodeInsulationImpedance3": "ฉนวนกันความร้อนขั้วบวก 3",
  "Meter_in_Grid_Eastron_Standard_3P_Meter": "ระบบพลังงานไฟฟ้ามาตรฐานสามเฟส",
  "unc.65323.positiveElectrodeInsulationImpedance4": "ฉนวนกันความร้อนขั้วบวก 4",
  "unc.65323.positiveElectrodeInsulationImpedance1": "ฉนวนกันความร้อนขั้วบวก 1",
  "unc.65323.positiveElectrodeInsulationImpedance2": "ฉนวนกันความร้อนขั้วบวก 2",
  "plant.updateTime": "เวลาอัปเดตข้อมูลสภาพอากาศ",
  "solis.10001.fullHour": "จำนวนชั่วโมงเต็มกำลัง",
  "unc.65323.positiveElectrodeInsulationImpedance5": "ฉนวนกันความร้อนขั้วบวก 5",
  "unc.65323.positiveElectrodeInsulationImpedance6": "ฉนวนกันความร้อนแรงสูงสุด 6",
  "jl_param_ctrl_option_forward": "ตั้งค่าไปยัง",
  "jl_param_ctrl_option_WTS_Energy_CORE_Power_CORE": "ใช้พลังงาน",
  "jl_param_ctrl_option_Master": "อาจารย์",
  "End_user.btn_binding": "จับคู่",
  "common.50100.pv4Current": "ปัจจุบัน PV 4",
  "plant.today": "วันนี้",
  "form.networkCall11": "จะทำการเรียกกลับไปยังเครือข่าย ที่ปรับ แต่งไว้ หรือไม่",
  "plant.input_Country": "โปรดเลือกประเทศ",
  "jl_param_ctrl_name_Reconnect-US": "เชื่อมต่อ - เรา",
  "storage.s3.65292.batDischargeCur": "แบตเตอรี่ต้องการปล่อยกระแสไฟ",
  "global.device": "ตั้งค่าอินเวอร์เตอร์",
  "setting.type3.startTime": "เวลาเริ่ม",
  "unc.65323.batteryPower": "พลังงานแบตเตอรี่",
  "setting.type12.val.powerCycle": "วงจรไฟฟ้า",
  "subtitle.schedule": "ตัวจับเวลา",
  "unc.65323.spiAutoTestThresholdAPhaseU1": "ระดับการทดสอบอัตโนมัติของเอสพีไอระดับ AU >",
  "setting.type12.batFullRestoreDischargeVol": "คืนค่าแรงดันไฟฟ้า",
  "unc.65323.spiAutoTestThresholdAPhaseU4": "ระดับการทดสอบอัตโนมัติระดับ Au < <",
  "unc.65323.spiAutoTestThresholdAPhaseU3": "ระดับการทดสอบอัตโนมัติ AU <",
  "unc.65323.spiAutoTestThresholdAPhaseU2": "ระดับการทดสอบอัตโนมัติระดับ Au > 10 นาที",
  "setting.type12.LEDSpeed": "ความเร็วของ LED",
  "setting.type11.timerSetting": "ตั้งค่าตัวจับเวลา",
  "bw_RTparam_name_DataloggerSN": "หมายเลขซีเรียล",
  "product.versionNumber": "หมายเลขรุ่น",
  "storage.s3.65292.mainsTodayChargeEnergy": "วันเดียวกับ ที่ไฟฟ้าเปิด",
  "jl_param_ctrl_name_BatteryPsmaxPercentageSetting(onlyforCEI0-21)": "ตั้งค่าเปอร์เซ็นต์ของแบตเตอรี่ Psmax (เฉพาะอิตาลีเท่านั้น )",
  "tip.opsLog.end": "จบ",
  "setting.type12.val.white": "สีขาว",
  "jl_param_ctrl_option_PYLON_LV": "PYLON_LV",
  "bw_param_ctrl_group_GridDispatch": "ตารางกริด",
  "unc.65323.pv1Power": "พลังงานแสงอาทิตย์ 1",
  "subtitle.FeederPowerOnTheSameDay": "ระบบพลังงานแบบหมุนเวียนของดวงอาทิตย์",
  "jl_param_ctrl_name_UN-G-F-T01": "กุน - จี - เอฟ - ที 01",
  "jl_param_ctrl_name_UN-G-F-T02": "มุน - จี - เอฟ - ที 02",
  "product.parameterName": "ชื่อพารามิเตอร์",
  "jl_param_ctrl_note_ChargeTimeSlot4": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "fr-FR": "ฝรั่งเศส",
  "jl_param_ctrl_note_ChargeTimeSlot3": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "plant.socialContribution": "การช่วยเหลือทางสังคม",
  "jl_param_ctrl_note_ChargeTimeSlot2": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "jl_param_ctrl_note_ChargeTimeSlot1": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "common.50402.name": "ชื่ออุปกรณ์",
  "switchover.tipsProvisionServices": "ขอให้เรามีบริการ ที่ดีขึ้น",
  "datalog.email": "กรุณาป้อนกล่องจดหมาย",
  "jl_param_ctrl_note_ChargeTimeSlot6": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "jl_param_ctrl_note_ChargeTimeSlot5": "ไม่สามารถทับซ้อนกับช่วงเวลาอื่น ๆ ของการชาร์จ และความแข็งแรงอื่น ๆ",
  "tip.energy.tip1.grid": "พลังงาน ที่สะสมให้กับกริดไฟฟ้า",
  "agent.title": "เพิ่มตัวแทน",
  "ywt.65323.clsLockTime": "เวลาล็อคของชั้น",
  "jl_param_ctrl_option_STELTECLV": "รักนะรักนะ",
  "tip.device.todayEnergy": "พลังงานในวันนี้",
  "Special.datalogSn": "กรุณาใส่หมายเลขคลังสื่อ",
  "common.50402.STATION_ID": "เลขสถานี",
  "jl_param_ctrl_name_MaxChargingCurrent": "ปัจจุบันการชาร์จสูงสุด",
  "jl_param_ctrl_name_StartFrequency": "ความถี่ในการเริ่มต้น",
  "common.50402.pac": "กำลังไฟฟ้า",
  "unc.65323.gridCurrentC": "กระแสไฟฟ้ากริด C",
  "unc.65323.gridCurrentB": "กระแสไฟฟ้าในกริด B",
  "unc.65323.gridCurrentA": "กระแสไฟฟ้า",
  "setting.type3.stopTime": "เวลาสิ้นสุด",
  "setting.type11.dischargeLongTime1": "ระยะเวลาการคายประจุ 1",
  "setting.type11.dischargeLongTime2": "ระยะเวลาการคายประจุ 2",
  "setting.type11.dischargeLongTime3": "ระยะเวลาการคายประจุ 3",
  "setting.type11.dischargeLongTime4": "ระยะเวลาการคายประจุ 4",
  "EN50438_L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "form.agent": "เจ้าหน้า ที่",
  "storage.s3.65292.pvRadiatorTemp": "PV หม้อน้ำอุณหภูมิ (องศาเซลเซียส)",
  "common.50402.PV23_I": "ปัจจุบัน PV 23",
  "GNC": "China _ GNC",
  "subtitle.BatteryMinimumSOC(%)": "แบตเตอรี่ ที่เล็ก ที่สุดของ SOC ( % )",
  "GNB": "China _ GNB",
  "subtitle.DischargeEnabled": "ปล่อยไฟฟ้า ที่ทำงาน",
  "bw_RTparam_name_PV2Voltage": "แรงดันไฟฟ้าแบบเรียลไทม์",
  "jl_param_ctrl_option_AMPACE_HV": "ปัมป์อัปโหลด",
  "product.PleaseEnterTheMaximumValue": "โปรดป้อนค่าสูงสุด",
  "storage.s3.65292.bPhaseOnGridPower": "มีพลังงานไฟฟ้า ที่ด้านข้างของระบบไฟฟ้า B",
  "bw_param_ctrl_group_GridMeterSettings": "ตั้งค่าแผ่นงาน",
  "sotrage.search": "ค้นหา",
  "unc.65323.ctCPhaseActivePower": "ไฟฟ้าสถิต C กำลังไฟฟ้า",
  "agent.add_agent": "เพิ่มตัวแทน",
  "subtitle.StopIt": "หยุด",
  "France": "แฟรงค์",
  "common.50402.PV23_V": "แรงดันไฟฟ้า PV 23",
  "bw_RTparam_name_GridVoltageL2": "แรงดันไฟฟ้าของกริด L 2",
  "bw_RTparam_name_GridVoltageL3": "แรงดันไฟฟ้าของกริด L 3",
  "bw_RTparam_name_GridVoltageL1": "แรงดันไฟฟ้าของกริด L 1",
  "tip.home.total": "ระดับพลังงานสะสม",
  "R14H-208": "ยูเอสเอสอาร์ 14 เอช - 208",
  "jl_param_ctrl_name_OV-G-V01": "เครื่องรักษาความปลอดภัยเครื่อง 01",
  "jl_param_ctrl_name_OV-G-V02": "อฟ - G - V 02",
  "socket.readdata": "กำลังอ่านค่าเรจิสเตอร์:",
  "End_user.lable_Energyprice": "หน่วยพลังงาน",
  "bw_RTparam_name_BatteryPower": "พลังงานแบตเตอรี่",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "พลังงานสูงสุดของฟีดอินเทอร์เน็ตกับความจุของเครื่องถ่ายโอนแสงอาทิตย์ (รวมทั้งพลังงานแสงอาทิตย์ และพลังงานแสงอาทิตย์ทั้งหมด ที่มีการเข้าถึงอินเวอร์เตอร์ และพลังงานแสงอาทิตย์)",
  "setting.general.needGreat": "ต้องมากกว่า นี้",
  "unc.65323.drmStatus": "สถานะ",
  "unc.65323.pv6Power": "พลังงานแสงอาทิตย์",
  "unc.65323.pv4Current": "ไฟฟ้าสุริยะ 4",
  "tip.log.routerPassword": "รหัสผ่านเราเตอร์ผิดพลาด",
  "PEA": "ดาวน์โหลด",
  "agent.submit": "ส่ง",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeParameters": "ตั้งค่ามาตรฐานของกริด - พารามิเตอร์มาตรฐานของกริด",
  "setting.type12.batBulkVol": "การชาร์จแบตเตอรี่อย่างต่อเนื่อง",
  "common.50100.outputGridCurrent": "ส่งออกความถี่ของกริด",
  "common.50402.PV10_I": "กระแสไฟฟ้า PV 10",
  "ywt.65323.dcComponentC": "องค์ประกอบ DC",
  "jl_param_ctrl_name_GENPortLoadON": "การโหลดพอร์ตเครื่องกำเนิดไฟฟ้า",
  "button.unfollow": "ยกเลิกการสนใจ",
  "tip.validate.validatePassword": "รหัสผ่าน ที่คุณป้อนไม่สอดคล้องกันโปรดตรวจสอบ และพิมพ์ใหม่อีกครั้ง",
  "validator.bank": "กรุณาใส่หมายเลขบัตรธนาคาร ที่ถูกต้อง",
  "plant.delete": "ลบ",
  "solis.10001.aphasePowerFactor": "ตารางไฟฟ้า A พลังงาน",
  "setting.type12.val.batteryStatus": "สถานะการชาร์จแบตเตอรี่",
  "bw_param_ctrl_option_Forced charging and discharging": "บังคับการชาร์จ",
  "bw_param_ctrl_note_ChargeCutSoc": "จำกัด ค่าในการชาร์จแบตเตอรี่",
  "mini.65290.Powpvmax": "เพิ่มพลังงานเข้าสูงสุด",
  "jl_param_ctrl_name_Off-GridOverdischargeSOC": "วางยาสลบผ่านทางเน็ต",
  "title.connectWifi": "เส้นทางการเชื่อมต่อ",
  "mini.65290.stPV2_UV": "กด 2 ค้างไว้",
  "storage.v2.65284.time": "เวลาของอุปกรณ์",
  "placeholder.enterPlantType": "กรุณาพิมพ์ประเภทของสถานี",
  "jl_param_ctrl_note_FailSafeSwitch": "สวิตช์นี้ ใช้สำหรับการเปิด/ปิดการทำงานล้มเหลวคุณสมบัติความปลอดภัยหากการสื่อสารตารางไฟฟ้าสูญหายตัวกลับจะรายงาน",
  "bar.plant": "สถานีไฟฟ้า",
  "subtitle.Model": "รุ่น",
  "jl_param_ctrl_option_PureDrive": "PureDrive",
  "solis.10001.version": "เวอร์ชันของซอฟต์แวร์อินเวอร์ชั่น",
  "token.invalid": "ไม่มีโทโคนโปรดเข้าสู่ระบบอีกครั้ง",
  "subtitle.notAllDay": "ไม่ใช่ทั้งวัน",
  "global.storage_data": "ตั้งค่าพารามิเตอร์ของการจัดเก็บ",
  "common.50402.PV10_V": "แรงดันไฟฟ้า PV 10",
  "jl_param_ctrl_note_FeedinPowerLimitValue": "ตั้งค่า และปล่อยให้มีการ จำกัด พลังงานสูงสุดของฟีด",
  "storage.s3.65292.bat16CellVol": "แรงดันไฟฟ้าแกน 16",
  "tip.messageInfo.inverter": "อินเวอร์เตอร์",
  "subtitle.realTimeParam": "พารามิเตอร์แบบเรียลไทม์",
  "setting.type22.reactiveControlSet": "ควบคุมแบบพาสซีฟ",
  "ywt.65323.pv3Current": "ไฟฟ้าสุริยะ 3",
  "ywt.65323.dcComponentB": "องค์ประกอบ DCB",
  "ywt.65323.dcComponentA": "องค์ประกอบ DC",
  "jl_param_ctrl_group_AdvancedSetting-InverterOutputPowerSetting": "การตั้งค่าขั้นสูง - การตั้งค่ากำลังส่งออกอินเวอร์เตอร์  ",
  "unc.65323.leakageCurrent": "กระแสรั่วไหล  ",
  "setting.type6.activePowerSwitch": "สวิตช์กำลังไฟฟ้าที่ใช้งานได้  ",
  "product.nation": "ประเทศ  ",
  "storage.v2.65284.pvEnergyDay": "ผลผลิต PV วันนี้  ",
  "setting.socket.tuesday": "วันอังคาร  ",
  "jl_param_ctrl_option_CT": "CT  ",
  "solis.10001.iAc3": "กระแสด้าน AC-T  ",
  "solis.10001.iAc2": "กระแสด้าน AC-S  ",
  "jl_param_ctrl_group_WorkMode-FeedinPriorityMode": "โหมดการทำงาน - โหมดให้ความสำคัญกับการจ่ายไฟ  ",
  "solis.10001.iAc1": "กระแสด้าน AC-R  ",
  "storage.v2.65284.batteryTemp1": "อุณหภูมิแบตเตอรี่ชุดที่ 1 (℃)  ",
  "storage.v2.65284.batteryTemp2": "อุณหภูมิแบตเตอรี่ชุดที่ 2 (℃)  ",
  "product.PleaseEnterTheDecimalPoint": "กรุณาใส่จุดทศนิยม  ",
  "GNL-A": "China_GNL-A  ",
  "mini.65290.invPvPower": "กำลังไฟฟ้า PV  ",
  "unc.65323.batAlarmFlag": "สถานะเตือนแบตเตอรี่  ",
  "token.empty": "Token ไม่สามารถเว้นว่างได้  ",
  "placeholder.verificationCode": "กรุณาใส่รหัสยืนยัน  ",
  "subtitle.plantAddress": "ที่ตั้งโรงงาน  ",
  "R14H-240": "USA_R14H-240  ",
  "sotrage.deviceSn": "กรุณาใส่หมายเลขซีเรียลอุปกรณ์  ",
  "App.submit": "ส่ง  ",
  "jl_param_ctrl_note_StopChargingSOC": "เพื่อตั้งค่า SOC ของแบตเตอรี่ที่เครื่องกำเนิดไฟฟ้าจะหยุดทำงาน  ",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "สวิตช์ช่วงเวลาปล่อยประจุ 6  ",
  "tip.plant.read-write": "อ่านและเขียน  ",
  "subtitle.DailyChargingCapacityOfTheBattery": "พลังงานที่ชาร์จวันนี้  ",
  "plant.lable_TimeZone": "เขตเวลา  ",
  "plant.delivered": "ส่งมอบแล้ว  ",
  "plant.storageDischargePower": "กำลังปล่อยประจุแบตเตอรี่  ",
  "mini.65290.Res19": "การจอง 19  ",
  "mini.65290.Res18": "การเก็บรักษา 18  ",
  "mini.65290.Res17": "การจอง 17  ",
  "mini.65290.Res16": "การจอง 16  ",
  "setting.type3.ForcedPowerProtection": "โหมดป้องกันกำลังไฟฟ้าบังคับ  ",
  "mini.65290.Res15": "การเก็บรักษา 15  ",
  "Egypt": "Egypt_Egypt  ",
  "mini.65290.Res14": "การเก็บรักษา 14  ",
  "mini.65290.Res13": "การเก็บรักษา 13  ",
  "device.productType": "ประเภทผลิตภัณฑ์  ",
  "mini.65290.Res12": "การเก็บรักษา 12  ",
  "mini.65290.Res11": "การจอง 11  ",
  "mini.65290.Res10": "การเก็บรักษา 10  ",
  "plant.yes": "ใช่  ",
  "jl_param_ctrl_option_RiSheng": "RiSheng  ",
  "plant.noUserInfo": "ผู้ใช้ที่ยังไม่ได้รับมอบ  ",
  "End_user.close": "ปิด  ",
  "common.50402.PV9_V": "PV9 แรงดันไฟฟ้า  ",
  "App.yes": "ใช่  ",
  "jl_param_ctrl_option_GS_Energy": "GS Energy  ",
  "jl_param_ctrl_group_GridFeedinPowerLimit": "ขีดจำกัดกำลังไฟฟ้าที่จ่ายเข้าสู่กริด  ",
  "unc.65323.totalFeedInGridEnergy": "พลังงานทั้งหมดที่จ่ายเข้าสู่กริด  ",
  "device.category.pv": "โซลาร์เซลล์  ",
  "common.50402.PV9_I": "PV9 กระแสไฟฟ้า  ",
  "mini.65290.Res20": "การเก็บรักษา 20  ",
  "ship.select": "กรุณาเลือกบริษัท  ",
  "jl_param_ctrl_option_YOSHOPOLV": "YOSHOPO LV  ",
  "setting.type10.PVPriority": "ให้ความสำคัญกับโซลาร์เซลล์  ",
  "setting.type10.outputPower": "กำลังส่งออก  ",
  "jl_param_ctrl_name_PVOnlyOverloadReset": "รีเซ็ตการโอเวอร์โหลดเฉพาะ PV  ",
  "unc.65323.load2GeneratorVoltageC": "แรงดันเครื่องกำเนิดไฟฟ้า Load2 C  ",
  "jl_param_ctrl_name_01-FrequencyDeratingFstop": "01-Frequency Derating Fstop  ",
  "unc.65323.load2GeneratorVoltageB": "แรงดันเครื่องกำเนิดไฟฟ้า Load2 B  ",
  "unc.65323.load2GeneratorVoltageA": "แรงดันเครื่องกำเนิดไฟฟ้า Load2 A  ",
  "bw_RTparam_name_DongleRssi": "RSSI  ",
  "button.auto": "อัตโนมัติ  ",
  "bw_param_ctrl_option_Grid&PVUseMeter": "การใช้มิเตอร์กริดและ PV  ",
  "bw_RTparam_name_ForceChargingSOC": "SOC การชาร์จบังคับ  ",
  "product.LastThreeMonths": "ในช่วงสามเดือนที่ผ่านมา  ",
  "jl_param_ctrl_name_Startup-FH": "Startup-FH  ",
  "jl_param_ctrl_name_01-FrequencyDeratingFstart": "01-Frequency Derating Fstart  ",
  "product.ParentDevice": "อุปกรณ์หลัก  ",
  "jl_param_ctrl_name_Startup-FL": "Startup-FL  ",
  "jl_param_ctrl_option_P_Mode-Volt-vatt": "P Mode-Volt-vatt  ",
  "unc.65323.ctStatus": "สถานะ CT  ",
  "subtitle.Auto-replenishment": "การเติมกำลังไฟฟ้าอัตโนมัติ  ",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "สวิตช์ช่วงเวลาปล่อยประจุ 4  ",
  "unc.65323.loadCPhaseActivePower": "กำลังไฟฟ้าที่ใช้งานได้ของเฟส C  ",
  "setting.type12.bulkChargeVol": "แรงดันไฟฟ้า CV ชาร์จ  ",
  "tip.log.getBluetoothServiceFail": "ไม่สามารถรับบริการอุปกรณ์บลูทูธได้  ",
  "device.more": "เพิ่มเติม  ",
  "product.createProduct": "สร้างผลิตภัณฑ์  ",
  "jl_param_ctrl_name_DischargeCurrent1": "กระแสปล่อยประจุ 1  ",
  "jl_param_ctrl_name_DischargeCurrent3": "กระแสปล่อยประจุ 3  ",
  "jl_param_ctrl_name_DischargeCurrent2": "กระแสปล่อยประจุ 2  ",
  "Upgrade.deviceSn": "กรุณาใส่หมายเลขซีเรียลอุปกรณ์  ",
  "jl_param_ctrl_name_DischargeCurrent5": "กระแสปล่อยประจุ 5  ",
  "jl_param_ctrl_name_DischargeCurrent4": "กระแสปล่อยประจุ 4  ",
  "jl_param_ctrl_name_FeedinPowerLimitValue": "ค่าขีดจำกัดกำลังไฟฟ้าที่จ่ายเข้า  ",
  "jl_param_ctrl_name_DischargeCurrent6": "กระแสปล่อยประจุ 6  ",
  "agent.input_address": "กรุณาใส่ที่อยู่  ",
  "ywt.65323.pvTotalPower": "กำลังไฟฟ้า PV ทั้งหมด  ",
  "sidebar.sotrage": "รายการแบตเตอรี่  ",
  "R21-208": "USA_R21-208  ",
  "placeholder.enterOldPassword": "กรุณาใส่รหัสผ่านเก่า  ",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "กำลังไฟฟ้า PV ที่ติดตั้งทั้งหมดที่เชื่อมต่อกับอินเวอร์เตอร์ไฮบริด  ",
  "tip.validate.timeZone": "เขตเวลาไม่สามารถเว้นว่างได้ กรุณาเลือกเขตเวลา  ",
  "jl_param_ctrl_option_AlpSolarrLV": "AlpSolarr LV  ",
  "placeholder.endTime": "เวลาสิ้นสุด  ",
  "subtitle.total2": "ทั้งหมด  ",
  "setting.ops15.workMode1": "โหมดให้ความสำคัญกับการจ่ายไฟ  ",
  "setting.ops15.workMode2": "โหมดออฟกริด  ",
  "home.echarts6.title": "เพิ่มอุปกรณ์  ",
  "setting.ops15.workMode3": "ใช้เอง  ",
  "product.PleaseUploadNoBackground": "กรุณาอัปโหลดภาพอุปกรณ์โดยไม่มีพื้นหลัง  ",
  "sidebar.auth_manage": "สิทธิ์  ",
  "NRS097": "South Africa_NRS097  ",
  "role.status": "สถานะบทบาท  ",
  "tip.validate.oldPassword": "รหัสผ่านเก่าไม่สามารถเว้นว่างได้ กรุณาใส่รหัสผ่านเก่า  ",
  "jl_param_ctrl_option_Lithiumbattery": "แบตเตอรี่ลิเธียม  ",
  "storage.s3.65292.msAvgTemp": "อุณหภูมิเฉลี่ยหลัก-รอง (℃)  ",
  "button.forgetPassword": "ลืมรหัสผ่าน  ",
  "bw_RTparam_name_allowCharged": "อนุญาตให้ชาร์จและปล่อยประจุ  ",
  "device.category.battery": "แบตเตอรี่  ",
  "plant.edit_plant": "แก้ไขฉาก  ",
  "tip.plant.filter": "หน้าจอ  ",
  "jl_param_ctrl_name_Self-UseModeSwitch": "สวิตช์โหมดใช้เอง  ",
  "jl_param_ctrl_name_GridPortPoweredBy": "พอร์ตกริดจ่ายไฟโดย  ",
  "title.vistorLogin": "เข้าสู่ระบบนักท่องเที่ยว  ",
  "tip.base.minDistance": "ล่าสุด  ",
  "plant.statisticalAnalysis": "การวิเคราะห์ทางสถิติ  ",
  "jl_param_ctrl_option_Meter": "มิเตอร์  ",
  "Special.type": "กรุณาเลือกประเภท  ",
  "shipment.supplier": "ผู้จัดหา  ",
  "storage.s3.65292.bat8CellVol": "แรงดันเซลล์ 8  ",
  "setting.type12.lcdRestartPage": "LCD ไม่มีการทำงาน กลับสู่หน้าหลัก  ",
  "jl_param_ctrl_note_StartChargingSOC": "เพื่อตั้งค่า SOC ของแบตเตอรี่ที่เครื่องกำเนิดไฟฟ้าจะเริ่มทำงาน  ",
  "subtitle.battery": "แบตเตอรี่  ",
  "product.UpdateTime": "เวลาอัปเดต  ",
  "setting.type6.enaINVTR": "เปิด/ปิดไฟฟ้าจากระยะไกล  ",
  "unc.65323.ctVoltageC": "แรงดัน CT C  ",
  "unc.65323.ctVoltageB": "แรงดัน CT B  ",
  "subtitle.guideVideo": "วิดีโอแนะนำ  ",
  "unc.65323.ctVoltageA": "แรงดัน CT A  ",
  "device.todayElectricityConsumption": "การใช้ไฟฟ้าวันนี้  ",
  "setting.type3.lowBatteryAlam": "ค่าการเตือนระดับต่ำสำหรับ SOC ของแบตเตอรี่  ",
  "tip.request.netWork": "การเชื่อมต่อเครือข่ายล้มเหลว กรุณาตรวจสอบเครือข่าย  ",
  "bw_RTparam_name_ApparentPOAP_Grid": "กำลังไฟฟ้าปรากฏของเฟส A (กริด)  ",
  "Firmware.create": "สร้างโฟลเดอร์  ",
  "Firmware.file_name": "กรุณาใส่ชื่อไฟล์  ",
  "RD1699": "Spain_RD1699  ",
  "solis.10001.batteryVoltage": "แรงดันแบตเตอรี่  ",
  "storage.v2.65284.internalTemp": "อุณหภูมิภายในระบบ (℃)  ",
  "ISONE240A": "USA_ISONE240A  ",
  "common.50100.wnHardwareVersion": "เวอร์ชันฮาร์ดแวร์ดองเกิล  ",
  "ywt.65323.pv6Power": "กำลังไฟฟ้า PV 6  ",
  "device.category.switch": "สวิตช์  ",
  "jl_param_ctrl_name_Max.gridpowerwhenForcecharging": "กำลังไฟฟ้ากริดสูงสุดเมื่อชาร์จบังคับ  ",
  "subtitle.tariffType": "ประเภทราคาไฟฟ้า  ",
  "bw_RTparam_name_CurrentOfCPhase_PV": "กระแสไฟฟ้าของเฟส C (PV)  ",
  "ywt.65323.busVoltage": "แรงดันบัส  ",
  "tip.opsLog.type": "ประเภท  ",
  "R21-240": "USA_R21-240  ",
  "datalog.upgrade": "อัปเกรด  ",
  "storage.s3.65292.loadTodayUseMainsEnergy": "การใช้ไฟฟ้าโหลดจากกริดวันนี้  ",
  "subtitle.plantName": "ชื่อโรงงาน  ",
  "common.50402.INV_RUN_STATE": "สถานะการทำงานของอินเวอร์เตอร์  ",
  "ywt.65323.todayFeedInGridEnergy": "การจ่ายไฟฟ้าเข้าสู่กริดรายวัน  ",
  "datalog.setting": "ตั้งค่า  ",
  "dev.type.oem": "OEM  ",
  "role.info": "ข้อมูล  ",
  "tip.plant.name": "ชื่อ  ",
  "common.50300.name": "ชื่ออุปกรณ์  ",
  "common.50300.sn": "หมายเลขซีเรียลอุปกรณ์  ",
  "subtitle.deviceDetails": "รายละเอียดอุปกรณ์  ",
  "G99N": "UK_G99N  ",
  "setting.type11.maxChargeCur": "กำลังไฟฟ้าชาร์จสูงสุด  ",
  "setting.ops15.optimizeRevenue": "เพิ่มรายได้  ",
  "jl_param_ctrl_note_10minOvervoltageSetting": "การตั้งค่าเฉพาะที่เกี่ยวข้องกับรหัสกริด กรุณาไม่แก้ไขการตั้งค่าหากผู้ให้บริการเครือข่ายท้องถิ่นไม่อนุญาต  ",
  "plant.electricPowerConsumption": "กำลังไฟฟ้าโหลด  ",
  "unc.65323.spiAutoTestTimeAPhaseU4": "SPI Auto Test Time APhase U4  ",
  "unc.65323.spiAutoTestTimeAPhaseU3": "SPI Auto Test Time APhase U3  ",
  "unc.65323.spiAutoTestTimeAPhaseU2": "SPI Auto Test Time APhase U2  ",
  "unc.65323.spiAutoTestTimeAPhaseU1": "SPI Auto Test Time APhase U1  ",
  "common.environmentChange": "การเปลี่ยนแปลงสภาพแวดล้อมบัญชี ยืนยันเพื่อรีเฟรชบัญชีหรือเข้าสู่ระบบใหม่  ",
  "subtitle.DailyPowerConsumption": "การใช้ไฟฟ้ารายวัน  ",
  "App.New_Version": "เวอร์ชันใหม่",
  "dev.type.odm": "ODM",
  "home.echarts4.subhead": "จำนวนฉากใหม่/จำนวนฉากทั้งหมดที่เพิ่ม",
  "bw_RTparam_name_BatteryChargingCurrentLimit": "ขีดจำกัดกระแสการชาร์จแบตเตอรี่",
  "common.50100.pv2Voltage": "แรงดัน PV2",
  "bw_RTparam_name_PFOB_Grid": "ตัวประกอบกำลังของเฟส B (กริด)",
  "jl_param_ctrl_note_AFCIProtect": "เปิด/ปิดการป้องกัน AFCI",
  "setting.type22.inputMode": "โหมดอินพุต",
  "setting.type22.systemSetting": "การตั้งค่าข้อมูลอุปกรณ์",
  "common.50402.PV18_V": "แรงดัน PV18",
  "subtitle.status": "สถานะ",
  "tip.validate.phone": "หมายเลขโทรศัพท์มือถือรองรับเฉพาะจีนแผ่นดินใหญ่ โปรดใช้อีเมลเพื่อกู้คืนข้อมูลอื่น",
  "datalog.Version": "หมายเลขเวอร์ชัน",
  "unc.65323.pv1Current": "กระแส PV1",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "เปิดใช้งานเฉพาะการควบคุมช่วงเวลาการชาร์จ",
  "common.50402.PV18_I": "กระแส PV18",
  "setting.type12.val.low": "ต่ำ",
  "ywt.65323.returnFlowPortBPhaseActivePower": "กำลังงานจริงของเฟส B ที่พอร์ตรีฟลักซ์",
  "subtitle.email": "อีเมล",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "โหลด 2/กำลังงานที่ผลิตได้ประจำวันของเครื่องกำเนิดไฟฟ้า",
  "shipment.MaterialCode": "รหัสวัสดุ MDM",
  "solis.10001.batteryTotalChargeEnergy": "พลังงานการชาร์จทั้งหมดของแบตเตอรี่",
  "storage.s3.65292.bat3CellVol": "แรงดันเซลล์ 3",
  "ywt.65323.batTotalChargeEnergy": "พลังงานการชาร์จทั้งหมดของแบตเตอรี่",
  "setting.type22.functionSelect": "การเลือกฟังก์ชัน",
  "jl_param_ctrl_group_GridCodeSetting-SpecialSetting": "การตั้งค่ารหัสกริด - การตั้งค่าเฉพาะ",
  "unc.65323.pv1Voltage": "แรงดัน PV1",
  "setting.type12.batEquSet": "ฟังก์ชันการปรับสมดุลแบตเตอรี่",
  "tip.validate.passwordFormTip": "โปรดป้อนรหัสผ่านที่ประกอบด้วยตัวเลขและตัวอักษร 6-20 หลัก",
  "End_user.lable_StationName": "ชื่อฉาก",
  "jl_param_ctrl_option_WECO_HV_": "WECO HV",
  "EN50438IE": "Ireland_EN50438IE",
  "jl_param_ctrl_name_LimitedReactivePowerValue": "ค่ากำลังงานรีแอคทีฟที่จำกัด",
  "unc.65323.returnFlowPortCurrentC": "กระแสพอร์ตรีฟลักซ์ C",
  "setting.type10.phaseGridSide": "ด้านกริด",
  "unc.65323.warningStatus": "สถานะการแจ้งเตือน",
  "ywt.65323.bmsBatteryCurrent": "กระแสแบตเตอรี่ BMS",
  "ESB-SC": "Ireland_ESB-SC",
  "unc.65323.returnFlowPortCurrentB": "กระแสพอร์ตรีฟลักซ์ B",
  "unc.65323.returnFlowPortCurrentA": "กระแสพอร์ตรีฟลักซ์ A",
  "upload.uploadError": "การอัปโหลดไฟล์ล้มเหลว โปรดติดต่อผู้ดูแลระบบ",
  "jl_param_ctrl_name_81>S2F-Time": "81>S2F-Time",
  "solis.10001.batteryMonthDischargeEnergy": "พลังงานที่ปล่อยออกมาประจำเดือน",
  "jl_param_ctrl_name_FailSafeSwitch": "สวิตช์ FailSafe",
  "dept.add.exist": "ไม่สามารถเพิ่มแผนก '% s' ได้ ชื่อแผนกมีอยู่แล้ว",
  "setting.type12.solarFeedToGird": "การเชื่อมต่อกริดพลังงานแสงอาทิตย์ที่ไม่ได้ใช้งาน",
  "Overload_Fault_Clearing": "การล้างข้อผิดพลาด OverLoad",
  "subtitle.CumulativePowerGeneration": "ผลผลิตทั้งหมด",
  "Tips.firmware_deleteCDN": "ลบไฟล์จาก CDN?",
  "unc.65323.clsLockNum": "จำนวนครั้งที่ล็อก CLS",
  "bw_RTparam_name_Power-onTime": "เวลาที่เปิดเครื่อง",
  "unc.65323.load2GeneratorTodayConsumeEnergy": "พลังงานที่ใช้ประจำวันของเครื่องกำเนิดไฟฟ้า Load2",
  "Tips.no": "ไม่",
  "solis.10001.pow9": "กำลังงาน PV -9",
  "datalog.span_value": "ค่า",
  "solis.10001.pow8": "กำลังงาน PV -8",
  "solis.10001.pow7": "กำลังงาน PV -7",
  "solis.10001.pow6": "กำลังงาน PV -6",
  "common.50402.PV1_V": "แรงดัน PV1",
  "solis.10001.pow5": "กำลังงาน PV -5",
  "solis.10001.pow4": "กำลังงาน PV -4",
  "solis.10001.pow3": "กำลังงาน PV -3",
  "solis.10001.pow2": "กำลังงาน PV -2",
  "solis.10001.pow1": "กำลังงาน PV -1",
  "setting.type3.dischargeScheduleMode": "โหมดการปล่อยพลังงานตามเวลา",
  "sidebar.plant_plant": "โรงงาน",
  "dept.suspend": "แผนกถูกระงับ ไม่สามารถเพิ่มใหม่ได้",
  "mini.65290.stPV5_OV": "แรงดันอินพุต PV5 เกิน",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "สวิตช์ช่องเวลาการชาร์จ 6",
  "common.50402.PV1_I": "กระแส PV1",
  "solis.10001.gridPower": "กำลังงานกริด",
  "plant.plantOverview": "ภาพรวมโรงงาน",
  "jl_param_ctrl_option_Grid": "กริด",
  "socket.setting": "ตั้งค่า",
  "ESB-MV": "Ireland_ESB-MV",
  "jl_param_ctrl_note_FeedinPriorityModeSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดโหมด Feed in Priority",
  "title.addSchedule": "เพิ่มตัวจับเวลา",
  "jl_param_ctrl_name_AutoBatAwaken": "ปลุกแบตเตอรี่อัตโนมัติ",
  "subtitle.ForcedFullCharge": "การชาร์จเต็มบังคับ",
  "socket.read": "อ่าน",
  "jl_param_ctrl_note_TimeofUseSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดการตั้งค่า Time of use เพื่อให้ผู้ใช้สามารถตั้งค่ารูปแบบการชาร์จ/ปล่อยพลังงานที่กำหนดเองได้",
  "jl_param_ctrl_option_AoboetHV": "Aoboet HV",
  "solis.10001.updateShelfEndTime": "เวลาสิ้นสุดการรับประกัน",
  "subtitle.dealerNumber": "รหัสตัวแทนจำหน่าย",
  "product.deviceList": "รายการอุปกรณ์ (บันทึกการส่งสินค้า)",
  "login.privacyPolicy": "นโยบายความเป็นส่วนตัว",
  "device.selet_data": "เลือกวันที่",
  "plant.currency": "สกุลเงิน",
  "mini.65290.stUV_Vgrid": "การป้องกันแรงดันต่ำด้านกริด",
  "jl_param_ctrl_group_BackupSetting": "การตั้งค่าแบ็กอัพ",
  "setting.type12.LED3Color": "สี LED3",
  "setting.type10.endTime": "เวลาสิ้นสุด",
  "jl_param_ctrl_note_BatteryHealingSOC": "เป้าหมาย SOC สำหรับฟังก์ชันการรักษาแบตเตอรี่",
  "tip.noData": "ไม่มีข้อมูลในขณะนี้",
  "org.user": "ผู้ใช้",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM7mode": "การตั้งค่าร้อยละของกำลังงานรีแอคทีฟภายใต้โหมด DRM7",
  "mini.65290.stPV5_UV": "แรงดันอินพุต PV5 ต่ำ",
  "DK": "Denmark_DK",
  "setting.type12.val.slow": "ช้า",
  "G98": "UK_G98",
  "G99": "UK_G99",
  "plant.total": "ทั้งหมด",
  "tip.log.openBluetoothSystem": "เปิดการตั้งค่า Bluetooth",
  "bw_RTparam_name_ReactivePOCP_Grid": "กำลังงานรีแอคทีฟของเฟส C (กริด)",
  "ywt.65323.bmsChargeCurrentLimit": "ขีดจำกัดกระแสการชาร์จ BMS",
  "common.50100.pv3CumulativePowerGeneration": "ผลผลิตทั้งหมด PV3",
  "jl_param_ctrl_option_0E-EN50549": "0E-EN50549",
  "upload.imageDetail": "รายละเอียดภาพ",
  "setting.type22.restartSolpe": "ความชันการรีสตาร์ท",
  "setting.type7.batteryVoltage": "แรงดันแบตเตอรี่",
  "product.stepSize": "ขั้นตอน",
  "device.inverterTemp": "อุณหภูมิอินเวอร์เตอร์ (℃)",
  "tip.log.wifiLoadFail": "การโหลดรายการ WiFi ล้มเหลว โปรดป้อนข้อมูลด้วยตนเอง",
  "jl_param_ctrl_option_01-Australia": "01-Australia",
  "agent.language": "ภาษา",
  "bw_RTparam_name_CurrentOfAPhase_PV": "กระแสของเฟส B (PV)",
  "bw_RTparam_name_PV2Power": "กำลังงาน PV2",
  "bw_RTparam_group_ Dongle": "ดองเกิล",
  "storage.s3.65292.batTodayChargeEnergy": "พลังงานที่ชาร์จได้ประจำวัน",
  "jl_param_ctrl_option_07-US_Rule21Phase1": "07-US Rule21Phase1",
  "setting.type3.startCompareEnd": "เวลาที่เริ่มต้นของตัวจับเวลาต้องน้อยกว่าเวลาสิ้นสุด",
  "subtitle.timeZone": "เขตเวลา",
  "End_user.Agent_Code": "ตัวแทน:",
  "bar.endpoint": "เทอร์มินัล",
  "sidebar.plant": "การจัดการฉาก",
  "subtitle.run": "ฟังก์ชัน",
  "App.APP_Type": "ประเภทแอป:",
  "ASNZ4777-A": "Australia_ASNZ4777-A",
  "tip.energy.explain": "อธิบาย",
  "ASNZ4777-C": "Australia_ASNZ4777-C",
  "ASNZ4777-B": "Australia_ASNZ4777-B",
  "jl_param_ctrl_name_81>S2S": "81>S2S",
  "plant.userInfo": "ข้อมูลผู้ใช้",
  "subtitle.LogicalView": "มุมมองเชิงตรรกะ",
  "home.echarts2.subhead": "การเข้าสู่ระบบประจำวัน/จำนวนผู้ใช้ทั้งหมด",
  "button.confirm": "ยืนยัน",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "jl_param_ctrl_name_81>S2F": "81>S2F",
  "common.password": "รหัสผ่าน",
  "ywt.65323.bmsMinVoltage": "แรงดันต่ำสุดของ BMS",
  "mini.65290.Tempmax": "อุณหภูมิการทำงานสูงสุด (℃)",
  "agent.input_company": "โปรดเลือกบริษัท",
  "subtitle.findPhone": "การกู้คืนหมายเลขโทรศัพท์มือถือ",
  "ywt.65323.gridApparentPower": "กำลังงานปรากฏของกริดไฟฟ้า",
  "Ajouterbar.plant": "เพิ่มโรงงาน",
  "device.Fault&Alarm": "ข้อผิดพลาดและการแจ้งเตือน",
  "storage.s3.65292.outputStatus": "สถานะเอาต์พุต",
  "setting.type6.OF_resopnseTime": "เวลาตอบสนองการโอเวอร์คล็อกระดับ {num}",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "แรงดันต่ำสุดของแบตเตอรี่สำหรับการปล่อยพลังงานแบบออฟกริด 2 (V)",
  "storage.s3.65292.totalLoadPower": "โหลดทั้งหมด",
  "product.socket": "ซ็อกเก็ต",
  "subtitle.on-GridPlant": "โรงงานที่เชื่อมต่อกริด",
  "setting.type10.ApprovalStandards": "มาตรฐานการรับรอง",
  "common.50402.vpv7": "vpv7",
  "device.select": "โปรดเลือก",
  "common.50402.vpv6": "vpv6",
  "common.50402.vpv5": "vpv5",
  "common.50402.vpv4": "vpv4",
  "ISONE208": "USA_ISONE208",
  "common.50402.vpv3": "vpv3",
  "common.50402.vpv2": "vpv2",
  "common.50402.vpv1": "vpv1",
  "common.50402.hTotal": "hTotal",
  "socket.title": "การตั้งค่าซ็อกเก็ต",
  "device.version": "เวอร์ชัน",
  "product.ImportParameter": "นำเข้าพารามิเตอร์",
  "common.50402.vpv9": "vpv9",
  "common.50402.vpv8": "vpv8",
  "setting.type11.onGridMinDischargeVol": "แรงดันปล่อยต่ำสุดสำหรับการเชื่อมต่อกริด (V)",
  "unc.65323.loadCurrentA": "กระแสโหลด A",
  "service.not.found": "ไม่พบบริการ",
  "unc.65323.loadCurrentC": "กระแสโหลด C",
  "unc.65323.loadCurrentB": "กระแสโหลด B",
  "setting.type3.batterySOCSetting": "การตั้งค่า SOC ของแบตเตอรี่",
  "bar.user": "ผู้ใช้",
  "storage.s3.65292.invTemp": "อุณหภูมิอินเวอร์เตอร์",
  "tip.home.today": "ผลผลิตประจำวัน",
  "tip.log.monitoringSuccess": "ตรวจสอบการเปลี่ยนแปลงค่าคุณลักษณะของอุปกรณ์ Bluetooth แบบพลังงานต่ำได้สำเร็จ",
  "storage.s3.65292.pvTotalEnergy": "ผลผลิตทั้งหมด PV",
  "jl_param_ctrl_name_Min.DroopVoltage": "แรงดัน Droop ต่ำสุด",
  "jl_param_ctrl_name_Peak-shavingSetting": "การตั้งค่า Peak-shaving",
  "jl_param_ctrl_note_Max.gridpowerwhenForcecharging": "กำลังงานกริดสูงสุดที่อนุญาตสำหรับการชาร์จแบตเตอรี่แบบบังคับ",
  "common.50402.DATA_TIME": "เวลาข้อมูล",
  "setting.type12.inputSourceChangeAlarm": "การแจ้งเตือนการเปลี่ยนแปลงแหล่งอินพุต",
  "setting.type3.pureLightControlMode": "โหมดควบคุมแสงบริสุทธิ์",
  "End_user.lable_TimeZone": "เขตเวลา",
  "unc.65323.generatorRelayStatus": "สถานะรีเลย์เครื่องกำเนิดไฟฟ้า",
  "common.50402.PV22_I": "กระแส PV22",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFD_Droop": "03&0E-Underfrequency Ramping FD_Droop",
  "login.userAgreement": "ข้อตกลงผู้ใช้",
  "bw_RTparam_name_PFOA_Grid": "ตัวประกอบกำลังของเฟส A (กริด)",
  "setting.type7.stopchangeCurrent": "กระแสหยุดการชาร์จ",
  "tip.log.notsupport": "แพลตฟอร์มปัจจุบันรองรับการเรียกใช้ฟังก์ชัน Bluetooth",
  "ywt.65323.ctCPhaseActivePower": "กำลังงานจริงของเฟส C ของ EM",
  "End_user.lable_Country": "ประเทศ",
  "storage.s3.65292.batStatus": "สถานะแบตเตอรี่",
  "tip.log.masterControlId": "รหัสควบคุมหลักไม่สามารถเว้นว่างได้ โปรดป้อนรหัส",
  "Firmware.folder_name": "ชื่อไฟล์:",
  "C10/11": "Belgium_C10/11",
  "ISONE240": "USA_ISONE240",
  "plant.dataReportingTime": "เวลารายงานข้อมูล",
  "common.50402.PV22_V": "แรงดัน PV22",
  "jl_param_ctrl_option_Generator": "เครื่องกำเนิดไฟฟ้า",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "สวิตช์ช่องเวลาการชาร์จ 2",
  "placeholder.searchDataloggerName": "ค้นหาชื่อดองเกิล",
  "ywt.65323.load2GeneratorFrequency": "โหลด 2/ความถี่เครื่องกำเนิดไฟฟ้า",
  "jl_param_ctrl_option_Dowell": "Dowell",
  "setting.type10.modeSelect": "รูปแบบ",
  "btn.import": "นำเข้า",
  "bw_RTparam_name_GridStatus": "สถานะกริด",
  "ywt.65323.warningStatus": "สถานะการแจ้งเตือน",
  "jl_param_ctrl_name_Off-gridModeSwitch": "สวิตช์โหมดออฟกริด",
  "button.ok": "ยืนยัน",
  "unc.65323.clsLockTime": "เวลาล็อก CLS",
  "solis.10001.reactivePower": "กำลังงานรีแอคทีฟของอินเวอร์เตอร์",
  "bw_RTparam_name_PV2Current": "กระแส PV2",
  "agent.input_phone": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFdstart": "13H-Underfrequency Ramping Fdstart",
  "tip.plant.addVisitor": "เพิ่มผู้เยี่ยมชม",
  "mini.65290.Iacrms": "กระแส RMS ด้านกริด",
  "tip.validate.plantType": "ประเภทโรงงานไม่สามารถเว้นว่างได้ โปรดเลือกประเภทโรงงาน",
  "device.pleaseSelect": "โปรดเลือกรายการข้อมูลทางด้านซ้าย",
  "device.productModel": "รุ่นผลิตภัณฑ์",
  "datalogs_logs.Version": "โปรดป้อนเวอร์ชัน",
  "subtitle.StandbyMode": "โหมดแบ็กอัพ",
  "NTS631": "Spain_NTS631",
  "user.not.exist": "ผู้ใช้ไม่มีอยู่",
  "tip.addDatalogger.searchAroundBluetooth": "เครือข่าย Bluetooth รอบตัวสามารถใช้งานได้",
  "jl_param_ctrl_note_ReservedSOC": "SOC ที่สงวนไว้ มีผลเฉพาะเมื่อสวิตช์สำรองแบตเตอรี่เปิดใช้งาน",
  "VIETNAM": "Vietnam_VIETNAM",
  "agent.phone": "หมายเลขโทรศัพท์",
  "product.PleaseenterTheSubmodelSerialNumber": "โปรดป้อนหมายเลขรุ่นย่อย",
  "title.device": "อุปกรณ์",
  "UL-208V-18": "USA_UL-208V-18",
  "storage.s3.65292.batTodayDischargeEnergy": "พลังงานที่ปล่อยออกมาประจำวัน",
  "unc.65323.clsStatus": "สถานะ CLS",
  "upload.fail": "การอัปโหลดล้มเหลว",
  "UL-208V-13": "USA_UL-208V-13",
  "setting.type19.offgrid.offNet": "ออฟกริด",
  "subtitle.mode": "โหมด",
  "ywt.65323.pv5Power": "กำลังงาน PV5",
  "common.50402.PV17_V": "แรงดัน PV17",
  "storage.s3.65292.bat11CellVol": "แรงดันเซลล์ 11",
  "common.50402.PV17_I": "กระแส PV17",
  "unc.65323.batTotalDischargeEnergy": "พลังงานที่ปล่อยออกมาทั้งหมด",
  "supplier.type.ywt": "INVT",
  "jl_param_ctrl_option_JA-H": "JA-H",
  "setting.type12.batUnderVol": "แรงดันตัดแบตเตอรี่",
  "Logs.search": "ค้นหา",
  "storage.s3.65292.batSurplusCapacity": "ความจุแบตเตอรี่ที่เหลือ",
  "subtitle.GeneralSettings": "การตั้งค่าทั่วไป",
  "register.lable.Email": "อีเมล",
  "bar.my": "ของฉัน",
  "jl_param_ctrl_option_JA-L": "JA-L",
  "login.sendverCode": "ส่งรหัสยืนยัน",
  "tip.validate.notInTheScope": "พารามิเตอร์อินพุตไม่อยู่ในช่วงที่กำหนด",
  "jl_param_ctrl_note_Off-gridModeSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดโหมดออฟกริด\nหาก SOC ของแบตเตอรี่น้อยกว่า 30% อย่าเปิดใช้งานโหมดออฟกริด",
  "NO_Meter": "ไม่มีมิเตอร์",
  "unc.65323.load2GeneratorFrequency": "ความถี่เครื่องกำเนิดไฟฟ้า Load2",
  "common.50100.outputGridVoltage": "แรงดันกริดเอาต์พุต",
  "mini.65290.Firmware_ver2": "เวอร์ชันเฟิร์มแวร์ 2",
  "mini.65290.Firmware_ver3": "เวอร์ชันเฟิร์มแวร์ 3",
  "solis.10001.cphasePowerFactor": "กำลังงานจริงมิเตอร์ C",
  "mini.65290.Firmware_ver1": "เวอร์ชันเฟิร์มแวร์ 1",
  "setting.socket.monday": "วันจันทร์",
  "plant.batteryCapacity": "ความจุแบตเตอรี่ (kWh)",
  "bw_RTparam_name_BatteryStatus": "สถานะแบตเตอรี่",
  "global.battery_data": "ตั้งค่าพารามิเตอร์แบตเตอรี่",
  "tip.connectWifi.masterId": "โปรดป้อนรหัสควบคุมหลัก",
  "mini.65290.stOV_Vgrid": "การป้องกันแรงดันสูงด้านกริด",
  "subtitle.OptimizerNumber": "หมายเลขออปติไมเซอร์",
  "mini.65290.stPV2_OV": "แรงดันอินพุต PV2 เกิน",
  "agent.title_device": "อัปโหลด",
  "TR-2": "Turkey_TR-2",
  "role.applySuccess": "การใช้งานสำเร็จ",
  "jl_param_ctrl_note_ACCouplingSwitch": "เพื่อเปิด/ปิดฟังก์ชัน AC coupling เพื่อใช้การปรับความถี่ในการควบคุมการผลิตพลังงานของอินเวอร์เตอร์ PV",
  "unc.65323.load2GeneratorAPhaseActivePower": "กำลังงานจริงเฟส A ของเครื่องกำเนิดไฟฟ้า Load2",
  "form.lable_StationType": "ประเภทฉาก",
  "common.50300.fault": "ข้อผิดพลาด",
  "systemAuthority.accountManagement": "บทบาท",
  "setting.type12.buzzerAlarm": "การแจ้งเตือนด้วยเสียงบัซเซอร์",
  "jl_param_ctrl_option_UpowerUE-I": "UPower UE-I",
  "product.RandDtype": "ประเภท R&D",
  "jl_param_ctrl_option_UpowerUE-H": "UPower UE-H",
  "button.yes": "ใช่",
  "subtitle.updatePhone": "อัปเดตหมายเลขโทรศัพท์",
  "jl_param_ctrl_name_UN-G-F02": "UN-G-F 02",
  "tip.log.wifiPasswordError": "รหัสผ่าน WiFi ไม่สามารถมีอักขระพิเศษ (ǎǐò•♢ ∝ ℃℉, ฯลฯ)",
  "jl_param_ctrl_name_UN-G-F01": "UN-G-F 01",
  "storage.s3.65292.pvTodayEnergy": "ผลผลิตประจำวัน PV",
  "setting.type19.offgrid.gridNet": "การเชื่อมต่อกริด",
  "common.50402.tempperature": "อุณหภูมิ (℃)",
  "bw_RTparam_name_buy": "ซื้อไฟฟ้า",
  "storage.s3.65292.homeLoadPower": "กำลังงานโหลดครัวเรือน",
  "jl_param_ctrl_option_HDEnergy": "HD Energy",
  "tip.opsLog.command": "ประเภทคำสั่ง",
  "tip.opsLog.start": "เริ่มต้น",
  "jl_param_ctrl_group_WorkMode-Off-GridMode": "โหมดการทำงาน - โหมดออฟกริด",
  "product.expirationDate": "ระยะเวลาการรับประกันคุณภาพ",
  "BDEW": "Germany_BDEW",
  "product.WhetherYoSupportBatchRead": "รองรับการอ่านแบบกลุ่มหรือไม่",
  "agent.input_password": "โปรดป้อนรหัสผ่าน",
  "button.save": "บันทึก",
  "login.forgotPassword": "ลืมรหัสผ่าน",
  "device.email": "โปรดป้อนที่อยู่อีเมลของคุณ",
  "jl_param_ctrl_name_FrequencyDeratingMode": "โหมด Frequency Derating",
  "jl_param_ctrl_name_FeedinPowerLimitSwitch": "สวิตช์จำกัดกำลังงาน Feed in",
  "setting.socket.switchStatus": "สวิตช์ซ็อกเก็ต",
  "setting.socket.saturday": "วันเสาร์",
  "setting.type12.faultCodeRecord": "บันทึกข้อผิดพลาดซอฟต์แวร์การสื่อสาร",
  "jl_param_ctrl_option_PhaseC(3P)": "เฟส C (สามเฟส)",
  "solis.10001.aLookedPower": "กำลังงานปรากฏมิเตอร์ A",
  "subtitle.todayConsumption": "การใช้งานประจำวัน",
  "bw_RTparam_group_Inverter": "อินเวอร์เตอร์",
  "jl_param_ctrl_name_StopChargingSOC": "SOC หยุดการชาร์จ",
  "bw_RTparam_name_DataloggerVersion": "เวอร์ชันดองเกิล",
  "home.echarts3.subhead": "การเข้าสู่ระบบประจำวัน/จำนวนตัวแทนทั้งหมด",
  "subtitle.all": "ทั้งหมด",
  "common.50300.Standby": "สแตนด์บาย",
  "button.allReady": "อ่านทั้งหมด",
  "sidebar.system_log": "บันทึกการดำเนินการ",
  "subtitle.energyFlowDiagram": "แผนผังการไหลของพลังงาน",
  "ywt.65323.ctAPhaseActivePower": "กำลังงานจริงของเฟส A ของ EM",
  "jl_param_ctrl_option_GeneratorPort": "พอร์ตเครื่องกำเนิดไฟฟ้า",
  "bw_RTparam_name_Fullchargecapacityofbattery": "ความจุแบตเตอรี่เต็ม",
  "tip.log.connectSuccess": "การเชื่อมต่อ Bluetooth สำเร็จ",
  "common.50402.etotal": "etotal",
  "Special.endtime": "เวลาสิ้นสุด",
  "common.50100.wnSoftwareVersion": "เวอร์ชันซอฟต์แวร์ดองเกิล",
  "ywt.65323.batTotalDischargeEnergy": "พลังงานที่ปล่อยออกมาทั้งหมด",
  "bw_RTparam_name_SSID": "SSID",
  "common.50402.fac3": "fac3",
  "tip.plant.visitor": "ผู้เยี่ยมชม",
  "common.50402.fac2": "fac2",
  "common.50402.fac1": "fac1",
  "product.remark": "หมายเหตุ",
  "jl_param_ctrl_name_ACCoupling_OFF_Bat_Volt": "AC Coupling_OFF_Bat_Volt",
  "storage.s3.65292.pv2Power": "กำลังงานเอาต์พุต PV2",
  "setting.type6.noHave": "ไม่มีอะไร",
  "End_user.input_Address": "โปรดป้อนที่อยู่",
  "End_user.input_email": "โปรดป้อนที่อยู่อีเมลของผู้ใช้",
  "bw_RTparam_name_BatteryMode": "โหมดแบตเตอรี่",
  "device.parameterControl": "การควบคุมพารามิเตอร์",
  "product.firmwareSpecification": "คำอธิบายเฟิร์มแวร์",
  "tip.configurationState.addDeviceSuccess": "เพิ่มอุปกรณ์สำเร็จ",
  "plant.no": "ไม่",
  "ywt.65323.negativeElectrodeInsulationImpedance": "อิมพีแดนซ์ฉนวนเชิงลบ",
  "login.system": "ระบบจัดการพลังงานอัจฉริยะ Haier",
  "product.newProduct": "ผลิตภัณฑ์ใหม่",
  "tip.log.getWiFiList": "กำลังค้นหารายการ WiFi",
  "bw_RTparam_name_GridLoadPower": "กำลังงานโหลดกริด",
  "subtitle.InputVoltage": "แรงดันอินพุต",
  "setting.type11.chargeLongTime3": "ระยะเวลาการชาร์จ 3",
  "setting.type11.chargeLongTime4": "ระยะเวลาการชาร์จ 4",
  "socket.span": "มีการตั้งค่าที่อยู่รีจิสเตอร์หลายที่ และต้องตั้งค่าหลายค่า ค่าที่ตั้งค่าต้องคั่นด้วย เช่น (1, 2, 3)",
  "setting.type11.chargeLongTime1": "ระยะเวลาการชาร์จ 1",
  "setting.type11.chargeLongTime2": "ระยะเวลาการชาร์จ 2",
  "setting.type22.acUnderFrequency2": "ความถี่ต่ำ AC ลำดับที่สอง (Hz)",
  "jl_param_ctrl_name_BatteryCapacity": "ความจุแบตเตอรี่",
  "jl_param_ctrl_name_FactoryReset": "รีเซ็ตโรงงาน",
  "setting.type22.SNset": "การตั้งค่าหมายเลขซีเรียล",
  "plant.country": "ประเทศ/ภูมิภาค",
  "solis.10001.iPv8": "กระแส PV-8",
  "solis.10001.iPv7": "กระแส PV-7",
  "solis.10001.iPv6": "กระแส PV-6",
  "btn.search": "ค้นหา",
  "jl_param_ctrl_option_UZ_ENERGY": "UZ ENERGY",
  "solis.10001.iPv5": "กระแส PV-5",
  "solis.10001.iPv9": "กระแส PV-9",
  "setting.type22.acOverVolTime1": "เวลาความถี่สูง AC ลำดับที่หนึ่ง (s)",
  "setting.type22.acOverVolTime2": "เวลาความถี่สูง AC ลำดับที่สอง (s)",
  "device.input_ent_address": "ที่อยู่รีจิสเตอร์สิ้นสุด",
  "setting.type12.backLightOn": "LCD ไม่มีการทำงานแบ็คไลท์",
  "solis.10001.apparentPower": "กำลังงานปรากฏของอินเวอร์เตอร์",
  "MEX-CFE": "Aruba,El Salvador,Nicaragua,Honduras,Guatemala,Panama,Dominica,Mexico_MEX-CFE",
  "VDE4105": "Germany_VDE4105",
  "Logs.endtime": "เวลาสิ้นสุด",
  "jl_param_ctrl_option_Tower_US": "Tower US",
  "setting.type22.acUnderFrequency1": "ความถี่ต่ำ AC ลำดับที่หนึ่ง (Hz)",
  "Reset_the_grid_code_related_working_mod": "รีเซ็ตโหมดการทำงานที่เกี่ยวข้องกับรหัสกริด",
  "title.accountInfo": "ข้อมูลบัญชี",
  "subtitle.DSPSoftwareVersion": "เวอร์ชันซอฟต์แวร์ DSP",
  "VDE4110": "Germany_VDE4110",
  "storage.s3.65292.softWareVersion1": "เวอร์ชัน DSP",
  "storage.s3.65292.softWareVersion4": "เวอร์ชัน ARM",
  "storage.s3.65292.softWareVersion2": "เวอร์ชัน BMS",
  "storage.s3.65292.softWareVersion3": "เวอร์ชันซอฟต์แวร์ 3",
  "storage.s3.65292.bPhaseActivePower": "กำลังงานจริงเอาต์พุตเฟส B",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingSlope(Fdroop)": "03&11H&12H-Frequency Derating Slope(Fdroop)",
  "unc.65323.loadFrequency": "ความถี่โหลด",
  "jl_param_ctrl_note_Position": "เพื่อตั้งค่าตำแหน่งที่เชื่อมต่ออินเวอร์เตอร์ PV",
  "bw_RTparam_name_CurrentOfBPhase_PV": "แรงดันของเฟส C (PV)",
  "agent.close": "ยกเลิก",
  "tip.energy.choiceDate": "ข้อมูลปัจจุบันมีให้ใช้งานเท่านั้น",
  "subtitle.InputCurrent": "กระแสอินพุต",
  "product.PleaseEnterTheParameterCode": "โปรดป้อนรหัสพารามิเตอร์",
  "bw_RTparam_name_vatBmsVersion": "เวอร์ชัน BMS",
  "jl_param_ctrl_note_BaselineSOC": "เพื่อตั้งค่าระดับ SOC ของแบตเตอรี่ที่ต้องรักษาเมื่อไม่ถึงขีดจำกัดกำลังงานกริดสูงสุดที่ใช้งานได้",
  "tip.log.wifiFail": "โปรดตรวจสอบบัญชีและรหัสผ่านเราเตอร์แล้วลองเชื่อมต่ออีกครั้ง",
  "device.runningStatus": "สถานะการทำงาน",
  "setting.type12.val.green": "สีเขียว",
  "common.cancel": "ยกเลิก",
  "ywt.65323.loadVoltageC": "แรงดันโหลด C",
  "ywt.65323.loadVoltageA": "แรงดันโหลด A",
  "ywt.65323.loadVoltageB": "แรงดันโหลด B",
  "device.deviceSnisExist": "โปรดยืนยันว่าหมายเลขซีเรียลอุปกรณ์มีอยู่หรือไม่",
  "tip.messageInfo.storage": "แบตเตอรี่",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "SOC ต่ำสุดสำหรับการปล่อยพลังงานแบบออฟกริด 2 (%)",
  "mini.65290.Irmsmax": "กระแส RMS สูงสุดที่เชื่อมต่อกริด",
  "setting.type12.val.parallelMode1": "ไม่มีเครื่องขนาน",
  "title.changePassword": "เปลี่ยนรหัสผ่าน",
  "ywt.65323.dcTemperature": "อุณหภูมิ DC (℃)",
  "setting.type12.val.parallelMode2": "การทำงานขนานเฟสเดียว",
  "Iran": "Iran_Iran",
  "solis.10001.batteryTotalDischargeEnergy": "พลังงานที่ปล่อยออกมาทั้งหมด",
  "storage.s3.65292.bPhaseVoltage": "แรงดันเอาต์พุตเฟส B",
  "role.webPermissions": "สิทธิ์เว็บไซต์",
  "storage.s3.65292.batChargeCur": "กระแสขอชาร์จแบตเตอรี่",
  "unc.65323.loadAPhaseActivePower": "กำลังงานจริงเฟส A ของโหลด",
  "tip.log.bluetoothCommunication": "การสื่อสาร Bluetooth ได้ถูกสร้างขึ้น",
  "role.permissions": "สิทธิ์บทบาท",
  "bw_param_ctrl_name_GridBreake": "ขีดจำกัดกระแสกริด",
  "product.operation": "การดำเนินการ",
  "device.todayChargingCapacity": "พลังงานที่ชาร์จได้ประจำวัน",
  "storage.s3.65292.batChargeTimerSet": "เปิดใช้งานแบตเตอรี่ตามเวลา",
  "subtitle.wifiSignal": "สัญญาณ WiFi",
  "product.ReturnToSuperior": "กลับสู่ระดับสูงกว่า",
  "product.PleaseEnter": "โปรดป้อนชื่อผลิตภัณฑ์",
  "solis.10001.batteryPowerPec": "เปอร์เซ็นต์กำลังงานแบตเตอรี่",
  "button.selectAll": "เลือกทั้งหมด",
  "setting.type10.PureOffGrid": "โหมดเริ่มต้นออฟกริดบริสุทธิ์",
  "common.50402.PV2_V": "แรงดัน PV2",
  "role.type": "ประเภทบทบาท",
  "common.50402.PV2_I": "กระแส PV2",
  "tip.plant.realTimePower": "กำลังงานแบบเรียลไทม์",
  "plant.spontaneousSelfUsePower": "กำลังงานการบริโภคเอง",
  "setting.type11.onGridMaxDischargeCur": "กระแสปล่อยสูงสุดสำหรับการเชื่อมต่อกริด (A)",
  "form.classify": "การจำแนก",
  "bw_RTparam_name_UPSReserveSoc": "SOC สำรอง EPS",
  "setting.type7.recordFaultCodes": "บันทึกรหัสข้อผิดพลาด",
  "End_user.max_5": "จำนวนอักขระสูงสุดไม่เกิน 5",
  "device.input_start_address": "ที่อยู่รีจิสเตอร์เริ่มต้น",
  "End_user.max_8": "จำนวนอักขระสูงสุดไม่เกิน 8",
  "unc.65323.load2GeneratorCPhaseActivePower": "กำลังงานจริงเฟส C ของเครื่องกำเนิดไฟฟ้า Load2",
  "device.input_start_read": "ที่อยู่รีจิสเตอร์เริ่มต้น",
  "placeholder.input": "โปรดป้อน",
  "jl_param_ctrl_option_FOX": "FOX",
  "plant.electricEnergy": "ผลผลิต",
  "setting.type22.acUnderVol1": "แรงดันต่ำ AC ลำดับที่หนึ่ง (V)",
  "setting.type22.acUnderVol2": "แรงดันต่ำ AC ลำดับที่สอง (V)",
  "common.add": "เพิ่มใหม่",
  "common.50300.etotal": "ผลผลิตสะสม (kWh)",
  "tip.log.closeSuccess": "การเชื่อมต่อ Bluetooth ถูกตัดการเชื่อมต่อ",
  "home.echarts2.title": "ผู้ใช้ที่ล็อกอิน",
  "jl_param_ctrl_option_BackupPort": "พอร์ตแบ็กอัพ",
  "G99-NI": "UK_G99-NI",
  "product.PleaseSelectTheDeviceType": "โปรด",
  "storage.s3.65292.bat7CellVol": "แรงดันเซลล์ 7",
  "common.50402.ID": "รหัสอินเวอร์เตอร์",
  "setting.type3.chargeTransferDischarge": "ค่าตั้ง SOC จากประจุเต็มถึงการคายประจุ",
  "storage.s3.65292.mainsCpCurrent": "กระแสเฟส C ของยูทิลิตี้",
  "device.installPerson": "ผู้ติดตั้ง",
  "bw_RTparam_name_Maximumcellvoltage": "แรงดันเซลล์สูงสุด",
  "common.50402.PV30_I": "กระแส PV30",
  "form.edit_plant_plant": "แก้ไขโรงงาน",
  "dept.edit.exist": "ไม่สามารถแก้ไขแผนก '% s' ได้, ชื่อแผนกมีอยู่แล้ว",
  "solis.10001.iPv4": "กระแส PV-4",
  "product.deviceSubclass": "คล้ายอุปกรณ์",
  "solis.10001.iPv3": "กระแส PV-3",
  "solis.10001.iPv2": "กระแส PV-2",
  "solis.10001.iPv1": "กระแส PV-1",
  "EN50549": "อื่นๆ_EN50549",
  "tip.log.searchSurroundingDevicesPermission": "การค้นหาอุปกรณ์ใกล้เคียงโดยไม่ได้รับอนุญาต",
  "storage.s3.65292.bPhaseOnGridCurrent": "กระแสด้านกริดเฟส B",
  "jl_param_ctrl_name_27.S1": "27.S1",
  "jl_param_ctrl_name_27.S2": "27.S2",
  "jl_param_ctrl_name_PowerFactorSettingValue": "ค่าตั้งตัวประกอบกำลัง",
  "storage.s3.65292.mainsBpVoltage": "แรงดันเฟส B ของยูทิลิตี้",
  "tip.log.locationNotPermission": "การกำหนดตำแหน่งไม่ได้เปิดใช้งาน",
  "jl_param_ctrl_note_PowerFactorSettingValue": "เพื่อตั้งค่าตัวประกอบกำลังของอินเวอร์เตอร์",
  "device.power": "กำลัง",
  "tip.validate.choiceCountry": "กรุณาเลือกประเทศก่อน",
  "jl_param_ctrl_name_ACCouplingSwitch": "สวิตช์เชื่อมต่อ AC",
  "jl_param_ctrl_name_MaxDischargingCurrent": "กระแสคายประจุสูงสุด",
  "setting.type12.val.countryRegulations3": "อเมริกาใต้",
  "storage.v2.65284.pvGenerartion": "ความสามารถในการผลิตกระแส PV",
  "JAM-230": "จาเมกา_JAM-230",
  "setting.type12.val.countryRegulations1": "อินเดีย",
  "setting.type12.val.countryRegulations2": "เยอรมนี",
  "jl_param_ctrl_name_BatteryHealingSOC": "SOC การรักษาแบตเตอรี่",
  "unc.65323.returnFlowPortTotalActivePower": "กำลังงานทั้งหมดของพอร์ตการไหลกลับ",
  "form.lable_StationType_plant": "ประเภทของโรงงาน",
  "jl_param_ctrl_option_UserDefine": "ผู้ใช้กำหนด",
  "Dubai-B": "ดูไบ_Dubai-B",
  "common.50402.PV30_V": "แรงดัน PV30",
  "Dubai-A": "ดูไบ_Dubai-A",
  "setting.type12.val.yellow": "สีเหลือง",
  "jl_param_ctrl_name_ChargeCurrent5": "กระแสประจุ 5",
  "jl_param_ctrl_name_ChargeCurrent4": "กระแสประจุ 4",
  "jl_param_ctrl_name_ChargeCurrent6": "กระแสประจุ 6",
  "jl_param_ctrl_name_ChargeCurrent1": "กระแสประจุ 1",
  "EN50549-2": "อื่นๆ_EN50549-2",
  "jl_param_ctrl_name_ChargeCurrent3": "กระแสประจุ 3",
  "tip.log.stopSearchFail": "หยุดการค้นหา Bluetooth รอบข้างล้มเหลว",
  "jl_param_ctrl_name_ChargeCurrent2": "กระแสประจุ 2",
  "setting.type11.minSocDischarge": "SOC ขั้นต่ำ (%) สำหรับการคายประจุอัจฉริยะ",
  "sidebar.socket": "รายการซ็อกเก็ต",
  "solis.10001.socDischargeSet": "SOC ถูกคายประจุเกิน",
  "menu.edit.exist": "ไม่สามารถแก้ไขเมนู '% s' ได้, ชื่อเมนูมีอยู่แล้ว",
  "ywt.65323.bmsBatteryVoltage": "แรงดันแบตเตอรี่ BMS",
  "form.edit_plant": "แก้ไขฉาก",
  "jl_param_ctrl_option_Soluna": "Soluna",
  "ywt.65323.batteryStatus": "สถานะแบตเตอรี่",
  "plant.already.deliver": "โรงงานส่งมอบแล้ว",
  "mini.65290.Vmpptmax": "แรงดัน mppt สูงสุด",
  "tip.home.backEndLoad": "โหลดออฟกริด",
  "subtitle.installationDate": "วันที่ติดตั้ง",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFD_Droop": "13H-Underfrequency Ramping FD_Droop",
  "setting.type12.val.inputOvlRange1": "โหมด APL (90-280V)",
  "bw_RTparam_group_Dongle": "ดองเกิล",
  "jl_param_ctrl_option_OFF": "ปิด",
  "setting.type19.offGridControlMode": "ควบคุมออฟกริด",
  "End_user.format": "กรุณาใส่รูปแบบที่ถูกต้อง",
  "jl_param_ctrl_note_Peak-shavingSwitch": "สวิตช์นี้ใช้เพื่อเปิด/ปิดโหมด Peakshaving\nโหมดนี้รองรับการใช้กับแบตเตอรี่ลิเธียมที่มีการสื่อสารเท่านั้น",
  "setting.type12.val.inputOvlRange2": "โหมด UPS (170-280V)",
  "bw_RTparam_name_TotalPower": "กำลังงานทั้งหมด",
  "tip.validate.firstChoicePlant": "กรุณาเลือกโรงงานก่อน",
  "Barbados": "บาร์เบโดส_Barbados",
  "placeholder.country": "ประเทศ",
  "bw_RTparam_name_Systemmaximumtemperaturecellserialnumber": "หมายเลขซีเรียลเซลล์อุณหภูมิสูงสุดของระบบ",
  "setting.type22.inputModeSet": "โหมดอินพุต",
  "setting.type12.val.energySource": "แหล่งพลังงาน",
  "common.50402.generation": "การผลิตไฟฟ้าเชื่อมต่อกริด",
  "product.leastValue": "ค่าต่ำสุด",
  "login.retrievePassword": "ดึงรหัสผ่าน",
  "common.50402.PV25_V": "แรงดัน PV25",
  "solis.10001.gridSellTotalEnergy": "ส่งออกทั้งหมด",
  "jl_param_ctrl_option_Slave": "สเลฟ",
  "ywt.65323.todayConsumeEnergy": "การบริโภควันนี้",
  "sidebar.system_tongxun": "บันทึกการสื่อสาร",
  "global.socket": "การตั้งค่าโซเก็ต",
  "plant.lable_InstalltionDate": "วันที่ติดตั้ง",
  "unc.65323.pvMonthlyEnergy": "ผลผลิตรายเดือน",
  "product.fileName": "ชื่อไฟล์",
  "bw_RTparam_name_PackIDofMaxCellVoltage": "หมายเลขแพ็คของเซลล์แบตเตอรี่ที่มีแรงดันไฟฟ้าสูงสุด",
  "tip.log.heartbeat": "การโต้ตอบของข้อมูลเตือนหัวใจ",
  "org.pleaseChooseOrg": "กรุณาเลือกองค์กรก่อน",
  "jl_param_ctrl_option_EXIDE": "EXIDE",
  "bw_RTparam_name_BatteryVersion": "เวอร์ชันแบตเตอรี่",
  "jl_param_ctrl_option_Enable": "เปิดใช้งาน",
  "bw_RTparam_group_Grid": "เครือข่ายไฟฟ้า",
  "jl_param_ctrl_name_0E-FrequencyDeratingFstop": "0E-ลดความถี่ Fstop",
  "menu.child.exist": "มีเมนูย่อยที่ไม่สามารถลบได้",
  "setting.type10.batteryLowAlarm": "จุดเตือนแบตเตอรี่ต่ำ",
  "storage.v2.65284.heatsinkTemp": "อุณหภูมิเครื่องระบายความร้อน (°C)",
  "ywt.65323.bmsDischargeCurrentLimit": "การ จำกัด กระแสการระบายของ BMS",
  "unc.65323.loadTotalConsumeEnergy": "พลังงานสุทธิที่ใช้ไปของโหลด",
  "bw_RTparam_name_BatterySN": "หมายเลขซีเรียลของแบตเตอรี่",
  "setting.type10.batteryLowShutdown": "จุดปิดระบบจากแบตเตอรี่ต่ำ",
  "common.50402.PV12_I": "กระแส PV12",
  "org.leader": "ผู้รับผิดชอบ",
  "ywt.65323.pv2Voltage": "แรงดันไฟฟ้า PV 2",
  "storage.s3.65292.batSoh": "SOH",
  "validator.max": "อนุญาตให้ใช้สูงสุด {num} อักขระ",
  "jl_param_ctrl_option_Unlock": "ปลดล็อค",
  "jl_param_ctrl_note_EN50549GradientLimitforPower-onChange": "การ จำกัด ความชันพลังงานเริ่มต้นสำหรับรหัสเครือข่าย EN50549",
  "validate.tips.PleaseEnterPassword": "กรุณาใส่รหัสผ่าน",
  "ywt.65323.loadActivePower": "พลังงานไฟฟ้าประกอบของโหลด",
  "menu.show.status": "แสดงผล",
  "role.no": "หมายเลขบทบาท",
  "home.echarts4.title_plant": "เพิ่มโรงงาน",
  "common.50402.PV12_V": "แรงดันไฟฟ้า PV12",
  "de-DE": "ภาษาเยอรมัน",
  "storage.s3.65292.batTotalChargeEnergy": "พลังงานการชาร์จทั้งหมดของแบตเตอรี่",
  "plant.powerAnalysis": "การวิเคราะห์พลังงาน",
  "setting.type12.resetPvStorage": "รีเซ็ตข้อมูลสถิติ PV",
  "ywt.65323.gridAPhaseActivePower": "พลังงานไฟฟ้าประกอบของเฟส A ในเครือข่ายไฟฟ้า",
  "battery.datalogSn": "กรุณาป้อนหมายเลขซีเรียลของเครื่องเก็บข้อมูล",
  "unc.65323.spiAutoTestTimeCPhaseU1": "เวลาการทดสอบอัตโนมัติของ SPI - Pha C U >>",
  "unc.65323.spiAutoTestTimeCPhaseU3": "เวลาการทดสอบอัตโนมัติของ SPI - Pha C U <",
  "unc.65323.spiAutoTestTimeCPhaseU2": "เวลาการทดสอบอัตโนมัติของ SPI - Pha C U > 10 นาที",
  "product.ParameterClass": "ประเภทพารามิเตอร์",
  "bw_param_ctrl_option_Disable": "ปิดใช้งาน",
  "unc.65323.spiAutoTestTimeCPhaseU4": "เวลาการทดสอบอัตโนมัติของ SPI - Pha C U <<",
  "solis.10001.batteryTodayDischargeEnergy": "ปริมาณการระบายไฟฟ้าของแบตเตอรี่ในแต่ละวัน",
  "setting.type12.overloadReset": "รีบูตเมื่อเกิดโอเวอร์โหลด",
  "subtitle.selectPlantType": "เลือกประเภทสถานีพลังงาน",
  "bw_RTparam_name_Positionofthelowestvoltagebatterycellinthesystem": "ตำแหน่งเซลล์แบตเตอรี่ที่มีแรงดันต่ำสุดในระบบ",
  "product.PleaseSelectDevelopmentType": "กรุณาเลือกประเภทการวิจัยและพัฒนา",
  "mini.65290.Ipv6": "กระแสป้อนของ PV6",
  "tip.opsLog.bindSuccess": "การเชื่อมโยงสำเร็จ",
  "jl_param_ctrl_group_GridCodeSetting-FrequencyDeratingSetting": "การตั้งค่ามาตรฐานสายไฟฟ้า - การตั้งค่าการลดโหลดความถี่",
  "mini.65290.Ipv1": "กระแสป้อนของ PV1",
  "setting.type11.timeStr": "เวลาของอุปกรณ์",
  "mini.65290.Ipv2": "กระแสป้อนของ PV2",
  "mini.65290.Ipv3": "กระแสป้อนของ PV3",
  "title.privacyPolicy": "ข้อตกลงความเป็นส่วนตัว",
  "btn.setting_address": "การตั้งค่าที่อยู่",
  "mini.65290.Ipv4": "กระแสป้อนของ PV4",
  "mini.65290.Ipv5": "กระแสป้อนของ PV5",
  "setting.type22.reactivePercentage": "เปอร์เซ็นต์ของกำลังไร้จ่าย",
  "tip.opsLog.deleteDeviceSN": "คุณแน่ใจหรือไม่ว่าต้องการลบ?",
  "btn.close": "กลับ",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "สวิตช์ช่วงเวลาซื้อไฟฟ้า 4",
  "setting.type22.parameterScope": "ช่วงของพารามิเตอร์",
  "storage.s3.65292.batVoltage": "แรงดันของแบตเตอรี่",
  "ywt.65323.ctFrequency": "ความถี่ของมิเตอร์ไฟฟ้า",
  "jl_param_ctrl_option_12H-Austria": "12H - ออสเตรีย",
  "jl_param_ctrl_option_0F-CEI_0-21": "0F - CEI 0 - 21",
  "Meter_in_Grid_Eastron_Standard_1P_Meter": "มาตรฐานสายไฟฟ้าแบบเฟสเดียวของ Eastron จากด้านสายไฟฟ้า",
  "mini.65290.Temperature": "อุณหภูมิการทำงานของอินเวอร์เตอร์ (°C)",
  "End_user.input_City": "กรุณาเลือกเมือง",
  "solis.10001.bLookedPower": "กำลังจินตภาพของมิเตอร์ไฟฟ้า B",
  "datalog.btn_reset": "รีบูต",
  "subtitle.selectDeviceType": "เลือกประเภทอุปกรณ์",
  "jl_param_ctrl_group_AdvancedSetting-DailyPV-ISODetection": "การตั้งค่าขั้นสูง - การตรวจสอบความฉนวนของ PV ในแต่ละวัน",
  "jl_param_ctrl_option_DuraHV": "DuraHV",
  "setting.type7.overDischargeVoltage": "แรงดันการระบายไฟฟ้าเกิน",
  "jl_param_ctrl_name_BackupPortReferenceVoltageSetting": "แรงดันการจ่ายไฟของโหลด Backup",
  "setting.socket.enableOrNot": "เปิดใช้งานหรือไม่",
  "device.todayDischargingCapacity": "ปริมาณการระบายไฟฟ้าของแบตเตอรี่ในวันนี้",
  "common.50100.pv3Power": "กำลังจริงของ PV3",
  "mini.65290.Vmpptmin": "แรงดัน mppt น้อยที่สุด",
  "common.50402.iac2": "กระแสสลับ 2",
  "common.50402.iac1": "กระแสสลับ 1",
  "title.retrievePassword": "กู้รหัสผ่าน",
  "common.50402.iac3": "กระแสสลับ 3",
  "jl_param_ctrl_note_MaxDischargingCurrent": "การตั้งค่ากระแสระบายไฟฟ้าที่อนุญาตสูงสุด",
  "subtitle.Off-gridMode": "โหมดการทำงานแบบไม่เชื่อมต่อกับสายไฟฟ้า",
  "plant.purchaseElectricity": "ปริมาณการซื้อไฟฟ้า",
  "org.area": "ประเทศ/ภูมิภาค",
  "storage.s3.65292.onGridActivePower": "กำลังไฟฟ้าเชิงบวกในการเชื่อมต่อกับสายไฟฟ้า",
  "tip.opsLog.content": "เนื้อหา",
  "jl_param_ctrl_option_GS-HV": "GS - HV",
  "device.productName": "ชื่อผลิตภัณฑ์",
  "End_user.lable_IncomeUnit": "หน่วยรายได้",
  "unc.65323.loadVoltageA": "แรงดันโหลด A",
  "unc.65323.loadVoltageB": "แรงดันโหลด B",
  "unc.65323.loadVoltageC": "แรงดันโหลด C",
  "subtitle.switch": "สวิตช์",
  "placeholder.enterPhone": "กรุณาป้อนหมายเลขโทรศัพท์",
  "G83/1-A": "UK_G83/1 - A",
  "battery.search": "ค้นหา",
  "storage.s3.65292.bat1CellVol": "แรงดันของเซลล์แบตเตอรี่ 1",
  "common.confirm": "ยืนยัน",
  "zh-CN": "ภาษาจีน",
  "setting.type12.val.powerUnchanged": "พลังงานกลไม่เปลี่ยนแปลง",
  "device.buyPowers": "ซื้อไฟฟ้า",
  "subtitle.off": "ปิด",
  "unc.65323.pv3Voltage": "แรงดันของ PV3",
  "form.shipSN": "หมายเลขซีเรียลการส่งออก",
  "bw_RTparam_name_batDcdcVersion": "หมายเลขเวอร์ชันของ DCDC ของแบตเตอรี่",
  "sidebar.battery": "รายการแบตเตอรี่",
  "bw_param_ctrl_name_DispatchReactivepower": "กำลังไร้จ่ายในการจัดการ",
  "product.networkingMode": "วิธีการเชื่อมต่ออินเทอร์เน็ต",
  "CQC-DZ": "CQC - DZ",
  "setting.type22.shutdown": "สวิตช์ระยะไกล",
  "setting.type11.maxChargeVol": "แรงดันการชาร์จสูงสุด (V)",
  "jl_param_ctrl_name_ReservedSOC": "SOC ที่เก็บไว้",
  "solis.10001.eTotal": "ปริมาณการผลิตไฟฟ้าทั้งหมด",
  "home.echarts6.subhead": "อุปกรณ์ใหม่/จำนวนอุปกรณ์ทั้งหมด",
  "jl_param_ctrl_option_SinglePhase": "เฟสเดียว",
  "global.device_data": "การตั้งค่าพารามิเตอร์ของอินเวอร์เตอร์:",
  "subtitle.BatteryUndervoltageThreshold(A)": "ค่าขั้นต่ำของแรงดันต่ำเกินไปของแบตเตอรี่ (A)",
  "jl_param_ctrl_name_04-FrequencyDeratingFstop": "04 - ความถี่จุดสิ้นสุดการลดโหลด",
  "product.QueryResultList": "รายการผลการค้นหา",
  "solis.10001.batteryChargingCurrent": "การจำกัดกระแสชาร์จของแบตเตอรี่",
  "ywt.65323.ctPowerFactor": "ปัจจัยกำลังของมิเตอร์ไฟฟ้า",
  "subtitle.value": "ค่า",
  "jl_param_ctrl_option_Duracell": "Duracell",
  "validate.email.reacquireCode": "รับใหม่",
  "jl_param_ctrl_name_UnblanceOutput": "การส่งออกไม่สมดุล",
  "solis.10001.batteryYearDischargeEnergy": "ปริมาณการระบายไฟฟ้าของแบตเตอรี่ในแต่ละปี",
  "plant.equivalentTreePlanting": "ปริมาณต้นไม้ที่เทียบเท่า",
  "tip.log.wifiName": "ชื่อ WiFi ไม่ควรถูกปล่อยว่างกรุณาเลือกหรือป้อน WiFi 2.4",
  "placeholder.currentNoPlant": "ปัจจุบันไม่มีสถานีพลังงานกรุณาคลิกที่ปุ่มเพิ่ม!",
  "jl_param_ctrl_name_ManualSetMaster.Slave": "การตั้งค่าหลัก/รองแบบตัวเอง",
  "ywt.65323.loadAPhaseActivePower": "กำลังไฟฟ้าเชิงบวกของโหลด Pha A",
  "plant.sellPowers": "กำลังไฟฟ้าที่ขาย",
  "plant.buildState": "สถานะการก่อสร้าง",
  "jl_param_ctrl_option_3": "3",
  "jl_param_ctrl_option_4": "4",
  "jl_param_ctrl_option_5": "5",
  "jl_param_ctrl_option_6": "6",
  "tip.log.openIosBtSystem": "กรุณารีบูตสวิตช์ Bluetooth",
  "jl_param_ctrl_option_7": "7",
  "unc.65323.spiAutoTestThresholdCPhaseU4": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha C U <<",
  "unc.65323.spiAutoTestThresholdCPhaseU2": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha C U > 10 นาที",
  "jl_param_ctrl_option_0": "0",
  "unc.65323.spiAutoTestThresholdCPhaseU3": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha C U <",
  "jl_param_ctrl_option_1": "1",
  "jl_param_ctrl_option_2": "2",
  "unc.65323.spiAutoTestThresholdCPhaseU1": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha C U >>",
  "subtitle.findEmail": "กู้รหัสผ่านผ่านทางอีเมล",
  "setting.type10.productModelNumber": "รุ่นผลิตภัณฑ์",
  "product.PleaseEnterTheVersionNumber": "กรุณาป้อนหมายเลขเวอร์ชัน",
  "bw_param_ctrl_group_BatterySettings": "การตั้งค่าของแบตเตอรี่",
  "setting.general.needSmall": "ต้องน้อยกว่า",
  "unc.65323.bmsChargeCurrentLimit": "การจำกัดกระแสชาร์จของ BMS",
  "SG": "Singapore_SG",
  "unc.65323.batFaultFlag": "เครื่องหมายความผิดพลาดของแบตเตอรี่",
  "setting.type3.systemWorkMode": "โหมดการทำงานของระบบ",
  "jl_param_ctrl_group_AdvancedSetting-PowerFactorSetting": "การตั้งค่าขั้นสูง - การตั้งค่าปัจจัยกำลัง",
  "setting.type7.setVal.toggle": "สลับ",
  "bw_RTparam_name_PV3Power": "กำลังจริงของ PV3",
  "jl_param_ctrl_group_WorkMode-Self-UseMode": "โหมดการทำงาน - ใช้ไฟฟ้าที่ผลิตเอง",
  "sidebar.home": "ภาพรวมข้อมูล",
  "placeholder.enterDeviceSN": "กรุณาป้อนหมายเลขซีเรียลของอุปกรณ์",
  "tip.plant.pvcapacityMax": "ความจุ PV สูงสุด",
  "jl_param_ctrl_group_GridCodeSetting-CERTModeSetting": "การตั้งค่ามาตรฐานสายไฟฟ้า - การเลือกการรับรอง",
  "jl_param_ctrl_option_Lithium_battery": "แบตเตอรี่ลิเธียม",
  "jl_param_ctrl_note_BatteryModel": "การตั้งค่าหมายเลขรุ่นของแบตเตอรี่ที่เชื่อมต่อกับอินเวอร์เตอร์ในปัจจุบัน",
  "common.edit": "แก้ไข",
  "sidebar.system_datalog_log": "บันทึกของเครื่องเก็บข้อมูล",
  "setting.general.gapScope": "ช่วงเวลาของการป้อนพารามิเตอร์คือ",
  "datalog.btn_setting": "การตั้งค่า",
  "R14-240A": "USA_R14 - 240A",
  "plant.installPerson": "ช่างติดตั้ง",
  "tip.log.permissionOpen": "ตรวจสอบให้แน่ใจว่าการอนุญาตการระบุตำแหน่งและ Bluetooth ถูกเปิดใช้งานแล้ว",
  "End_user.lable_InstalltionDate": "วันที่ติดตั้ง",
  "datalog.btn_settingdns": "การตั้งค่าชื่อโดเมน",
  "common.50402.INV_U_AC": "แรงดันของอินเวอร์เตอร์",
  "bw_RTparam_name_TotalConsumption": "ปริมาณการชาร์จสะสม",
  "setting.type12.dataColor": "สีของข้อมูลแสดง",
  "setting.ops15.offGirdSoc": "SOC ระบายไฟฟ้าเกิน (%)",
  "Firmware.search": "ค้นหา",
  "setting.type12.batFloatVol": "แรงดันการชาร์จนิ่งของแบตเตอรี่",
  "storage.s3.65292.batMaxPressure": "ความแตกต่างของแรงดันสูงสุดของเซลล์แบตเตอรี่เดี่ยว",
  "jl_param_ctrl_name_UN-G-V02": "UN - G - V 02",
  "jl_param_ctrl_name_UN-G-V01": "UN - G - V 01",
  "TW": "China_TW",
  "datalog.btn_setup": "การตั้งค่าขั้นสูง",
  "plant.plantPowerGeneration": "การผลิตไฟฟ้าสะสมของโรงไฟฟ้า",
  "tip.opsLog.selectDate": "เลือกวันที่",
  "bw_param_ctrl_name_BatteryReady": "บิตเปิดใช้งานของแบตเตอรี่",
  "common.50402.PV25_I": "กระแสของ PV25",
  "agent.password": "รหัสผ่าน",
  "jl_param_ctrl_name_3Tau(P)Setting": "การตั้งค่า 3Tau(P)",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "ใช้มิเตอร์ไฟฟ้าในสายไฟฟ้าใช้ CT ในสาย PV",
  "plant.photovoltaicCapacity": "ความจุของพลังงานแสงอาทิตย์ (kWh)",
  "tip.opsLog.operation": "การดำเนินการ",
  "unc.65323.batteryVoltage": "แรงดันของแบตเตอรี่",
  "jl_param_ctrl_note_MaxChargingCurrent": "การตั้งค่ากระแสชาร์จที่อนุญาตสูงสุด",
  "setting.type7.nowTimeStr": "เวลาปัจจุบัน",
  "tip.log.getIPFail": "การรับ IP ของรูเตอร์ล้มเหลว",
  "role.edit": "แก้ไข",
  "password.reset.success": "การรีเซ็ตรหัสผ่านสำเร็จ",
  "common.50402.fault": "ความผิดพลาด",
  "jl_param_ctrl_name_BatteryWakeupTimeSetting": "เวลาการปลุกแบตเตอรี่แบบตัวเอง",
  "plant.storageChargingPower": "กำลังชาร์จของระบบสะสมพลังงาน",
  "form.import": "นำเข้าข้อมูลอุปกรณ์",
  "setting.type11.switchPCS": "การควบคุมการเปิดและปิดเครื่อง",
  "jl_param_ctrl_name_SOC4": "SOC4",
  "jl_param_ctrl_name_SOC5": "SOC5",
  "jl_param_ctrl_name_SOC2": "SOC2",
  "jl_param_ctrl_name_SOC3": "SOC3",
  "deviceType.empty": "ประเภทอุปกรณ์ไม่รองรับ",
  "jl_param_ctrl_name_SOC6": "SOC6",
  "ywt.65323.ctCurrentB": "กระแสของมิเตอร์ไฟฟ้า B",
  "ywt.65323.ctCurrentA": "กระแสของมิเตอร์ไฟฟ้า A",
  "setting.type7.PVChargingCurrent": "กระแสชาร์จของพลังงานแสงอาทิตย์",
  "ywt.65323.ctCurrentC": "กระแสของมิเตอร์ไฟฟ้า C",
  "jl_param_ctrl_option_CNTE_HV": "CNTE_HV",
  "jl_param_ctrl_option_KODAK": "KODAK",
  "setting.ops15.invTime": "เวลาของอินเวอร์เตอร์",
  "unc.65323.ctAPhaseActivePower": "กำลังไฟฟ้าเชิงบวกของมิเตอร์ไฟฟ้า Pha A",
  "Firmware.select_folder": "เลือกโฟลเดอร์:",
  "setting.type12.val.medium": "ภาษาจีน",
  "subtitle.DeviceInformation": "ข้อมูลอุปกรณ์",
  "jl_param_ctrl_name_SOC1": "SOC1",
  "setting.type10.PVOnly": "ชาร์จด้วยพลังงานแสงอาทิตย์เท่านั้น",
  "mini.65290.stUV_Fgrid": "การป้องกันความถี่ต่ำเกินไปของแรงดันสายไฟฟ้า",
  "storage.s3.65292.pv2Current": "กระแสของแผงโซลาร์ช่องที่ 2",
  "unc.65323.spiAutoTestThresholdF4": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - F <<",
  "unc.65323.spiAutoTestThresholdF3": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - F <",
  "unc.65323.spiAutoTestThresholdF2": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - F >",
  "title.repetitionTime": "เวลาการทำซ้ำ",
  "unc.65323.spiAutoTestThresholdF1": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - F >>",
  "form.networkCall": "ทำการเรียกกลับการจัดการเครือข่ายหรือไม่",
  "jl_param_ctrl_option_Allow": "อนุญาต",
  "ywt.65323.pvTodayEnergy": "ปริมาณการผลิตไฟฟ้าของพลังงานแสงอาทิตย์ในวันนี้",
  "solis.10001.cReactivePower": "กำลังไร้จ่ายของมิเตอร์ไฟฟ้า C",
  "tip.log.searching": "กำลังค้นหา Bluetooth ในบริเวณโดยรอบ",
  "bw_RTparam_name_WiFiType": "ประเภทการเชื่อมต่ออินเทอร์เน็ต",
  "common.50300.istr24": "กระแสของสายรวม 24",
  "common.50300.istr23": "กระแสของสายรวม 23",
  "common.50300.istr22": "กระแสของสายรวม 22",
  "common.50300.istr21": "กระแสของสายรวม 21",
  "jl_param_ctrl_name_ClearOverload(OffGrid)Fault": "การล้างความผิดพลาดของโอเวอร์โหลดในโหมดไม่เชื่อมต่อกับสายไฟฟ้า",
  "setting.type12.LEDEffect": "ผลลัพธ์ของ LED",
  "common.50300.istr20": "กระแสของสายรวม 20",
  "HK": "China_HK",
  "common.success": "สำเร็จ",
  "jl_param_ctrl_name_VoltageDroopSetting": "การลดแรงดันเนื่องจากโอเวอร์โหลดทางทางเลือก",
  "tip.validate.searchingState": "กำลังค้นหา Bluetooth อยู่โปรดอย่าแตะซ้ำ",
  "jl_param_ctrl_note_BatteryWakeupTimeSetting": "การตั้งค่าการปลุกตัวเองแบบเวลา",
  "ywt.65323.spiAutoTestEndFlag": "เครื่องหมายการสิ้นสุดการทดสอบอัตโนมัติของ SPI",
  "role.typeTip": "ผู้ดูแลระบบของผู้ติดตั้ง: เป็นบทบาทที่กำหนดให้กับผู้อำนวยการองค์กรผู้ติดตั้งโดยค่าเริ่มต้นมีเพียงคนเดียวในทั้งแพลตฟอร์ม บทบาทของผู้ติดตั้ง: เป็นบทบาทที่ผู้อำนวยการองค์กรผู้ติดตั้งสามารถกำหนดให้กับพนักงานสามารถมีได้หลายคน บทบาทของแพลตฟอร์ม: เป็นบทบาทที่สามารถใช้งานได้โดยทุกคนยกเว้นผู้ติดตั้ง",
  "product.ParameterSettingType": "ประเภทการตั้งค่าพารามิเตอร์",
  "validate.email.verificationCodeHasBeenSent": "รหัสยืนยันถูกส่งแล้ว",
  "ywt.65323.phaseOrder": "ลำดับเฟส",
  "setting.socket.repetition": "เวลาการทำซ้ำ",
  "ywt.65323.totalConsumeEnergy": "ปริมาณการใช้ไฟฟ้าที่สะสม",
  "subtitle.ChargingCurrentLimit(A)": "การจำกัดกระแสชาร์จ (A)",
  "common.50300.istr19": "กระแสของสายรวม 19",
  "common.50300.istr18": "กระแสของสายรวม 18",
  "setting.type3.confirmClose": "คุณแน่ใจหรือไม่ว่าต้องการปิดเครื่อง?",
  "common.50300.istr17": "กระแสของสายรวม 17",
  "common.50300.istr16": "กระแสของสายรวม 16",
  "common.50300.istr15": "กระแสของสายรวม 15",
  "common.50300.istr14": "กระแสของสายรวม 14",
  "common.50300.istr13": "กระแสของสายรวม 13",
  "common.50300.istr12": "กระแสของสายรวม 12",
  "storage.s3.65292.bat14CellVol": "แรงดันของเซลล์แบตเตอรี่ 14",
  "common.50300.istr11": "กระแสของสายรวม 11",
  "common.50300.istr10": "กระแสของสายรวม 10",
  "jl_param_ctrl_option_P-Factor": "ค่าสัมประสิทธิ์ P",
  "device.saveSuccess": "คำสั่งพารามิเตอร์ถูกส่งแล้ว กรุณารีเฟรชหน้าหรือคลิกปุ่ม [อ่าน] เพื่อยืนยันว่าพารามิเตอร์มีผลหรือไม่",
  "bw_param_ctrl_name_DispatchSOC": "SOC การจัดการ",
  "setting.type22.reactiveControlModeChoice.val2": "การควบคุมเปอร์เซ็นต์ของกำลังไร้จ่าย",
  "unc.65323.loadReactivePower": "กำลังไร้จ่ายของโหลด",
  "setting.type22.reactiveControlModeChoice.val1": "การควบคุมปัจจัยกำลัง",
  "setting.type22.reactiveControlModeChoice.val3": "การควบคุมเส้นโค้ง QV",
  "End_user.add_station": "เพิ่มฉาก",
  "subtitle.DeviceAddress": "ที่อยู่ของอุปกรณ์",
  "Chile": "Chile_Chile",
  "bw_param_ctrl_group_WorkMode": "โหมดการทำงาน",
  "jl_param_ctrl_option_NotAllowed": "ไม่อนุญาต",
  "plant.electricityConsumptionTotal": "ปริมาณการใช้ไฟฟ้าที่สะสม",
  "setting.type6.countryCode": "หมายเลขประเทศ",
  "register.guidance.toLogin": "มีบัญชีอยู่แล้วไปเข้าสู่ระบบ",
  "End_user.lable_PVCapacity": "ความจุของเซลล์แสงอาทิตย์",
  "tip.validate.passwordError2": "กรุณาป้อนรหัสผ่านที่ถูกต้อง (รหัสผ่านไม่ควรมีอักขระพิเศษสัญลักษณ์หรือช่องว่างใดๆ)",
  "jl_param_ctrl_group_OnOff": "สวิตช์ของอินเวอร์เตอร์",
  "jl_param_ctrl_note_VoltageDroopSetting": "ฟังก์ชันการลดแรงดันเมื่อพอร์ต Backup มีโอเวอร์โหลด",
  "Firmware.listed_files": "รายการไฟล์:",
  "ywt.65323.leakageCurrent": "กระแสรั่ว",
  "plant.windDirection": "ทิศทางลม",
  "User-define_60": "User - define 60",
  "tip.plant.tip": "คำเตือน",
  "org.createTime": "เวลาที่สร้าง",
  "sidebar.roleManagement": "การจัดการบทบาท",
  "common.handleFail": "การดำเนินการล้มเหลว",
  "setting.type11.functionSwitchObj.val1": "โหมดอัจฉริยะ",
  "jl_param_ctrl_name_FeedinPriorityModeSwitch": "สวิตช์ความสำคัญของการส่งไฟฟ้าไปยังสายไฟฟ้า",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "พลังงานที่ดึงมาจากแหล่งไฟฟ้า",
  "tip.log.CRC": "การตรวจสอบ CRC ล้มเหลว",
  "plant.spontaneousSelfUse": "ใช้ไฟฟ้าที่ผลิตเอง",
  "tip.plant.totalEnergyMin": "ปริมาณการผลิตไฟฟ้าทั้งหมดต่ำสุด",
  "mini.65290.DeviceID": "หมายเลขซีเรียลของอุปกรณ์",
  "product.PleaseEnterTheUnit": "กรุณาป้อนค่าต่ำสุด",
  "setting.type7.isOpen": "การควบคุมการเปิดและปิดเครื่อง",
  "ywt.65323.returnFlowPortReactivePower": "กำลังไร้จ่ายของพอร์ตการไหลย้อนกลับ",
  "common.50300.turnon_time": "เวลาที่เชื่อมต่อ",
  "form.lable_StationName": "ชื่อฉาก",
  "device.wang": "สายไฟฟ้า: ด้านสายไฟฟ้า",
  "form.lable_StationName_plant": "ชื่อสถานีพลังงาน",
  "product.AddFirmware": "เพิ่มฟอร์มแวร์",
  "ywt.65323.mpptTemperature": "อุณหภูมิของ MPPT (°C)",
  "jl_param_ctrl_name_10minOvervoltageSetting": "การตั้งค่าความถี่ของแรงดันสไลด์",
  "form.input_StationName": "กรุณาป้อนชื่อฉาก",
  "jl_param_ctrl_option_GSL": "GSL",
  "bw_RTparam_name_PV1Voltage": "แรงดันจริงของ PV1",
  "jl_param_ctrl_name_HDB": "พารามิเตอร์ HDB",
  "unc.65323.batTotalChargeEnergy": "ปริมาณการชาร์จที่สะสม",
  "setting.type10.hybridModel": "การชาร์จแบบผสม",
  "bw_param_ctrl_option_Disable TimePeriodControl": "การควบคุมช่วงเวลาที่ปิดใช้งาน",
  "storage.s3.65292.batPower": "กำลังของแบตเตอรี่",
  "storage.s3.65292.pv2Voltage": "แรงดันของแผงโซลาร์ช่องที่ 2",
  "jl_param_ctrl_name_GridChargingPowerLimit": "การจำกัดกำลังชาร์จจากสายไฟฟ้า",
  "subtitle.deviceSN": "หมายเลขซีเรียลของอุปกรณ์",
  "setting.type11.functionSwitchObj.val3": "โหมดการใช้ไฟฟ้าที่ผลิตเอง",
  "setting.type11.functionSwitchObj.val2": "โหมดการตั้งเวลา",
  "ywt.65323.pv2Current": "กระแสของ PV2",
  "setting.type6.recover": "กู้คืน",
  "storage.s3.65292.machineOnStatus": "สถานะการเปิดเครื่อง",
  "common.50402.eday": "ปริมาณการผลิตไฟฟ้าในวันนี้ (หน่วย)",
  "tip.log.setMTUsSuccess": "การตั้งค่า MTU สำเร็จ",
  "storage.v2.65284.cellVoltage9": "แรงดันของเซลล์แบตเตอรี่ 9",
  "storage.v2.65284.cellVoltage8": "แรงดันของเซลล์แบตเตอรี่ 8",
  "plant.powerGeneration": "ปริมาณการผลิตไฟฟ้า",
  "jl_param_ctrl_group_GridCodeSetting-\nInitialSetting": "การตั้งค่ามาตรฐานสายไฟฟ้า - การกู้คืนค่าเริ่มต้น",
  "ywt.65323.returnFlowPortAPhaseActivePower": "กำลังไฟฟ้าเชิงบวกของ Pha A ของพอร์ตการไหลย้อนกลับ",
  "productEquipment.firmwareUpdate": "การอัพเกรดฟอร์มแวร์",
  "storage.v2.65284.cellVoltage3": "แรงดันของเซลล์แบตเตอรี่ 3",
  "storage.v2.65284.cellVoltage2": "แรงดันของเซลล์แบตเตอรี่ 2",
  "storage.v2.65284.cellVoltage1": "แรงดันของเซลล์แบตเตอรี่ 1",
  "storage.v2.65284.cellVoltage7": "แรงดันของเซลล์แบตเตอรี่ 7",
  "storage.v2.65284.cellVoltage6": "แรงดันของเซลล์แบตเตอรี่ 6",
  "storage.v2.65284.cellVoltage5": "แรงดันของเซลล์แบตเตอรี่ 5",
  "storage.v2.65284.cellVoltage4": "แรงดันของเซลล์แบตเตอรี่ 4",
  "ywt.65323.gridActivePower": "กำลังไฟฟ้าเชิงบวกของสายไฟฟ้า",
  "role.per.user": "แต่ละผู้ใช้สามารถมีเพียงบทบาทเดียวเท่านั้น",
  "bw_param_ctrl_name_Grid_Regulation": "มาตรฐานสายไฟฟ้า",
  "common.50402.istr21": "กระแสของสายรวม 21",
  "common.50402.istr20": "กระแสของสายรวม 20",
  "ywt.65323.pv3Voltage": "แรงดันของ PV3",
  "jl_RTparam_name_vatBmsVersion": "หมายเลขเวอร์ชันของแพ็คแบตเตอรี่",
  "common.50402.istr24": "กระแสของสายรวม 24",
  "common.50402.istr23": "กระแสของสายรวม 23",
  "common.50402.istr22": "กระแสของสายรวม 22",
  "device.empty": "อุปกรณ์ไม่มีอยู่",
  "storage.s3.65292.outPutFreq": "ความถี่ของการส่งออก",
  "subtitle.alias": "ชื่อย่อ",
  "subtitle.environmentalBenefit": "ผลกระทบต่อสภาพแวดล้อม",
  "mini.65290.stPV3_UV": "แรงดันต่ำเกินไปของ PV Input 3",
  "common.50300.out_pac": "กำลังการผลิตไฟฟ้า (กิโลวัตต์)",
  "R21P3-208": "USA_R21P3 - 208",
  "unc.65323.spiAutoTestTimeBPhaseU1": "เวลาการทดสอบอัตโนมัติของ SPI - Pha B U >>",
  "unc.65323.spiAutoTestTimeBPhaseU2": "เวลาการทดสอบอัตโนมัติของ SPI - Pha B U > 10 นาที",
  "unc.65323.spiAutoTestTimeBPhaseU3": "เวลาการทดสอบอัตโนมัติของ SPI - Pha B U <",
  "unc.65323.spiAutoTestTimeBPhaseU4": "เวลาการทดสอบอัตโนมัติของ SPI - Pha B U <<",
  "common.50402.ipv2": "กระแสตรง 2",
  "common.50402.ipv1": "กระแสตรง 1",
  "common.50402.ipv4": "กระแสตรง 4",
  "common.50402.ipv3": "กระแสตรง 3",
  "common.50402.ipv6": "กระแสตรง 6",
  "End_user.lable_City": "เมือง",
  "common.50402.ipv5": "กระแสตรง 5",
  "bw_param_ctrl_option_Enable": "เปิดใช้งาน",
  "common.50402.ipv8": "กระแสตรง 8",
  "common.50402.ipv7": "กระแสตรง 7",
  "datalog.datalogSn": "กรุณาป้อนหมายเลขซีเรียลของเครื่องเก็บข้อมูล",
  "common.50402.ipv9": "กระแสตรง 9",
  "setting.type22.pvStartLowVol": "แรงดันต่ำตอนเริ่มต้นของ PV",
  "tip.base.minSize": "ค่าน้อยที่สุด",
  "bw_RTparam_name_TotalEnergyfromBattery": "ปริมาณการระบายไฟฟ้าที่สะสม",
  "setting.type12.acSupplyEndTime": "เวลาที่หยุดของแหล่งไฟฟ้าสลับ",
  "unc.65323.load2GeneratorReactivePower": "กำลังไร้จ่ายของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "การเปิดใช้งานการควบคุมช่วงเวลาชาร์จและระบายไฟฟ้า",
  "bw_RTparam_name_Maximumtemperatureofbattery": "อุณหภูมิสูงสุดของแบตเตอรี่",
  "common.50402.INV_P_AC": "กำลังไฟฟ้าเชิงบวกของอินเวอร์เตอร์",
  "login.enteremail": "กรุณาป้อนอีเมล",
  "R21P3-20A": "USA_R21P3 - 20A",
  "jl_param_ctrl_name_Startup-VH": "Startup - VH",
  "mini.65290.stRes1": "สถานะที่เก็บไว้ 1",
  "jl_param_ctrl_option_51.2VLithium_Battery_Without_COMM": "แบตเตอรี่ลิเธียม 51.2V (ไม่มี COM)",
  "menu.add.exist": "การเพิ่มเมนู '%s' ล้มเหลวชื่อเมนูมีอยู่แล้ว",
  "mini.65290.stRes4": "สถานะที่เก็บไว้ 4",
  "storage.s3.65292.mainsBpPower": "กำลังไฟฟ้า Pha B ของสายไฟฟ้า",
  "mini.65290.stRes5": "สถานะที่เก็บไว้ 5",
  "mini.65290.stRes2": "สถานะที่เก็บไว้ 2",
  "mini.65290.stRes3": "สถานะที่เก็บไว้ 3",
  "register.lable.password": "รหัสผ่าน",
  "mini.65290.stRes6": "สถานะที่เก็บไว้ 6",
  "product.GroupName": "ชื่อกลุ่ม",
  "jl_param_ctrl_name_Startup-VL": "Startup - VL",
  "product.parameterCoding": "รหัสพารามิเตอร์",
  "setting.type12.val.solarSupplyPriority1": "แบตเตอรี่ - โหลด - สาธารณะ",
  "ywt.65323.returnFlowPortFrequency": "ความถี่ของพอร์ตการไหลย้อนกลับ",
  "setting.type12.val.solarSupplyPriority2": "โหลด - แบตเตอรี่ - สาธารณะ",
  "KSC8565-T": "KSC8565 - T",
  "device.category.charging.pile": "เครื่องชาร์จ",
  "MEA": "Thailand_MEA",
  "CEI_0-21": "Italy_CEI 0 - 21",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "การตั้งค่าช่วงเวลาชาร์จและระบายไฟฟ้า",
  "login.remember": "จำจดอีเมลและรหัสผ่าน",
  "jl_param_ctrl_option_Voltage1V_Time0.1s_Frequency0.1Hz": "แรงดัน 0.1V เวลา 0.01s ความถี่ 0.01Hz",
  "jl_param_ctrl_note_WorkModeDefault": "การรีเซ็ตโหมดการทำงานที่เกี่ยวข้องกับรหัสสายไฟฟ้า",
  "CEI0-21": "Italy_CEI 0 - 21",
  "KSC8565-D": "KSC8565 - D",
  "unc.65323.bmsTemperature": "อุณหภูมิของ BMS (°C)",
  "jl_param_ctrl_note_AutoBatAwaken": "ฟังก์ชันการปลุกแบตเตอรี่อัตโนมัติ ระบบจะเริ่มฟังก์ชันการปลุกแบตเตอรี่เมื่ออินเวอร์เตอร์ถูกเชื่อมต่อกับไฟฟ้า",
  "tip.opsLog.inverter": "ช่วงเวลา",
  "CEI_0-16": "Italy_CEI 0 - 16",
  "tip.validate.passwordError": "รูปแบบรหัสผ่านไม่ถูกต้องกรุณาป้อนรหัสผ่านที่มีความยาว 6 - 20 ตัวอักษรและตัวเลข",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "สวิตช์ช่วงเวลาระบายไฟฟ้า 2",
  "register.title.WelcomeRegister": "ยินดีต้อนรับสู่การลงทะเบียน",
  "jl_param_ctrl_note_CTDirection": "การเปลี่ยนทิศทางที่มีผลของ CT",
  "Special.search": "ค้นหา",
  "jl_param_ctrl_note_InverterMaxOutputPowerSetting": "การตั้งค่าค่ากำลังสูงสุดที่อนุญาตให้อินเวอร์เตอร์ส่งออก",
  "common.50402.PV3_V": "แรงดันของ PV3",
  "bw_RTparam_group_Battery": "แบตเตอรี่",
  "jl_param_ctrl_note_MPPTMulti-peakScanInterval": "การตั้งค่าช่วงเวลาในระหว่างการสแกน IV เนื่องจากการดำเนินการสแกน IV อาจส่งผลต่อการผลิตไฟฟ้า",
  "MEX": "China_MEX",
  "solis.10001.cLookedPower": "กำลังจินตภาพของมิเตอร์ไฟฟ้า C",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "สวิตช์ช่วงเวลาระบายไฟฟ้า 3",
  "bar.mine": "ของฉัน",
  "bw_RTparam_name_forcedCharge": "การชาร์จแบบบังคับและการระบายไฟฟ้า",
  "common.50402.PV3_I": "กระแสของ PV3",
  "device.voltageV": "แรงดันของอุปกรณ์ V",
  "End_user.input_StationType": "กรุณาเลือกประเภท",
  "agent.company": "บริษัท",
  "storage.v2.65284.pvEnergyTotal": "ปริมาณการผลิตไฟฟ้าที่สะสมของพลังงานแสงอาทิตย์",
  "ywt.65323.gridVoltageCA": "แรงดันสายไฟฟ้า CA",
  "jl_param_ctrl_note_Peak-shavingSetting": "สวิตช์นี้ใช้เพื่อเปิด/ปิดการปรับแต่งแบบไดนามิกการดึงไฟฟ้าจากสายไฟฟ้าในระยะเวลาชาร์จแบบบังคับ เมื่อสวิตช์ถูกเปิดอินเวอร์เตอร์จะชาร์จแบตเตอรี่แบบบังคับแบบไดนามิกในขณะเดียวกันจะรักษา \\\"กำลังไฟฟ้าสายไฟฟ้าที่สูงสุดระหว่างชาร์จแบบบังคับ\\\" ไม่ให้เกิน",
  "solis.10001.bReactivePower": "กำลังไร้จ่ายของมิเตอร์ไฟฟ้า B",
  "solis.10001.dcInputType": "จำนวนช่องป้อนกระแสตรง",
  "unc.65323.gridCPhaseActivePower": "กำลังไฟฟ้าเชิงบวกของสายไฟฟ้า Pha C",
  "G99-B": "UK_G99 - B",
  "subtitle.plantImage": "รูปภาพของสถานีพลังงาน",
  "storage.s3.65292.mainsCpPower": "กำลังไฟฟ้า Pha C ของสายไฟฟ้า",
  "ywt.65323.gridReactivePower": "กำลังไร้จ่ายของสายไฟฟ้า",
  "unc.65323.pv4Voltage": "แรงดันของ PV4",
  "setting.type12.batEquChargeVol": "แรงดันการชาร์จเท่า ๆ กันของแบตเตอรี่ (V)",
  "title.deviceMessage": "ข้อความจากอุปกรณ์",
  "org.status": "สถานะ",
  "storage.s3.65292.loadTodayEnergy": "ปริมาณการใช้ไฟฟ้าของโหลดในวันนี้",
  "storage.s3.65292.deviceSn": "หมายเลขซีเรียลของอุปกรณ์",
  "common.50402.PV24_I": "กระแสของ PV24",
  "jl_param_ctrl_option_GLG": "GLG",
  "Firmware.delete": "ลบ",
  "plant.selfSufficient": "การดำรงชีวิตด้วยตัวเอง",
  "bw_param_ctrl_option_TOU": "TOU",
  "jl_param_ctrl_note_UnblanceOutput": "\\\"สวิตช์นี้ใช้เพื่อเปิด/ปิดความสามารถในการส่งออกไม่สมดุลของอินเวอร์เตอร์",
  "storage.s3.65292.bat6CellVol": "คำเตือน: หากไม่ได้เชื่อมต่อสายไม่สามารถเปิดโหมดนี้ได้\\\"",
  "jl_param_ctrl_name_DryContact": "แรงดันของเซลล์แบตเตอรี่ 6",
  "mini.65290.stPV3_OV": "ฟังก์ชันจุดติดต่อแห้ง",
  "unc.65323.spiAutoTestThresholdBPhaseU3": "แรงดันสูงเกินไปของ PV Input 3",
  "unc.65323.spiAutoTestThresholdBPhaseU4": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha B U <",
  "subtitle.restartdatalogger": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha B U <<",
  "device.user": "รีบูตเครื่องเก็บข้อมูล",
  "product.PleaseEnterSubmodelNumber": "ผู้ใช้",
  "unc.65323.spiAutoTestThresholdBPhaseU1": "กรุณาป้อนรุ่นย่อย",
  "unc.65323.spiAutoTestThresholdBPhaseU2": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha B U >>",
  "tip.validate.confirmPassword": "ค่าขั้นต่ำการทดสอบอัตโนมัติของ SPI - Pha B U > 10 นาที",
  "jl_param_ctrl_option_Voltage0.1V_Time0.01s_Frequency0.01Hz": "ยืนยันว่ารหัสผ่านยืนยันไม่ควรถูกปล่อยว่าง",
  "button.upgrade": "แรงดัน 0.1V เวลา 0.01s ความถี่ 0.01Hz",
  "datalog.btn_close": "อัปเดต",
  "bw_RTparam_name_Locationofthelowesttemperaturebatterycellinthesystem": "ยกเลิก",
  "device.b.phase": "ตำแหน่งเซลล์แบตเตอรี่ที่มีอุณหภูมิต่ำสุดในระบบ",
  "common.50402.PV24_V": "Pha B",
  "tip.log.init": "แรงดันของ PV24",
  "subtitle.InputPower": "การเริ่มต้น Bluetooth",
  "plant.input_Energyprice": "กำลังป้อน",
  "bw_RTparam_name_OverDischargeSOC": "กรุณาป้อนราคาต่อหน่วย",
  "setting.type11.dischargeStartTime1": "SOC ระบายไฟฟ้าเกิน",
  "setting.type11.dischargeStartTime2": "เวลาเริ่มระบายไฟฟ้า 1",
  "setting.type11.dischargeStartTime3": "เวลาเริ่มระบายไฟฟ้า 2",
  "setting.type11.dischargeStartTime4": "เวลาเริ่มระบายไฟฟ้า 3",
  "bw_param_ctrl_name_ChargeTimeSlot1": "เวลาเริ่มระบายไฟฟ้า 4",
  "unc.65323.returnFlowPortFrequency": "เวลาชาร์จแบบบังคับ 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "ความถี่ของพอร์ตการไหลย้อนกลับ",
  "device.dataGateway": "เวลาชาร์จแบบบังคับ 2",
  "subtitle.WorkingModeSettings": "เกตเวย์ข้อมูล",
  "ywt.65323.gridFrequencyC": "การตั้งค่าโหมดการทำงาน",
  "login.sure": "ความถี่ของสายไฟฟ้า C",
  "title.addPlant": "ยืนยัน",
  "setting.type12.val.blue": "เพิ่มสถานีพลังงาน",
  "setting.type11.dischargeTimeCurrent3": "สีน้ำเงิน",
  "setting.type11.dischargeTimeCurrent2": "กระแสระบายไฟฟ้าในช่วงเวลาระบายไฟฟ้า 3 (A)",
  "setting.type12.batEquDay": "กระแสระบายไฟฟ้าในช่วงเวลาระบายไฟฟ้า 2 (A)",
  "setting.type11.dischargeTimeCurrent4": "จำนวนวันที่ชาร์จเท่า ๆ กันของแบตเตอรี่ (วัน)",
  "ywt.65323.gridFrequencyB": "กระแสระบายไฟฟ้าในช่วงเวลาระบายไฟฟ้า 4 (A)",
  "ywt.65323.gridFrequencyA": "ความถี่ของสายไฟฟ้า B",
  "subtitle.load": "ความถี่ของสายไฟฟ้า A",
  "setting.type11.dischargeTimeCurrent1": "โหลด",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "กระแสระบายไฟฟ้าในช่วงเวลาระบายไฟฟ้า 1 (A)",
  "unc.65323.pv3Current": "การตั้งค่าชาร์จและระบายไฟฟ้าเริ่มมีผลเมื่อเลือกโหมด \\\"TOU\\\"",
  "device.operationMonitoring": "กระแสของ PV3",
  "ywt.65323.generatorRelayStatus": "สถานะการทำงานของอินเวอร์เตอร์",
  "setting.type10.utilityPriority": "สถานะของรีเลย์เครื่องกำเนิดไฟฟ้า",
  "common.50402.istr18": "ความสำคัญของสายไฟฟ้า",
  "tip.plant.pvcapacityMin": "กระแสของสายรวม 18",
  "common.50402.istr17": "ความจุ PV ต่ำสุด",
  "storage.s3.65292.mosTemp": "กระแสของสายรวม 17",
  "common.50402.istr16": "อุณหภูมิของ MOS (°C)",
  "tip.log.bluetoothException": "กระแสของสายรวม 16",
  "common.50402.istr15": "การตัดการเชื่อมต่อ Bluetooth ไม่ปกติโปรดยืนยันว่าการเชื่อมต่อ Bluetooth ของอุปกรณ์ถูกเปิดแล้วจากนั้นเชื่อมต่อใหม่",
  "Mala-LV": "กระแสของสายรวม 15",
  "tip.validate.verificationError": "Malaysia_Mala - LV",
  "bw_RTparam_name_TotalRuntime": "รหัสยืนยันไม่ถูกต้องกรุณาป้อนรหัสยืนยันที่ถูกต้อง",
  "common.50402.PV11_I": "เวลารวมของ PV",
  "common.50402.istr19": "กระแสของ PV11",
  "jl_param_ctrl_name_BatteryModel": "กระแสของสายรวม 19",
  "common.50402.istr10": "รุ่นของแบตเตอรี่",
  "jl_param_ctrl_option_LithiumBatteryLV(RS485)": "กระแสของสายรวม 10",
  "jl_param_ctrl_name_OV-G-F01": "OV - G - F 01",
  "jl_param_ctrl_name_OV-G-F02": "OV - G - F 02",
  "placeholder.enterConfirmPassword": "กรุณายืนยันรหัสผ่านใหม่",
  "common.50402.istr14": "istr14",
  "plant.owner": "เจ้าของ",
  "common.50402.istr13": "istr13",
  "common.50402.istr12": "istr12",
  "common.50402.istr11": "istr11",
  "jl_param_ctrl_name_27.S2Time": "เวลา 27.S2",
  "solis.10001.homeGridTodayEnergy": "การใช้พลังงานวันนี้",
  "ywt.65323.returnFlowPortVoltageB": "แรงดันพอร์ตไหลกลับเฟส B",
  "ywt.65323.returnFlowPortVoltageC": "แรงดันพอร์ตไหลกลับเฟส C",
  "jl_param_ctrl_name_BatteryHealingSwitch": "สวิตช์การฟื้นฟูแบตเตอรี่",
  "tip.log.bluetoothAuthorization": "การให้รับอนุญาต Bluetooth ของแอปไม่ได้เปิด",
  "common.50100.pv2CumulativePowerGeneration": "ผลผลิตรวมของ PV2",
  "ywt.65323.returnFlowPortVoltageA": "แรงดันพอร์ตไหลกลับเฟส A",
  "jl_param_ctrl_option_BYD_HVL": "BYD HVL",
  "plant.deviceList": "รายการอุปกรณ์",
  "common.50100.totalPvEnergy": "ผลผลิตรวม",
  "subtitle.Restarting": "กำลังรีสตาร์ท",
  "jl_param_ctrl_name_BaselineSOC": "SOC เบสไลน์",
  "storage.s3.65292.afterLoadPower": "กำลังโหลดของระบบหลังสุด",
  "bw_RTparam_name_online": "ออนไลน์",
  "agent.import_device": "นำเข้าอุปกรณ์",
  "jl_param_ctrl_name_DailyPV-ISODetection": "การตรวจสอบ PV - ISO รายวัน",
  "solis.10001.acOutputType": "ระดับเอาต์พุต AC",
  "common.50402.PV11_V": "แรงดัน PV11",
  "collector.params.error": "การอ่านพารามิเตอร์ที่ไม่ใช่ Dongle ผิดปกติ",
  "PN-50549": "โปแลนด์_PN - 50549",
  "subtitle.timeshare": "การแบ่งช่วงเวลา",
  "productEquipment.linkageInformation": "ข้อมูลการเชื่อมต่อ",
  "button.later": "ภายหลัง",
  "subtitle.endUsers": "ผู้ใช้สุดท้าย",
  "setting.type22.lowVoltage": "แรงดันต่ำในการเริ่มต้น AC",
  "common.50402.turnon_time": "เวลาเปิด",
  "jl_param_ctrl_name_HSB": "HSB",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "กรุณาเปิดสวิตช์ก่อน",
  "jl_param_ctrl_name_Recover-FL": "Recover - FL",
  "tip.connectWifi.commandSetFail": "การตั้งค่าคำสั่งล้มเหลว กรุณาเชื่อมต่อ Dongle ใหม่",
  "jl_param_ctrl_name_Recover-FH": "Recover - FH",
  "tip.log.locationPermission": "การเปิดใช้งานการระบุตำแหน่ง",
  "DK1": "เดนมาร์ก_DK1",
  "DK2": "เดนมาร์ก_DK2",
  "bw_RTparam_name_Meter.CTSetting": "การตั้งค่ามิเตอร์/CT",
  "common.50402.type": "ประเภท",
  "device.installer": "องค์กร",
  "login.agreement.checkAgreeAgreement": "กรุณาเลือกว่าคุณยอมรับข้อกำหนดการให้บริการและนโยบายความเป็นส่วนตัว",
  "bw_RTparam_name_TotalConsumptionEnergy": "พลังงานการใช้พลังงานรวม",
  "product.PleaseEnterTheProductSerialNumber": "กรุณากรอกหมายเลขซีเรียลของผลิตภัณฑ์",
  "jl_param_ctrl_option_B_BOX_HV_BYD": "B_BOX_HV BYD",
  "tip.validate.enterDecimal": "ต้องป้อน {num} หลักทศนิยมหรือจำนวนเต็ม",
  "Reset_the_grid_code_related_power_limit": "รีเซ็ตขีดจำกัดกำลังที่เกี่ยวข้องกับรหัสระบบไฟฟ้า",
  "setting.type10.power": "กำลังไฟฟ้าเฟส",
  "jl_param_ctrl_name_OV-G-F-T01": "OV - G - F - T 01",
  "common.50300.pac": "การผลิตไฟฟ้า",
  "mini.65290.stErrAccess_EEPROM": "ข้อผิดพลาดการเข้าถึง EEPROM",
  "jl_param_ctrl_name_OV-G-F-T02": "OV - G - F - T 02",
  "plant.humidity": "ความชื้น",
  "unc.65323.returnFlowPortPowerFactor": "ปัจจัยกำลังของพอร์ตไหลกลับ",
  "subtitle.todayEnergy": "การใช้พลังงานไฟฟ้าวันนี้",
  "solis.10001.batteryPower": "กำลังของแบตเตอรี่",
  "jl_param_ctrl_name_0E-FrequencyDeratinghysteresisresponsetime(Tstop)": "เวลาปฏิกิริยาประกอบการลดความถี่ (Tstop) 0E - Frequency Derating hysteresis response time",
  "jl_param_ctrl_name_10minOvervoltageDefault": "แรงดันเกินค่าเริ่มต้น 10 นาที",
  "setting.type12.switchOptions": "ตัวเลือกสวิตช์",
  "jl_param_ctrl_name_GenChargePower": "กำลังประกอบไฟของเครื่องกำเนิดไฟ",
  "tip.log.queryWiFi": "การสอบถามรายการ WiFi สำเร็จ",
  "storage.s3.65292.mainsMarker": "สัญลักษณ์การไหลของพลังงานจากระบบไฟฟ้า",
  "validator.greater": "กรุณากรอกตัวเลขที่มากกว่าศูนย์",
  "jl_param_ctrl_name_DischargeTimeSlot1": "ช่วงเวลาปล่อยประจุ 1",
  "jl_param_ctrl_name_DischargeTimeSlot2": "ช่วงเวลาปล่อยประจุ 2",
  "device.he": "โหลด",
  "jl_param_ctrl_name_DischargeTimeSlot3": "ช่วงเวลาปล่อยประจุ 3",
  "bw_param_ctrl_group_GridSafetyConfig": "การตั้งค่าความปลอดภัยของระบบไฟฟ้า",
  "jl_param_ctrl_name_DischargeTimeSlot4": "ช่วงเวลาปล่อยประจุ 4",
  "tip.log.connectFail": "การเชื่อมต่อ Bluetooth ล้มเหลว",
  "jl_param_ctrl_name_DischargeTimeSlot5": "ช่วงเวลาปล่อยประจุ 5",
  "btn.export": "ส่งออก",
  "jl_param_ctrl_name_DischargeTimeSlot6": "ช่วงเวลาปล่อยประจุ 6",
  "jl_param_ctrl_name_Metercompensation": "การชดเชยมิเตอร์",
  "common.50300.status": "สถานะ",
  "ywt.65323.loadTodayConsumeEnergy": "การใช้พลังงานรายวัน",
  "subtitle.ForceCharge2": "การประกอบไฟบังคับ 2",
  "subtitle.ForceCharge1": "การประกอบไฟบังคับ 1",
  "jl_param_ctrl_group_TimeOfUse": "การใช้เวลา",
  "storage.s3.65292.mainsApVoltage": "แรงดันเฟส A จากระบบไฟฟ้า",
  "storage.v2.65284.cellVoltage14": "แรงดันเซลล์ 14",
  "GN300V": "จีน_GN300V",
  "storage.v2.65284.cellVoltage13": "แรงดันเซลล์ 13",
  "storage.v2.65284.cellVoltage12": "แรงดันเซลล์ 12",
  "storage.v2.65284.cellVoltage11": "แรงดันเซลล์ 11",
  "solis.10001.uAc1": "แรงดันด้าน AC - R",
  "jl_param_ctrl_name_13H-FrequencyDeratingSlope(Fdroop)": "ความชันการลดความถี่ 13H - Frequency Derating Slope (Fdroop)",
  "solis.10001.uAc2": "แรงดันด้าน AC - S",
  "storage.v2.65284.cellVoltage16": "แรงดันเซลล์ 16",
  "solis.10001.uAc3": "แรงดันด้าน AC - T",
  "plant.lable_Address": "ที่อยู่",
  "storage.v2.65284.cellVoltage15": "แรงดันเซลล์ 15",
  "storage.v2.65284.cellVoltage10": "แรงดันเซลล์ 10",
  "ywt.65323.powerFactor": "ปัจจัยกำลัง",
  "jl_param_ctrl_note_ManualSetMaster.Slave": "เพื่อตั้งค่าอินเวอร์เตอร์ว่าเป็นอุปกรณ์หลักหรืออุปกรณ์รองในการทำงานแบบขนาน",
  "tip.log.gettingIP": "การรับที่อยู่ IP ของเราเตอร์",
  "setting.type11.chargeTimeCurrent4": "กระแสประกอบไฟช่วงเวลาประกอบไฟ 4 (A)",
  "socket.stopaddress": "ที่อยู่ลงทะเบียนสิ้นสุด",
  "setting.type3.onlyAddThree": "เพิ่มตัวจับเวลาสูงสุด 21 ตัว",
  "device.a.phase": "เฟส A",
  "setting.type11.chargeTimeCurrent1": "กระแสประกอบไฟช่วงเวลาประกอบไฟ 1 (A)",
  "setting.type11.chargeTimeCurrent3": "กระแสประกอบไฟช่วงเวลาประกอบไฟ 3 (A)",
  "subtitle.socketBluetooth": "Bluetooth ของส็อกเก็ต",
  "jl_param_ctrl_option_YES": "ใช่",
  "setting.type11.chargeTimeCurrent2": "กระแสประกอบไฟช่วงเวลาประกอบไฟ 2 (A)",
  "device.electic.meter.data": "ข้อมูลมิเตอร์ไฟฟ้า",
  "subtitle.deviceType": "ประเภทอุปกรณ์",
  "agent.relus_email": "กรุณากรอกที่อยู่อีเมล์ที่ถูกต้อง",
  "tip.validate.country": "ประเทศไม่สามารถเว้นว่างได้ กรุณาเลือกประเทศ",
  "bw_param_ctrl_group_SystemConfig": "การตั้งค่าระบบ",
  "subtitle.revenue": "รายได้",
  "setting.type10.onlyAddThree": "เพิ่มตัวจับเวลาสูงสุด {num} ตัว",
  "subtitle.dataType": "ประเภทข้อมูล",
  "tip.log.getBluetoothServiceSuccess": "การรับบริการอุปกรณ์ Bluetooth สำเร็จ",
  "solis.10001.cveragePowerFactor": "ปัจจัยกำลังของมิเตอร์ C",
  "solis.10001.pSum": "กำลังไฟฟ้าเฟสของระบบไฟฟ้าทั้งหมด",
  "plant.equivalentIncome": "รายได้เทียบเท่า",
  "ywt.65323.load2GeneratorBPhaseActivePower": "กำลังไฟฟ้าเฟส B ของโหลด 2/เครื่องกำเนิดไฟ",
  "placeholder.select": "กรุณาเลือก",
  "storage.s3.65292.mcuTemp": "อุณหภูมิ MCU (℃)",
  "bw_RTparam_name_Systemminimumvoltagecellserialnumber": "หมายเลขซีเรียลของเซลล์แบตเตอรี่ที่มีแรงดันต่ำที่สุดในระบบ",
  "jl_param_ctrl_option_PhaseB(3P)": "เฟส B (สามเฟส)",
  "ship.endtime": "เวลาสิ้นสุด",
  "End_user.lable_Address": "ที่อยู่",
  "subtitle.firmwareVersion": "เวอร์ชันเฟิร์มแวร์",
  "menu.is.external": "ใช่",
  "login.password.not.blank": "รหัสผ่านเข้าสู่ระบบไม่สามารถเว้นว่างได้",
  "storage.v2.65284.runningStatus": "สถานะการทำงานของอุปกรณ์",
  "setting.type22.acOverFrequencyTime1": "เวลาประกอบการไฟฟ้า AC เกินความถี่ลำดับที่หนึ่ง (s)",
  "setting.type22.acOverFrequencyTime2": "เวลาประกอบการไฟฟ้า AC เกินความถี่ลำดับที่สอง (s)",
  "common.50402.sn": "หมายเลขซีเรียลของอินเวอร์เตอร์",
  "tip.log.reconnect": "การเชื่อมต่อ Bluetooth ใหม่",
  "jl_param_ctrl_name_OverdischargeSOC": "SOC แบตเตอรี่หมดจ่าย",
  "storage.s3.65292.mainsTotalChargeEnergy": "พลังงานที่ประกอบจากระบบไฟฟ้าทั้งหมด",
  "sidebar.firmware": "OTA",
  "ywt.65323.gridVoltageAB": "แรงดันระหว่างเฟส AB ของระบบไฟฟ้า",
  "bw_RTparam_name_BatterySOC": "SOC ของแบตเตอรี่",
  "register.lable.VerificationCode": "รหัสยืนยัน",
  "bw_RTparam_name_BatterySOH": "SOH ของแบตเตอรี่",
  "End_user.btn_search": "ค้นหา",
  "jl_param_ctrl_option_Jinko": "Jinko",
  "User-define": "กำหนดเอง_User - define",
  "setting.type3.DCOutputNormallyOpen": "โหมดเปิดตลอดของเอาต์พุต DC",
  "unc.65323.phaseOrder": "ลำดับเฟส",
  "datalog.span_order": "คำสั่ง",
  "tip.plant.onlyread": "อ่านเท่านั้น",
  "datalog.methods_version": "กำลังตรวจสอบการอัพเดตเวอร์ชันหรือไม่?",
  "device.totalPower": "กำลังไฟฟ้าทั้งหมด",
  "storage.s3.65292.bPhaseApparentPower": "กำลังไฟฟ้าเฟส B เอาต์พุต",
  "ywt.65323.gridVoltageBC": "แรงดันระหว่างเฟส BC ของระบบไฟฟ้า",
  "product.binding.error": "ผลิตภัณฑ์ถูกผูกมัดแล้วและไม่สามารถลบได้",
  "storage.s3.65292.offlineAlarm": "เตือนการไม่อยู่ในเครือข่าย",
  "product.blockEncoding": "การเข้ารหัสกลุ่ม",
  "storage.s3.65292.batRatedCapacity": "ความจุระดับนิยมของแบตเตอรี่",
  "productEquipment.productModelNumber": "รุ่นผลิตภัณฑ์",
  "subtitle.WhenClosedAllOptimizersStopWorking": "หลังจากปิดเครื่อง ระบบเพิ่มประสิทธิภาพทั้งหมดจะหยุดทำงาน",
  "login.passLength": "รหัสผ่านต้องมีความยาวระหว่าง 8 ถึง 20 ตัวอักษร",
  "bw_RTparam_name_BatterySN3": "หมายเลขซีเรียลของแบตเตอรี่ 3",
  "bw_RTparam_name_TotalOperationTime": "เวลารวมการทำงาน",
  "setting.socket.friday": "วันศุกร์",
  "subtitle.HMISoftwareVersion": "เวอร์ชันซอฟต์แวร์ HMI",
  "bw_RTparam_name_BatterySN2": "หมายเลขซีเรียลของแบตเตอรี่ 2",
  "bw_RTparam_name_BatterySN1": "หมายเลขซีเรียลของแบตเตอรี่ 1",
  "tip.log.queryServerState": "การส่งคำสั่งเพื่อสอบถามสถานะการโต้ตอบระหว่างอุปกรณ์และเซิร์ฟเวอร์สำเร็จ",
  "mini.65290.stRelayoN": "สถานะรีเลย์เปิด",
  "solis.10001.type": "ประเภทอินเวอร์เตอร์",
  "bw_RTparam_name_BatterySN6": "หมายเลขซีเรียลของแบตเตอรี่ 6",
  "bw_RTparam_name_BatterySN5": "หมายเลขซีเรียลของแบตเตอรี่ 5",
  "bw_RTparam_name_BatterySN4": "หมายเลขซีเรียลของแบตเตอรี่ 4",
  "storage.s3.65292.loadTotalUseMainsEnergy": "การใช้พลังงานโหลดจากระบบไฟฟ้าทั้งหมด",
  "ywt.65323.loadTotalConsumeEnergy": "การใช้พลังงานทั้งหมด",
  "org.deleteSuccess": "ลบสำเร็จ",
  "common.delete": "ลบ",
  "tip.validate.incomeunit": "สกุลเงินไม่สามารถเว้นว่างได้ กรุณาเลือกสกุลเงิน",
  "retrieve.tips.sendVerificationCodeEmailAddress": "รหัสยืนยันถูกส่งไปยังอีเมล์ {scope} ของคุณแล้ว",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "กรุณากรอกที่อยู่ตามโปรโตคอลพารามิเตอร์",
  "storage.s3.65292.bat2CellVol": "แรงดันเซลล์ 2",
  "unc.65323.pvTotalPower": "กำลังไฟฟ้า PV ทั้งหมด",
  "form.file": "ลากไฟล์มาที่นี่หรือกดปุ่มอัปโหลด",
  "R21P3-24A": "สหรัฐอเมริกา_R21P3 - 24A",
  "jl_param_ctrl_note_PowerLimitDefault": "รีเซ็ตขีดจำกัดกำลังที่เกี่ยวข้องกับรหัสระบบไฟฟ้า.",
  "unc.65323.returnFlowPortCPhaseActivePower": "กำลังไฟฟ้าเฟส C ของพอร์ตไหลกลับ",
  "R21P3-240": "สหรัฐอเมริกา_R21P3 - 240",
  "Firmware.import_folder": "นำเข้าไฟล์",
  "ywt.65323.load2GeneratorCurrentC": "กระแสของโหลด 2/เครื่องกำเนิดไฟเฟส C",
  "plant.input_TimeZone": "กรุณาเลือกโซนเวลา",
  "switchover.SelectIdentity": "กรุณาเลือกบทบาทของคุณ",
  "subtitle.deforestation": "ต้นไม้",
  "ywt.65323.load2GeneratorCurrentB": "กระแสของโหลด 2/เครื่องกำเนิดไฟเฟส B",
  "jl_param_ctrl_name_01-Under-FreqDerateFstart": "ความถี่เริ่มการลดกำลัง 01 - Under - Freq Derate Fstart",
  "ywt.65323.load2GeneratorCurrentA": "กระแสของโหลด 2/เครื่องกำเนิดไฟเฟส A",
  "unc.65323.bmsDischargeCurrentLimit": "ขีดจำกัดกระแสปล่อยประจุของ BMS",
  "title.editSchedule": "แก้ไขตัวจับเวลา",
  "tip.connectWifi.enterSSID": "กรุณากรอกบัญชีเราเตอร์",
  "jl_param_ctrl_name_GeneratorCharge": "การประกอบไฟของเครื่องกำเนิดไฟ",
  "shipment.haierSn": "หมายเลขซีเรียลของ Haier",
  "IEC61727L": "ปากีสถาน, อินเดีย_IEC61727L",
  "datalog.span_firmware": "สัญญาณ/เวอร์ชันเฟิร์มแวร์:",
  "device.protocolDirectives": "คำสั่งโปรโตคอล",
  "device.category.collecting.box": "กล่องรวม",
  "unc.65323.pv3Power": "กำลังไฟฟ้า PV3",
  "setting.type7.inputPassword": "การป้อนรหัสผ่าน",
  "product.value": "ค่า",
  "tip.connectWifi.enterPassword": "กรุณากรอกรหัสผ่านของเราเตอร์",
  "login.verCode": "รหัสยืนยัน",
  "common.50100.pv1Voltage": "แรงดัน PV1",
  "setting.type12.val.batteryCapacity": "เปอร์เซ็นต์ความจุของแบตเตอรี่",
  "systemAuthority.systemSettings": "การตั้งค่าระบบ",
  "setting.type22.startSolpe": "ความชันเริ่มต้น",
  "ywt.65323.bmsRequestFlag": "ธงสัญญาณคำขอของ BMS",
  "datalog.span_inputsetting": "กรุณากรอกชื่อโดเมน",
  "tip.energy.tip2": "29",
  "storage.s3.65292.chargeStatus": "สถานะการประกอบไฟ",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "โหมดการทำงาน",
  "Logs.starttime": "เวลาเริ่มต้น",
  "storage.s3.65292.bPhaseCurrent": "กระแสเอาต์พุตเฟส B",
  "unc.65323.gridFrequencyC": "ความถี่ของระบบไฟฟ้า C",
  "btn.add": "เพิ่มเข้าไป",
  "common.reset": "รีเซ็ต",
  "jl_param_ctrl_name_81<S1-Time": "81 < S1 - Time",
  "unc.65323.gridFrequencyB": "ความถี่ของระบบไฟฟ้า B",
  "unc.65323.gridFrequencyA": "ความถี่ของระบบไฟฟ้า A",
  "jl_param_ctrl_option_SUNWODA_HV": "SUNWODA HV",
  "product.PleaseSelectAFolderPath": "กรุณาเลือกเส้นทางโฟลเดอร์",
  "solis.10001.gridPurchasedTotalEnergy": "จำนวนทั้งหมดที่นำเข้า",
  "home.echarts5.subhead": "Dongle ใหม่/จำนวน Dongle ทั้งหมดที่เพิ่ม",
  "placeholder.endDate": "วันที่สิ้นสุด",
  "subtitle.dealer": "ตัวแทนจำหน่าย",
  "ywt.65323.pv1Power": "กำลังไฟฟ้า PV 1",
  "plant.electricityConsumptionToday": "ผลผลิตวันนี้",
  "setting.type22.restartDelayTime": "เวลาล่าช้าในการรีสตาร์ท",
  "bw_param_ctrl_name_MeterCTSelect": "การเลือกมิเตอร์ CT",
  "jl_param_ctrl_name_Pdischarge": "Pdischarge",
  "bw_RTparam_name_DailyEnergytoGrid": "การส่งออกรายวัน",
  "tip.opsLog.reset": "รีเซ็ต",
  "subtitle.alarmEndTime": "เวลาสิ้นสุด",
  "solis.10001.gridCurrentC": "กระแสของระบบไฟฟ้า C",
  "jl_param_ctrl_name_MPPTMulti-peakScanningSwitch": "สวิตช์การสแกนหลายยอดของ MPPT",
  "setting.type19.totalActivePower": "กำลังไฟฟ้า",
  "solis.10001.gridCurrentB": "กระแสของระบบไฟฟ้า B",
  "solis.10001.gridCurrentA": "กระแสของระบบไฟฟ้า A",
  "ywt.65323.batFaultFlag": "เครื่องบ่งชี้ความผิดปกติของแบตเตอรี่",
  "solis.10001.batteryYearChargeEnergy": "พลังงานที่ประกอบรายปี",
  "setting.type7.generatorSwitchCmd": "การสลับเครื่องกำเนิดไฟ",
  "ship.supplierSn.not.empty": "หมายเลขซีเรียล MES ไม่สามารถเว้นว่างได้",
  "solis.10001.batteryMonthChargeEnergy": "พลังงานที่ประกอบรายเดือน",
  "plant.input_email": "กรุณากรอกที่อยู่อีเมล์ของผู้ใช้",
  "subtitle.selectDateType": "เลือกประเภทวันที่",
  "subtitle.HardwareVersionNumber": "หมายเลขเวอร์ชันฮาร์ดแวร์",
  "common.50402.PV19_V": "แรงดัน PV19",
  "unc.65323.gridAPhaseActivePower": "กำลังไฟฟ้าเฟส A ของระบบไฟฟ้า",
  "setting.type12.val.cyan": "สีฟ้า",
  "subtitle.family": "ครอบครัว",
  "setting.type12.countryRegulations": "กฎระเบียบแห่งชาติ",
  "Firmware.folder_path": "เส้นทางโฟลเดอร์:",
  "jl_param_ctrl_option_NoResponseMode": "โหมดไม่ตอบสนอง",
  "common.50300.vpv12": "แรงดัน DC 12",
  "jl_param_ctrl_note_GridCode": "การตั้งค่ารหัสระบบไฟฟ้า กรุณาเลือกรหัสระบบไฟฟ้าที่เหมาะสมกับข้อกำหนดท้องถิ่น",
  "mini.65290.stOV_Fgrid": "การป้องกันความถี่ไฟฟ้าเกินของแรงดันด้านระบบไฟฟ้า",
  "common.50402.PV19_I": "กระแส PV19",
  "common.50300.vpv10": "แรงดัน DC 10",
  "common.50300.vpv11": "แรงดัน DC 11",
  "jl_param_ctrl_name_EPSSwitchingTime": "เวลาการสลับ EPS",
  "tip.connectWifi.tip": "กรุณาเลือก WiFi 2.4G",
  "subtitle.settingParam": "ตั้งค่าพารามิเตอร์",
  "setting.type3.restoreFactory": "กู้คืนการตั้งค่าเริ่มต้นของโรงงาน",
  "setting.type7.setVal.clearAlarm": "ลบคำเตือน",
  "tip.validate.cameraPermission": "แอปต้องการสิทธิ์ใช้กล้องเพื่อสแกนและเพิ่ม Dongle",
  "jl_param_ctrl_note_EPSSwitchingTime": "0 หมายถึงว่าพารามิเตอร์ EPS ไม่ถูกต้องและโหมด EPS ถูกปิด",
  "jl_param_ctrl_name_PowerLimitDefault": "ขีดจำกัดกำลังค่าเริ่มต้น",
  "jl_param_ctrl_option_UZ(Catl)": "UZ (Catl)",
  "unc.65323.returnFlowPortApparentPower": "กำลังไฟฟ้าเฟสของพอร์ตไหลกลับ",
  "storage.s3.65292.pvChargeCurrent": "กระแสประกอบไฟ PV",
  "title.distributionNetworkStatus": "สถานะเครือข่ายการกระจายไฟฟ้า",
  "global.DataDetails": "รายละเอียดข้อมูล",
  "jl_param_ctrl_name_BatteryType": "ประเภทแบตเตอรี่",
  "product.parameterManagement": "การจัดการพารามิเตอร์",
  "device.optimizer": "ตัวเพิ่มประสิทธิภาพ",
  "tip.log.bluetoothService": "กรุณาเปิดใช้บริการ Bluetooth",
  "bw_param_ctrl_note_BatteryReady": "การเชื่อมต่อแบตเตอรีโดยค่าเริ่มต้นคือ 'มีแบตเตอรี'. หากไม่ได้เชื่อมต่อแบตเตอรี (เช่น อินเวอร์เตอร์ถูกเชื่อมต่อกับ PV แต่ไม่เชื่อมต่อกับโมดูลแบตเตอรีใดๆ) ให้เลือก 'ไม่มีแบตเตอรี' ไม่งั้นอุปกรณ์จะค้นหาแบตเตอรีที่ไม่มีอยู่และจะเข้าสู่โหมดข้อผิดพลาด",
  "setting.type12.val.outputSource2": "พลังงานแสงอาทิตย์ -> แบตเตอรี -> ใช้สาธารณะ",
  "setting.type12.val.outputSource1": "พลังงานแสงอาทิตย์ -> สาธารณะ -> แบตเตอรี",
  "plant.energyAnalysis": "การวิเคราะห์พลังงาน",
  "title.systemMessage": "ข้อความจากระบบ",
  "storage.s3.65292.cPhaseVoltage": "แรงดันเอาต์พุตเฟส C",
  "sotrage.select": "กรุณาเลือก",
  "jl_param_ctrl_name_3Tau(Q)Setting": "การตั้งค่า 3Tau (Q)",
  "datalog.methodes_DNS": "คุณต้องการตั้งค่าชื่อโดเมนนี้หรือไม่",
  "storage.v2.65284.BMSTemp": "อุณหภูมิ BMS (℃)",
  "setting.type12.batReChargeVol": "กู้คืนแรงดันการประกอบไฟ",
  "bw_RTparam_name_TodayConsumption": "การใช้พลังงานวันนี้",
  "mini.65290.stPV6_OV": "แรงดันเกิน PV input 6",
  "common.50100.pv2Power": "กำลังไฟฟ้า PV2",
  "unc.65323.pv5Voltage": "แรงดัน PV5",
  "solis.10001.model": "รุ่นอินเวอร์เตอร์",
  "upload.knowandSure": "รู้และยืนยัน",
  "setting.type22.startDelayTime": "เวลาล่าช้าในการเริ่มต้น",
  "jl_param_ctrl_option_Zeta": "Zeta",
  "setting.type12.val.high": "สูง",
  "product.remove": "ลบ",
  "bw_RTparam_name_TotalReactivePower_PV": "กำลังไฟฟ้าเฟสของ PV ทั้งหมด",
  "storage.s3.65292.transformerTemp": "อุณหภูมิของหม้อแปลง (℃)",
  "unc.65323.inverterTemperature": "อุณหภูมิของอินเวอร์เตอร์ (℃)",
  "jl_param_ctrl_option_Single": "เดี่ยว",
  "role.exist": "อักขระนี้มีอยู่แล้ว",
  "setting.ops15.batType": "ประเภทแบตเตอรี่",
  "jl_param_ctrl_note_Off-GridOverdischargeSOC": "เพื่อตั้งค่า SOC แบตเตอรี่ที่หมดจ่ายในสภาวะไม่มีระบบไฟฟ้า",
  "bw_RTparam_name_BatteryChargeCut-offVoltage": "แรงดันตัดการประกอบไฟของแบตเตอรี่",
  "AS4777-15": "ออสเตรเลีย_AS4777 - 15",
  "jl_param_ctrl_option_PYTESH": "PYTESH",
  "tip.log.listeningFailure": "การตรวจสอบการเปลี่ยนค่าคุณสมบัติการตรวจสอบล้มเหลว กรุณาเชื่อมต่อ Bluetooth ใหม่",
  "bw_RTparam_name_VoltageOfAPhase_PV": "แรงดันเฟส A (PV)",
  "tip.log.routerAccount": "ข้อผิดพลาดบัญชีเราเตอร์",
  "dev.type.self": "พัฒนาขึ้นเอง",
  "GREECE": "กรีซี_GREECE",
  "jl_param_ctrl_name_TimeofUseDischargeCurrentSet": "การตั้งค่ากระแสปล่อยประจุตามเวลา",
  "button.next": "ขั้นตอนถัดไป",
  "device.communicationEquipment": "Dongle",
  "tip.log.connectWiFiFail": "การเชื่อมต่อเราเตอร์ล้มเหลว",
  "menu.add.parent": "การเพิ่มเมนู '% s' ล้มเหลว เมนูชั้นบนไม่สามารถเลือกตัวเองได้",
  "product.storage": "แบตเตอรี่",
  "plant.lable_Country": "ประเทศ",
  "jl_param_ctrl_name_Ramp-up-US": "การเพิ่มขึ้นอย่างช้าๆ - US",
  "agent.address": "ที่อยู่",
  "product.ProtocolAddress": "ที่อยู่ในโปรโตคอลพารามิเตอร์",
  "jl_param_ctrl_option_LGChemLV": "LG Chem LV",
  "TOR": "ออสเตรีย_TOR",
  "unc.65323.returnFlowPortAPhaseActivePower": "กำลังไฟฟ้าเฟส A ของพอร์ตไหลกลับ",
  "subtitle.total": "ทั้งหมด",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "การใช้มิเตอร์ CT ของระบบไฟฟ้า/การใช้มิเตอร์ PV",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "เวลาการทดสอบอัตโนมัติ SPI ภาพเฟส C U >>",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "เวลาการทดสอบอัตโนมัติ SPI ภาพเฟส C U > 10 นาที",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "เวลาการทดสอบอัตโนมัติ SPI ภาพเฟส C U <",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "เวลาการทดสอบอัตโนมัติ SPI ภาพเฟส C U <<",
  "MEX-CFE-SP": "เม็กซิโก_MEX - CFE - SP",
  "global.storage": "การตั้งค่าการเก็บพลังงาน",
  "jl_param_ctrl_option_LG_16H": "LG_16H",
  "solis.10001.gridFac": "ความถี่ของระบบไฟฟ้า",
  "jl_param_ctrl_name_WithGenerator": "มีเครื่องกำเนิดไฟ",
  "bw_RTparam_name_GridCurrentL1": "กระแสของระบบไฟฟ้า L1",
  "bw_RTparam_name_GridCurrentL2": "กระแสของระบบไฟฟ้า L2",
  "bw_RTparam_name_GridCurrentL3": "กระแสของระบบไฟฟ้า L3",
  "org.passwordResetSuccess": "การรีเซ็ตรหัสผ่านสำเร็จ",
  "setting.type10.ACCharging": "เวลาประกอบไฟ",
  "jl_param_ctrl_name_CTDirection": "ทิศทางของ CT",
  "setting.type12.inputVolRange": "ช่วงแรงดันป้อน",
  "ywt.65323.pvTotalEnergy": "ผลผลิตรวมของ PV",
  "setting.type12.solarSupplyPriority": "ให้ความสำคัญกับแหล่งพลังงานจากพลังงานแสงอาทิตย์",
  "ywt.65323.ctTotalActivePower": "กำลังไฟฟ้าเฟสของ EM ทั้งหมด",
  "setting.type12.batEquTimeout": "เวลาหมดของการสมดุลแบตเตอรี่ (นาที)",
  "jl_param_ctrl_group_AdvancedSetting-SpecialFunctionSetting": "การตั้งค่าขั้นสูง - การตั้งค่าฟังก์ชันพิเศษ",
  "product.battery": "แบตเตอรี่",
  "AS4777-02": "ออสเตรเลีย_AS4777 - 02",
  "mini.65290.Vpv5": "แรงดันป้อน PV5",
  "mini.65290.Vpv6": "แรงดันป้อน PV6",
  "mini.65290.Vpv3": "แรงดันป้อน PV3",
  "common.50402.PV4_V": "แรงดัน PV4",
  "mini.65290.Vpv4": "แรงดันป้อน PV4",
  "mini.65290.Vpv1": "แรงดันป้อน PV1",
  "mini.65290.Vpv2": "แรงดันป้อน PV2",
  "jl_param_ctrl_name_01-Powerderatechangeslopelimit（Wgra-）": "ขีดจำกัดความชันการเปลี่ยนการลดกำลัง 01 - Power derate change slope limit（Wgra - ）",
  "title.setting": "ตั้งค่า",
  "subtitle.lastSync": "การซิงค์ข้อมูลสำเร็จสุดท้าย",
  "common.50402.PV4_I": "กระแส PV4",
  "device.getParamsFail": "การรับพารามิเตอร์ล้มเหลว",
  "product.explain": "อธิบาย",
  "subtitle.startAddress": "ที่อยู่ลงทะเบียนเริ่มต้น",
  "bw_RTparam_name_PV1Current": "กระแส PV1",
  "ywt.65323.load2GeneratorReactivePower": "กำลังไฟฟ้าเฟสของโหลด 2/เครื่องกำเนิดไฟ",
  "AS4777_SA": "Australia_AS4777_SA",
  "datalog.span_reset": "รีสตาร์ท Dongle  ",
  "jl_param_ctrl_option_DMEGC": "DMEGC  ",
  "sidebar.systematicSupply": "บันทึกการจัดส่ง  ",
  "setting.type3.mode": "รูปแบบ  ",
  "productEquipment.customInstruction": "คำสั่งกำหนดเอง  ",
  "subtitle.endAddress": "สิ้นสุดที่อยู่รีจิสเตอร์  ",
  "unc.65323.ctCurrentA": "CT กระแส A  ",
  "unc.65323.ctCurrentB": "CT กระแส B  ",
  "plant.submit": "ส่ง  ",
  "jl_param_ctrl_option_ROSENESS": "ROSEN ESS  ",
  "unc.65323.ctCurrentC": "CT กระแส C  ",
  "setting.type22.lowFrequency": "AC เริ่มต้นความถี่ต่ำ  ",
  "setting.type6.UF_resopnseTime": "{num} ระดับเวลาตอบสนองความถี่ต่ำ  ",
  "custom50": "User defined_Custom50  ",
  "sidebar.endbenutzer": "ผู้ใช้  ",
  "bw_RTparam_name_GridTotalActivePower": "กำลังงานรวมของกริด  ",
  "ESB-Micro": "Ireland_ESB-Micro  ",
  "subtitle.localDebug": "การดีบั๊กใกล้ปลายทาง  ",
  "agent.input_language": "กรุณาเลือกภาษา  ",
  "tip.plant.comprehensive": "การจัดเรียงแบบครอบคลุม  ",
  "tip.ops.restartDatalogger": "คุณแน่ใจหรือไม่ว่าต้องการรีสตาร์ท Dongle?  ",
  "subtitle.totalRevenue": "รายได้รวม  ",
  "Upgrade.endtime": "เวลาสิ้นสุด  ",
  "product.ApplicationList": "รายการผลิตภัณฑ์  ",
  "bw_param_ctrl_name_ChargeCutSoc": "จุดสิ้นสุดการชาร์จ SOC",
  "setting.type12.LEDSwitch": "สวิตช์ LED  ",
  "tip.userLocation": "ตำแหน่งของผู้ใช้  ",
  "product.productImage": "รูปภาพผลิตภัณฑ์  ",
  "storage.v2.65284.dcOutputPower": "กำลังงาน DC output  ",
  "subtitle.year": "ปี  ",
  "custom60": "User defined_Custom60  ",
  "bw_RTparam_name_PSSILevel": "ระดับ PSSI  ",
  "ywt.65323.loadCurrentA": "กระแสโหลด A  ",
  "ywt.65323.loadCurrentB": "กระแสโหลด B  ",
  "ywt.65323.loadCurrentC": "กระแสโหลด C  ",
  "subtitle.SN": "หมายเลขซีเรียล  ",
  "jl_param_ctrl_name_81<S2S-Time": "81<S2S-Time  ",
  "bw_RTparam_name_Locationofthehighesttemperaturebatterycellinthesystem": "ตำแหน่งเซลล์แบตเตอรี่ที่มีอุณหภูมิสูงสุดในระบบ  ",
  "ywt.65323.loadCPhaseActivePower": "กำลังงาน Active ของโหลดเฟส C  ",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "สวิตช์ช่องเวลา Charge Time Slot 3  ",
  "bw_param_ctrl_option_HybridMode": "โหมด Hybrid  ",
  "jl_param_ctrl_name_0E-FrequencyDeratingHysteresis": "0E-Frequency Derating Hysteresis  ",
  "form.shiptype": "ประเภทการจัดส่ง  ",
  "login.success": "เข้าสู่ระบบสำเร็จ  ",
  "common.50402.Planned": "การหยุดทำงานตามแผน  ",
  "jl_param_ctrl_option_06-South_Africa": "06 - แอฟริกาใต้",
  "common.50300.eday": "การผลิตไฟฟ้าวันนี้ (kWh)  ",
  "jl_param_ctrl_note_10minOvervoltageDefault": "รีเซ็ตการป้องกันแรงดันเกิน 10 นาทีที่เกี่ยวข้องกับรหัสกริด  ",
  "unc.65323.pv2Voltage": "แรงดันไฟฟ้าโซลาร์ 2",
  "subtitle.energyPrice": "ราคาไฟฟ้า  ",
  "storage.s3.65292.cPhaseActivePower": "กำลังไฟฟ้าที่ออกจากเฟส C",
  "bw_RTparam_name_DailyEnergyfromGrid": "ปริมาณการซื้อไฟในวันนี้",
  "tip.configurationState.connecting": "กำลังเชื่อมต่อ  ",
  "BRA-N": "Brazil_BRA-N  ",
  "jl_param_ctrl_name_InverterMaxOutputPowerSetting": "การตั้งค่ากำลังงานสูงสุดของอินเวอร์เตอร์  ",
  "mini.65290.onGridPower": "กำลังงาน Active  ",
  "datalog.methods_delete": "ลบ?  ",
  "tip.log.subscriptionEigenvalueFail": "เปิดใช้งานฟังก์ชันแจ้งเตือนเมื่อค่าคุณลักษณะของอุปกรณ์บลูทูธพลังงานต่ำเปลี่ยนแปลง, การสมัครค่าคุณลักษณะล้มเหลว  ",
  "Logs.type": "กรุณาเลือกประเภท  ",
  "hipment.devType": "ประเภทการพัฒนา  ",
  "jl_param_ctrl_option_LG_10H": "LG 10H  ",
  "Meter_in_Load_Eastron_Standard_3P_Meter": "มิเตอร์ในโหลด Eastron Standard 3P Meter  ",
  "product.not.exist": "ผลิตภัณฑ์ไม่มีอยู่  ",
  "ship.mdn.not.exist": "หมายเลขผลิตภัณฑ์ mdn ไม่มีอยู่  ",
  "register.lable.register": "รีจิสเตอร์  ",
  "solis.10001.uPv20": "PV Voltage -20  ",
  "productEquipment.warnMessage": "ข้อมูลการแจ้งเตือน  ",
  "login.password.length.error": "ความยาวรหัสผ่านต้องอยู่ระหว่าง 8-20 ตัวอักษร  ",
  "placeholder.searchPlantName": "ค้นหาชื่อโรงงาน  ",
  "placeholder.readAndAgree": "ฉันได้อ่านและยอมรับ  ",
  "solis.10001.uPv19": "PV Voltage -19  ",
  "solis.10001.uPv18": "PV Voltage -18  ",
  "jl_param_ctrl_option_LeadAcid": "แบตเตอรี่ตะกั่วกรด  ",
  "btn.download": "ดาวน์โหลดตัวอย่าง  ",
  "tip.log.locationService": "กรุณาเปิดใช้งานบริการตำแหน่งที่ตั้ง  ",
  "solis.10001.uPv11": "PV Voltage -11  ",
  "unc.65323.gridActivePower": "กำลังงาน Active ของกริด  ",
  "sidebar.device": "อุปกรณ์  ",
  "ISONE208A": "USA_ISONE208A  ",
  "solis.10001.uPv10": "PV Voltage -10  ",
  "solis.10001.uPv13": "PV Voltage -13  ",
  "device.electric.currentA": "กระแสอุปกรณ์ A  ",
  "solis.10001.uPv12": "PV Voltage -12  ",
  "solis.10001.uPv15": "PV Voltage -15  ",
  "solis.10001.uPv14": "PV Voltage -14  ",
  "solis.10001.uPv17": "PV Voltage -17  ",
  "solis.10001.uPv16": "PV Voltage -16  ",
  "device.chu": "แบตเตอรี่  ",
  "jl_param_ctrl_note_BackupPortReferenceVoltageSetting": "การตั้งค่าแรงดันอ้างอิงสำหรับพอร์ตสำรองเมื่ออินเวอร์เตอร์ทำงานในโหมดออฟกริด  ",
  "setting.type7.setVal.reset": "รีเซ็ต  ",
  "solis.10001.uPv31": "PV Voltage -31  ",
  "storage.s3.65292.bat10CellVol": "แรงดันเซลล์ 10  ",
  "jl_param_ctrl_option_NoBattery": "ไม่มีแบตเตอรี่  ",
  "solis.10001.uPv30": "PV Voltage -30  ",
  "subtitle.basicParam": "พารามิเตอร์พื้นฐาน  ",
  "jl_param_ctrl_name_PassiveModeSwitc": "สวิตช์โหมด Passive  ",
  "device.title": "การตั้งค่าอินเวอร์เตอร์  ",
  "solis.10001.uPv29": "PV Voltage -29  ",
  "subtitle.OutputPower": "กำลังงาน Output  ",
  "solis.10001.uPv22": "PV Voltage -22  ",
  "product.OwningUpperLevelParameterCategory": "หมวดหมู่พารามิเตอร์ระดับบน  ",
  "solis.10001.uPv21": "PV Voltage -21  ",
  "solis.10001.uPv24": "PV Voltage -24  ",
  "jl_param_ctrl_option_ZNTECH": "ZNTECH  ",
  "solis.10001.uPv23": "PV Voltage -23  ",
  "App.no": "ไม่  ",
  "solis.10001.uPv26": "PV Voltage -26  ",
  "solis.10001.uPv25": "PV Voltage -25  ",
  "it-IT": "อิตาลี  ",
  "solis.10001.uPv28": "PV Voltage -28  ",
  "solis.10001.uPv27": "PV Voltage -27  ",
  "upload.fileTypeError": "กรุณาเลือกรูปแบบไฟล์ที่ถูกต้อง  ",
  "sotrage.sotrage": "การตั้งค่าแบตเตอรี่  ",
  "jl_param_ctrl_name_81<S1": "81<S1  ",
  "plant.lable_StationType": "ประเภทฉาก  ",
  "unc.65323.powerFactor": "ตัวประกอบกำลัง  ",
  "placeholder.scanCodeAddPlant": "กรุณาสแกนโค้ดเพื่อเพิ่มโรงงาน!  ",
  "the.latest.version.was.not.found": "ไม่มีเวอร์ชันล่าสุด  ",
  "jl_param_ctrl_note_LimitedReactivePowerValue": "เพื่อตั้งค่าขีดจำกัดกำลังงาน Reactive ของอินเวอร์เตอร์  ",
  "setting.type7.batteryCapacity": "ความจุแบตเตอรี่  ",
  "unc.65323.ctApparentPower": "CT Apparent Power  ",
  "setting.type22.acOverVol2": "แรงดันเกิน AC ลำดับที่สอง (V)  ",
  "setting.type22.acOverVol1": "แรงดันเกิน AC ลำดับแรก (V)  ",
  "bw_param_ctrl_name_PVCapacityStorage": "ความจุการเก็บพลังงาน PV  ",
  "jl_param_ctrl_option_step mode": "โหมดขั้นตอน  ",
  "Upgrade.Inverter": "อินเวอร์เตอร์  ",
  "unc.65323.faultStatus2": "สถานะข้อผิดพลาด 2  ",
  "unc.65323.faultStatus1": "สถานะข้อผิดพลาด 1  ",
  "setting.type7.clearHistory": "ลบประวัติ  ",
  "subtitle.parameter": "พารามิเตอร์  ",
  "jl_param_ctrl_note_ParallelMode": "เพื่อตั้งค่าหากอินเวอร์เตอร์ทำงานในโหมดเดี่ยวหรือโหมดขนาน  ",
  "tip.ops.setDomainName": "คุณแน่ใจหรือไม่ว่าต้องการตั้งชื่อโดเมนนี้?  ",
  "storage.s3.65292.acTotalEnergy": "กำลังงาน AC สะสม  ",
  "jl_param_ctrl_name_TotalNumberOfHybridInvertersConnected": "จำนวนอินเวอร์เตอร์ Hybrid ที่เชื่อมต่อ  ",
  "validate.retrieve.passwordEnteredTwiceInconsistent": "รหัสผ่านไม่ตรงกัน  ",
  "setting.type22.activePercentage": "เปอร์เซ็นต์ Merit  ",
  "supplier.type.nep": "NEP  ",
  "subtitle.BatteryBMSActivationCommand": "คำสั่งเปิดใช้งาน BMS ของแบตเตอรี่  ",
  "bw_RTparam_name_charging": "อนุญาตให้ชาร์จและไม่อนุญาตให้คายประจุ  ",
  "placeholder.enterPVCapacity": "กรุณาใส่ความจุ PV  ",
  "device.readWrite": "เครื่องมือ Direct Read-Write  ",
  "End_user.lable_StationType": "ประเภทฉาก  ",
  "Upgrade.datalog": "Dongle  ",
  "mini.65290.tmp": "อุณหภูมิอินเวอร์เตอร์(℃)  ",
  "plant.selfSufficientPower": "กำลังงาน Self-Sufficiency  ",
  "jl_param_ctrl_name_AFCIProtect": "การป้องกัน AFCI  ",
  "tip.messageInfo.microInverter": "Micro reverse  ",
  "bw_RTparam_name_TotalApparentPower_PV": "กำลังงาน Apparent รวม (PV)  ",
  "jl_param_ctrl_option_InverterOnAndOffGridSignal": "สัญญาณอินเวอร์เตอร์ On และ Off Grid  ",
  "ywt.65323.load2GeneratorAPhaseActivePower": "กำลังงาน Active ของโหลด 2/Generator เฟส A  ",
  "tip.log.communicationException": "การสื่อสารบลูทูธผิดปกติ, กรุณาเชื่อมต่อบลูทูธใหม่  ",
  "device.userReceiveDate": "วันที่ผู้ใช้รับข้อมูล  ",
  "product.name": "ซีรีส์ผลิตภัณฑ์",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "กำลังงาน Active ที่เชื่อมต่อกับกริดไม่สามารถเกินกำลังงานสูงสุดของรุ่นผลิตภัณฑ์ที่เลือก  ",
  "LTU-1": "Lithuania_LTU-1  ",
  "tip.home.socketPower": "โหลดซ็อกเก็ต  ",
  "setting.type12.batteryParam": "พารามิเตอร์แบตเตอรี่  ",
  "common.50300.creationDate": "เวลาข้อมูลล่าสุด  ",
  "LTU-2": "Lithuania_LTU-2  ",
  "jl_param_ctrl_note_ACCoulplingMax.fre": "ความถี่สูงสุดที่อนุญาตในระบบสำหรับควบคุมการผลิตไฟฟ้าของอินเวอร์เตอร์ PV  ",
  "jl_param_ctrl_group_GridCodeSetting-PowerLimit": "การตั้งค่ารหัสกริด-ขีดจำกัดกำลังงาน  ",
  "tip.log.stopSearch": "หยุดค้นหาบลูทูธรอบข้าง  ",
  "common.50100.pv4CumulativePowerGeneration": "PV4 Total Yield  ",
  "tip.plant.installationDateMin": "วันที่ติดตั้งล่าสุด  ",
  "common.50402.vpv10": "vpv10  ",
  "btn.edit": "แก้ไข  ",
  "ywt.65323.batChargeVoltage": "แรงดันชาร์จ  ",
  "common.50402.vpv12": "vpv12  ",
  "common.50402.vpv11": "vpv11  ",
  "bw_RTparam_name_State": "สถานะ  ",
  "jl_param_ctrl_name_13H-FrequencyDeratingResponseTime": "13H-Frequency Derating Response Time  ",
  "common.submit": "ส่ง  ",
  "bw_param_ctrl_name_DispatchTime": "เวลาการส่ง  ",
  "mini.65290.stOV_Temp": "การป้องกันอุณหภูมิเกินของอินเวอร์เตอร์  ",
  "jl_param_ctrl_name_BatteryReserveSwitch": "สวิตช์สำรองแบตเตอรี่  ",
  "plant.electricityConsumptionMonth": "ผลผลิตเดือนนี้  ",
  "setting.type6.open": "เปิด  ",
  "setting.type3.systemSetting": "การตั้งค่าระบบ  ",
  "tip.validate.newPassword": "รหัสผ่านใหม่ไม่สามารถว่างเปล่า, กรุณาใส่รหัสผ่านใหม่  ",
  "agent.agent_delete": "ลบตัวแทน?  ",
  "role.submit": "ส่ง  ",
  "UL-208V-A": "USA_UL-208V-A  ",
  "storage.s3.65292.batChargePower": "กำลังงานชาร์จแบตเตอรี่  ",
  "subtitle.manuallyAdd": "เพิ่มด้วยตนเอง  ",
  "jl_param_ctrl_name_GridStandardPrecision": "ความแม่นยำมาตรฐานกริด  ",
  "tip.currentNoDatalog": "ไม่มี Dongle ที่ใช้งานได้  ",
  "home.echarts1.title": "ผู้ใช้ที่ลงทะเบียน  ",
  "GNHN-B": "China_GNHN-B  ",
  "GNHN-A": "China_GNHN-A  ",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "สวิตช์ช่องเวลา Charge Time Slot 5  ",
  "storage.s3.65292.batTemp": "อุณหภูมิแบตเตอรี่(℃)  ",
  "datalog.span_info": "ข้อมูล  ",
  "unc.65323.batteryCurrent": "กระแสแบตเตอรี่  ",
  "tip.device.power": "กำลังงาน  ",
  "bw_param_ctrl_name_DispatchStart": "เวลาเริ่มต้นการส่ง  ",
  "jl_param_ctrl_name_G100BackflowCurrent": "กระแสย้อนกลับ G100  ",
  "NewZeal": "Australia_NewZeal  ",
  "unc.65323.ctTotalActivePower": "กำลังงาน Active รวมของ CT  ",
  "ywt.65323.spiAutoTestThresholdF4": "เกณฑ์การทดสอบอัตโนมัติ SPI F<<  ",
  "ywt.65323.spiAutoTestThresholdF3": "เกณฑ์การทดสอบอัตโนมัติ SPI F<  ",
  "solis.10001.batteryHealthSoh": "Battery SOH  ",
  "setting.type11.offGridMaxDisChargeCur": "กระแสคายประจุสูงสุดออฟกริด (A)  ",
  "bw_RTparam_name_Minimumtemperatureofbattery": "อุณหภูมิต่ำสุดสูงสุด  ",
  "ywt.65323.spiAutoTestThresholdF2": "เกณฑ์การทดสอบอัตโนมัติ SPI F>>  ",
  "ywt.65323.spiAutoTestThresholdF1": "เกณฑ์การทดสอบอัตโนมัติ SPI F>>  ",
  "unc.65323.todayFeedInGridEnergy": "พลังงานที่ป้อนเข้าสู่กริดวันนี้  ",
  "unc.65323.ctBPhaseActivePower": "กำลังงาน Active ของเฟส B ของ CT  ",
  "ywt.65323.ctStatus": "สถานะ EM  ",
  "bw_RTparam_name_RSSI": "RSSI  ",
  "device.deviceRegisterDate": "วันที่ลงทะเบียนอุปกรณ์  ",
  "setting.type10.timeSharingGridConnection": "การตั้งค่าเชื่อมต่อกริดตามเวลา  ",
  "button.cancle": "ยกเลิก  ",
  "bw_RTparam_name_LANIP": "LAN IP  ",
  "End_user.input_PVCapacity": "กรุณาใส่ความจุแบตเตอรี่  ",
  "setting.ops15.workMode": "โหมดการทำงาน  ",
  "home.echarts3.title": "เพิ่มตัวแทน  ",
  "common.50402.PV27_V": "PV27 Voltage  ",
  "product.subType": "ประเภทย่อย  ",
  "ywt.65323.returnFlowPortCPhaseActivePower": "กำลังงาน Active ของเฟส C ที่พอร์ตย้อนกลับ  ",
  "solis.10001.uPv32": "PV Voltage -32  ",
  "bw_param_ctrl_option_withBattery": "มีแบตเตอรี่  ",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "การบริโภคทั้งหมดของ Load2/Generator  ",
  "KS2": "Korea_KS2  ",
  "common.50402.PV27_I": "กระแส PV27  ",
  "KS3": "Korea_KS3  ",
  "solis.10001.gridPurchasedTodayEnergy": "Daily Imported  ",
  "tip.energy.tip1.solar": "แปลงพลังงานแสงอาทิตย์เป็นพลังงานไฟฟ้าเพื่อชาร์จแบตเตอรี่หรือจ่ายพลังงานให้กับโหลด  ",
  "sidebar.default": "หน้าสำหรับการนำทาง  ",
  "App.Whether_update": "จำเป็นต้องอัปเดตหรือไม่  ",
  "bw_RTparam_name_photovoltaics": "CT ใช้สำหรับกริดและโซลาร์เซลล์  ",
  "agent.delete": "ลบ  ",
  "setting.type7.reset": "รีเซ็ตการควบคุม  ",
  "common.50300.tempperature": "อุณหภูมิ(℃)  ",
  "jl_param_ctrl_option_08-US_Rule21Phase3": "08-US Rule21Phase3  ",
  "setting.ops15.timingTime": "เวลาตามกำหนด  ",
  "storage.s3.65292.cChargeActivePower": "กำลังงาน Active ของเฟส C  ",
  "subtitle.socket": "ซ็อกเก็ต  ",
  "jl_param_ctrl_name_ParallelMode": "โหมดขนาน  ",
  "subtitle.ready": "อ่าน  ",
  "setting.socket.wednesday": "วันพุธ  ",
  "NA-EEA-A": "Switzerland_NA-EEA-A  ",
  "form.input_StationName_plant": "กรุณาใส่ชื่อโรงงาน  ",
  "login.email": "อีเมล  ",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "สวิตช์ช่องเวลา Discharge Time Slot 1  ",
  "setting.type22.setFunctionSelect.val2": "เปิดใช้งานมาตรการป้องกันการย้อนกลับ  ",
  "setting.type22.setFunctionSelect.val1": "ห้าม  ",
  "common.50402.PV14_I": "กระแส PV14  ",
  "jl_param_ctrl_name_0E-FrequencyDeratingSlope(Fdroop)": "0E-Frequency Derating Slope(Fdroop)  ",
  "product.unit": "หน่วย  ",
  "setting.type12.outputParam": "พารามิเตอร์ Output  ",
  "bw_param_ctrl_name_UPSreserveenable": "เปิดใช้งาน UPS สำรอง  ",
  "title.message": "ข่าวสาร  ",
  "unc.65323.batTodayDischargeEnergy": "พลังงานที่คายประจุวันนี้  ",
  "button.close": "ปิด  ",
  "device.read_data": "อ่านข้อมูลรีจิสเตอร์:  ",
  "product.reset": "รีเซ็ต  ",
  "ywt.65323.batteryVoltage": "แรงดันแบตเตอรี่  ",
  "common.50402.CAPACITY": "ความจุ  ",
  "device.input_end_read": "สิ้นสุดที่อยู่รีจิสเตอร์  ",
  "KS1": "Korea_KS1  ",
  "product.UploadUpTo9Photos": "อัปโหลดรูปภาพสูงสุด 9 รูป  ",
  "form.input_station_plant": "กรุณาใส่ชื่อโรงงาน  ",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFdstart": "03&0E-Underfrequency Ramping Fdstart  ",
  "form.input_station": "กรุณาใส่ชื่อฉาก  ",
  "unc.65323.negativeElectrodeInsulationImpedance": "อิมพีแดนซ์ฉนวนขั้วลบ  ",
  "common.50402.PV14_V": "แรงดัน PV14  ",
  "title.userAgreement": "ข้อตกลงผู้ใช้  ",
  "tip.log.server03": "มีการแลกเปลี่ยนข้อมูล 03  ",
  "setting.type12.val.outPutSourcePriority3": "พลังงานแสงอาทิตย์ -> แบตเตอรี่ -> พลังงานหลัก  ",
  "setting.type12.val.outPutSourcePriority2": "ให้ความสำคัญกับพลังงานแสงอาทิตย์  ",
  "setting.type12.val.outPutSourcePriority1": "ให้ความสำคัญกับพลังงานหลัก  ",
  "tip.log.server04": "มีการแลกเปลี่ยนข้อมูล 04  ",
  "jl_param_ctrl_option_05-Brazil": "05-Brazil  ",
  "plant.operatingData": "ข้อมูลการดำเนินงาน  ",
  "storage.s3.65292.batTotalDischargeEnergy": "พลังงานที่คายประจุทั้งหมด  ",
  "bw_RTparam_name_offline": "ออฟไลน์  ",
  "setting.type22.acOverFrequency2": "ความถี่เกิน AC ลำดับที่สอง (Hz)  ",
  "subtitle.PVCapacity": "ความจุ PV  ",
  "ship.search": "ค้นหา  ",
  "setting.type22.acOverFrequency1": "ความถี่เกิน AC ลำดับแรก (Hz)  ",
  "button.SendVerificationCode": "ส่งรหัสยืนยัน  ",
  "tip.plant.installationDateMax": "วันที่ติดตั้งที่ไกลที่สุด  ",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFpmax": "01-Underfrequency Ramping Fpmax  ",
  "solis.10001.dcPac": "กำลังงาน Input รวมของอินเวอร์เตอร์  ",
  "storage.s3.65292.mainsBpCurrent": "กระแสเฟส B ของ Utility  ",
  "upload.fileSizeExceed": "ขนาดรูปภาพที่อัปโหลดไม่สามารถเกิน  ",
  "EN50549TR": "Turkey_EN50549TR  ",
  "common.50300.istr3": "กระแสสาย 3  ",
  "common.50300.istr4": "กระแสสาย 4  ",
  "common.50300.istr5": "กระแสสาย 5  ",
  "common.50300.istr6": "กระแสสาย 6  ",
  "jl_param_ctrl_name_Peak-shavingSwitch": "สวิตช์ Peak-shaving  ",
  "common.50300.istr1": "กระแสสาย 1  ",
  "common.50300.istr2": "กระแสสาย 2  ",
  "tip.log.queryWiFiState": "ส่งคำสั่งสอบถามรายการ WiFi สำเร็จ  ",
  "setting.type7.chargingLimitVoltage": "แรงดันจำกัดการชาร์จ  ",
  "jl_param_ctrl_name_ForcechargeSOC": "Forcecharge SOC  ",
  "storage.s3.65292.invPower": "กำลังงานอินเวอร์เตอร์  ",
  "button.edit": "แก้ไข  ",
  "mini.65290.stPV6_UV": "PV input 6 underVoltage  ",
  "jl_param_ctrl_option_51.2VLithiumbatteryLV": "แบตเตอรี่ลิเธียม 51.2V LV  ",
  "common.50402.PV5_V": "PV5 Voltage  ",
  "product.ParameterDataType": "ประเภทข้อมูลพารามิเตอร์  ",
  "device.maxFour": "หน่วยไม่สามารถเกิน 4 ประเภท  ",
  "setting.type12.batType": "ประเภทแบตเตอรี่  ",
  "storage.v2.65284.batterySOC": "ความจุแบตเตอรี่ที่เหลือ SOC  ",
  "bw_param_ctrl_option_selfuse": "ใช้เอง  ",
  "bw_param_ctrl_option_DCMode": "โหมด DC  ",
  "ywt.65323.pvAnnualEnergy": "ผลผลิตประจำปี  ",
  "bw_RTparam_name_ApparentPOBP_Grid": "กำลังงาน Apparent ของเฟส B (กริด)  ",
  "common.50402.PV5_I": "กระแส PV5  ",
  "jl_param_ctrl_option_14H-AU_FCAS": "14H-AU FCAS  ",
  "plant.input_station": "กรุณาใส่ชื่อฉาก  ",
  "common.50300.istr7": "กระแสสาย 7  ",
  "common.50300.istr8": "กระแสสาย 8  ",
  "common.50300.istr9": "กระแสสาย 9  ",
  "setting.type3.stopDischarge": "ค่าตั้งค่าหยุดคายประจุ SOC ต่ำสุด  ",
  "tip.validate.integer": "ต้องเป็นจำนวนเต็ม  ",
  "bw_RTparam_name_Systemminimumtemperaturecellserialnumber": "หมายเลขซีเรียลเซลล์อุณหภูมิต่ำสุดของระบบ  ",
  "button.logOut": "ออกจากระบบ  ",
  "plant.photovoltaicPowerGenerations": "ผลผลิต PV รวม  ",
  "bw_param_ctrl_name_PV_Meter_negate": "ทิศทางมิเตอร์ PV  ",
  "ywt.65323.gridCurrentB": "กระแสกริด B  ",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "ความจุ PV ของอินเวอร์เตอร์กริด  ",
  "ywt.65323.gridCurrentC": "กระแสกริด C  ",
  "setting.type10.standbyMode": "โหมดสำรอง  ",
  "setting.type12.batEquTime": "เวลาเฉลี่ยการชาร์จแบตเตอรี่ (นาที)  ",
  "ywt.65323.gridCurrentA": "กระแสกริด A  ",
  "jl_param_ctrl_option_Power-Q": "Power-Q  ",
  "ywt.65323.totalFeedInGridEnergy": "พลังงานที่จ่ายให้กริดสะสม  ",
  "jl_param_ctrl_group_ParallelSetting": "การตั้งค่าแบบขนาน  ",
  "setting.type11.minSocBMS": "SOC ต่ำสุดของ BMS (%)  ",
  "Meter_in_Load_Acrel_3P_Meter": "มิเตอร์ในโหลด Acrel 3P Meter  ",
  "role.addTip": "สนับสนุนการกำหนดค่าสิทธิ์สำหรับผู้ใช้เว็บและแอป B-end แต่ไม่รวมผู้ใช้แอป C-end  ",
  "common.fail": "ล้มเหลว  ",
  "solis.10001.averagePowerFactor": "ตัวประกอบกำลังมิเตอร์ A  ",
  "button.upload": "อัปโหลด  ",
  "subtitle.level": "ความรุนแรง  ",
  "jl_param_ctrl_name_Recover-VL": "Recover-VL  ",
  "jl_param_ctrl_name_Recover-VH": "Recover-VH  ",
  "ywt.65323.gridCPhaseActivePower": "กำลังงาน Active ของเฟส C ในกริดไฟฟ้า  ",
  "tip.home.off-gridPower": "โหลดออฟกริด  ",
  "product.scope": "ขอบเขต  ",
  "jl_param_ctrl_name_MeterTypeandInstallationLocation": "ประเภทมิเตอร์  ",
  "mini.65290.activePower": "กำลังงาน Active  ",
  "unc.65323.gridApparentPower": "กำลังงาน Apparent ของกริด  ",
  "solis.10001.uPv1": "PV Voltage -1  ",
  "setting.type12.val.percentageLoad": "เปอร์เซ็นต์โหลด  ",
  "solis.10001.gridSellTodayEnergy": "Daily Exported  ",
  "solis.10001.uPv2": "PV Voltage -2  ",
  "solis.10001.uPv3": "PV Voltage -3  ",
  "solis.10001.uPv4": "PV Voltage -4  ",
  "solis.10001.uPv5": "PV Voltage -5  ",
  "solis.10001.uPv6": "PV Voltage -6  ",
  "solis.10001.uPv7": "PV Voltage -7  ",
  "solis.10001.eMonth": "ผลผลิตประจำเดือน  ",
  "solis.10001.uPv8": "PV Voltage -8  ",
  "solis.10001.uPv9": "PV Voltage -9  ",
  "bw_RTparam_name_Systemmaximumvoltagecellserialnumber": "หมายเลขซีเรียลเซลล์แรงดันสูงสุดของระบบ  ",
  "solis.10001.bveragePowerFactor": "ตัวประกอบกำลังมิเตอร์ B  ",
  "jl_param_ctrl_name_Pcharge": "Pcharge  ",
  "ywt.65323.batTodayDischargeEnergy": "พลังงานที่คายประจุทั้งหมด  ",
  "plant.plantName": "ชื่อโรงงาน  ",
  "Tips.yes": "ใช่  ",
  "bw_RTparam_name_TotalActivePower_PV": "กำลังงาน Active รวม (PV)  ",
  "jl_param_ctrl_note_ACCoupling_OFF_SOC": "สนับสนุนเฉพาะแบตเตอรี่ลิเธียม  ",
  "ywt.65323.spiAutoTestTimeF1": "เวลาการทดสอบอัตโนมัติ SPI F>>  ",
  "ywt.65323.spiAutoTestTimeF2": "เวลาการทดสอบอัตโนมัติ SPI F>  ",
  "jl_param_ctrl_note_AutoBatAwakenTimeSetting": "การตั้งค่าเวลาตื่น  ",
  "ywt.65323.spiAutoTestTimeF3": "เวลาการทดสอบอัตโนมัติ SPI F<  ",
  "ywt.65323.spiAutoTestTimeF4": "เวลาการทดสอบอัตโนมัติ SPI F<<  ",
  "bw_RTparam_name_TodayGridLoadConsumption": "การบริโภคโหลดกริดวันนี้  ",
  "jl_param_ctrl_option_00-NO": "00-NO  ",
  "subtitle.BatterySOC": "SOC ของแบตเตอรี่  ",
  "storage.s3.65292.aPhaseOnGridPower": "กำลังงานที่มีในกริดเฟส A  ",
  "jl_param_ctrl_name_0C&0A-FrequencyDeratingSlope(Fdroop)": "0C&0A-Frequency Derating Slope(Fdroop)  ",
  "jl_param_ctrl_name_MPPTMulti-peakScanInterval": "ช่วงเวลาสแกนหลายยอด MPPT  ",
  "unc.65323.ctFrequency": "ความถี่ CT  ",
  "tip.log.closeFail": "ไม่สามารถตัดการเชื่อมต่อบลูทูธได้  ",
  "common.required": "จำเป็น  ",
  "device.datalogSn": "กรุณาใส่หมายเลขซีเรียลของ Dongle  ",
  "jl_param_ctrl_name_AutoBatAwakenTimeSetting": "การตั้งค่าเวลาตื่นแบตเตอรี่อัตโนมัติ  ",
  "tip.configurationState.connectSuccess": "เชื่อมต่อสำเร็จ  ",
  "storage.s3.65292.pv1Current": "กระแส PV1  ",
  "org.parent": "องค์กร Superior",
  "datalog.sn": "Datalog SN  ",
  "setting.type7.factory": "คืนค่าเป็นค่าโรงงาน  ",
  "jl_param_ctrl_name_StartChargingSOC": "SOC เริ่มต้นการชาร์จ  ",
  "storage.s3.65292.loadTotalEnergy": "กำลังงานโหลดสะสม  ",
  "title.createAccount": "สร้างบัญชี  ",
  "EN50549IE": "Ireland_EN50549IE  ",
  "jl_param_ctrl_note_BatteryWakeupVoltageSetting": "การตั้งค่าแรงดันตื่น  ",
  "unc.65323.pv4Power": "กำลังงาน PV4  ",
  "setting.type7.equalizingChargeCmd": "ชาร์จทันทีและสมดุล  ",
  "button.rememberMe": "จำรหัสผ่านบัญชี  ",
  "ywt.65323.pv3Power": "กำลังงาน PV 3  ",
  "dept.not.exist": "ข้อมูลแผนกไม่มีอยู่  ",
  "bw_RTparam_name_TotalEnergyfromGrid": "Total Imported  ",
  "jl_param_ctrl_name_BatteryWakeupSwitch": "สวิตช์ตื่นแบตเตอรี่  ",
  "org.orgName": "ชื่อองค์กร  ",
  "jl_param_ctrl_option_FixReactive": "แก้ไข Reactive  ",
  "Special.Examples": "ตัวอย่าง: (2305210230,2305210139)  ",
  "tip.home.on-gridPower": "กำลังงานที่เชื่อมต่อกับกริด  ",
  "tip.log.noInteraction": "ไม่มีปฏิสัมพันธ์ข้อมูล  ",
  "subtitle.today": "วัน  ",
  "setting.type6.poweradjppm": "อัตราการควบคุมกำลังงานอินเวอร์เตอร์  ",
  "tip.plant.paramChoice": "การเลือกพารามิเตอร์  ",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "เปิดใช้งานเฉพาะการควบคุมช่วงเวลาคายประจุ  ",
  "subtitle.areYouSure": "คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ต  ",
  "bw_RTparam_name_ChargeCutSoc": "Charge Cut Soc  ",
  "mdn.exist": "หมายเลขวัสดุ mdn มีอยู่แล้ว, ไม่ต้องเพิ่มอีก  ",
  "plant.sunriseSunset": "พระอาทิตย์ขึ้นและพระอาทิตย์ตก  ",
  "ywt.65323.ctApparentPower": "กำลังงาน Apparent ของ EM  ",
  "plant.installer": "องค์กร  ",
  "jl_param_ctrl_name_Max.usableGridPower": "กำลังงานกริดที่ใช้งานได้สูงสุด  ",
  "unc.65323.returnFlowPortVoltageC": "แรงดันพอร์ตย้อนกลับ C  ",
  "unc.65323.returnFlowPortVoltageB": "แรงดันพอร์ตย้อนกลับ B  ",
  "plant.input_StationType": "กรุณาเลือกประเภท  ",
  "unc.65323.returnFlowPortVoltageA": "แรงดันพอร์ตย้อนกลับ A  ",
  "jl_param_ctrl_option_48VLithiumBattery_WithoutCOMM": "แบตเตอรี่ลิเธียม 48V (ไม่มี COMM)  ",
  "sidebar.personal": "ข้อมูลผู้ใช้  ",
  "solis.10001.bphasePowerFactor": "กำลังงาน Active มิเตอร์ B  ",
  "EN50549PO": "Global_EN50549PO  ",
  "placeholder.confirmPassword": "กรุณายืนยันรหัสผ่าน  ",
  "tip.plant.totalEnergyMax": "การบริโภคพลังงานรวมสูงสุด  ",
  "button.send": "ส่งออก  ",
  "common.50402.dispatch": "dispatch  ",
  "device.btn_read": "อ่าน  ",
  "General60": "User defined_General 60  ",
  "setting.socket.thursday": "วันพฤหัสบดี  ",
  "setting.type12.maxChargingCur": "กระแสชาร์จสูงสุด  ",
  "unc.65323.batChargeVoltage": "แรงดันชาร์จแบตเตอรี่  ",
  "placeholder.choiceInstallationDate": "กรุณาเลือกวันที่ติดตั้ง  ",
  "agent.title_edit": "แก้ไขตัวแทน  ",
  "subtitle.selectTimezone": "เลือกเขตเวลา  ",
  "home.echarts5.title": "เพิ่ม Dongle  ",
  "setting.type6.UV_resopnseTime": "{num} ระดับเวลาตอบสนองแรงดันต่ำ  ",
  "datalog.no": "ไม่  ",
  "product.AssociatedPowerStationState": "สถานะโรงงานที่เกี่ยวข้อง  ",
  "subtitle.toggle": "สวิตช์  ",
  "General50": "User defined_General 50  ",
  "ship.mdn.not.empty": "Mdn ไม่สามารถว่างเปล่า  ",
  "device.totalFrequency": "ความถี่รวม  ",
  "storage.s3.65292.aPhaseActivePower": "กำลังงาน Active ของเฟส A output  ",
  "setting.type12.val.additionalPower": "กำลังงานเพิ่มเติม  ",
  "End_user.input_IncomeUnit": "เลือกหน่วยรายได้  ",
  "End_user.no": "ไม่  ",
  "storage.s3.65292.bat12CellVol": "แรงดันเซลล์ 12  ",
  "unc.65323.pv5Current": "กระแส PV5  ",
  "storage.s3.65292.pvPower": "กำลังงาน PV  ",
  "EN50549NL": "Netherlands_EN50549NL  ",
  "bw_RTparam_name_VoltageOfBPhase_PV": "กระแสเฟส A (PV)  ",
  "common.50402.PV13_I": "กระแส PV13  ",
  "jl_param_ctrl_option_B_BOX_LVBYD": "B_BOX_LV BYD  ",
  "placeholder.city": "เมือง  ",
  "setting.type7.inverter485Address": "ที่อยู่ 485  ",
  "storage.s3.65292.batCurrent": "กระแสแบตเตอรี่  ",
  "device.btn_close": "กลับ  ",
  "bw_RTparam_name_PackIDofMaxCellTemperature": "Pack ID ของเซลล์อุณหภูมิสูงสุด  ",
  "ywt.65323.clsStatus": "สถานะ CLS  ",
  "tip.log.getFeatureValuesSucess": "ได้รับค่าคุณลักษณะทั้งหมดในบริการที่กำหนดของบลูทูธสำเร็จ",
  "End_user.title_delete": "ลบ?",
  "placeholder.enterNewPassword": "กรุณาป้อนรหัสผ่านใหม่",
  "jl_param_ctrl_name_Restore-T": "Restore-T",
  "menu.edit.parent": "การแก้ไขเมนู '%s' ล้มเหลว เมนูชั้นบนไม่สามารถเลือกตัวเองได้",
  "product.sort": "การจัดลำดับ",
  "tip.validate.pvCapacity": "ความจุแบตเตอรี่พลังงานแสงอาทิตย์ไม่สามารถเป็นค่าว่าง กรุณาป้อนความจุแบตเตอรี่",
  "common.50402.PV13_V": "แรงดันไฟฟ้า PV13",
  "unc.65323.load2GeneratorBPhaseActivePower": "กำลังไฟฟ้าประกอบเฟส B ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "title.phone": "โทรศัพท์",
  "device.mutipleRead": "อ่านข้อมูลเป็นกลุ่ม",
  "subtitle.version": "เวอร์ชัน",
  "product.FileAddress": "ที่อยู่ไฟล์",
  "storage.s3.65292.batChargeLimitVol": "ค่ากำหนดการแรงดันไฟฟ้าของการชาร์จแบตเตอรี่",
  "mini.65290.stPV1_UV": "แรงดันไฟฟ้า PV 1 ต่ำเกินไป",
  "jl_param_ctrl_name_27.S1Time": "27.S1 Time",
  "bw_RTparam_name_ReactivePOBP_Grid": "กำลังไฟฟ้าไม่ประกอบของมิเตอร์ไฟฟ้า B",
  "unc.65323.ctPowerFactor": "ปัจจัยกำลังของมิเตอร์ไฟฟ้า",
  "device.setting": "การตั้งค่า",
  "product.equipment": "อุปกรณ์",
  "solis.10001.aReactivePower": "กำลังไฟฟ้าไม่ประกอบของมิเตอร์ไฟฟ้า A",
  "device.noDeviceDetail": "ยังไม่มีรายละเอียดอุปกรณ์",
  "storage.s3.65292.batSOC": "ปริมาณพลังงานที่เหลือของแบตเตอรี่ SOC",
  "bw_RTparam_name_PackIDofMinCellTemperature": "หมายเลขอุณหภูมิลดสุดของโมดูลแบตเตอร์ในระบบ",
  "storage.s3.65292.cPhaseCurrent": "กระแสไฟฟ้าเอาต์พุตเฟส C",
  "subtitle.offline": "ออฟไลน์",
  "jl_param_ctrl_group_AdvancedSetting-Meter.CTSetting": "การตั้งค่าขั้นสูง - การตั้งค่ามิเตอร์ไฟฟ้า/CT",
  "setting.type12.val.fast": "เร็ว",
  "jl_param_ctrl_name_FrequencyDeratingDefault": "การตั้งค่ากลับค่าเริ่มต้นของการลดโหลดความถี่",
  "jl_param_ctrl_option_48VLithiumbatteryLV": "แบตเตอรี่ลิเธียม 48V LV",
  "product.ImportDeviceList": "นำเข้าบัญชีรายชื่ออุปกรณ์",
  "jl_param_ctrl_option_AlphaHV": "Alpha HV",
  "Special.save": "บันทึก",
  "device.saveFail": "การส่งพารามิเตอร์ล้มเหลว",
  "plant.noIncomeTip": "เพื่อการคำนวณผลตอบแทนเทียบเท่าของคุณให้ดีขึ้น กรุณาป้อนราคาซื้อและขายไฟฟ้า",
  "bw_param_ctrl_name_RTC": "การตั้งค่าเวลาประกอบ",
  "tip.configurationState.wait": "กรุณารอสักครู่",
  "device.basicInfo": "ข้อมูลพื้นฐาน",
  "role.name": "ชื่อบทบาท",
  "setting.type10.ChargeDischargeTimeSetting": "การตั้งค่าเวลาชาร์จและเดินทาง",
  "jl_param_ctrl_option_CFELV": "CFE LV",
  "subtitle.OutputCurrent": "กระแสไฟฟ้าเอาต์พุต",
  "setting.type7.overVoltage": "แรงดันไฟฟ้าเกิน",
  "sidebar.datalog": "รายการเครื่องรับสัญญาณ",
  "unc.65323.spiAutoTestResult": "ผลการทดสอบอัตโนมัติของ SPI",
  "subtitle.ChargingEnabled": "การเปิดใช้งานการชาร์จ",
  "device.workMode": "โหมดการทำงาน",
  "socket.value": "กรุณาป้อนค่าการตั้งค่า",
  "bw_RTparam_name_GridPowerL3": "กำลังไฟฟ้าประกอบของระบบไฟฟ้า L3",
  "bw_RTparam_name_GridPowerL1": "กำลังไฟฟ้าประกอบของระบบไฟฟ้า L1",
  "jl_param_ctrl_name_0C-FrequencyDeratingFstart": "จุดความถี่เริ่มต้นการลดโหลด 0C",
  "subtitle.DischargeCurrentLimit(A)": "การจำกัดกระแสไฟฟ้าในการเดินทาง (A)",
  "bw_RTparam_name_GridPowerL2": "กำลังไฟฟ้าประกอบของระบบไฟฟ้า L2",
  "setting.type10.forcedDischarge": "เวลาการเดินทาง",
  "tip.home.acPower": "กำลังไฟฟ้าของระบบไฟฟ้า",
  "ywt.65323.pv2Power": "กำลังไฟฟ้าของโซลาร์ 2",
  "jl_param_ctrl_name_G100Switch": "สวิตช์ G100",
  "device.voltage": "แรงดันไฟฟ้า",
  "device.yuan": "แหล่งที่มาจากโซลาร์",
  "tip.addDatalogger.scan": "สแกนรหัส QR หรือป้อนหมายเลขซีเรียลของเครื่องรับสัญญาณด้วยตนเองใต้รหัส QR",
  "storage.v2.65284.dcOutputCurrent": "กระแสไฟฟ้าเอาต์พุต DC",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "สวิตช์ช่วงเวลาชาร์จ 1",
  "device.operationalDataAnalysis": "การวิเคราะห์ข้อมูลการทำงาน",
  "jl_param_ctrl_name_InverterConnectedPhaseSetting": "การตั้งค่าการเชื่อมต่อเฟสของอินเวอร์เตอร์",
  "mini.65290.Ipvmax": "กระแสไฟฟ้า PV สูงสุดที่สามารถรับได้",
  "form.shiptime": "เวลาออกสินค้า",
  "language.management": "การจัดการหลายภาษา",
  "ship.category.not.empty": "ประเภทสินค้าไม่สามารถเป็นค่าว่าง",
  "plant.powerConsumption": "ปริมาณการใช้ไฟฟ้า",
  "sidebar.firmware_log": "บันทึกการอัพเกรด",
  "bw_param_ctrl_option_Normal": "ปกติ",
  "50300_E-G3-0-1": "การป้องกันไฟฟ้าเกินแรงดันของระบบไฟฟ้า",
  "product.ProductDetailsSettings": "การตั้งค่ารายละเอียดผลิตภัณฑ์ Balcony 1",
  "jl_param_ctrl_name_BackupPortEnablingSetting": "การตั้งค่าการเปิดใช้งานพอร์ต Backup",
  "device.softUpdateTime": "เวลาการอัพเดทซอฟต์แวร์",
  "EN50549ES": "Estonia_EN50549ES",
  "device.search": "การค้นหา",
  "storage.s3.65292.socketPower9": "กำลังไฟฟ้าของสัญญาณ 9",
  "storage.s3.65292.socketPower8": "กำลังไฟฟ้าของสัญญาณ 8",
  "storage.s3.65292.socketPower7": "กำลังไฟฟ้าของสัญญาณ 7",
  "subtitle.NeedMoreHelp": "ความช่วยเหลือเพิ่มเติม",
  "storage.s3.65292.socketPower6": "กำลังไฟฟ้าของสัญญาณ 6",
  "plant.sellingPrice": "ราคาขายไฟฟ้า",
  "storage.s3.65292.socketPower5": "กำลังไฟฟ้าของสัญญาณ 5",
  "tip.log.wifiConenct": "กำลังตรวจสอบสถานะการเชื่อมต่อเส้นทาง",
  "storage.s3.65292.socketPower4": "กำลังไฟฟ้าของสัญญาณ 4",
  "product.inDevelopment": "กำลังพัฒนา",
  "storage.s3.65292.socketPower3": "กำลังไฟฟ้าของสัญญาณ 3",
  "storage.s3.65292.socketPower2": "กำลังไฟฟ้าของสัญญาณ 2",
  "storage.s3.65292.socketPower1": "กำลังไฟฟ้าของสัญญาณ 1",
  "ltcg_RTparam_group_Inverter": "อินเวอร์เตอร์",
  "bw_RTparam_name_TotalConsumptionPower": "กำลังไฟฟ้าทั้งหมดในการใช้งาน",
  "subtitle.OutputVoltage": "แรงดันไฟฟ้าเอาต์พุต",
  "unc.65323.todayConsumeEnergy": "ปริมาณการใช้ไฟฟ้าในวันนี้",
  "jl_param_ctrl_name_CTRatio": "อัตราส่วนการเปลี่ยนแปลงของ CT",
  "jl_param_ctrl_group_SmartPort-GENSetting": "การตั้งค่าการกำเนิดไฟฟ้า - พอร์ตอัจฉริยะ",
  "EN50549FI": "Finland_EN50549FI",
  "RENBLAD": "Norway_RENBLAD",
  "bw_RTparam_name_TotalYield": "ปริมาณการผลิตไฟฟ้าที่สะสม",
  "plant.input_Address": "กรุณาป้อนที่อยู่",
  "ltwn_RTparam_group_Inverter": "อินเวอร์เตอร์",
  "bw_RTparam_name_BatteryRunningTime": "เวลาการทำงานทั้งหมด",
  "UL-240V-18": "USA_UL - 240V - 18",
  "jl_param_ctrl_name_Startup-T": "Startup - T",
  "setting.type3.weekend": "วันหยุดสุดสัปดาห์",
  "tip.log.bluetoothPermission": "การเปิดใช้งาน Bluetooth",
  "subtitle.messageDetail": "รายละเอียดข้อความ",
  "solis.10001.eToday": "ปริมาณการผลิตไฟฟ้าในวัน",
  "jl_param_ctrl_option_09-Dubai": "09 - ดูไบ",
  "subtitle.ChargingPeriod": "ช่วงเวลาชาร์จ",
  "jl_param_ctrl_group_AdvancedSetting-MPPTMulti-peakScanningSet": "การตั้งค่าขั้นสูง - การตั้งค่าการสแกนคลื่นสองยอด",
  "tip.home.frontEndLoad": "โหลดด้านหน้า",
  "storage.s3.65292.batWorkStatus": "สถานะสวิตช์แบตเตอรี่",
  "login.enterpassword": "กรุณาป้อนรหัสผ่าน",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "ค่าขอบเขตการทดสอบอัตโนมัติของ SPI เฟส A U>>",
  "unc.65323.ctReactivePower": "กำลังไฟฟ้าไม่ประกอบของมิเตอร์ไฟฟ้า",
  "bw_RTparam_name_gridCT": "ระบบไฟฟ้าใช้ CT โซลาร์ใช้มิเตอร์ไฟฟ้า",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "ค่าขอบเขตการทดสอบอัตโนมัติของ SPI เฟส A U<<",
  "tip.validate.noSocketTimer": "ยังไม่มีตัวจับเวลาสัญญาณ กรุณาคลิกเพื่อเพิ่ม",
  "storage.s3.65292.bat15CellVol": "แรงดันไฟฟ้าของเซลล์แบตเตอรี่ 15",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "ค่าขอบเขตการทดสอบอัตโนมัติของ SPI เฟส A U<",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "ค่าขอบเขตการทดสอบอัตโนมัติของ SPI เฟส A U>10 นาที",
  "subtitle.plantType": "ประเภทโรงไฟฟ้า",
  "tip.validate.energyPrice": "ราคาซื้อไฟฟ้าไม่สามารถเป็นค่าว่าง กรุณาป้อนราคาซื้อไฟฟ้า",
  "ywt.65323.pv4Current": "กระแสไฟฟ้าโซลาร์ 4",
  "Firmware.select_folder_type": "กรุณาเลือกประเภทโฟลเดอร์",
  "supplier.type.styr": "การนำเข้าสถานะทางนิเวศ",
  "setting.type10.baudRate": "อัตราพอร์ต 485",
  "subtitle.CurrentPower": "กำลังไฟฟ้าปัจจุบัน",
  "jl_param_ctrl_group_WorkMode-Peak-shavingMode": "โหมดการทำงาน - โหมดลดยอด",
  "jl_param_ctrl_name_TimeSetting": "การตั้งค่าเวลา",
  "jl_param_ctrl_name_OnOff": "สวิตช์อินเวอร์เตอร์",
  "R14-208": "USA_R14 - 208",
  "storage.v2.65284.batteryVoltage": "แรงดันไฟฟ้าแบตเตอร์",
  "bw_RTparam_name_charge": "การใช้งานฟังก์ชันชาร์จและเดินทางยังไม่ได้เปิดใช้งาน",
  "tip.energy.tip3.Co2": "การลดปริมาณการปล่อยก๊าซคาร์บอนไดออกไซด์:",
  "plant.year": "ปัจจุบัน",
  "product.NewParameter": "พารามิเตอร์ใหม่",
  "subtitle.reset": "การตั้งค่ากลับค่าเริ่มต้น",
  "unc.65323.gridReactivePower": "กำลังไฟฟ้าไม่ประกอบของระบบไฟฟ้า",
  "agent.input_email": "กรุณาป้อนอีเมล",
  "subtitle.Co2": "คาร์บอนไดออกไซด์",
  "supplier.type.unc": "ยูเน็ตครีเอชั่น",
  "ship.deviceSn": "กรุณาป้อนหมายเลขซีเรียลของอุปกรณ์",
  "product.serialNumber": "หมายเลขซีเรียลผลิตภัณฑ์",
  "ywt.65323.drmStatus": "สถานะ DRM",
  "End_user.input_Energyprice": "กรุณาป้อนราคาต่อหน่วย",
  "tip.opsLog.recordLog": "อุปกรณ์ที่ต้องการบันทึกบันทึกเวลา",
  "common.50300.hTotal": "เวลาการผลิตไฟฟ้าที่สะสม",
  "agent.span": "ตัวอย่าง: เอกสาร Excel",
  "Firmware.uplad_folder": "การอัปโหลดไฟล์",
  "placeholder.enterPassword": "กรุณาป้อนรหัสผ่าน 6 - 20 ตัวอักษร",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "ปริมาณการใช้ไฟฟ้าในวันของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "tip.log.bluetoothNotPermission": "การไม่เปิดใช้งาน Bluetooth",
  "upload.needOpen": "ไฟล์นี้อาจต้องดาวน์โหลดเพื่อดู",
  "common.50402.Standby": "โหมดอยู่นิ่ง",
  "subtitle.selectInstallationDate": "การเลือกวันที่ติดตั้ง",
  "jl_param_ctrl_name_08-FrequencyDeratingFstop": "จุดความถี่สิ้นสุดการลดโหลด 08",
  "unc.65323.pv2Current": "กระแสไฟฟ้าโซลาร์ 2",
  "socket.setting_device": "การตั้งค่าพารามิเตอร์อินเวอร์เตอร์:",
  "product.updataManagement": "การจัดการการอัพเกรด",
  "common.50300.ipv6": "กระแสไฟฟ้า DC 6",
  "bw_RTparam_name_VoltageOfCPhase_PV": "แรงดันไฟฟ้าเฟส B ของมิเตอร์ไฟฟ้า",
  "common.50300.ipv7": "กระแสไฟฟ้า DC 7",
  "common.50300.ipv4": "กระแสไฟฟ้า DC 4",
  "common.50300.ipv5": "กระแสไฟฟ้า DC 5",
  "jl_param_ctrl_name_FeedinCurrentLimitValue": "ค่ากำหนดการการจำกัดกระแสไฟฟ้าเข้าสู่ระบบไฟฟ้า",
  "common.50300.ipv2": "กระแสไฟฟ้า DC 2",
  "common.50300.ipv3": "กระแสไฟฟ้า DC 3",
  "common.50300.ipv1": "กระแสไฟฟ้า DC 1",
  "tip.validate.city": "ชื่อเมืองไม่สามารถเป็นค่าว่าง กรุณาเลือกเมือง",
  "common.50100.pv3Voltage": "แรงดันไฟฟ้าเวลาจริงของ PV3",
  "jl_param_ctrl_note_FeedinCurrentLimitValue": "ค่ากำหนดการการจำกัดกระแสไฟฟ้าเข้าสู่ระบบไฟฟ้าที่สูงสุดที่ตั้งค่าที่จุดเชื่อมต่อ",
  "common.50300.ipv8": "กระแสไฟฟ้า DC 8",
  "common.50300.ipv9": "กระแสไฟฟ้า DC 9",
  "ywt.65323.pv1Voltage": "แรงดันไฟฟ้าโซลาร์ 1",
  "plant.input_City": "กรุณาเลือกเมือง",
  "jl_param_ctrl_name_Meter.CTSetting": "การตั้งค่ามิเตอร์ไฟฟ้า/CT",
  "storage.s3.65292.beforeLoadMarker": "เครื่องหมายการไหลของพลังงานโหลดด้านหน้า",
  "common.50402.PV26_V": "แรงดันไฟฟ้า PV26",
  "common.50402.PV26_I": "กระแสไฟฟ้า PV26",
  "jl_param_ctrl_name_TimeofUseChargeCurrentSet": "การตั้งค่ากระแสไฟฟ้าชาร์จเพื่อเพิ่มผลตอบแทน",
  "jl_param_ctrl_note_ForcechargeSOC": "เนื่องจากปรากฏการณ์การระบายพลังงานเองของแบตเตอร์ ค่า SOC ของแบตเตอร์อาจต่ำกว่าค่า SOC ในการระบายพลังงานเกิน. เมื่อถึงค่า SOC การชาร์จบังคับ อินเวอร์เตอร์จะชาร์จแบตเตอร์อัตโนมัติเพื่อป้องกันไม่ให้แบตเตอร์เข้าสู่โหมดนอน",
  "Upgrade.starttime": "เวลาเริ่มต้น",
  "setting.type11.maxSocDischarge": "SOC สูงสุดในการเดินทางอัจฉริยะ (%)",
  "ywt.65323.clsLockNum": "จำนวนครั้งการล็อค CLS",
  "sidebar.logout": "ออกจากบัญชี",
  "storage.v2.65284.batteryCurrent": "กระแสไฟฟ้าในการชาร์จและเดินทางของแบตเตอร์",
  "Firmware.input_folder_name": "ป้อนชื่อไฟล์อินพุต",
  "bw_param_ctrl_group_SystemInfo": "ข้อมูลระบบ",
  "button.register": "การลงทะเบียน",
  "jl_RTparam_name_batDcdcVersion": "รุ่นของแบตเตอร์ DCDC",
  "AS4777_NA": "Australia_AS4777_NA",
  "login.newPassword": "รหัสผ่านใหม่",
  "user.register.success": "การลงทะเบียนสำเร็จ",
  "login.donTHaveAccount": "ยังไม่มีบัญชี?",
  "jl_param_ctrl_option_PhaseA(3P)": "เฟส A (สามเฟส)",
  "jl_param_ctrl_name_AutoBatWakeupVoltageSetting": "แรงดันไฟฟ้าในการปลุกตัวเองของแบตเตอร์อัตโนมัติ",
  "product.DetailSetting": "การตั้งค่ารายละเอียด",
  "solis.10001.pow10": "กำลังไฟฟ้า PV - 10",
  "solis.10001.pow12": "กำลังไฟฟ้า PV - 12",
  "solis.10001.pow11": "กำลังไฟฟ้า PV - 11",
  "subtitle.photo": "รูปประจำตัว",
  "subtitle.currency": "สกุลเงิน",
  "subtitle.storagePlant": "โรงไฟฟ้าสำรองพลังงาน",
  "subtitle.customizable": "การกำหนดเอง",
  "jl_param_ctrl_name_04-FrequencyDeratingFstart": "จุดความถี่เริ่มต้นการลดโหลด 04",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingFstart": "จุดความถี่เริ่มต้นการลดโหลด 03&11H&12H",
  "common.50402.PV6_V": "แรงดันไฟฟ้า PV6",
  "plant.weather": "สภาพอากาศ",
  "ywt.65323.pv4Voltage": "แรงดันไฟฟ้าโซลาร์ 4",
  "App.APP_Version": "การปล่อยเวอร์ชันของแอป",
  "setting.type22.acUnderFrequencyTime1": "เวลาเฟสแรกของความถี่ไฟฟ้า AC ต่ำ (วินาที)",
  "setting.type22.acUnderFrequencyTime2": "เวลาเฟสที่สองของความถี่ไฟฟ้า AC ต่ำ (วินาที)",
  "setting.type3.timingDischarge": "โหมดการเดินทางตามเวลาจับเวลา",
  "common.50402.PV6_I": "กระแสไฟฟ้า PV6",
  "jl_param_ctrl_option_Disable": "ไม่เปิดใช้งาน",
  "mini.65290.stAbnorm_Ris": "ความผิดปกติของความต้านทานการฉนวน",
  "jl_param_ctrl_note_EN50549PowerChangeGradientafterFaultTripRestart": "การจำกัดความชันของกำลังในการเชื่อมต่อใหม่ของรหัสระบบไฟฟ้า EN50549",
  "App.IOS_Version": "เวอร์ชัน IOS:",
  "form.addShip": "การเพิ่มอุปกรณ์ที่ออกสินค้า",
  "common.50402.INV_EG_TOTAL": "ปริมาณการผลิตไฟฟ้าที่สะสมของอินเวอร์เตอร์",
  "subtitle.LayoutDrawing": "แผนผังการจัดเรียง",
  "product.ProductOfOwnership": "ผลิตภัณฑ์ที่เป็นเจ้าของ",
  "bw_param_ctrl_note_Systemmode": "DC: สำหรับสถานที่ติดตั้งอินเวอร์เตอร์ผสม หมายถึงระบบโซลาร์ใหม่ โมดูลโซลาร์เชื่อมต่อตรงกับอินเวอร์เตอร์; สำหรับสถานที่ติดตั้งอินเวอร์เตอร์แบตเตอร์ ไม่มีอินเวอร์เตอร์โซลาร์ในสถานที่ อินเวอร์เตอร์แบตเตอร์เชื่อมต่อเข้ากับระบบไฟฟ้าเท่านั้น ระบบไฟฟ้าเท่านั้นที่สามารถชาร์จแบตเตอร์ได้.\n\nAC: หมายถึงระบบการปรับปรุงโซลาร์ ยังมีอินเวอร์เตอร์โซลาร์เชื่อมต่ออยู่กับระบบไฟฟ้า โมดูลโซลาร์เชื่อมต่ออยู่กับอินเวอร์เตอร์โซลาร์ ไม่เชื่อมต่อตรงกับอินเวอร์เตอร์การเก็บพลังงาน\n\nHybrid: หมายถึงสถานที่มีอินเวอร์เตอร์โซลาร์เชื่อมต่ออยู่กับระบบไฟฟ้า และมีโมดูลโซลาร์เชื่อมต่อตรงกับอินเวอร์เตอร์ผสม.",
  "datalog.span_settingdns": "การตั้งค่าดเมน",
  "sotrage.datalogSn": "กรุณาป้อนหมายเลขซีเรียลของเครื่องรับสัญญาณ",
  "product.Inverter": "อินเวอร์เตอร์",
  "ywt.65323.ctReactivePower": "กำลังไฟฟ้าไม่ประกอบของมิเตอร์ไฟฟ้า",
  "role.appPermissions": "สิทธิ์เมนูของแอป",
  "bw_RTparam_group_Load": "โหลด",
  "jl_param_ctrl_name_EN50549GradientLimitforPower-onChange": "การจำกัดความชันของการเปลี่ยนแปลงการเปิดใช้งานไฟฟ้า EN50549",
  "bw_RTparam_name_Mac": "ที่อยู่ MAC",
  "common.50100.pv3Current": "กระแสไฟฟ้าเวลาจริงของ PV3",
  "tip.opsLog.communication": "การสื่อสาร",
  "jl_RTparam_name_BatteryVersion": "รุ่นของแบตเตอร์",
  "unc.65323.loadTodayConsumeEnergy": "ปริมาณการใช้ไฟฟ้าในวันของโหลด",
  "bw_RTparam_name_grid": "ระบบไฟฟ้าและมิเตอร์ไฟฟ้าโซลาร์",
  "org.deleteTip": "การกระทำนี้จะลบแผนกนี้ คุณต้องการดำเนินการต่อหรือไม่?",
  "jl_param_ctrl_name_OV-G-V-T02": "OV - G - V - T 02",
  "ywt.65323.pv1Current": "กระแสไฟฟ้าโซลาร์ 1",
  "common.50300.type": "ประเภทอุปกรณ์",
  "placeholder.startDate": "วันเริ่มต้น",
  "End_user.btn_delete": "ลบ",
  "jl_param_ctrl_option_PowerOFF": "เปิดเครื่อง",
  "jl_param_ctrl_option_backward": "การตั้งค่ากลับ",
  "unc.65323.pvTodayEnergy": "ปริมาณการผลิตไฟฟ้าในวันของโซลาร์",
  "Meter_in_Grid_Acrel_3P_Meter": "สามเฟส Acrel ด้านระบบไฟฟ้า",
  "tip.validate.installationDate": "วันที่ติดตั้งไม่สามารถเป็นค่าว่าง กรุณาเลือกวันที่ติดตั้ง",
  "jl_param_ctrl_name_OV-G-V-T01": "OV - G - V - T 01",
  "ywt.65323.batTodayChargeEnergy": "ปริมาณการชาร์จในวันนี้",
  "storage.s3.65292.cPhaseOnGridPower": "กำลังไฟฟ้าเฟส C ด้านระบบไฟฟ้า",
  "login.email.length.error": "ความยาวของอีเมลไม่สามารถเกิน 50 ตัวอักษร.",
  "jl_param_ctrl_option_No_Battery": "ไม่มีแบตเตอร์",
  "subtitle.temperature": "อุณหภูมิ (°C)",
  "product.deviceType": "ประเภทอุปกรณ์",
  "subtitle.PhysicalView": "มุมมองทางกายภาพ",
  "title.faultMessage": "ข้อความข้อผิดพลาด",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "ปริมาณพลังงานจากระบบไฟฟ้าให้กับแบตเตอร์",
  "setting.type10.antiRefluxPower": "กำลังไฟฟ้าในการป้องกันการไหลย้อนกลับ",
  "validate.tips.passwordRule": "กรุณาป้อนรหัสผ่าน 8 - 10 ตัวอักษร",
  "setting.type7.paramterSetting": "การตั้งค่าพารามิเตอร์",
  "storage.s3.65292.mainsFreq": "ความถี่ของระบบไฟฟ้า",
  "subtitle.export": "การส่งออก",
  "jl_param_ctrl_note_OnOff": "เปิดหรือปิดอินเวอร์เตอร์",
  "setting.type8.systemSwitch": "สวิตช์ระบบ",
  "solis.10001.batteryTodayChargeEnergy": "ปริมาณการชาร์จในวัน",
  "jl_param_ctrl_name_0A-FrequencyDeratingFstart": "จุดความถี่เริ่มต้นการลดโหลด 0A",
  "tip.energy.tip3.title2": "1 kWh เท่ากับ:",
  "subtitle.TimedChargingAndDischarging": "การชาร์จและเดินทางตามเวลาจับเวลา",
  "setting.type12.val.powerRotation": "การสลับพลังงาน",
  "setting.type3.lowBatteryShutdown": "ค่ากำหนดการในการหยุดการเดินทาง SOC ต่ำสุดของแบตเตอร์",
  "solis.10001.pow25": "กำลังไฟฟ้า PV - 25",
  "common.50402.outages": "การหยุดการผลิตไฟฟ้าเนื่องจากการจำกัดการใช้ไฟฟ้า",
  "solis.10001.pow24": "กำลังไฟฟ้า PV - 24",
  "solis.10001.pow27": "กำลังไฟฟ้า PV - 27",
  "solis.10001.pow26": "กำลังไฟฟ้า PV - 26",
  "solis.10001.pow29": "กำลังไฟฟ้า PV - 29",
  "solis.10001.homeLoadTodayEnergy": "ปริมาณการใช้ไฟฟ้าในวันของโหลด",
  "solis.10001.pow28": "กำลังไฟฟ้า PV - 28",
  "R14-240": "USA_R14 - 240",
  "tip.log.bluetoothAbnormal": "การเชื่อมต่อ Bluetooth ไม่ปกติ กำลังพยายามเชื่อมต่อใหม่",
  "mini.65290.StINVTPOWERON": "สถานะการทำงานของอินเวอร์เตอร์",
  "subtitle.grid": "ระบบไฟฟ้า",
  "plant.deleteSuccess": "การลบโรงไฟฟ้าสำเร็จ",
  "org.namenick": "ชื่อ/ชื่อเล่น",
  "solis.10001.pow30": "กำลังไฟฟ้า PV - 30",
  "jl_param_ctrl_name_WorkModeDefault": "การตั้งค่ากลับค่าเริ่มต้นของโหมดการทำงาน",
  "jl_param_ctrl_name_OverdischargeHysteresisSOC": "SOC การระบายพลังงานเกิน",
  "solis.10001.pow32": "กำลังไฟฟ้า PV - 32",
  "solis.10001.pow31": "กำลังไฟฟ้า PV - 31",
  "solis.10001.pow14": "กำลังไฟฟ้า PV - 14",
  "solis.10001.pow13": "กำลังไฟฟ้า PV - 13",
  "solis.10001.pow16": "กำลังไฟฟ้า PV - 16",
  "solis.10001.pow15": "กำลังไฟฟ้า PV - 15",
  "solis.10001.pow18": "กำลังไฟฟ้า PV - 18",
  "solis.10001.pow17": "กำลังไฟฟ้า PV - 17",
  "solis.10001.pow19": "กำลังไฟฟ้า PV - 19",
  "BRAZIL": "Brazil_BRAZIL",
  "subtitle.details": "รายละเอียด",
  "storage.s3.65292.mainsCpVoltage": "แรงดันไฟฟ้าเฟส C ของระบบไฟฟ้า",
  "storage.s3.65292.pv1Voltage": "แรงดันไฟฟ้าแผงโซลาร์ช่องที่ 1",
  "bw_RTparam_name_Frequent_PV": "ความถี่ของมิเตอร์ไฟฟ้า",
  "unc.65323.load2GeneratorCurrentB": "กระแสไฟฟ้าเฟส B ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "unc.65323.load2GeneratorCurrentA": "กระแสไฟฟ้าเฟส A ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "solis.10001.pow21": "กำลังไฟฟ้า PV - 21",
  "solis.10001.pow20": "กำลังไฟฟ้า PV - 20",
  "unc.65323.load2GeneratorCurrentC": "กระแสไฟฟ้าเฟส C ของโหลด 2/เครื่องกำเนิดไฟฟ้า",
  "solis.10001.pow23": "กำลังไฟฟ้า PV - 23",
  "product.DownloadTemplate": "ดาวน์โหลดเทมเพลต",
  "solis.10001.pow22": "กำลังไฟฟ้า PV - 22",
  "subtitle.Optimizer": "ตัวปรับให้เหมาะสม",
  "common.50700.xnl_RTparam_group_Load": "โหลด",
  "common.50700.xnl_RTparam_group_Inverter": "อินเวอร์เตอร์",
  "common.50700.xnl_RTparam_group_Grid": "ระบบไฟฟ้า",
  "common.50700.170": "ไม่ถูกต้อง",
  "common.50700.169": "การทดสอบในโรงงาน",
  "common.50700.168": "กำลังอัพเกรด",
  "common.50700.167": "โหมดอยู่นิ่ง",
  "common.50700.166": "ความผิดพลาดถาวร",
  "common.50700.165": "ความผิดพลาด",
  "common.50700.164": "การแยกจากเครือข่ายไฟฟ้า",
  "common.50700.163": "การเชื่อมต่อกับเครือข่ายไฟฟ้า",
  "common.50700.162": "กำลังตรวจสอบ",
  "common.50700.161": "การรอ",
  "common.50700.160": "การตรวจสอบตัวเอง",
  "common.50700.TFreq": "ความถี่เฟส T",
  "common.50700.TCurrent": "กระแสเฟส T",
  "common.50700.SVolt": "แรงดันเฟส S",
  "common.50700.SPower": "กำลังเฟส S",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "ความถี่เฟส S",
  "common.50700.SCurrent": "กระแสเฟส S",
  "common.50700.RVolt": "แรงดันเฟส R",
  "common.50700.runningState": "สถานะการทำงาน",
  "common.50700.RPower": "กำลังเฟส R",
  "common.50700.RFreq": "ความถี่เฟส R",
  "common.50700.ResidualEnergy": "ปริมาณพลังงานที่เหลือในแบตเตอรี่",
  "common.50700.ReactivePower": "กำลังไร้โครง",
  "common.50700.RCurrent": "กระแสเฟส R",
  "common.50700.pvPower": "กำลัง PV",
  "common.50700.pv9Volt": "แรงดัน PV9",
  "common.50700.pv9Power": "กำลัง PV9",
  "common.50700.pv9Current": "กระแส PV9",
  "common.50700.pv8Volt": "แรงดัน PV8",
  "common.50700.pv8Power": "กำลัง PV8",
  "common.50700.pv8Current": "กระแส PV8",
  "common.50700.pv7Volt": "แรงดัน PV7",
  "common.50700.pv7Power": "กำลัง PV7",
  "common.50700.pv7Current": "กระแส PV7",
  "common.50700.pv6Volt": "แรงดัน PV6",
  "common.50700.pv6Power": "กำลัง PV6",
  "common.50700.pv6Current": "กระแส PV6",
  "common.50700.pv5Volt": "แรงดัน PV5",
  "common.50700.pv5Power": "กำลัง PV5",
  "common.50700.pv5Current": "กระแส PV5",
  "common.50700.pv4Volt": "แรงดัน PV4",
  "common.50700.pv4Power": "กำลัง PV4",
  "common.50700.pv4Current": "กระแส PV4",
  "common.50700.pv3Volt": "แรงดัน PV3",
  "common.50700.pv3Power": "กำลัง PV3",
  "common.50700.pv3Current": "กระแส PV3",
  "common.50700.pv2Volt": "แรงดัน PV2",
  "common.50700.pv2Power": "กำลัง PV2",
  "common.50700.pv2Current": "กระแส PV2",
  "common.50700.pv1Volt": "แรงดัน PV1",
  "common.50700.pv1Power": "กำลัง PV1",
  "common.50700.pv1Current": "กระแสไฟฟ้าใน PV1",
  "common.50700.pv18Volt": "แรงดัน PV18",
  "common.50700.pv18Power": "กำลัง PV18",
  "common.50700.pv18Current": "กระแส PV18",
  "common.50700.pv17Volt": "แรงดัน PV17",
  "common.50700.pv17Power": "กำลัง PV17",
  "common.50700.pv17Current": "กระแส PV17",
  "common.50700.pv16Volt": "แรงดัน PV16",
  "common.50700.pv16Power": "กำลัง PV16",
  "common.50700.pv16Current": "กระแส PV16",
  "common.50700.pv15Volt": "แรงดัน PV15",
  "common.50700.pv15Power": "กำลัง PV15",
  "common.50700.pv15Current": "กระแส PV15",
  "common.50700.pv14Volt": "แรงดัน PV14",
  "common.50700.pv14Power": "กำลัง PV14",
  "common.50700.pv14Current": "กระแส PV14",
  "common.50700.pv13Volt": "แรงดัน PV13",
  "common.50700.pv13Power": "กำลัง PV13",
  "common.50700.pv13Current": "กระแส PV13",
  "common.50700.pv12Volt": "แรงดัน PV12",
  "common.50700.pv12Power": "กำลัง PV12",
  "common.50700.pv12Current": "กระแส PV12",
  "common.50700.pv11Volt": "แรงดัน PV11",
  "common.50700.pv11Power": "กำลัง PV11",
  "common.50700.pv11Current": "กระแส PV11",
  "common.50700.pv10Volt": "แรงดัน PV10",
  "common.50700.pv10Power": "กำลัง PV10",
  "common.50700.pv10Current": "กระแส PV10",
  "common.50700.PowerFactor": "ปัจจัยกำลัง",
  "common.50700.meterPowerT": "กำลังมิเตอร์ไฟ T",
  "common.50700.meterPowerS": "กำลังมิเตอร์ไฟ S",
  "common.50700.meterPowerR": "กำลังมิเตอร์ไฟ R",
  "common.50700.meterPower2": "กำลังมิเตอร์ไฟ 2",
  "common.50700.meterPower": "กำลังมิเตอร์ไฟ",
  "common.50700.loadsPowerT": "กำลังเฟส T ของโหลด",
  "common.50700.loadsPowerS": "กำลังเฟส S ของโหลด",
  "common.50700.loadsPowerR": "กำลังเฟส R ของโหลด",
  "common.50700.loadsPower": "กำลังโหลด",
  "common.50700.loads": "ปริมาณการใช้ไฟของโหลด",
  "common.50700.invTemperation": "อุณหภูมิของอินเวอร์เตอร์",
  "common.50700.invBatVolt": "แรงดันแบตเตอรี่ทางด้านอินเวอร์เตอร์",
  "common.50700.invBatPower": "กำลังแบตเตอรี่ทางด้านอินเวอร์เตอร์",
  "common.50700.invBatCurrent": "กระแสแบตเตอรี่ทางด้านอินเวอร์เตอร์",
  "common.50700.gridConsumptionPower": "กำลังสูญเสียของเครือข่ายไฟฟ้า",
  "common.50700.gridConsumption": "ปริมาณการใช้ไฟจากเครือข่ายไฟฟ้าทั้งหมด",
  "common.50700.generationPower": "กำลังการผลิตไฟ",
  "common.50700.generation": "ปริมาณการผลิตไฟสะสม",
  "common.50700.feedinPower": "กำลังการเชื่อมต่อกับเครือข่ายไฟฟ้า",
  "common.50700.feedin": "ปริมาณการส่งไฟกลับเข้าเครือข่ายไฟฟ้าทั้งหมด",
  "common.50700.epsVoltT": "แรงดันเฟส T ของ EPS",
  "common.50700.epsVoltS": "แรงดันเฟส S ของ EPS",
  "common.50700.epsVoltR": "แรงดันเฟส R ของ EPS",
  "common.50700.epsPowerT": "กำลังเฟส T ของ EPS",
  "common.50700.epsPowerS": "กำลังเฟส S ของ EPS",
  "common.50700.epsPowerR": "กำลังเฟส R ของ EPS",
  "common.50700.epsPower": "กำลัง EPS",
  "common.50700.epsCurrentT": "กระแสเฟส T ของ EPS",
  "common.50700.epsCurrentS": "กระแสเฟส S ของ EPS",
  "common.50700.epsCurrentR": "กระแสเฟส R ของ EPS",
  "common.50700.energyThroughput": "ปริมาณการเคลื่อนที่ของแบตเตอรี่",
  "common.50700.dspTemperature": "อุณหภูมิของ DSP",
  "common.50700.dischargeEnergyToTal": "ปริมาณการระบายไฟทั้งหมด",
  "common.50700.chargeTemperature": "อุณหภูมิการชาร์จ",
  "common.50700.chargeEnergyToTal": "ปริมาณการชาร์จทั้งหมด",
  "common.50700.boostTemperation": "อุณหภูมิของเครื่องชาร์จ",
  "common.50700.batVolt": "แรงดันแบตเตอรี่",
  "common.50700.batTemperature": "อุณหภูมิของแบตเตอรี่",
  "common.50700.batStatusV2": "สถานะของแบตเตอรี่",
  "common.50700.batStatus": "สถานะของแบตเตอรี่",
  "common.50700.batDischargePower": "กำลังการระบายไฟแบตเตอรี่",
  "common.50700.batCurrent": "กระแสแบตเตอรี่",
  "common.50700.batChargePower": "กำลังการชาร์จแบตเตอรี่",
  "common.50700.ambientTemperation": "อุณหภูมิแวดล้อม",
  "system.dataScreen": "หน้าจอข้อมูล",
  "plant.pleaseSelectDate": "กรุณาเลือกวันที่",
  "device.address": "ที่อยู่รีจิสเตอร์",
  "device.faultClearing": "ล้างข้อผิดพลาด",
  "device.chargeSetting": "การตั้งค่าการชาร์จ",
  "device.dischargeSetting": "การตั้งค่าการปล่อย",
  "device.dynamicPriceTip": "เจ้าของบ้านได้เปิดโหมด AI แล้ว พารามิเตอร์นี้ไม่รองรับการแก้ไขด้วยตนเอง",
  "subtitle.noSolution": "กรุณาอ้างอิงคู่มือผู้ใช้หรือติดต่อฝ่ายบริการหลังการขายโดยตรง",
  "subtitle.alarmName": "ชื่อการแจ้งเตือน",
  "common.noPermissions": "ยังไม่มีเนื้อหา กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดค่า",
  "common.personalCenter": "ศูนย์ส่วนบุคคล",
  "common.deviceSet": "การตั้งค่าอุปกรณ์",
  "common.productDetail": "รายละเอียดผลิตภัณฑ์",
  "validator.min": "ป้อนอย่างน้อย {num} ตัวอักษร",
  "shipment.PleaseSelectStatus": "กรุณาเลือกสถานะ",
  "shipment.PleaseEnterMaterialCode": "กรุณากรอกรหัสวัสดุ MDM",
  "shipment.MdmCode": "รหัส MDM",
  "shipment.devType": "วิธีการพัฒนา",
  "shipment.shippingManagementTemplage": "เทมเพลตการนำเข้าการจัดการการจัดส่ง",
  "product.PleaseEnterSupplier": "กรุณากรอกผู้จัดหา",
  "person.changePassword": "เปลี่ยนรหัสผ่าน",
  "person.userName": "ชื่อผู้ใช้",
  "person.company": "บริษัท",
  "person.newPassword": "รหัสผ่านใหม่",
  "person.confirmPassword": "ยืนยันรหัสผ่าน",
  "person.userInformation": "ข้อมูลผู้ใช้",
  "person.basicInformation": "ข้อมูลพื้นฐาน",
  "person.address": "ที่อยู่",
  "person.phone": "โทรศัพท์",
  "person.confirmChange": "ยืนยันการเปลี่ยนแปลง",
  "weather.clearSky": "ท้องฟ้าแจ่มใส",
  "weather.fewClouds": "มีเมฆบางส่วน",
  "weather.scatteredClouds": "เมฆกระจาย",
  "weather.brokenClouds": "เมฆเป็นกลุ่ม",
  "weather.overcastClouds": "เมฆครึ้ม",
  "weather.lightRain": "ฝนตกเล็กน้อย",
  "weather.moderateRain": "ฝนปานกลาง",
  "weather.heavyRain": "ฝนตกหนัก",
  "weather.thunderstormWithLightRain": "พายุฝนฟ้าคะนองกับฝนตกเล็กน้อย",
  "weather.thunderstormWithRain": "พายุฝนฟ้าคะนองกับฝน",
  "weather.thunderstormWithHeavyRain": "พายุฝนฟ้าคะนองกับฝนตกหนัก",
  "weather.lightSnow": "หิมะตกเล็กน้อย",
  "weather.snow": "หิมะตก",
  "weather.heavySnow": "หิมะตกหนัก",
  "weather.sleet": "หิมะเปียก",
  "weather.showerRain": "ฝนตกเป็นระยะ",
  "weather.lightShowerRain": "ฝนตกเป็นระยะเล็กน้อย",
  "weather.heavyShowerRain": "ฝนตกเป็นระยะหนัก",
  "weather.mist": "หมอกบาง",
  "weather.smoke": "ควัน",
  "weather.haze": "หมอกควัน",
  "weather.dust": "ฝุ่นฟุ้ง",
  "weather.fog": "หมอก",
  "weather.sand": "พายุทราย",
  "weather.ash": "เถ้าภูเขาไฟ",
  "weather.squall": "พายุลมแรง",
  "weather.tornado": "พายุทอร์นาโด",
  "th-TH": "ภาษาไทย",
  "device.to": "ถึง",
  "device.range": "ช่วง",
  "device.noParamsChange": "ไม่มีการแก้ไขพารามิเตอร์ใด ๆ ไม่จำเป็นต้องส่ง",
  "device.timeCopy": "มีช่วงเวลาที่ซ้ำกัน กรุณาแก้ไข",
  "bTerminal.correlationDeleteTheDevice": "หากลบอุปกรณ์นี้ อุปกรณ์ที่เกี่ยวข้องจะถูกลบพร้อมกัน ต้องการลบหรือไม่",
  "user.userEmail": "อีเมลผู้ใช้",
  "user.agentCode": "รหัสตัวแทน",
  "user.phoneModel": "รุ่นโทรศัพท์",
  "user.phoneOs": "ระบบปฏิบัติการโทรศัพท์",
  "user.appVersion": "เวอร์ชันแอป",
  "user.country": "ประเทศ",
  "user.createTime": "เวลาสร้าง",
  "user.loginTime": "เวลาเข้าสู่ระบบ",
  "log.operationEmail": "อีเมลการดำเนินการ",
  "log.deviceSn": "SN อุปกรณ์",
  "log.opType": "ประเภทการดำเนินการ",
  "log.opTime": "เวลาการดำเนินการ",
  "log.content": "เนื้อหาการดำเนินการ",
  "log.params": "พารามิเตอร์",
  "plant.dataUpdate": "อัปเดตข้อมูล",
  "device.paramRangeErrorDefault": "ช่วงข้อมูลไม่ถูกต้อง ช่วงที่ป้อนควรเป็น ",
  "device.paramRangeError": "ช่วงข้อมูลไม่ถูกต้อง",
  "validate.requiredFormat": "กรุณาป้อนตามรูปแบบตัวอย่าง",
  "plant.addStation": "เพิ่มสถานีไฟฟ้า",
  "product.ProtocolCode": "ID ผลิตภัณฑ์ IoT",
  "system.taskCenter": "ศูนย์งาน",
  "task.name": "ชื่องาน",
  "task.type": "ประเภทงาน",
  "task.status": "สถานะ",
  "task.createDate": "เวลาสร้าง",
  "task.progress": "ความคืบหน้า",
  "task.view": "ดู",
  "task.stop": "หยุด",
  "task.stopConfirm": "ยืนยันที่จะหยุดงานหรือไม่?",
  "task.stopSuccess": "หยุดงานสำเร็จ",
  "task.stopFail": "หยุดงานล้มเหลว",
  "task.confirm": "ยืนยัน",
  "task.cancel": "ยกเลิก",
  "task.mutipleSearch": "ค้นหาแบบกลุ่ม",
  "task.mutipleSend": "ส่งแบบกลุ่ม",
  "task.taskDetail": "รายละเอียดงาน",
  "task.equipmentList": "รายการอุปกรณ์",
  "task.fileLimit": "สามารถอัปโหลดไฟล์ xls/xlsx เท่านั้น",
  "task.reChoose": "ล้างรายการแล้วเลือกใหม่",
  "task.tip": "ลากไฟล์มาที่นี่หรือ",
  "task.upload": "คลิกอัปโหลด",
  "task.templateDownload": "ดาวน์โหลดเทมเพลต",
  "task.mutipleHandleParams": "พารามิเตอร์การจัดการแบบกลุ่ม",
  "common.previousStep": "ขั้นตอนก่อนหน้า",
  "task.requiredProductModel": "กรุณาเลือกรุ่นผลิตภัณฑ์",
  "task.requiredEquipmentList": "กรุณาอัปโหลดรายการอุปกรณ์",
  "task.equipmentListTip": "ข้อมูลตารางว่างเปล่าหรืออัปโหลดล้มเหลว กรุณาตรวจสอบ",
  "task.requiredParameter": "กรุณาเลือกพารามิเตอร์",
  "task.writeValue": "เขียนค่า",
  "task.progressRate": "อัตราความคืบหน้า",
  "task.readTime": "เวลาอ่าน",
  "task.sendTime": "เวลาส่ง",
  "task.mutipleSearchTemplate": "เทมเพลตการค้นหาแบบกลุ่ม",
  "task.mutipleSendTemplate": "เทมเพลตการส่งแบบกลุ่ม",
  "task.uploadSuccess": "อัปโหลดสำเร็จ",
  "task.sendSuccess": "สร้างงานสำเร็จ",
  "task.inProgress": "กำลังดำเนินการ",
  "task.completed": "เสร็จสิ้น",
  "task.failed": "ล้มเหลว",
  "task.success": "สำเร็จ",
  "system.configureImport": "นำเข้าการกำหนดค่า",
  "common.50700.xnl_RTparam_group_Battery": "แบตเตอรี่",
  "common.50702.xnl_RTparam_group_Battery": "แบตเตอรี่",
  "common.50698.TVolt": "แรงดันเฟส T",
  "common.50700.TPower": "พลังงานเฟส T",
  "common.50700.TVolt": "แรงดันเฟส T",
  "common.50300.todayFeedInGridEnergy": "พลังงานที่ป้อนเข้าสู่กริดวันนี้  ",
  "common.50300.todayConsumeEnergy": "ปริมาณการใช้ไฟฟ้าในวันนี้",
  "common.50300.totalFeedInGridEnergy": "พลังงานทั้งหมดที่จ่ายเข้าสู่กริด  ",
  "common.50300.Ia": "กระแสเฟส A",
  "common.50300.Pa": "กำลังเชิงกิจของเฟส A",
  "common.50300.Ib": "กระแสเฟส B",
  "common.50300.Pb": "กำลังเชิงกิจของเฟส B",
  "common.50300.Ic": "กระแสเฟส C",
  "common.50300.Pc": "กำลังเชิงกิจของเฟส C",
  "common.50300.ctTotalActivePower": "กำลังทำงานทั้งหมด",
  "bTerminal.ModifyTheNameOfTheDevice": "เปลี่ยนชื่ออุปกรณ์",
  "bTerminal.OnlyWithin100Characters": "มีเฉพาะในภาษาจีนและภาษาอังกฤษและตัวเลขภายใน 100 คำ",
  "bTerminal.rename": "เปลี่ยนชื่อ",
  "paramters.basicInformation": "ข้อมูลพื้นฐาน",
  "paramters.DCSide": "ด้าน DC",
  "paramters.ACSide": "ด้าน AC",
  "paramters.stringCurrent": "กระแสสตริง",
  "paramters.moreParamters": "ข้อมูลเพิ่มเติม",
  "paramters.debugInformation": "ข้อมูลดีบัก",
  "paramters.current": "กระแส",
  "paramters.voltage": "แรงดันไฟฟ้า",
  "paramters.power": "กำลังไฟฟ้า",
  "paramters.init": "เริ่มต้น",
  "paramters.wait": "กำลังรอ",
  "paramters.normal": "ปกติ",
  "paramters.abnormal": "ข้อผิดพลาด",
  "paramters.burn": "เบิร์นอิน",
  "device.category.heatpump": "ปั๊มความร้อน",
  "ai.robot.manage.family": "สวัสดี หุ่นยนต์ AI กำลังจัดการการใช้ไฟฟ้าในบ้านของคุณอยู่",
  "ai.robot.predicted.price": "ได้รับราคาไฟฟ้าของวันนี้แล้ว ทำนายการผลิตไฟฟ้าในวันนี้ที่ {###}kWh",
  "ai.robot.regulating.heat.pump": "จะมีการปรับการทำงานของปั๊มความร้อนตามความเหมาะสม",
  "device.category.module": "ส่วนประกอบ",
  "50000_0X561-M-12": "ขั้นตอนตารางไม่สอดคล้อง",
  "50000_0X561-M-13": "ตัวอย่าง DCV ผิดปกติ",
  "50000_0X561-M-14": "ความผิดพลาดแฟลชกล่องดำ",
  "50000_0X561-M-15": "ความผิดพลาด RTC",
  "bw.content.alarm.0X55E-M-60": "ขั้นตอนตารางไม่สอดคล้อง",
  "bw.content.alarm.0X55E-M-61": "ตัวอย่าง DCV ผิดปกติ",
  "bw.content.alarm.0X55E-M-62": "ความผิดพลาดแฟลชกล่องดำ",
  "bw.content.alarm.0X55E-M-63": "ความผิดพลาด RTC",
  "bw_RTparam_name_TotalEnergyInvOutput": "พลังงานรวม INV ผลิต",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "product.deviceInstallationGuideFirst": "กรุณาอัปโหลดรูปภาพคู่มือการติดตั้งอุปกรณ์เพื่อแนะนำผู้ติดตั้งทีละขั้นตอนผ่านการติดตั้งและการดำเนินการแอป",
  "product.deviceInstallationGuideSecond": "ขอแนะนำให้รวมคำแนะนำสำหรับการเข้าสู่โหมดการกำหนดค่าอุปกรณ์ตำแหน่ง QR code SN การสร้างไซต์ การเพิ่มอุปกรณ์ การดำเนินการ Bluetooth การกำหนดค่าแบบด่วน ฯลฯ",
  "product.mdnTip": "9 หลักแรกของ SN Haier",
  "login.rememberAccount": "จำบัญชีและรหัสผ่าน",
  "login.enterAccount": "กรุณากรอกอีเมลหรือหมายเลขโทรศัพท์",
  "login.correctAccount": "กรุณากรอกอีเมลหรือหมายเลขโทรศัพท์ที่ถูกต้อง",
  "login.accountPlaceholder": "กรุณากรอกอีเมลหรือหมายเลขโทรศัพท์",
  "register.accountVerification": "การยืนยันบัญชี",
  "register.companyRegistration": "การลงทะเบียนบริษัท",
  "register.staffRegistration": "การลงทะเบียนพนักงาน",
  "register.companyInfo": "กรุณาให้ข้อมูลบริษัทด้านล่าง",
  "register.companyFullName": "ชื่อเต็มบริษัท",
  "register.installationCountryNotice": "กรุณาเลือกประเทศที่ลงทะเบียนผู้ติดตั้งอย่างระมัดระวัง คุณไม่สามารถติดตั้งระบบนอกพื้นที่ลงทะเบียนได้",
  "register.detailAddress": "ที่อยู่โดยละเอียด",
  "register.postalCode": "รหัสไปรษณีย์",
  "register.contactName": "ชื่อผู้ติดต่อ",
  "register.contactInfo": "เบอร์โทรศัพท์หรืออีเมลผู้ติดต่อ",
  "register.applyJoinCompany": "สมัครเข้าร่วมบริษัท",
  "register.companyCodeInfo": "กรุณากรอกรหัสบริษัทและข้อมูลส่วนตัวเพื่อเข้าร่วมบริษัทที่ลงทะเบียนแล้ว",
  "register.registrationCode": "รหัสลงทะเบียนบริษัท",
  "register.codeHint": "สามารถขอรหัสได้โดยติดต่อผู้ดูแลระบบบริษัท",
  "register.realName": "ชื่อ",
  "register.accountVerificationInfo": "เลือกวิธีใดวิธีหนึ่งต่อไปนี้เพื่อลงทะเบียนบัญชีให้เสร็จสมบูรณ์",
  "register.emailRegistration": "การลงทะเบียนอีเมล",
  "register.sixDigitCode": "รหัสยืนยัน 6 หลัก",
  "register.getVerificationCode": "รับรหัสยืนยัน",
  "register.resendAfterSeconds": "ส่งอีกครั้งใน {seconds} วินาที",
  "register.password6to20": "รหัสผ่าน 6-20 ตัวอักษร",
  "register.phoneNumber": "หมายเลขโทรศัพท์",
  "register.phoneRegistration": "การลงทะเบียนโทรศัพท์",
  "register.optionalEmail": "ทางเลือก: ที่อยู่อีเมล",
  "register.previousPage": "หน้าก่อนหน้า",
  "register.companyAlreadyRegistered": "บริษัท '{companyName}' ได้รับการลงทะเบียนแล้ว",
  "register.companyExistOptions": "คุณสามารถกลับไปแก้ไขชื่อบริษัท หรือสมัครเข้าร่วมบริษัทนี้ได้",
  "register.returnToModify": "กลับไปแก้ไข",
  "register.companyRegisteredApplyJoin": "สมัครเข้าร่วม",
  "register.validation.selectCountry": "กรุณาเลือกประเทศ/ภูมิภาค",
  "register.validation.selectCity": "กรุณาเลือกเมือง",
  "register.validation.enterDetailAddress": "กรุณากรอกที่อยู่โดยละเอียด",
  "register.validation.enterCorrectPostalCode": "กรุณากรอกรูปแบบรหัสไปรษณีย์ที่ถูกต้อง",
  "register.validation.enterRegistrationCode": "กรุณากรอกรหัสลงทะเบียนบริษัท",
  "register.validation.enterYourName": "กรุณากรอกชื่อของคุณ",
  "register.validation.passwordLength": "ความยาวรหัสผ่านต้องมี 6-20 ตัวอักษร",
  "register.validation.enterPasswordAgain": "กรุณากรอกรหัสผ่านอีกครั้ง",
  "register.validation.passwordMismatch": "รหัสผ่านทั้งสองไม่ตรงกัน",
  "register.validation.correctPhoneFormat": "กรุณากรอกรูปแบบหมายเลขโทรศัพท์ที่ถูกต้อง",
  "register.validation.correctPhoneOrEmailFormat": "กรุณากรอกรูปแบบหมายเลขโทรศัพท์หรืออีเมลที่ถูกต้อง",
  "register.validation.correctEmailFormat": "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
  "register.validation.enterVerificationCode": "กรุณากรอกรหัสยืนยัน",
  "register.validation.sixDigitNumber": "รหัสยืนยันต้องมี 6 หลัก",
  "register.validation.enterCompanyName": "กรุณากรอกชื่อบริษัท",
  "register.validation.companyRegisteredChooseAction": "บริษัทลงทะเบียนแล้ว กรุณาเลือกการดำเนินการ",
  "register.message.searchCompanyFailed": "ค้นหาบริษัทล้มเหลว",
  "register.message.checkCompanyStatusFailed": "ตรวจสอบสถานะบริษัทล้มเหลว",
  "register.message.getCityListFailed": "รับรายการเมืองล้มเหลว",
  "register.message.companyRegisteredChooseAction": "บริษัทลงทะเบียนแล้ว กรุณาเลือกการดำเนินการ",
  "register.message.completeCompanyInfo": "กรุณากรอกข้อมูลบริษัทให้ครบถ้วน",
  "register.message.enterEmailFirst": "กรุณากรอกที่อยู่อีเมลก่อน",
  "register.message.correctEmailFormat": "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
  "register.message.verificationCodeSent": "รหัสยืนยันถูกส่งไปที่: {contact}",
  "register.message.sendVerificationCodeFailed": "ส่งรหัสยืนยันล้มเหลว",
  "register.message.enterPhoneFirst": "กรุณากรอกหมายเลขโทรศัพท์ก่อน",
  "register.message.correctPhoneFormat": "กรุณากรอกรูปแบบหมายเลขโทรศัพท์ที่ถูกต้อง",
  "register.message.completeAccountInfoAndFixErrors": "กรุณากรอกข้อมูลบัญชีให้ครบถ้วนและแก้ไขข้อผิดพลาด",
  "register.message.companyRegistrationSuccess": "ลงทะเบียนบริษัทสำเร็จ!",
  "register.message.companyRegistrationFailed": "ลงทะเบียนบริษัทล้มเหลว",
  "register.message.staffRegistrationSuccess": "ลงทะเบียนพนักงานสำเร็จ!",
  "register.message.staffRegistrationFailed": "ลงทะเบียนพนักงานล้มเหลว",
  "registerAccomplish.applicationComplete": "การสมัครเสร็จสมบูรณ์",
  "registerAccomplish.congratulations": "ขอแสดงความยินดี คุณได้ลงทะเบียนเสร็จสมบูรณ์แล้ว",
  "registerAccomplish.certificationRequired": "คุณต้องดำเนินการต่อไปยังศูนย์รับรองเพื่อยืนยันตัวตน มิฉะนั้นคุณจะไม่สามารถเปิดใช้งานอุปกรณ์ได้",
  "registerAccomplish.greenChannelInfo": "สำหรับสถานการณ์ฉุกเฉินพิเศษในแผนก เพื่อไม่ให้การติดตั้งล่าช้า คุณสามารถเลือกช่องทางพิเศษเพื่อรับสิทธิ์ชั่วคราวในการเปิดใช้งานอุปกรณ์เป็นเวลา 2 เดือน",
  "registerAccomplish.certificationCenter": "ศูนย์รับรอง",
  "registerAccomplish.greenChannel": "ช่องทางพิเศษ",
  "registerAccomplish.returnToLogin": "กลับสู่หน้าเข้าสู่ระบบ",
  "registerAccomplish.useHaierEnergyApp": "คุณสามารถใช้แอป Haier Energy เพื่อเพิ่มอุปกรณ์ได้",
  "registerAccomplish.applyingGreenChannel": "คุณกำลังสมัครช่องทางพิเศษ",
  "registerAccomplish.confirmSubmit": "ยืนยันการส่ง",
  "registerAccomplish.returnToPrevious": "กลับสู่หน้าก่อนหน้า",
  "registerAccomplish.applicationSubmittedSuccessfully": "การสมัครของคุณถูกส่งสำเร็จแล้ว!",
  "registerAccomplish.missingAgentIdParameter": "พารามิเตอร์ agentId หายไป ไม่สามารถสมัครช่องทางพิเศษได้",
  "registerAccomplish.greenChannelApplicationSuccess": "สมัครช่องทางพิเศษสำเร็จ!",
  "registerAccomplish.greenChannelApplicationFailed": "สมัครช่องทางพิเศษล้มเหลว",
  "sidebar.prefill": "การประเมินและข้อเสนอแนะ",
  "system.reportCenter": "ศูนย์รายงาน",
  "system.reportMonth": "รายงานประจำเดือน",
  "system.reportYear": "รายงานประจำปี",
  "report.exportAll": "ส่งออกรายการทั้งหมด",
  "report.installedCapacity": "กำลังการติดตั้ง",
  "report.capacityErrorTip": "ช่วงตัวกรองกำลังการติดตั้งไม่ถูกต้อง",
  "report.exportFailed": "การส่งออกล้มเหลว โปรดลองอีกครั้งในภายหลัง",
  "report.firstChoiceTime": "โปรดเลือกวันที่ก่อน แล้วจึงส่งออก",
  "paramters.deviceTotalInformation": "ข้อมูลรวมของอุปกรณ์",
  "paramters.innerInverter": "อินเวอร์เตอร์ภายใน",
  "paramters.outerInverter": "อินเวอร์เตอร์ภายนอก",
  "paramters.outerInverterFromPvSide": "จากมิเตอร์ด้าน PV",
  "paramters.activePower": "กำลังจริง",
  "paramters.apparentPower": "กำลังรูปปรากฏ",
  "paramters.reactivePower": "กำลังเหนี่ยวนำ",
  "paramters.powerFactor": "ตัวประกอบกำลัง",
  "paramters.phaseA": "เฟส A",
  "paramters.phaseB": "เฟส B",
  "paramters.phaseC": "เฟส C",
  "report.allSelect": "เลือกทั้งหมด",
  "report.compare": "เปรียบเทียบ",
  "report.energy": "กำลังไฟฟ้าจริง",
  "report.ipv": "กระแสตรง",
  "report.vpv": "แรงดันตรง",
  "report.fac": "ความถี่กระแสสลับ",
  "report.vac": "แรงดันไฟฟ้าสลับ",
  "report.iac": "กระแสไฟฟ้าสลับ",
  "report.temperature": "อุณหภูมิภายใน",
  "report.str_cur": "กระแสสตริง",
  "report.inverterCompare": "เปรียบเทียบอินเวอร์เตอร์",
  "report.inverterCompareTip": "เพิ่มแล้วในรายการ กรุณาอย่าเพิ่มซ้ำ",
  "report.pleaseChooseInverter": "กรุณาเลือกอินเวอร์เตอร์",
  "report.pleaseChooseCompare": "กรุณาเลือกรายการที่ต้องการเปรียบเทียบ",
  "report.compareItem": "รายการที่ต้องการเปรียบเทียบ",
  "system.inverterCompare": "การเปรียบเทียบอินเวอร์เตอร์",
  "placeholder.selectScope": "กรุณาเลือก{scope}",
  "register.tooltip.title": "จะค้นหารหัสลงทะเบียนบริษัทได้อย่างไร?",
  "register.tooltip.appPathTitle": "1. ในแอป",
  "register.tooltip.webPathTitle": "2. ในคอนโซลเว็บ",
  "registerAccomplish.companyRegisterCodeIs": "รหัสลงทะเบียนบริษัทของคุณคือ",
  "registerAccomplish.enterSystem": "เข้าสู่ระบบ",
  "registerAccomplish.pleaseLoginFirst": "กรุณาเข้าสู่ระบบก่อน",
  "org.phoneNumber": "เบอร์โทรศัพท์",
  "org.certificationStatus": "สถานะการรับรอง",
  "org.permission": "สิทธิ์การใช้งาน",
  "org.accountSource": "ที่มาของบัญชี",
  "org.certificationStatusTip": "ในขณะนี้ใช้ได้เฉพาะสิทธิ์ในการเพิ่มอุปกรณ์ในแอป Haier Energy เท่านั้น",
  "org.unauthenticated": "ยังไม่ได้รับรองตัวตน",
  "org.authenticated": "ได้รับรองตัวตนแล้ว",
  "org.noNeedToAuthenticate": "ไม่จำเป็นต้องรับรองตัวตน",
  "org.unauthorized": "ไม่ได้รับอนุญาต",
  "org.authorized": "ได้รับอนุญาต",
  "org.temporaryAuthorization": "การอนุญาตชั่วคราว",
  "org.remainingDays": "วันที่เหลือ: {scope} วัน",
  "org.allocated": "จัดสรรแล้ว",
  "org.registered": "ลงทะเบียนแล้ว",
  "org.authorization": "การอนุญาต",
  "org.addressDetail": "ที่อยู่โดยละเอียด",
  "org.postalCode": "รหัสไปรษณีย์",
  "org.accountSwitch": "สลับบัญชี",
  "org.viewAccountInfo": "ดูข้อมูลบัญชี",
  "org.baseInfo": "ข้อมูลพื้นฐาน",
  "org.certificationInfo": "ข้อมูลการรับรอง",
  "org.restDays": "วันที่เหลือ",
  "org.applyTime": "เวลาที่สมัคร",
  "org.certificationTime": "เวลาที่รับรอง",
  "org.registerCode": "รหัสลงทะเบียน",
  "org.registrationTip": "เมื่อลงทะเบียน คุณสามารถกรอกรหัสลงทะเบียนบริษัทเพื่อขอเข้าร่วมบริษัทนั้นได้",
  "org.authenticationTip": "บัญชีนี้ถูกปิดการใช้งาน ไม่สามารถอนุญาตได้",
  "org.authenticationTip2": "บัญชีนี้ได้รับอนุญาตแล้ว หรือการอนุญาตชั่วคราวยังไม่หมดอายุ จึงไม่สามารถอนุญาตซ้ำได้",
  "org.temporaryAuthorizationTip": "การอนุญาตเป็นสิทธิ์ชั่วคราว โดยค่าเริ่มต้นคือ 3 เดือน",
  "org.temporaryAuthorizationSuccess": "อนุญาตสำเร็จ",
  "system.intelligentDiagnosis": "การวินิจฉัยอัจฉริยะ",
  "system.ivline": "เส้นโค้ง IV",
  "subtitle.ivlineCreate": "งานสแกน",
  "diagnosis.diagnosisTime": "เวลาการวินิจฉัย",
  "diagnosis.faultQuantity": "จำนวนข้อผิดพลาด",
  "diagnosis.scanCompleteTime": "เวลาที่สแกนเสร็จสิ้น",
  "diagnosis.scanProgress": "ความคืบหน้าการสแกน",
  "diagnosis.newTask": "สร้างงานใหม่",
  "diagnosis.deleteTask": "ลบงาน",
  "diagnosis.deleteTaskSuccess": "ลบงานเรียบร้อยแล้ว",
  "diagnosis.closeAll": "ล้างทั้งหมด",
  "diagnosis.startScan": "เริ่มสแกน",
  "diagnosis.pleaseChooseInverter": "กรุณาเลือกอินเวอร์เตอร์",
  "diagnosis.stringSetting": "ตั้งค่าสตริง",
  "diagnosis.taskSetting": "ตั้งค่างาน",
  "diagnosis.batchComponentSetting": "ตั้งค่าคอมโพเนนต์แบบกลุ่ม",
  "diagnosis.componentType": "ประเภทคอมโพเนนต์",
  "diagnosis.maxPower": "กำลังไฟสูงสุด (Pmax)",
  "diagnosis.bestWorkingVoltage": "แรงดันทำงานที่เหมาะสมที่สุด (Vmpp)",
  "diagnosis.bestWorkingCurrent": "กระแสทำงานที่เหมาะสมที่สุด (Impp)",
  "diagnosis.openCircuitVoltage": "แรงดันวงจรเปิด (Voc)",
  "diagnosis.shortCircuitCurrent": "กระแสลัดวงจร (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "สัมประสิทธิ์อุณหภูมิของกำลังไฟสูงสุด",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "สัมประสิทธิ์อุณหภูมิของแรงดันวงจรเปิด",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "สัมประสิทธิ์อุณหภูมิของกระแสลัดวงจร",
  "diagnosis.nominalComponentConversionEfficiency": "ประสิทธิภาพการแปลงพลังงานของคอมโพเนนต์ตามค่ามาตรฐาน",
  "diagnosis.firstYearDecayRate": "อัตราการเสื่อมสภาพปีแรก",
  "diagnosis.yearlyDecayRate": "อัตราการเสื่อมสภาพรายปี",
  "diagnosis.fillFactor": "แฟกเตอร์เติมเต็ม (Fill Factor)",
  "product.maxPvChannels": "จำนวนสตริง PV สูงสุดที่รองรับ",
  "product.componentManufacturer": "ผู้ผลิตโมดูล",
  "product.componentType": "ประเภทโมดูล",
  "product.ratedPower": "กำลังไฟฟ้าเรต",
  "product.mppVoltage": "แรงดัน MPP",
  "product.mppCurrent": "กระแส MPP",
  "product.openCircuitVoltage": "แรงดันวงจรเปิด",
  "product.shortCircuitCurrent": "กระแสลัดวงจร",
  "product.maxPowerTempCoeff": "สัมประสิทธิ์อุณหภูมิกำลังสูงสุด",
  "product.openVoltageTempCoeff": "สัมประสิทธิ์อุณหภูมิแรงดันวงจรเปิด",
  "product.shortCurrentTempCoeff": "สัมประสิทธิ์อุณหภูมิกระแสลัดวงจร",
  "product.componentEfficiency": "ประสิทธิภาพการแปลงของโมดูล (ชื่อเรียก)",
  "product.firstYearDegradation": "อัตราเสื่อมปีแรก",
  "product.annualDegradation": "อัตราเสื่อมต่อปี",
  "product.fillFactor": "ฟิลล์แฟกเตอร์",
  "product.placeholder.range_0_9999_2dp": "0-9999 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.placeholder.range_0_99_2dp": "0-99 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.placeholder.range_0_999_2dp": "0-999 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.placeholder.range_neg1_1_2dp": "-1-1 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.rule.range_0_9999_2dp": "กรุณากรอกตัวเลข 0-9999 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.rule.range_0_99_2dp": "กรุณากรอกตัวเลข 0-99 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.rule.range_0_999_2dp": "กรุณากรอกตัวเลข 0-999 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.rule.range_neg1_1_2dp": "กรุณากรอกตัวเลข -1 ถึง 1 ทศนิยมไม่เกินสองตำแหน่ง",
  "product.ivScanSupport": "รองรับการสแกนกราฟ IV",
  "diagnosis.componentManufacturer": "ผู้ผลิตคอมโพเนนต์",
  "diagnosis.componentAmount": "จำนวนคอมโพเนนต์",
  "diagnosis.capacity": "ความจุสตริง",
  "diagnosis.stringAmount": "จำนวนสตริง (ชิ้น)",
  "diagnosis.inverterSerialNumber": "หมายเลขซีเรียลของอินเวอร์เตอร์",
  "diagnosis.totalCapacity": "ความจุสตริงรวม",
  "diagnosis.pleaseFillInAllItems": "มีช่องที่ยังไม่ได้กรอก กรุณาตรวจสอบ",
  "diagnosis.moreParamters": "พารามิเตอร์เพิ่มเติม",
  "diagnosis.envParam": "พารามิเตอร์สภาพแวดล้อม",
  "diagnosis.startTask": "เริ่มงาน",
  "diagnosis.startTaskSuccess": "เริ่มงานสำเร็จ",
  "diagnosis.start": "เริ่ม",
  "diagnosis.noDevice": "ไม่พบอุปกรณ์",
  "plant.withdrawDelivery": "Скасувати доставку",
  "plant.deliverUser": "Передати користувачеві",
  "plant.withdrawDeliveryTip": "Після скасування доставки кінцевий користувач не зможе керувати цією станцією. Дійте обережно.",
  "plant.undelivered": "Не доставлено",
  "plant.deliverManage": "Керування доставкою",
  "plant.email_format_error": "Неправильний формат електронної пошти",
  "plant.deliverUserTip": "Примітка: користувачі можуть увійти в Haier Energy за допомогою електронної пошти та через додаток контролювати встановлені вами пристрої.",
  "plant.deliverSuccess": "Доставлено успішно",
  "plant.known": "Зрозуміло",
  "plant.notRegistered": "Не зареєстровано",
  "plant.noPermission": "Ви не маєте прав скасовувати доставку. Це можуть зробити лише суперадміністратор платформи або адміністратор монтажника.",
  "plant.scanQRCode": "Будь ласка, попросіть власника відсканувати QR-код нижче",
  "plant.qrCodeExpireTip": "Після успішного отримання цей код авторизації стане недійсним.",
  "register.contactAdminForCode": "กรุณาติดต่อผู้ดูแลระบบบริษัทเพื่อขอรับรหัสลงทะเบียนบริษัท",
  "register.provideCompanyInfoBelow": "กรุณาให้ข้อมูลบริษัทด้านล่าง",
  "common.50800.defrosting": "การละลายน้ำแข็ง",
  "common.50800.antiFreezing": "ระบบป้องกันน้ำแข็ง",
  "common.50800.sterilization": "การฆ่าเชื้อ",
  "common.50800.antiRust": "ระบบป้องกันสนิม",
  "common.50800.auto": "อัตโนมัติ",
  "common.50800.cool": "การทำความเย็น",
  "common.50800.heat": "การทำความร้อน",
  "common.50800.dhw": "น้ำร้อนใช้ในครัวเรือน",
  "common.50800.pool": "สระว่ายน้ำ",
  "common.50800.heat+pool": "การทำความร้อน + สระว่ายน้ำ",
  "common.50800.auto+dhw": "อัตโนมัติ + น้ำร้อนใช้ในครัวเรือน",
  "common.50800.cool+dhw": "การทำความเย็น + น้ำร้อนใช้ในครัวเรือน",
  "common.50800.heat+dhw": "การทำความร้อน + น้ำร้อนใช้ในครัวเรือน",
  "shipment.shippingCustomer": "ลูกค้าจัดส่ง",
  "shipment.customerContact": "ผู้ติดต่อลูกค้า",
  "shipment.tag": "แท็ก",
  "shipment.addTag": "เพิ่มแท็ก",
  "shipment.editTag": "แก้ไขแท็ก",
  "shipment.tagContent": "เนื้อหาแท็ก",
  "shipment.tagColor": "สีแท็ก",
  "placeholder.selectShippingCustomer": "กรุณาเลือกลูกค้าจัดส่ง",
  "placeholder.enterCustomerContact": "กรุณาป้อนผู้ติดต่อลูกค้า",
  "placeholder.selectTag": "กรุณาเลือกแท็ก",
  "placeholder.enterTagContent": "กรุณาป้อนเนื้อหาแท็ก",
  "placeholder.noResult": "ไม่มีแท็กที่ตรงกัน",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "โรงไฟฟ้ายังไม่ส่งมอบ",
  "plant.not.exist": "สถานีไฟฟ้าไม่มีอยู่",
  "device.agent.admin.can.operate": "คุณไม่มีสิทธิ์ในการเรียกคืนการส่งมอบ",
  "plant.pure.light": "ศูนย์ที่อยู่อาศัยคาร์บอนเป็นศูนย์ - พลังงานแสงบริสุทธิ์",
  "ywt.60419.meterTPower\n": "กำลังไฟเฟส T ของมิเตอร์ไฟฟ้า",
  "ywt.60419.loadPower\n": "กำลังไฟโหลด",
  "status.enable": "เปิดใช้งาน",
  "status.disable": "ปิดใช้งาน",
  "end.app": "แอป",
  "end.backend": "แบ็กเอนด์",
  "module.product_management": "การจัดการผลิตภัณฑ์",
  "module.plant_management": "การจัดการโรงงาน",
  "module.shipment_management": "การจัดการการจัดส่ง",
  "module.device_management": "การจัดการอุปกรณ์",
  "module.device_detail": "รายละเอียดอุปกรณ์",
  "module.org_management": "การจัดการองค์กร",
  "module.login_register": "เข้าสู่ระบบ / ลงทะเบียน",
  "module.user_management": "การจัดการผู้ใช้",
  "module.family_management": "การจัดการครอบครัว",
  "module.physical_model": "โมเดลทางกายภาพ",
  "module.dictionary_value": "ค่าความหมายในพจนานุกรม",
  "param.name.dongle.reset.returnTip": "สติกเกอร์การสื่อสารรีเซ็ตสำเร็จ โปรดเชื่อมต่ออีกครั้ง",
  "bw_RTparam_name_AFCI_Version": "หมายเลขเวอร์ชัน AFCI",
  "bw_RTparam_name_BB_Version": "หมายเลขเวอร์ชันของบีแบคอัปบ็อกซ์",
  "test.code": "",
  "test.code1": "",
  "test.code3": "",
  "test.code.222": "",
  "dict.sttaus.not.normal": "tai",
  "dict.status.normal": "tai",
  "org.keyFilter": "ป้อนคำหลักเพื่อกรอง",
  "dict.status.not.normal": "tai--normal",
  "test": "",
  "role.status.abnormal": "ผิดปกติ",
  "filter.all.blank.null": "รุ่นการแปลทั้งหมดว่างเปล่า",
  "shipment.confirmDownload": "ดาวน์โหลดรายการ",
  "shipment.updateCustomer": "อัปเดตข้อมูลลูกค้าจัดส่ง",
  "shipment.invalidEquipmentList": "ต้องการดาวน์โหลดรายการอุปกรณ์ที่ตรวจสอบไม่ผ่านหรือไม่? (ใช้ได้ภายใน 10 นาที) จำนวนอุปกรณ์ที่ตรวจสอบไม่ผ่าน:",
  "plant.smart.investment": "การลงทุนอัจฉริยะคาร์บอนเป็นศูนย์",
  "module.oversea": "การจัดการใบงาน",
  "sidebar.workorder": "ใบสั่งงาน",
  "workorder.searchCreateTime": "เวลาที่สร้าง",
  "workorder.statusAll": "ทั้งหมด",
  "workorder.statusPending": "รอดำเนินการ",
  "workorder.statusCompleted": "เสร็จสิ้น",
  "workorder.statusClosed": "ปิดแล้ว",
  "workorder.no": "หมายเลขใบสั่งงาน",
  "workorder.tableDescription": "รายละเอียด",
  "workorder.plant": "โรงงาน",
  "workorder.device": "อุปกรณ์",
  "workorder.tableStatus": "สถานะ",
  "workorder.owner": "ผู้รับผิดชอบ",
  "workorder.handler": "ผู้ดำเนินการ",
  "workorder.handledTime": "เวลาดำเนินการ",
  "workorder.creator": "ผู้สร้าง",
  "workorder.createTime": "เวลาที่สร้าง",
  "workorder.timeTooltip": "เวลาตามเขตเวลาของโรงงาน",
  "workorder.tableAction": "การดำเนินการ",
  "workorder.actionDetails": "รายละเอียด",
  "workorder.actionHandle": "ดำเนินการ",
  "workorder.actionCancel": "ยกเลิก",
  "workorder.createTitle": "สร้างใบสั่งงาน",
  "workorder.description": "รายละเอียดความเสียหาย",
  "workorder.images": "รูปภาพความเสียหาย",
  "workorder.handleTitle": "ดำเนินการใบสั่งงาน",
  "workorder.group": "ข้อมูลการดำเนินการ",
  "workorder.feedback": "ความคิดเห็นการดำเนินการ",
  "workorder.handleimages": "รูปภาพการดำเนินการ",
  "workorder.detailsTitle": "รายละเอียดใบสั่งงาน",
  "workorder.detailsGroup": "ข้อมูลใบสั่งงาน",
  "workorder.uploadSuccess": "อัปโหลดสำเร็จ",
  "workorder.uploadNums": "อัปโหลดรูปภาพได้สูงสุด 3 ไฟล์",
  "workorder.uploadFormatTip": "รูปแบบไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ในรูปแบบ JPG, JPEG หรือ PNG",
  "workorder.uploadFormat": "กรุณาอัปโหลดไฟล์ขนาดไม่เกิน 5 MB ในรูปแบบ PNG/JPG/JPEG",
  "workorder.uploadImage": "อัปโหลด",
  "workorder.cancelTip": "การยกเลิกใบสั่งงานนี้จะปิดใบสั่งงานโดยอัตโนมัติ ดำเนินการต่อหรือไม่?",
  "workorder.basicInformation": "ข้อมูลพื้นฐาน",
  "income.unit.cny.pkr": "PKR",
  "alarmInfo.time": "เวลาเตือนภัย",
  "alarmInfo.duration": "ระยะเวลาของการเตือนภัย",
  "alarmInfo.level": "ระดับการแจ้งเตือน",
  "alarmInfo.triggerCondition": "เงื่อนไขทริกเกอร์",
  "alarmInfo.reason": "สาเหตุของการเตือนภัย",
  "alarmInfo.handleTime": "เวลาในการประมวลผล",
  "alarmInfo.handleType": "ประเภทการประมวลผล",
  "common.maintain": "กรุณารักษาไว้ก่อน",
  "device.robotChannel": "หุ่นยนต์",
  "device.communicationChannel": "แท่งสื่อสาร",
  "device.channelType": "ช่องทางการสื่อสาร",
  "device.switchChannelFailed": "ไม่สามารถเปลี่ยนช่องทางการสื่อสารได้",
  "test.chuneng": "chuneng",
  "Manual": "ด้วยมือ",
  "System": "ระบบ",
  "Processed": "ประมวลผลแล้ว",
  "Critical": "วิกฤติ",
  "Urgent": "ด่วน",
  "Severe": "ร้ายแรง",
  "General": "ทั่วไป",
  "Reminder": "การเตือนความจำ",
  "common.cropper": "การครอบตัดรูปภาพ",
  "common.confirmCropper": "ยืนยันการครอบตัด",
  "screen.platform": "แพลตฟอร์มจัดการพลังงาน",
  "plantScreen.title": "การจัดการโรงไฟฟ้า",
  "plantScreen.DailyElectricityGenerated": "ปริมาณไฟฟ้าที่ผลิตได้รายวัน",
  "plantScreen.DailyElectricityUsed": "ปริมาณไฟฟ้าที่ใช้รายวัน",
  "plantScreen.DailyElectricityPurchased": "ปริมาณไฟฟ้าที่ซื้อรายวัน",
  "plantScreen.DailyElectricitySold": "ปริมาณไฟฟ้าที่ขายรายวัน",
  "plantScreen.ChargingStatus": "สถานะการชาร์จ",
  "plantScreen.BatteryLevel": "ระดับแบตเตอรี่",
  "plantScreen.PhotovoltaicStatus": "สถานะโซลาร์เซลล์",
  "plantScreen.GridStatus": "สถานะกริด",
  "plantScreen.Charging": "กำลังชาร์จ",
  "plantScreen.Discharging": "กำลังคายประจุ",
  "plantScreen.Generating": "กำลังผลิต",
  "plantScreen.Idle": "ไม่ชาร์จไม่คายประจุ",
  "plantScreen.pvIDLE": "ไม่ผลิต",
  "plantScreen.BuyingElectricity": "ซื้อไฟฟ้า",
  "plantScreen.SellingElectricity": "ขายไฟฟ้า",
  "plantScreen.netdead": "ออฟกริด",
  "plantScreen.day": "วัน",
  "plantScreen.month": "เดือน",
  "plantScreen.year": "ปี",
  "plantScreen.life": "สะสม",
  "plantScreen.BatterySOC": "SOC แบตเตอรี่กักเก็บ",
  "plantScreen.PowerAnalysis": "การวิเคราะห์กำลัง",
  "plantScreen.EquivalentRevenue": "รายได้เทียบเท่า",
  "plantScreen.EnergyAnalysis": "การวิเคราะห์พลังงาน",
  "plantScreen.SocialContribution": "การมีส่วนร่วมทางสังคม",
  "plantScreen.Photovoltaic": "โซลาร์เซลล์",
  "plantScreen.Grid": "กริด",
  "plantScreen.Battery": "แบตเตอรี่",
  "plantScreen.Load": "โหลด",
  "plantScreen.Daily": "รายวัน",
  "plantScreen.Monthly": "รายเดือน",
  "plantScreen.Yearly": "รายปี",
  "plantScreen.Cumulative": "สะสม",
  "plantScreen.Unit": "หน่วย",
  "plantScreen.ElectricityGeneration": "ปริมาณการผลิตไฟฟ้า",
  "plantScreen.ElectricityConsumption": "ปริมาณการใช้ไฟฟ้า",
  "plantScreen.ChartSet.explain": "หมายเหตุ: กำลัง > 0 = คายประจุ; กำลัง < 0 = ชาร์จ",
  "plantScreen.ChartSet.Self-consumption": "พลังงานใช้เอง",
  "plantScreen.ChartSet.GridElectricity": "พลังงานขายสู่กริด",
  "plantScreen.ChartSet.Self-Sufficiency": "พลังงานพอเพียง",
  "plantScreen.ChartSet.PurchasedElectricity": "พลังงานที่ซื้อ",
  "plantScreen.ChartSet.PVPower": "กำลังการผลิตไฟฟ้าจากโซลาร์เซลล์",
  "plantScreen.ChartSet.ConsumptionPower": "กำลังการใช้ไฟฟ้า",
  "plantScreen.ChartSet.BatterySOC": "SOC แบตเตอรี่",
  "plantScreen.ChartSet.BatteryChargingPower": "กำลังการชาร์จแบตเตอรี่กักเก็บ",
  "plantScreen.ChartSet.BatteryDischargingPower": "กำลังการคายประจุแบตเตอรี่กักเก็บ",
  "plantScreen.ProtectedForest": "ปกป้องป่า",
  "plantScreen.CO2Emission": "คาร์บอนไดออกไซด์",
  "plantScreen.Media": "ถ่านหิน",
  "plant.EquivalentBenefit.GridView": "รายได้เทียบเท่า = พลังงานใช้เอง * อัตราซื้อ + พลังงานขายสู่กริด * อัตราขาย",
  "plant.MonitoringScreen": "จอมอนิเตอร์",
  "common.networkUnstable": "การเชื่อมต่อเครือข่ายขาดหาย โปรดตรวจสอบการตั้งค่าเครือข่ายของคุณ",
  "common.networkFull": "อินเทอร์เน็ตก็เต็มไปด้วยแสงแดดอีกครั้ง",
  "common.networkSlow": "เครือข่ายปัจจุบันช้า โปรดรอสักครู่หรือตรวจสอบการตั้งค่าเครือข่าย",
  "common.requestTimeout": "คำขอหมดเวลา โปรดตรวจสอบเครือข่ายหรือลองอีกครั้งในภายหลัง",
  "welcome": "",
  "device.operatingDataInfoTip": "หมายเหตุ: หากช่องนี้ว่างเปล่า กรุณาติดต่อผู้ดูแลระบบแพลตฟอร์ม IoT เพื่อทำการตั้งค่า",
  "shipment.operationRecordTitle": "ประวัติการดำเนินการ",
  "shipment.boundUserWarning": "ขออภัย อุปกรณ์นี้ถูกผูกกับผู้ใช้แล้ว ไม่สามารถอัปเดตลูกค้าการจัดส่งได้",
  "shipment.batchBoundUserWarning": "ขออภัย อุปกรณ์ที่เลือกมีอุปกรณ์ที่ถูกผูกกับผู้ใช้แล้วอยู่ด้วย ไม่สามารถอัปเดตลูกค้าการจัดส่งแบบกลุ่มได้",
  "shipment.uploadEquipmentListRequired": "กรุณาอัปโหลดไฟล์รายการอุปกรณ์",
  "shipment.errorDataTipTitle": "การแจ้งเตือนข้อมูลผิดปกติ",
  "shipment.downloadImportResult": "ดาวน์โหลดผลการนำเข้า",
  "shipment.downloading": "กำลังดาวน์โหลด...",
  "shipment.noFailedDataToDownload": "ไม่มีข้อมูลที่ล้มเหลวให้ดาวน์โหลด",
  "shipment.deleteTagConfirm": "คุณแน่ใจหรือไม่ว่าต้องการลบแท็ก \"{tagName}\"?",
  "common.addSuccess": "เพิ่มสำเร็จ",
  "common.editSuccess": "แก้ไขสำเร็จ",
  "dynamic.price.not.exist": "ไม่สามารถรับราคาค่าการใช้ไฟฟ้าสะสมได้",
  "product.pleaseUploadAtLeastOneImage": "กรุณาอัปโหลดรูปภาพอย่างน้อยหนึ่งรูป",
  "device.importTemplateDownload": "ดาวน์โหลดเทมเพลตนำเข้า",
  "device.snNumber": "หมายเลข SN",
  "device.enterSnCode": "กรุณากรอกรหัส SN",
  "device.enterSupplierSN": "กรุณากรอก SN ของผู้จัดจำหน่าย",
  "device.deviceModelLabel": "รุ่นอุปกรณ์",
  "device.importTip": "กรุณานำเข้ารหัสโรงไฟฟ้า ชื่ออุปกรณ์ หมายเลข SN และรหัส MDM ที่เกี่ยวข้อง",
  "device.importTip2": "กรุณานำเข้าชื่ออุปกรณ์ หมายเลข SN และรหัส MDM ที่เกี่ยวข้อง",
  "device.keepAtLeastOneRow": "ต้องเหลืออย่างน้อยหนึ่งแถว",
  "device.importSuccessWithCount": "นำเข้าข้อมูลอุปกรณ์ {count} รายการสำเร็จ",
  "device.fillAllRequiredFields": "กรุณากรอกฟิลด์ที่จำเป็นทั้งหมด",
  "device.enterPlantCode": "กรุณากรอกรหัสโรงไฟฟ้า",
  "device.plantCodeLabel": "รหัสโรงไฟฟ้า",
  "device.supplierSNLabel": "SN ของผู้จัดจำหน่าย",
  "device.importTemplateEmpty": "เทมเพลตนำเข้าเป็นค่าว่าง",
  "product.syncIotI18n": "Синхронізувати записи моделі IoT Qingluo",
  "product.confirmSyncIotI18n": "Ви впевнені, що хочете синхронізувати записи моделі IoT Qingluo?",
  "plant.plantCategory": "ประเภทสถานีไฟฟ้า",
  "plant.plantCode": "การเข้ารหัสสถานีไฟฟ้า",
  "plant.energyStorageCapacity": "ความจุในการจัดเก็บพลังงาน",
  "plant.energyStoragePower": "กำลังไฟฟ้าพลังงานสะสม",
  "plant.gridConnectionMode": "วิธีการออนไลน์",
  "plant.img": "รูปภาพสถานีไฟฟ้า",
  "device.realTimeMonitoring": "การตรวจสอบแบบเรียลไทม์",
  "device.propertyName": "ชื่ออสังหาริมทรัพย์",
  "device.issueCommand": "ผมล่าง",
  "device.history": "ประวัติศาสตร์",
  "device.properName": "ชื่อ",
  "device.daterange": "กำหนดเอง",
  "device.near24h": "เกือบ 24 ชั่วโมง",
  "device.date": "วันนี้",
  "device.near3d": "เกือบ 3 วัน",
  "device.chartModule": "โมดูลแผนภูมิ",
  "device.lineChart": "กราฟเส้นโค้ง",
  "device.barChart": "กราฟแท่ง",
  "device.dateRangeDayError": "ช่วงวันที่ควรอยู่ใน {scope} วัน",
  "device.SOCHistoryData": "ข้อมูลย้อนหลัง",
  "device.paramSave": "พารามิเตอร์ลง",
  "common.deleteTip": "ยืนยันการลบ {scope}?",
  "product.deleteConfirm": "คุณแน่ใจหรือไม่ว่าต้องการลบผลิตภัณฑ์ {productName}?",
  "upgrade.upgradeSN": "อัพเกรด SN",
  "upgrade.datalogSN": "บันทึกข้อมูล SN",
  "upgrade.upgradeType": "ประเภทการอัพเกรด",
  "upgrade.fileAddress": "ที่อยู่ไฟล์",
  "upgrade.plantTime": "เวลาสถานีไฟฟ้า",
  "upgrade.timeUTC8": "เวลา (UTC + 8)",
  "upgrade.timeServer": "เวลา (เซิร์ฟเวอร์)",
  "upgrade.content": "เนื้อหา",
  "upgrade.account": "หมายเลขบัญชี",
  "upgrade.devicesSN": "อุปกรณ์ SN",
  "firmware.secretType": "ประเภทความลับ",
  "product.ratedPowerOnTheACSide": "กำลังนามสกุลด้านข้าง AC (kW)",
  "product.ratedPowerOnTheDCSide": "กำลังนามสกุลด้านข้าง DC (kW)",
  "product.energyStoragePower": "กำลังจัดเก็บพลังงาน (kW)",
  "product.energyStorageCapacity": "ความจุจัดเก็บพลังงาน (kWh)",
  "login.downloadApp": "ดาวน์โหลดแอป",
  "login.agreeAndAccept": "ยอมรับและตกลง",
  "login.temporarilyDisagree": "ไม่ยอมรับชั่วคราว",
  "system.selfServiceReport": "บริการตนเอง",
  "iot.device.register.failed": "ลงทะเบียนอุปกรณ์ IoT ไม่สำเร็จ",
  "product.IoIDandPlatformSource": "รหัสผลิตภัณฑ์ IoT และแหล่งที่มาของแพลตฟอร์ม",
  "product.productIdCannotRepeat": "รหัสผลิตภัณฑ์ต้องไม่ซ้ำกัน",
  "common.title": "การตั้งค่าการแสดงคอลัมน์",
  "common.fixedLeft": "ตรึงไว้ทางซ้าย",
  "common.fixedRight": "ตรึงไว้ทางขวา",
  "common.notFixed": "ไม่ตรึง",
  "common.unfix": "เลิกตรึง",
  "common.resetSuccess": "รีเซ็ตการตั้งค่าคอลัมน์สำเร็จ",
  "system.selfServiceReport.hour": "ชั่วโมง",
  "system.selfServiceReport.selectPlant": "กรุณาเลือกสถานีไฟฟ้า",
  "system.selfServiceReport.selectYear": "เลือกปี",
  "system.selfServiceReport.metricSelection": "เลือกตัวชี้วัด",
  "system.selfServiceReport.required": "บังคับ",
  "system.selfServiceReport.startTimeCannotBeLater": "เวลาเริ่มต้นต้องไม่มากกว่าเวลาสิ้นสุด",
  "system.selfServiceReport.fieldIsRequired": "{field} เป็นข้อมูลบังคับ",
  "product.deviceTypeAccess.maxAddRows": "สามารถเพิ่มได้สูงสุด 2 รายการเท่านั้น",
  "product.accessPlatformCannotRepeat": "แหล่งที่มาของแพลตฟอร์มต้องไม่ซ้ำกัน",
  "alarmInfo.exceptionDesc": "คำอธิบายข้อยกเว้น",
  "alarmInfo.suggestion": "คำแนะนำในการจัดการ",
  "language.syncIot": "ซิงค์การแจ้งเตือน IoT",
  "language.syncSuccess": "ซิงค์การตั้งค่าการแจ้งเตือน IoT ของ Qingluo สำเร็จ",
  "plant.saveTimezoneTip": "การเปลี่ยนเขตเวลาอาจทำให้เกิด:\nกราฟข้อมูลอุปกรณ์ขาดช่วงหรือซ้อนทับกัน (กินเวลาหลายชั่วโมง)\nงานภายในอุปกรณ์อาจสับสนและอาจออฟไลน์ชั่วคราว",
  "plant.deviceCount": "จำนวนอุปกรณ์ที่ติดตั้งแล้ว",
  "common.rangeErrorTip": "ช่วง {scope} ผิดพลาด โปรดยืนยัน",
  "expired": "หมดอายุ",
  "due.today": "ภายในวันนี้",
  "register.goToLogin": "ไปที่การเข้าสู่ระบบ",
  "register.completeRegistration": "เสร็จสิ้นการลงทะเบียน",
  "register.accountAlreadyRegistered": "อีเมลหรือหมายเลขโทรศัพท์นี้ลงทะเบียนแล้ว กรุณาเข้าสู่ระบบหรือใช้บัญชีอื่น",
  "registerAccomplish.greenChannelDescription2": "สิทธิ์บัญชีที่ได้รับผ่านช่องทางนี้เป็นสิทธิ์ชั่วคราว และระยะเวลาที่ใช้ในการเปิดใช้งานอุปกรณ์คือ 2 เดือน",
  "registerAccomplish.greenChannelDescription3": "คุณต้องไปที่ศูนย์รับรองภายใน 2 เดือนเพื่อดำเนินการยืนยันตัวตนให้เสร็จสมบูรณ์และรับสิทธิ์ถาวรในการเปิดใช้งานอุปกรณ์",
  "priceConfig.effectiveTimeLabel": "ช่วงเวลาที่มีผล",
  "priceConfig.currentEffectivePrice": "อัตราค่าไฟที่มีผลอยู่ในปัจจุบัน",
  "priceConfig.currencyUnitLabel": "สกุลเงิน:",
  "priceConfig.addPrice": "เพิ่มอัตราค่าไฟ",
  "priceConfig.powerPrice": "อัตราค่าไฟฟ้า",
  "priceConfig.additionalFees": "ค่าธรรมเนียมเพิ่มเติม",
  "priceConfig.lastUpdateTime": "อัปเดตล่าสุด",
  "priceConfig.lastUpdateTimeLabel": "อัปเดตล่าสุด",
  "priceConfig.emptyCurrent": "ยังไม่มีอัตราค่าไฟที่มีผล โปรดคลิกปุ่มเพื่อกำหนดค่า",
  "priceConfig.emptyUpcoming": "ยังไม่มีอัตราค่าไฟที่จะมีผล",
  "priceConfig.upcomingTitle": "อัตราค่าไฟที่จะมีผล",
  "priceConfig.copyPriceTitle": "คัดลอกอัตราค่าไฟ",
  "priceConfig.deletePriceTitle": "ลบอัตราค่าไฟ",
  "priceConfig.deleteConfirmText": "โปรดยืนยันการลบอัตราค่าไฟต่อไปนี้",
  "priceConfig.otherPrice": "ค่าใช้จ่ายอื่น ๆ",
  "priceConfig.deleteWarning": "หากอัตราค่าไฟนี้กำลังมีผลอยู่ จะมีผลต่อการคำนวณรายได้และการทำงานของกลยุทธ์ AI",
  "priceConfig.priceTypeLabel": "ประเภทอัตราค่าไฟ",
  "priceConfig.timeOfUse": "ตามช่วงเวลา",
  "priceConfig.dynamic": "ไดนามิก",
  "priceConfig.timeOfUsePrice": "อัตราค่าไฟตามช่วงเวลา",
  "priceConfig.dynamicPrice": "อัตราค่าไฟแบบไดนามิก",
  "priceConfig.effectiveDatePlaceholder": "โปรดเลือกวันที่เริ่มมีผล",
  "priceConfig.copyEffectiveDatePlaceholder": "โปรดเลือกวันที่เริ่มมีผล",
  "priceConfig.nextStep": "ถัดไป",
  "priceConfig.buyPriceTitle": "อัตราค่าไฟซื้อไฟ",
  "priceConfig.feedInPriceTitle": "อัตราค่าไฟขายไฟเข้ากริด",
  "priceConfig.addTimePeriod": "เพิ่มช่วงเวลา",
  "priceConfig.electricitySurchargeTitle": "ค่าธรรมเนียมต่อหน่วยพลังงาน",
  "priceConfig.electricitySurchargeTooltip": "ค่าธรรมเนียมเพิ่มเติมต่อ 1 หน่วยไฟฟ้าที่ซื้อ",
  "priceConfig.fixedFeeTitle": "ค่าคงที่",
  "priceConfig.fixedFeeTooltip": "ค่าใช้จ่ายพื้นฐานประจำรอบบิลที่เป็นจำนวนคงที่ ไม่เปลี่ยนตามปริมาณการใช้หรือกำลัง",
  "priceConfig.hasFeeYes": "มี",
  "priceConfig.countryLabel": "ประเทศ",
  "priceConfig.secondaryRegionLabel": "พื้นที่ระดับที่สอง",
  "priceConfig.secondaryRegionPlaceholder": "โปรดเลือกพื้นที่ระดับที่สอง",
  "priceConfig.currencyUnitPlaceholder": "โปรดเลือกสกุลเงิน",
  "priceConfig.powerMarketLabel": "ตลาดไฟฟ้า",
  "priceConfig.powerMarketPlaceholder": "โปรดเลือกตลาดไฟฟ้า",
  "priceConfig.electricitySurchargePlaceholder": "ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0",
  "priceConfig.fixedFeePlaceholder": "ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0",
  "priceConfig.priceInputPlaceholder": "กรอกราคาไฟฟ้า (ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0)",
  "priceConfig.timePlaceholder": "เลือกเวลา",
  "priceConfig.selectEffectiveTimeTip": "โปรดเลือกช่วงเวลาที่มีผล",
  "priceConfig.selectPriceTypeTip": "โปรดเลือกประเภทอัตราค่าไฟ",
  "priceConfig.selectCountryTip": "โปรดเลือกประเทศ",
  "priceConfig.selectSecondaryRegionTip": "โปรดเลือกพื้นที่ระดับที่สอง",
  "priceConfig.selectCurrencyUnitTip": "โปรดเลือกสกุลเงิน",
  "priceConfig.selectPowerMarketTip": "โปรดเลือกตลาดไฟฟ้า",
  "priceConfig.electricitySurchargeInputTip": "กรุณากรอกค่าธรรมเนียมต่อหน่วยพลังงาน (ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "ค่าธรรมเนียมต่อหน่วยพลังงาน: ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0",
  "priceConfig.fixedFeeInputTip": "กรุณากรอกค่าคงที่ (ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "ค่าคงที่: ตัวเลขเต็มสูงสุด 7 หลัก ทศนิยม 8 หลัก และ ≥ 0",
  "priceConfig.buyTimeFullDayTip": "ช่วงเวลาอัตราค่าไฟซื้อไฟต้องรวม 24 ชั่วโมงครบทุกช่วง",
  "priceConfig.feedInTimeFullDayTip": "ช่วงเวลาอัตราค่าไฟขายไฟเข้ากริดต้องรวม 24 ชั่วโมงครบทุกช่วง",
  "priceConfig.buyTimeNoOverlapTip": "ช่วงเวลาอัตราค่าไฟซื้อไฟต้องไม่ทับซ้อนกัน",
  "priceConfig.feedInTimeNoOverlapTip": "ช่วงเวลาอัตราค่าไฟขายไฟเข้ากริดต้องไม่ทับซ้อนกัน",
  "priceConfig.loadFail": "ไม่สามารถโหลดข้อมูลอัตราค่าไฟได้",
  "priceConfig.copySelectPriceTip": "ยังไม่ได้เลือกอัตราค่าไฟ ไม่สามารถคัดลอกได้",
  "priceConfig.copyMissingPlantTip": "ไม่มีข้อมูลสถานีไฟฟ้า ไม่สามารถคัดลอกอัตราค่าไฟได้",
  "priceConfig.copySuccess": "คัดลอกสำเร็จ",
  "priceConfig.copyFail": "คัดลอกไม่สำเร็จ",
  "priceConfig.copyUnsupportedTip": "ไม่รองรับการคัดลอกอัตราค่าไฟประเภทนี้",
  "priceConfig.deleteSelectPriceTip": "ยังไม่ได้เลือกอัตราค่าไฟ",
  "priceConfig.deleteIdMissingTip": "ไม่พบรหัสอัตราค่าไฟ การลบล้มเหลว",
  "priceConfig.deleteSuccess": "ลบสำเร็จ",
  "priceConfig.deleteFail": "ลบไม่สำเร็จ",
  "priceConfig.missingPlantInfoTip": "ไม่มีข้อมูลสถานีไฟฟ้า",
  "priceConfig.confirmGiveUpEditTip": "คุณแน่ใจหรือไม่ว่าจะยกเลิกการแก้ไขอัตราค่าไฟนี้?",
  "priceConfig.confirmGiveUpCreateTip": "คุณแน่ใจหรือไม่ว่าจะยกเลิกการสร้างอัตราค่าไฟนี้?",
  "priceConfig.pageTitleAdd": "สร้างอัตราค่าไฟ",
  "priceConfig.pageTitleEdit": "แก้ไขอัตราค่าไฟ",
  "priceConfig.pageTitleView": "ดูอัตราค่าไฟ",
  "priceConfig.createSuccess": "สร้างสำเร็จ",
  "priceConfig.editSuccess": "แก้ไขสำเร็จ",
  "priceConfig.saveFail": "บันทึกไม่สำเร็จ",
  "priceConfig.dateRangePermanent": "{start} ถึง ไม่มีกำหนด",
  "priceConfig.dateRange": "{start} ถึง {end}",
  "priceConfig.routeTitle": "ราคาไฟฟ้า",
  "priceConfig.priceLabel": "ราคา",
  "priceConfig.surchargeLabel": "ค่าบริการเพิ่ม",
  "priceConfig.fixedFeeLabel": "ค่าบริการคงที่",
  "button.copy": "คัดลอก",
  "common.view": "ดู",
  "sidebar.bulletinBoard": "ติดตั้ง",
  "sidebar.dataQuery": "ค้นหาข้อมูล",
  "plant.electrovalence": "การกำหนดค่าอัตราค่าไฟฟ้า",
  "plant.energy_management": "การจัดการพลังงาน",
  "plant.energy_todayStrategy": "กลยุทธ์วันนี้",
  "plant.energy_PeakShavingAndValleyFilling": "การลดค่าพีคและเพิ่มค่าฐาน",
  "plant.energy_ValidTime": "เวลาที่มีผล",
  "plant.energy_Charging": "การชาร์จ",
  "plant.energy_Discharging": "การคายประจุ",
  "plant.energy_SelectStartTime": "เลือกเวลาเริ่มต้น",
  "plant.energy_StrategyName": "ชื่อกลยุทธ์",
  "plant.energy_StrategyType": "ประเภทกลยุทธ์",
  "plant.energy_Status": "สถานะ",
  "plant.energy_No": "ลำดับที่",
  "plant.energy_StartDate": "วันที่เริ่ม",
  "plant.energy_EndDate": "วันที่สิ้นสุด",
  "plant.energy_AddStrategy": "เพิ่มกลยุทธ์",
  "plant.energy_EffectiveTime": "เวลาที่มีผลบังคับใช้",
  "plant.energy_SelectStrategy": "เลือกกลยุทธ์",
  "plant.energy_SelectCorrespondingStrategy": "เลือกกลยุทธ์ที่สอดคล้องกัน",
  "plant.energy_ConfirmAndDeploy": "ยืนยันและส่งไปดำเนินการ",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "โปรดยืนยัน บันทึก และส่งไปดำเนินการกลยุทธ์",
  "plant.energy_Cancel": "ยกเลิก",
  "plant.energy_PleaseConfirmStrategyDeletion": "โปรดยืนยันการลบกลยุทธ์",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "หากไม่มีกลยุทธ์อื่น ให้ดำเนินการกลยุทธ์แบบมือถือ",
  "plant.energy_PriorityChargingTime": "เวลาชาร์จที่มีลำดับความสำคัญ",
  "plant.energy_PriorityDischargingTime": "เวลาคายประจุที่มีลำดับความสำคัญ",
  "plant.energy_PVConsumptionPeriod": "ช่วงเวลาการใช้พลังงานโซลาร์เซลล์",
  "plant.energy_StartTime": "เวลาเริ่มต้น",
  "plant.energy_EndTime": "เวลาสิ้นสุด",
  "plant.energy_ChargingPower": "กำลังชาร์จ",
  "plant.energy_DischargingPower": "กำลังคายประจุ",
  "plant.energy_SOCUpperLimit": "ขีดจำกัดบนของ SOC",
  "plant.energy_SOCLowerLimit": "ขีดจำกัดล่างของ SOC",
  "plant.energy_Action": "การดำเนินการ",
  "plant.energy_AddTimePeriod": "เพิ่มช่วงเวลา",
  "plant.energy_ChargingStatus": "สถานะการชาร์จ",
  "plant.energy_DischargingPower_kW": "กำลังคายประจุ (กิโลวัตต์)",
  "plant.energy_copyStrategy": "คัดลอกกลยุทธ์",
  "plant.energy_examine": "ดู",
  "plant.energy_delete": "ลบ",
  "plant.energy_edit": "แก้ไข",
  "plant.energy_basicInfo": "ข้อมูลพื้นฐาน",
  "plant.energy_PriorityChargingDischargingTime": "เวลาชาร์จและคายประจุที่มีลำดับความสำคัญ",
  "plant.energy_PeakShavingAtLeastOne": "ต้องมีอย่างน้อยหนึ่งรายการ",
  "plant.energy_overlapTime": "ห้ามมีช่วงเวลาเหลื่อมซ้อนกัน",
  "plant.energy_cover24hour": "ช่วงเวลาต้องครอบคลุม 24 ชั่วโมง",
  "plant.energy_PleaseConfirmStrategyModification": "โปรดยืนยันการแก้ไขกลยุทธ์",
  "plant.energy_Strategy": "กลยุทธ์",
  "plant.energy_cutOff_SOC": "SOC จุดหยุด",
  "plant.energy_EditStrategy": "แก้ไขกลยุทธ์",
  "plant.energy_ExamineStrategy": "ดูกลยุทธ์",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) ช่วงเวลาการชาร์จลำดับความสำคัญ: ชาร์จแบตเตอรี่โดยใช้พลังงานโซลาร์เซลล์ส่วนเกินและไฟฟ้าจากกริด (ช่วงนอกเวลาพีค) เพื่อให้ระดับ SOC ถึงค่าที่ตั้งไว้ แบตเตอรี่ไม่คายประจุ",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) ช่วงเวลาการคายประจุลำดับความสำคัญ: พลังงานโซลาร์เซลล์ส่วนเกินชาร์จแบตเตอรี่ เมื่อพลังงานโซลาร์เซลล์ไม่เพียงพอ แบตเตอรี่จะคายประจุก่อน ไปจนถึงขีดจำกัด SOC ที่ตั้งไว้ การจ่ายไฟจากกริดเป็นลำดับรอง",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) ช่วงเวลาการใช้พลังงานโซลาร์เซลล์: ไฟฟ้าจากโซลาร์เซลล์มีลำดับความสำคัญสำหรับการใช้โหลดก่อน จากนั้นสำหรับการชาร์จแบตเตอรี่ (จนถึงขีดจำกัดบนของ SOC) และสุดท้ายพลังงานส่วนเกินจะถูกจำกัดหรือขายเข้าสู่กริด เมื่อพลังงานโซลาร์เซลล์ไม่เพียงพอ แบตเตอรี่จะคายประจุก่อน (จนถึงขีดจำกัดล่างของ SOC) ตามด้วยการจ่ายไฟจากกริด",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) ช่วงเวลาอื่น: ไฟฟ้าจากโซลาร์เซลล์มีลำดับความสำคัญสำหรับการใช้โหลดก่อน จากนั้นสำหรับการชาร์จแบตเตอรี่ (จนถึงขีดจำกัดบนของ SOC) และสุดท้ายพลังงานส่วนเกินจะถูกจำกัดหรือขายเข้าสู่กริด แบตเตอรี่ไม่คายประจุ",
  "plant.energy_peak_shaving_valley_filling_explain": "กลยุทธ์ที่กำหนดเวลาการชาร์จ/คายประจุแบตเตอรี่เพื่อลดภาระในช่วงพีคและตอบสนองความต้องการในช่วงฐาน เพื่อให้การใช้ทรัพยากรเป็นไปอย่างสมดุล",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "ไฟฟ้าจากโซลาร์เซลล์มีลำดับความสำคัญสำหรับการใช้โหลดก่อน จากนั้นสำหรับการใช้งานของแบตเตอรี่ และสุดท้ายการผลิตไฟฟ้าจากโซลาร์เซลล์จะถูกจำกัดเพื่อป้องกันการไหลย้อนกลับ เมื่อพลังงานโซลาร์เซลล์ไม่เพียงพอ แบตเตอรี่จะคายประจุก่อน ตามด้วยการจ่ายไฟจากกริด",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "ไฟฟ้าจากโซลาร์เซลล์มีลำดับความสำคัญสำหรับการใช้โหลดก่อน จากนั้นสำหรับการใช้งานของแบตเตอรี่ และสุดท้ายพลังงานส่วนเกินจะขายเข้าสู่กริด เมื่อพลังงานโซลาร์เซลล์ไม่เพียงพอ แบตเตอรี่จะคายประจุก่อน ตามด้วยการจ่ายไฟจากกริด",
  "plant.energy_smart_strategy_station_profit_priority_explain": "รวมเป้าหมายหลายมิติ เช่น อัตราค่าไฟฟ้าตามช่วงเวลา การใช้พลังงานโซลาร์เซลล์ การเก็งกำไรช่วงพีคและฐาน การพยากรณ์โซลาร์เซลล์และโหลด และการจัดการความต้องการ ภายใต้เงื่อนไขของการรับประกันการทำงานที่เสถียรของไมโครกริด หุ่นยนต์ AI จะคำนวณและหาคำตอบที่เหมาะสมสำหรับการจัดการแบตเตอรี่กักเก็บพลังงานและโหลดที่ปรับได้อย่างชาญฉลาด เพื่อเพิ่มรายได้ของสถานที่โดยรวมให้สูงสุด",
  "plant.energy_manual_mode_explain": "ปัจจุบันไม่มีกลยุทธ์การจัดส่งไฟฟ้าสำหรับโซลาร์เซลล์และแบตเตอรี่กักเก็บพลังงาน โปรดไปที่หน้าอุปกรณ์เพื่อดำเนินการด้วยตนเอง",
  "plant.energy_SOCUpperLowerLimits": "ขีดจำกัดบนและล่างของ SOC",
  "plant.energy_ChargeDischargePower": "กำลังชาร์จและคายประจุ",
  "plant.energy_ChargeDischargeStatus": "สถานะการชาร์จและคายประจุ",
  "cookie.cookiePolicyText": "นโยบายคุกกี้",
  "cookie.savePreferences": "บันทึกการตั้งค่า",
  "cookie.preferencesTitle": "การตั้งค่าคุกกี้",
  "cookie.necessaryAccountExplain": "ใช้เพื่อรักษาสถานะการเข้าสู่ระบบของผู้ใช้ ซึ่งเป็นฟังก์ชันหลักของการยืนยันตัวตนเว็บไซต์และการจัดการเซสชัน หากไม่มีคุกกี้นี้ บัญชีผู้ใช้อาจไม่แสดงข้อมูลบนหน้าที่เข้าชมอย่างถูกต้อง",
  "cookie.necessaryAccount": "การยืนยันตัวตน",
  "cookie.necessaryExplain": "คุกกี้ประเภทนี้มีความจำเป็นอย่างยิ่งต่อการทำงานของเว็บไซต์ และไม่สามารถปิดการทำงานในระบบของเราได้ โดยปกติคุกกี้เหล่านี้จะถูกตั้งค่าผ่านการดำเนินการต่างๆ ของคุณ ซึ่งถือเป็นคำขอรับบริการ เช่น การตั้งค่าความเป็นส่วนตัว การเข้าสู่ระบบ หรือการกรอกแบบฟอร์ม คุณสามารถกำหนดให้เบราว์เซอร์ของคุณบล็อก หรือแจ้งเตือนเมื่อมีคุกกี้เหล่านี้ แต่บางส่วนของเว็บไซต์อาจไม่สามารถทำงานได้ คุกกี้ประเภทนี้จะไม่จัดเก็บข้อมูลส่วนบุคคลใดๆ ที่สามารถระบุตัวตนได้",
  "cookie.networkInfo": "ข้อมูลเครือข่าย",
  "cookie.networkInfoExplain": "วิเคราะห์ตำแหน่งทางภูมิศาสตร์และเครือข่ายผู้ให้บริการอินเทอร์เน็ต (ISP) เพื่อระบุการเข้าถึงที่เป็นอันตรายและปริมาณการเข้าชมที่ผิดปกติ เพิ่มประสิทธิภาพการกระจายเนื้อหาสำหรับผู้ให้บริการคลาวด์",
  "cookie.openPreferences": "ตั้งค่ากำหนด",
  "cookie.pageInfo": "ข้อมูลหน้าเว็บ",
  "cookie.pageInfoExplain": "บันทึกเส้นทางการเข้าถึงหน้าเว็บ คำขอ API และเวลาในการโหลดทรัพยากร เพื่อระบุปัญหาคอขวดด้านประสิทธิภาพ คำขอที่ล้มเหลว และข้อผิดพลาดของโค้ด ช่วยให้ทีมพัฒนาแก้ไขปัญหาที่เกิดขึ้นได้อย่างรวดเร็ว",
  "cookie.performance": "คุกกี้เพื่อประสิทธิภาพ",
  "cookie.performanceExplain": "คุกกี้ประเภทนี้ช่วยให้นับจำนวนผู้เยี่ยมชมและแหล่งที่มาของการเข้าชม เพื่อให้สามารถวัดและปรับปรุงประสิทธิภาพของเว็บไซต์ของเราได้ ช่วยให้ทราบว่าหน้าใดได้รับความนิยมมากที่สุดและน้อยที่สุด และดูว่าผู้เข้าชมมีการเคลื่อนไหวภายในเว็บไซต์อย่างไร ข้อมูลทั้งหมดที่คุกกี้เหล่านี้เก็บรวบรวมจะถูกรวมเข้าด้วยกัน และไม่สามารถระบุตัวตนได้ หากคุณไม่อนุญาตคุกกี้เหล่านี้ เราจะไม่ทราบว่าคุณเข้าชมเว็บไซต์ของเราเมื่อใด และจะไม่สามารถติดตามประสิทธิภาพของเว็บไซต์ได้",
  "cookie.sessionManagement": "การจัดการเซสชัน",
  "cookie.sessionManagementExplain": "ใช้เพื่อระบุเซสชันของผู้ใช้โดยเฉพาะ โดยรักษาฟังก์ชันหลักต่างๆ เช่น สถานะการเข้าสู่ระบบของผู้ใช้ เนื้อหาในตะกร้าสินค้า และข้อมูลแบบฟอร์ม",
  "cookie.targeting": "คุกกี้เพื่อการกำหนดเป้าหมาย",
  "cookie.targetingExplain": "คุกกี้ประเภทนี้อาจถูกกำหนดผ่านเว็บไซต์ของเราโดยพันธมิตรโฆษณาของเรา บริษัทเหล่านี้อาจนำไปใช้เพื่อสร้างโปรไฟล์ความสนใจของคุณ และแสดงโฆษณาที่เกี่ยวข้องให้คุณบนเว็บไซต์อื่นๆ คุกกี้เหล่านี้ไม่ได้จัดเก็บข้อมูลส่วนบุคคลโดยตรง แต่จะอ้างอิงจากการระบุตัวตนเฉพาะของเบราว์เซอร์และอุปกรณ์อินเทอร์เน็ตของคุณ หากคุณไม่อนุญาตคุกกี้เหล่านี้ คุณจะพบกับโฆษณาที่ตรงกับความสนใจน้อยลง",
  "cookie.userInfo": "ข้อมูลผู้ใช้",
  "cookie.userInfoExplain": "ใช้เพื่อติดตามตัวชี้วัดทางธุรกิจ เช่น การดูหน้าเว็บ (PV) และผู้เข้าชมที่ไม่ซ้ำ (UV) วิเคราะห์ปริมาณการเข้าชมระบบและการมีส่วนร่วมของผู้ใช้ เพื่อจัดลำดับความสำคัญของฟังก์ชันต่างๆ ให้สอดคล้องกับความต้องการหลัก",
  "cookie.userPreference": "การตั้งค่าอินเทอร์เฟซ",
  "cookie.userPreferenceExplain": "ใช้สำหรับบันทึกการตั้งค่าอินเทอร์เฟซผู้ใช้เพื่อปรับปรุงประสบการณ์การใช้งานเท่านั้น ไม่ใช่ฟังก์ชันหลักที่จำเป็นสำหรับการทำงานของเว็บไซต์",
  "cookie.cookieSwitch": "สวิตช์",
  "cookie.acceptNecessary": "เฉพาะที่จำเป็น",
  "cookie.bannerExplain": "เพื่อปรับปรุงประสบการณ์การท่องเว็บให้ดีขึ้น เราใช้คุกกี้เพื่อบันทึกสถานะการเข้าสู่ระบบ จดจำการตั้งค่าของคุณ และปรับให้เข้ากับพฤติกรรมการท่องเว็บของคุณ การคลิก 'ยอมรับทั้งหมด' หมายถึงคุณยอมรับนโยบายคุกกี้ของเรา",
  "cookie.cookieCategory": "หมวดหมู่คุกกี้",
  "cookie.cookieDescription": "วัตถุประสงค์",
  "cookie.cookieDuration": "ระยะเวลาที่มีผล",
  "cookie.cookieName": "ชื่อคุกกี้",
  "cookie.cookiePolicy": "นโยบายคุกกี้",
  "cookie.cookieSet": "การตั้งค่าคุกกี้",
  "cookie.cookieSetExplain": "สำหรับข้อมูลเพิ่มเติม โปรดดูที่",
  "cookie.acceptAll": "ยอมรับทั้งหมด",
  "cookie.deviceInfo": "ข้อมูลอุปกรณ์",
  "cookie.deviceInfoExplain": "แก้ไขปัญหาการจัดวางและความเข้ากันได้ของแต่ละอุปกรณ์ตามระบบปฏิบัติการ รุ่นอุปกรณ์ และประเภทเบราว์เซอร์ที่แตกต่างกัน เพิ่มประสิทธิภาพฟังก์ชันการปรับให้เหมาะกับอุปกรณ์ต่างๆ",
  "cookie.duration180": "180 วัน",
  "cookie.durationSession": "ระหว่างเซสชัน",
  "cookie.functional": "คุกกี้เพื่อการทำงาน",
  "cookie.functionalExplain": "คุกกี้ประเภทนี้ทำให้เว็บไซต์สามารถเพิ่มประสิทธิภาพการทำงานและปรับแต่งบริการให้เหมาะกับคุณได้ คุกกี้เหล่านี้อาจถูกกำหนดโดยเราหรือโดยผู้ให้บริการบุคคลที่สามที่เราเพิ่มบริการลงในหน้าเว็บของเรา หากคุณไม่อนุญาตคุกกี้เหล่านี้ บริการบางส่วนหรือทั้งหมดนี้อาจทำงานไม่ถูกต้อง",
  "cookie.longTerm": "ระยะยาว",
  "cookie.necessary": "คุกกี้ที่จำเป็นอย่างเคร่งครัด",
  "plant.enterUserAccount": "กรุณากรอกบัญชีผู้ใช้",
  "plant.deliverUserTipUnified": "หมายเหตุ: เมื่อผู้ใช้เข้าสู่ระบบ Haier Energy ด้วยหมายเลขโทรศัพท์หรืออีเมล จะสามารถตรวจสอบและควบคุมอุปกรณ์ที่คุณติดตั้งผ่านแอปได้",
  "plant.placeholderPhoneOrEmail": "กรุณากรอกหมายเลขโทรศัพท์หรืออีเมล",
  "plant.phoneOrEmailFormatError": "กรุณากรอกหมายเลขโทรศัพท์หรืออีเมลที่ถูกต้อง",
  "system.physicalModels": "การจัดการโมเดลอุปกรณ์",
  "subtitle.physicalModelsDetail": "รายละเอียดโมเดลอุปกรณ์",
  "physicalModels.functionSet": "ชุดฟังก์ชัน",
  "physicalModels.minItemsTip": "ต้องเก็บอย่างน้อย {scope} รายการ",
  "physicalModels.conflictTip": "ช่วงเวลาที่ขัดแย้ง: {scope}",
  "physicalModels.name": "ชื่อการตั้งค่า",
  "physicalModels.jsonCorrect": "รูปแบบ JSON ถูกต้อง",
  "physicalModels.jsonCorrectTip": "รูปแบบ JSON ถูกต้อง (ไม่ได้เชื่อมต่อบริการตรวจสอบ)",
  "physicalModels.jsonInCorrect": "รูปแบบ JSON ไม่ถูกต้อง",
  "physicalModels.deleteFailed": "การล้มเหลว",
  "physicalModels.loadPreviewFailed": "โหลดการตั้งค่าตัวอย่างล้มเหลว",
  "physicalModels.configEditor": "ตัวแก้ไขการตั้งค่า",
  "physicalModels.selectTemplate": "เลือกเทมเพลตที่ตั้งไว้",
  "physicalModels.jsonConfig": "การตั้งค่า JSON",
  "physicalModels.realTimePreview": "ดูตัวอย่างแบบเรียลไทม์",
  "physicalModels.checkJsonFormat": "โปรดตรวจสอบว่ารูปแบบ JSON ถูกต้องหรือไม่",
  "physicalModels.readDataStructure": "อ่านโครงสร้างข้อมูล",
  "physicalModels.userBehaviorData": "ข้อมูลดิบพฤติกรรมผู้ใช้",
  "physicalModels.actualDataData": "ข้อมูลที่ส่งจริง",
  "physicalModels.ready": "พร้อม",
  "physicalModels.previewConfigLoaded": "โหลดการตั้งค่าตัวอย่างแล้ว",
  "physicalModels.pasteFromClipboard": "วางจากคลิปบอร์ดแล้ว",
  "physicalModels.pasteFromClipboardTip": "กรุณาเพิ่มหมายเลขซีเรียลอุปกรณ์ต่อท้ายเส้นทางของเบราว์เซอร์ ตัวอย่างเช่น:",
  "physicalModels.error": "ข้อผิดพลาด",
  "plant.createType": "สร้างโดย",
  "physicalModels.jsonComplete": "การเติม JSON อัตโนมัติ",
  "physicalModels.jsonCompleteTip": "หากบันทึก JSON แล้ว การเติม JSON อีกครั้งอาจทำให้เกิดปัญหาด้านการผลิต โปรดดำเนินการด้วยความระมัดระวัง",
  "physicalModels.maxItemsTip": "อนุญาตสูงสุด {scope} รายการ",
  "physicalModels.Empty": "{scope} ไม่สามารถเว้นว่างได้",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "กำลังไฟฟ้าพลังงานแสงอาทิตย์",
  "plantScreen.singleSiteScree.GridImportPower": "กำลังนำเข้าไฟฟ้าจากกริด",
  "plantScreen.singleSiteScree.GridExportPower": "กำลังส่งออกไฟฟ้าสู่กริด",
  "plantScreen.singleSiteScree.ChargingPower": "กำลังชาร์จ",
  "plantScreen.singleSiteScree.DischargingPower": "กำลังคายประจุ",
  "plantScreen.singleSiteScree.LoadPower": "กำลังโหลด",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "อัตราการใช้พลังงานเอง",
  "plantScreen.ChartSet.GenerationPower": "กำลังผลิตไฟฟ้า",
  "plantScreen.ChartSet.DayAheadForecast": "การพยากรณ์ล่วงหน้า 1 วัน",
  "plantScreen.ChartSet.RealTimeForecast": "การพยากรณ์แบบเรียลไทม์",
  "plantScreen.ChartSet.RealTimeScheduling": "การจัดสรรแบบเรียลไทม์",
  "plantScreen.ChartSet.DayAheadScheduling": "การจัดสรรล่วงหน้า 1 วัน",
  "plantScreen.PlantInfo": "ข้อมูลโรงไฟฟ้า",
  "plantScreen.PhotovoltaicCapacity": "ความจุที่ติดตั้ง PV",
  "plantScreen.StorageCapacity": "ความจุแบตเตอรี่",
  "plantScreen.EnergyDispatch": "การจัดสรรพลังงาน",
  "plantScreen.SelfGenerationRate": "อัตราการผลิตไฟฟ้าใช้เอง",
  "plantScreen.DailyStorageCharging": "พลังงานที่ชาร์จรายวัน",
  "plantScreen.DailyStorageDischarging": "พลังงานที่คายประจุรายวัน",
  "plantScreen.DailyElectricitySold2": "ไฟฟ้าที่ขายรายวัน",
  "plantScreen.ChartSet.Storage": "การกักเก็บพลังงาน",
  "plantScreen.ChartSet.Solar": "PV",
  "plantScreen.ChartSet.Load": "โหลด",
  "plantScreen.ChartSet.ChargeDischargePower": "กำลังชาร์จ/คายประจุ",
  "plantScreen.coal": "ถ่านหิน",
  "physicalModels.missingIoTIdTip": "ขาด IoTId หรือ virtualId โปรดตรวจสอบ",
  "org.authCompanyName": "ชื่อบริษัทที่ได้รับการรับรอง",
  "org.serviceAddress": "ที่อยู่บริการ",
  "org.servicePhone": "เบอร์โทรศัพท์บริการ",
  "org.serviceEmail": "อีเมลบริการ",
  "org.companyLogo": "โลโก้บริษัท",
  "org.websiteUrl": "URL ของเว็บไซต์",
  "org.partnerId": "รหัสพันธมิตร",
  "org.serviceAgreement": "ข้อตกลงการบริการ",
  "org.serviceCertificate": "ใบรับรอง",
  "physicalModels.slotId": "รหัสระบุโฆษณa",
  "report.dataQuery.maxDevicesWarning": "เลือกได้สูงสุด 10 อุปกรณ์",
  "report.dataQuery.maxParamsWarning": "เลือกได้สูงสุด 10 พารามิเตอร์",
  "report.dataQuery.selectDeviceAndParamsFirst": "โปรดเลือกอุปกรณ์และพารามิเตอร์ก่อน",
  "report.dataQuery.chartTitle": "เปรียบเทียบแนวโน้มการทำงานหลายชุดข้อมูล",
  "report.dataQuery.selectDevice": "เลือกอุปกรณ์",
  "report.dataQuery.placeholderSelectDevice": "โปรดเลือกอุปกรณ์",
  "report.dataQuery.tabByModel": "ตามรุ่น",
  "report.dataQuery.tabByStation": "ตามโรงไฟฟ้า",
  "report.dataQuery.modelGroupName": "ชื่อรุ่น",
  "report.dataQuery.noMore": "ไม่มีเพิ่มเติม",
  "report.dataQuery.selectedDevicesFooter": "เลือกแล้ว {current} / 10 เครื่อง",
  "report.dataQuery.selectedDevicesShort": "อุปกรณ์ที่เลือก",
  "report.dataQuery.clear": "ล้าง",
  "report.dataQuery.noDeviceSelectedYet": "ยังไม่ได้เลือกอุปกรณ์",
  "report.dataQuery.selectParamsTitle": "เลือกพารามิเตอร์ (สูงสุด 10)",
  "report.dataQuery.maxParamsHint": "เลือกพร้อมกันได้สูงสุด 10 พารามิเตอร์",
  "report.dataQuery.searchParamsPlaceholder": "ค้นหาพารามิเตอร์",
  "report.dataQuery.noMatchingParams": "ไม่พบพารามิเตอร์ที่ตรงกัน",
  "report.dataQuery.selectDeviceFirst": "โปรดเลือกอุปกรณ์ก่อน",
  "report.dataQuery.placeholderDeviceSn": "ป้อนหมายเลขซีเรียลของอุปกรณ์",
  "report.dataQuery.placeholderModelName": "ป้อนชื่อรุ่น",
  "report.dataQuery.placeholderStationName": "ป้อนชื่อโรงไฟฟ้า",
  "report.dataQuery.selectedDevicesSummary": "เลือกแล้ว {count} เครื่อง",
  "report.dataQuery.startAnalysis": "เริ่มวิเคราะห์",
  "report.dataQuery.emptyGuide": "คลิกปุ่ม «เลือกอุปกรณ์» มุมซ้ายบน เลือกอุปกรณ์ที่ต้องการวิเคราะห์ได้สูงสุด 10 เครื่อง จากนั้นเลือกพารามิเตอร์และช่วงเวลาเพื่อเริ่ม",
  "report.dataQuery.noDataHint": "ไม่มีข้อมูลแสดงตามเงื่อนไขปัจจุบัน โปรดปรับอุปกรณ์ พารามิเตอร์ หรือช่วงเวลาแล้วลองอีกครั้ง",
  "report.dataQuery.tableTitle": "เปรียบเทียบข้อมูลการทำงานหลายอุปกรณ์",
  "report.dataQuery.peakLabel": "ค่าสูงสุด:",
  "report.dataQuery.peakColor": "สีแดง",
  "report.dataQuery.valleyLabel": "ค่าต่ำสุด:",
  "report.dataQuery.valleyColor": "สีน้ำเงิน",
  "report.dataQuery.timeByDay": "รายวัน",
  "report.dataQuery.timeByWeek": "รายสัปดาห์",
  "report.dataQuery.timeByMonth": "รายเดือน",
  "report.dataQuery.timeByCustom": "กำหนดเอง",
  "report.dataQuery.highlightNone": "ไม่ไฮไลต์",
  "report.dataQuery.highlightCol": "ไฮไลต์ความต่างตามคอลัมน์",
  "report.dataQuery.highlightRow": "ไฮไลต์ความต่างตามแถว",
  "report.dataQuery.weekdayMon": "จ.",
  "report.dataQuery.weekdayTue": "อ.",
  "report.dataQuery.weekdayWed": "พ.",
  "report.dataQuery.weekdayThu": "พฤ.",
  "report.dataQuery.weekdayFri": "ศ.",
  "report.dataQuery.weekdaySat": "ส.",
  "report.dataQuery.weekdaySun": "อา.",
  "report.dataQuery.axisMonthDay": "วันที่ {n}",
  "plant.statisticalCycle": "รอบสถิติ",
  "plant.stationTopology": "โทโพโลยีสถานี",
  "plant.topologyConfig": "การกำหนดค่าโทโพโลยี",
  "plant.projectName": "ชื่อโครงการ",
  "plant.topologyUrl": "URL โทโพโลยี",
  "plant.topologyMap": "แผนที่โทโพโลยี",
  "plant.topologyPlaceholder": "กรุณาใส่ URL โทโพโลยี",
  "plant.addScopeSuccess": "เพิ่ม {scope} สำเร็จ",
  "plant.updateScopeSuccess": "แก้ไข {scope} สำเร็จ",
  "plant.topologyUrlFormatError": "รูปแบบ URL โทโพโลยีไม่ถูกต้อง",
  "report.dataQuery.maxCurvesWarning": "การเลือกเกิน 10 เส้นกราฟ",
  "report.dataQuery.maxCurvesLimitHint": "เลือกได้สูงสุด 10 เส้นกราฟ",
  "report.dataQuery.selectParamsHeading": "เลือกพารามิเตอร์",
  "ota.don.upgrade": "อัปเกรดดองเกิล",
  "device.ota.tip.newversion": "เวอร์ชันปัจจุบันเป็นเวอร์ชันล่าสุดและไม่จำเป็นต้องอัปเดตใดๆ",
  "device.button.cancel": "ตกลง",
  "org.accountNumber": "หมายเลขบัญชีผู้ใช้",
  "org.accountName": "ชื่อบัญชีผู้ใช้",
  "org.description": "คำอธิบายผู้ใช้ไฟฟ้า",
  "org.creditCode": "รหัสเครดิตสังคม",
  "plant.deptName": "ชื่อองค์กร",
  "plant.businessScope": "อุตสาหกรรมและพาณิชยกรรม",
  "plant.withdrawBusinessDeliveryTip": "หลังจากเพิกถอนการส่งมอบแล้ว ผู้ใช้ {scope} จะไม่สามารถจัดการสถานีไฟฟ้านี้ได้อีกต่อไป โปรดดำเนินการด้วยความระมัดระวัง",
  "register.emailAlreadyRegistered": "อีเมลนี้ลงทะเบียนแล้ว กรุณาเข้าสู่ระบบโดยตรงหรือใช้บัญชีอื่น",
  "register.phoneAlreadyRegistered": "หมายเลขโทรศัพท์นี้ลงทะเบียนแล้ว กรุณาเข้าสู่ระบบโดยตรงหรือใช้บัญชีอื่น",
  "system.selfServiceReport.hourTimeTooltipLine1": "ชั่วโมงหมายถึงช่วงเวลา 1 ชั่วโมงที่เริ่มต้นจากชั่วโมงเต็มนั้น",
  "system.selfServiceReport.hourTimeTooltipLine2": "(เช่น 15:00 = 15:00–15:59)",
  "mapScreen.RevenueInfo": "ข้อมูลรายได้",
  "mapScreen.MonthlyRevenue": "รายได้รายเดือน",
  "mapScreen.YearlyRevenue": "รายได้รายปี",
  "mapScreen.CumulativeRevenue": "รายได้สะสม",
  "mapScreen.CarbonIndicator": "ตัวชี้วัดคาร์บอน",
  "mapScreen.StorageInfo": "ข้อมูลการจัดเก็บ",
  "mapScreen.MonthlyChargeDischarge": "การชาร์จ/ปล่อยรายเดือน",
  "mapScreen.YearlyChargeDischarge": "การชาร์จ/ปล่อยรายปี",
  "mapScreen.TotalPlants": "จำนวนโรงไฟฟ้า",
  "mapScreen.PvInstalledCapacity": "กำลังการผลิต PV ที่ติดตั้ง",
  "mapScreen.StorageInstalledCapacity": "กำลังการเก็บพลังงานที่ติดตั้ง",
  "mapScreen.ChargingPileCapacity": "กำลังชาร์จที่ติดตั้ง",
  "mapScreen.Residential": "ที่อยู่อาศัย",
  "mapScreen.Commercial": "พาณิชย์",
  "mapScreen.PlantCount": "ทั้งหมด {count} โรงไฟฟ้า",
  "mapScreen.NewEnergyPower": "กำลังการผลิตพลังงานหมุนเวียน",
  "mapScreen.GenerationInfo": "ข้อมูลการผลิตไฟฟ้า",
  "mapScreen.MonthlyGeneration": "การผลิตไฟฟ้ารายเดือน",
  "mapScreen.YearlyGeneration": "การผลิตไฟฟ้ารายปี",
  "mapScreen.ChargingPileInfo": "ข้อมูลสถานีชาร์จ",
  "mapScreen.MonthlyConsumption": "การใช้ไฟรายเดือน",
  "mapScreen.YearlyConsumption": "การใช้ไฟรายปี",
  "mapScreen.GridConnectionInfo": "ข้อมูลการเชื่อมต่อโครงข่าย",
  "mapScreen.MonthlyPurchaseFeedin": "การซื้อ/ส่งไฟฟ้าเข้าโครงข่ายรายเดือน",
  "mapScreen.YearlyPurchaseFeedin": "การซื้อ/ส่งไฟฟ้าเข้าโครงข่ายรายปี",
  "mapScreen.CO2Reduction": "การลด CO2",
  "mapScreen.SaveCoal": "ถ่านหินมาตรฐานที่ประหยัด",
  "mapScreen.TreePlanting": "ต้นไม้ที่ปลูก",
  "mapScreen.SelectCountry": "เลือกประเทศ",
  "mapScreen.BackToPrev": "กลับสู่ระดับก่อนหน้า",
  "mapScreen.Revenue": "รายได้",
  "mapScreen.ChargeAmount": "ปริมาณการชาร์จ",
  "mapScreen.DischargeAmount": "ปริมาณการปล่อย",
  "mapScreen.GenerationAmount": "ปริมาณการผลิต",
  "mapScreen.ConsumptionAmount": "ปริมาณการใช้",
  "mapScreen.PowerGeneration": "กำลังการผลิตไฟฟ้า",
  "mapScreen.PurchaseAmount": "ปริมาณที่ซื้อ",
  "mapScreen.GridSellAmount": "ปริมาณขายเข้าระบบ",
  "mapScreen.title": "แพลตฟอร์มจัดการพลังงาน",
  "mapScreen.PlantMonthlyRevenue": "รายได้รายเดือน",
  "mapScreen.PlantYearlyRevenue": "รายได้รายปี",
  "mapScreen.PlantCumulativeRevenue": "รายได้สะสม",
  "physicalModels.tagGroup": "กลุ่มแท็ก",
  "device.expandAll": "ขยายทั้งหมด",
  "device.collapseAll": "ยุบทั้งหมด",
  "common.deleteSuccess": "ลบสำเร็จ",
  "device.systemTime": "เวลาระบบ",
  "device.traceId": "รหัสติดตามเส้นทาง",
  "device.collectorSn": "หมายเลขซีเรียลของตัวรวบรวม",
  "device.functionCode": "รหัสฟังก์ชัน",
  "device.encryptedStr": "ข้อความเข้ารหัส",
  "device.decryptedStr": "ข้อความถอดรหัส",
  "device.dateRangeErrorScope": "ช่วงวันที่ควรอยู่ใน {scope} วัน",
  "common.noMore": "ไม่มีเพิ่มเติมแล้ว",
  "common.unloginOrExpired": "ยังไม่ได้เข้าสู่ระบบหรือเข้าสู่ระบบหมดอายุ",
  "common.serverError": "ข้อผิดพลาดของเซิร์ฟเวอร์ โปรดลองอีกครั้งในภายหลัง",
  "common.requestFailed": "การร้องขอล้มเหลว",
  "common.backendError": "ข้อผิดพลาดในการเชื่อมต่ออินเทอร์เฟซแบ็กเอนด์",
  "common.timeout": "การร้องขออินเทอร์เฟซระบบหมดเวลา",
  "common.systemInterface": "อินเทอร์เฟซระบบ",
  "common.contains": "ประกอบด้วย",
  "common.columnSetting": "การตั้งค่าคอลัมน์",
  "product.skipShipmentCheck": "ข้ามการตรวจสอบการจัดส่ง",
  "system.mapScreen": "พาโนรามา จอใหญ่",
  "settingDrawer.title": "การตั้งค่าเลย์เอาต์",
  "settingDrawer.themeMode": "โหมดธีม",
  "settingDrawer.darkTheme": "ธีมมืด",
  "settingDrawer.lightTheme": "ธีมสว่าง",
  "settingDrawer.themeColor": "สีธีม",
  "settingDrawer.navMode": "โหมดนำทาง",
  "settingDrawer.sideMenu": "เลย์เอาต์เมนูด้านข้าง",
  "settingDrawer.topMenu": "เลย์เอาต์เมนูด้านบน",
  "settingDrawer.mixMenu": "เลย์เอาต์ผสม",
  "settingDrawer.columnMenu": "เลย์เอาต์คอลัมน์",
  "settingDrawer.drawerMenu": "เลย์เอาต์ลิ้นชัก",
  "settingDrawer.layoutSetting": "การตั้งค่าเลย์เอาต์",
  "settingDrawer.contentWidth": "ความกว้างของเนื้อหา",
  "settingDrawer.contentWidthFixed": "คงที่",
  "settingDrawer.contentWidthFluid": "ไหล",
  "settingDrawer.fixedHeader": "ส่วนหัวคงที่",
  "settingDrawer.fixedSidebar": "แถบด้านข้างคงที่",
  "settingDrawer.hideFooter": "ซ่อนส่วนท้าย",
  "settingDrawer.multiTab": "โหมดหลายแท็บ",
  "settingDrawer.sidebarColorfulIcon": "ไอคอนแถบด้านข้างสีสัน",
  "settingDrawer.searchMode": "โหมดส่วนประกอบการค้นหา",
  "settingDrawer.searchModeHeader": "เวอร์ชันใหม่",
  "settingDrawer.searchModeForm": "เวอร์ชันเก่า",
  "settingDrawer.systemConfig": "การกำหนดค่าระบบ",
  "settingDrawer.systemTitle": "ชื่อระบบ",
  "settingDrawer.systemCopyright": "ข้อมูลลิขสิทธิ์",
  "settingDrawer.systemVersion": "เวอร์ชันระบบ",
  "settingDrawer.systemVersionPlaceholder": "หมายเลขเวอร์ชัน",
  "settingDrawer.tableStyle": "สไตล์ตาราง",
  "settingDrawer.tableSize": "ขนาดตาราง",
  "settingDrawer.tableSizeDefault": "ค่าเริ่มต้น",
  "settingDrawer.tableSizeMiddle": "กลาง",
  "settingDrawer.tableSizeSmall": "กะทัดรัด",
  "settingDrawer.tableBordered": "แสดงเส้นขอบ",
  "settingDrawer.tableFixHeader": "ตรึงส่วนหัว",
  "settingDrawer.tableHeaderBold": "ส่วนหัวตัวหนา",
  "settingDrawer.tableResizable": "ปรับความกว้างคอลัมน์ได้",
  "settingDrawer.tableRowSelection": "การเลือกแถว",
  "settingDrawer.tableHeaderBgColor": "สีพื้นหลังส่วนหัว",
  "settingDrawer.tableHeight": "ความสูงของตาราง",
  "settingDrawer.pageSize": "ขนาดหน้า",
  "settingDrawer.pageSizeUnit": "รายการ/หน้า",
  "settingDrawer.showTotal": "แสดงยอดรวม",
  "settingDrawer.showSizeChanger": "แสดงตัวเลือกขนาดหน้า",
  "settingDrawer.showQuickJumper": "แสดงการข้ามไปยังหน้า",
  "settingDrawer.tableStripe": "ลายทางซิงเกอร์",
  "settingDrawer.tableShowHeader": "แสดงส่วนหัว",
  "settingDrawer.saveTableConfig": "บันทึกการกำหนดค่าตาราง",
  "settingDrawer.reset": "รีเซ็ต",
  "settingDrawer.configManagement": "การจัดการการกำหนดค่า",
  "settingDrawer.saveAll": "บันทึกการตั้งค่าทั้งหมด",
  "settingDrawer.exportConfig": "ส่งออกการกำหนดค่า",
  "settingDrawer.importConfig": "นำเข้าการกำหนดค่า",
  "settingDrawer.resetAll": "รีเซ็ตการตั้งค่าทั้งหมด",
  "settingDrawer.msg.initFail": "การเริ่มต้นระบบล้มเหลว โปรดรีเฟรชหน้าและลองอีกครั้ง",
  "settingDrawer.msg.configInitFail": "การเริ่มต้นการกำหนดค่าล้มเหลว",
  "settingDrawer.msg.themeChangeFail": "การเปลี่ยนธีมล้มเหลว",
  "settingDrawer.msg.colorChangeFail": "การเปลี่ยนสีธีมล้มเหลว",
  "settingDrawer.msg.searchModeSwitched": "เปลี่ยนเป็นการค้นหาแบบ {mode}",
  "settingDrawer.msg.searchModeSwitchFail": "การเปลี่ยนส่วนประกอบการค้นหาล้มเหลว",
  "settingDrawer.msg.navModeSwitched": "เปลี่ยนเป็นโหมด {mode}",
  "settingDrawer.msg.navSide": "แถบด้านข้าง",
  "settingDrawer.msg.navTop": "เมนูด้านบน",
  "settingDrawer.msg.navMix": "ผสม",
  "settingDrawer.msg.navModeSwitchFail": "การเปลี่ยนโหมดนำทางล้มเหลว",
  "settingDrawer.msg.layoutSwitchFail": "การเปลี่ยนเลย์เอาต์ล้มเหลว",
  "settingDrawer.msg.settingUpdateFail": "การอัปเดตการตั้งค่าล้มเหลว",
  "settingDrawer.msg.tableStoreNotInit": "ที่จัดเก็บการกำหนดค่าตารางไม่ได้เริ่มต้น",
  "settingDrawer.msg.tableConfigSaved": "บันทึกการกำหนดค่าตารางแล้ว",
  "settingDrawer.msg.tableConfigSaveFail": "บันทึกการกำหนดค่าตารางล้มเหลว",
  "settingDrawer.msg.tableConfigReset": "รีเซ็ตการกำหนดค่าตารางแล้ว",
  "settingDrawer.msg.tableConfigResetFail": "รีเซ็ตการกำหนดค่าตารางล้มเหลว",
  "settingDrawer.msg.systemConfigUpdated": "อัปเดตการกำหนดค่าระบบแล้ว",
  "settingDrawer.msg.systemConfigUpdateFailStore": "การอัปเดตการกำหนดค่าระบบล้มเหลว: Store ไม่ได้เริ่มต้น",
  "settingDrawer.msg.systemConfigUpdateFail": "การอัปเดตการกำหนดค่าระบบล้มเหลว",
  "settingDrawer.msg.allConfigSaved": "บันทึกการตั้งค่าทั้งหมดแล้ว",
  "settingDrawer.msg.configSaveFail": "บันทึกการกำหนดค่าล้มเหลว",
  "settingDrawer.msg.configExported": "ส่งออกการกำหนดค่าแล้ว",
  "settingDrawer.msg.configExportFail": "ส่งออกการกำหนดค่าล้มเหลว",
  "settingDrawer.msg.configImportConfirmTitle": "ยืนยันการนำเข้าการกำหนดค่า",
  "settingDrawer.msg.configImportConfirmContent": "การนำเข้าการกำหนดค่าจะเขียนทับการตั้งค่าปัจจุบันทั้งหมด ดำเนินการต่อหรือไม่",
  "settingDrawer.msg.confirm": "ยืนยัน",
  "settingDrawer.msg.cancel": "ยกเลิก",
  "settingDrawer.msg.configImported": "นำเข้าการกำหนดค่าสำเร็จ",
  "settingDrawer.msg.configFileInvalid": "รูปแบบไฟล์การกำหนดค่าไม่ถูกต้อง",
  "settingDrawer.msg.resetConfirmTitle": "ยืนยันการรีเซ็ต",
  "settingDrawer.msg.resetConfirmContent": "การรีเซ็ตจะล้างการตั้งค่าแบบกำหนดเองทั้งหมดและคืนค่าเริ่มต้น ดำเนินการต่อหรือไม่",
  "settingDrawer.msg.allConfigReset": "รีเซ็ตการตั้งค่าทั้งหมดแล้ว"
}
